/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	module.exports = __webpack_require__(299);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(3);
	
	__webpack_require__(294);
	
	__webpack_require__(296);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	__webpack_require__(53);
	__webpack_require__(54);
	__webpack_require__(55);
	__webpack_require__(56);
	__webpack_require__(58);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(63);
	__webpack_require__(64);
	__webpack_require__(65);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(69);
	__webpack_require__(71);
	__webpack_require__(73);
	__webpack_require__(75);
	__webpack_require__(77);
	__webpack_require__(80);
	__webpack_require__(81);
	__webpack_require__(82);
	__webpack_require__(86);
	__webpack_require__(88);
	__webpack_require__(90);
	__webpack_require__(93);
	__webpack_require__(94);
	__webpack_require__(95);
	__webpack_require__(96);
	__webpack_require__(98);
	__webpack_require__(99);
	__webpack_require__(100);
	__webpack_require__(101);
	__webpack_require__(102);
	__webpack_require__(103);
	__webpack_require__(104);
	__webpack_require__(106);
	__webpack_require__(107);
	__webpack_require__(108);
	__webpack_require__(110);
	__webpack_require__(111);
	__webpack_require__(112);
	__webpack_require__(114);
	__webpack_require__(115);
	__webpack_require__(116);
	__webpack_require__(117);
	__webpack_require__(118);
	__webpack_require__(119);
	__webpack_require__(120);
	__webpack_require__(121);
	__webpack_require__(122);
	__webpack_require__(123);
	__webpack_require__(124);
	__webpack_require__(125);
	__webpack_require__(126);
	__webpack_require__(127);
	__webpack_require__(132);
	__webpack_require__(133);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	__webpack_require__(151);
	__webpack_require__(152);
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(160);
	__webpack_require__(161);
	__webpack_require__(167);
	__webpack_require__(168);
	__webpack_require__(170);
	__webpack_require__(171);
	__webpack_require__(172);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(182);
	__webpack_require__(183);
	__webpack_require__(184);
	__webpack_require__(185);
	__webpack_require__(188);
	__webpack_require__(190);
	__webpack_require__(191);
	__webpack_require__(192);
	__webpack_require__(194);
	__webpack_require__(196);
	__webpack_require__(198);
	__webpack_require__(199);
	__webpack_require__(200);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(205);
	__webpack_require__(212);
	__webpack_require__(215);
	__webpack_require__(216);
	__webpack_require__(218);
	__webpack_require__(219);
	__webpack_require__(222);
	__webpack_require__(223);
	__webpack_require__(225);
	__webpack_require__(226);
	__webpack_require__(227);
	__webpack_require__(228);
	__webpack_require__(229);
	__webpack_require__(230);
	__webpack_require__(231);
	__webpack_require__(232);
	__webpack_require__(233);
	__webpack_require__(234);
	__webpack_require__(235);
	__webpack_require__(236);
	__webpack_require__(237);
	__webpack_require__(238);
	__webpack_require__(239);
	__webpack_require__(240);
	__webpack_require__(241);
	__webpack_require__(242);
	__webpack_require__(243);
	__webpack_require__(245);
	__webpack_require__(246);
	__webpack_require__(247);
	__webpack_require__(248);
	__webpack_require__(249);
	__webpack_require__(250);
	__webpack_require__(252);
	__webpack_require__(253);
	__webpack_require__(254);
	__webpack_require__(255);
	__webpack_require__(256);
	__webpack_require__(257);
	__webpack_require__(258);
	__webpack_require__(259);
	__webpack_require__(261);
	__webpack_require__(262);
	__webpack_require__(264);
	__webpack_require__(265);
	__webpack_require__(266);
	__webpack_require__(267);
	__webpack_require__(270);
	__webpack_require__(271);
	__webpack_require__(272);
	__webpack_require__(273);
	__webpack_require__(274);
	__webpack_require__(275);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(279);
	__webpack_require__(280);
	__webpack_require__(281);
	__webpack_require__(282);
	__webpack_require__(283);
	__webpack_require__(284);
	__webpack_require__(285);
	__webpack_require__(286);
	__webpack_require__(287);
	__webpack_require__(288);
	__webpack_require__(289);
	__webpack_require__(292);
	__webpack_require__(293);
	module.exports = __webpack_require__(10);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(5)
	  , has            = __webpack_require__(6)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , $export        = __webpack_require__(9)
	  , redefine       = __webpack_require__(19)
	  , META           = __webpack_require__(23).KEY
	  , $fails         = __webpack_require__(8)
	  , shared         = __webpack_require__(24)
	  , setToStringTag = __webpack_require__(25)
	  , uid            = __webpack_require__(20)
	  , wks            = __webpack_require__(26)
	  , wksExt         = __webpack_require__(27)
	  , wksDefine      = __webpack_require__(28)
	  , keyOf          = __webpack_require__(30)
	  , enumKeys       = __webpack_require__(43)
	  , isArray        = __webpack_require__(46)
	  , anObject       = __webpack_require__(13)
	  , toIObject      = __webpack_require__(33)
	  , toPrimitive    = __webpack_require__(17)
	  , createDesc     = __webpack_require__(18)
	  , _create        = __webpack_require__(47)
	  , gOPNExt        = __webpack_require__(50)
	  , $GOPD          = __webpack_require__(52)
	  , $DP            = __webpack_require__(12)
	  , $keys          = __webpack_require__(31)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(51).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(45).f  = $propertyIsEnumerable;
	  __webpack_require__(44).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(29)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 5 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 6 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(8)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 8 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , core      = __webpack_require__(10)
	  , hide      = __webpack_require__(11)
	  , redefine  = __webpack_require__(19)
	  , ctx       = __webpack_require__(21)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 10 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(12)
	  , createDesc = __webpack_require__(18);
	module.exports = __webpack_require__(7) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(13)
	  , IE8_DOM_DEFINE = __webpack_require__(15)
	  , toPrimitive    = __webpack_require__(17)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(7) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(7) && !__webpack_require__(8)(function(){
	  return Object.defineProperty(__webpack_require__(16)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14)
	  , document = __webpack_require__(5).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(14);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , hide      = __webpack_require__(11)
	  , has       = __webpack_require__(6)
	  , SRC       = __webpack_require__(20)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(10).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 20 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(22);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(20)('meta')
	  , isObject = __webpack_require__(14)
	  , has      = __webpack_require__(6)
	  , setDesc  = __webpack_require__(12).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(8)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(12).f
	  , has = __webpack_require__(6)
	  , TAG = __webpack_require__(26)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(24)('wks')
	  , uid        = __webpack_require__(20)
	  , Symbol     = __webpack_require__(5).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(26);

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(5)
	  , core           = __webpack_require__(10)
	  , LIBRARY        = __webpack_require__(29)
	  , wksExt         = __webpack_require__(27)
	  , defineProperty = __webpack_require__(12).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 29 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(31)
	  , toIObject = __webpack_require__(33);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(32)
	  , enumBugKeys = __webpack_require__(42);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(6)
	  , toIObject    = __webpack_require__(33)
	  , arrayIndexOf = __webpack_require__(37)(false)
	  , IE_PROTO     = __webpack_require__(41)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(34)
	  , defined = __webpack_require__(36);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(35);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(33)
	  , toLength  = __webpack_require__(38)
	  , toIndex   = __webpack_require__(40);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(39)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(24)('keys')
	  , uid    = __webpack_require__(20);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 42 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(31)
	  , gOPS    = __webpack_require__(44)
	  , pIE     = __webpack_require__(45);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 44 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 45 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(35);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(13)
	  , dPs         = __webpack_require__(48)
	  , enumBugKeys = __webpack_require__(42)
	  , IE_PROTO    = __webpack_require__(41)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(16)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(49).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(12)
	  , anObject = __webpack_require__(13)
	  , getKeys  = __webpack_require__(31);
	
	module.exports = __webpack_require__(7) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5).document && document.documentElement;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(33)
	  , gOPN      = __webpack_require__(51).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(32)
	  , hiddenKeys = __webpack_require__(42).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(45)
	  , createDesc     = __webpack_require__(18)
	  , toIObject      = __webpack_require__(33)
	  , toPrimitive    = __webpack_require__(17)
	  , has            = __webpack_require__(6)
	  , IE8_DOM_DEFINE = __webpack_require__(15)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(7) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(47)});

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperty: __webpack_require__(12).f});

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(7), 'Object', {defineProperties: __webpack_require__(48)});

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(33)
	  , $getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	__webpack_require__(57)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(9)
	  , core    = __webpack_require__(10)
	  , fails   = __webpack_require__(8);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(59)
	  , $getPrototypeOf = __webpack_require__(60);
	
	__webpack_require__(57)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(36);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(6)
	  , toObject    = __webpack_require__(59)
	  , IE_PROTO    = __webpack_require__(41)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(59)
	  , $keys    = __webpack_require__(31);
	
	__webpack_require__(57)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(57)('getOwnPropertyNames', function(){
	  return __webpack_require__(50).f;
	});

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(14)
	  , meta     = __webpack_require__(23).onFreeze;
	
	__webpack_require__(57)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(14);
	
	__webpack_require__(57)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(9);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(70)});

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(31)
	  , gOPS     = __webpack_require__(44)
	  , pIE      = __webpack_require__(45)
	  , toObject = __webpack_require__(59)
	  , IObject  = __webpack_require__(34)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(8)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {is: __webpack_require__(72)});

/***/ },
/* 72 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(9);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(74).set});

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(14)
	  , anObject = __webpack_require__(13);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(21)(Function.call, __webpack_require__(52).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(76)
	  , test    = {};
	test[__webpack_require__(26)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(19)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(35)
	  , TAG = __webpack_require__(26)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Function', {bind: __webpack_require__(78)});

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(22)
	  , isObject   = __webpack_require__(14)
	  , invoke     = __webpack_require__(79)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 79 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(12).f
	  , createDesc = __webpack_require__(18)
	  , has        = __webpack_require__(6)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(7) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(14)
	  , getPrototypeOf = __webpack_require__(60)
	  , HAS_INSTANCE   = __webpack_require__(26)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(12).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(83);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(5).parseInt
	  , $trim     = __webpack_require__(84).trim
	  , ws        = __webpack_require__(85)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , defined = __webpack_require__(36)
	  , fails   = __webpack_require__(8)
	  , spaces  = __webpack_require__(85)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(87);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(5).parseFloat
	  , $trim       = __webpack_require__(84).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(85) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(5)
	  , has               = __webpack_require__(6)
	  , cof               = __webpack_require__(35)
	  , inheritIfRequired = __webpack_require__(89)
	  , toPrimitive       = __webpack_require__(17)
	  , fails             = __webpack_require__(8)
	  , gOPN              = __webpack_require__(51).f
	  , gOPD              = __webpack_require__(52).f
	  , dP                = __webpack_require__(12).f
	  , $trim             = __webpack_require__(84).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(47)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(7) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(19)(global, NUMBER, $Number);
	}

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(14)
	  , setPrototypeOf = __webpack_require__(74).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , toInteger    = __webpack_require__(39)
	  , aNumberValue = __webpack_require__(91)
	  , repeat       = __webpack_require__(92)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(8)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(35);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(39)
	  , defined   = __webpack_require__(36);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , $fails       = __webpack_require__(8)
	  , aNumberValue = __webpack_require__(91)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(9)
	  , _isFinite = __webpack_require__(5).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(97)});

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(14)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(9)
	  , isInteger = __webpack_require__(97)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(9)
	  , $parseFloat = __webpack_require__(87);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , $parseInt = __webpack_require__(83);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(9)
	  , log1p   = __webpack_require__(105)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 105 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(9)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(9)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(9)
	  , sign    = __webpack_require__(109);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 109 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(9)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(9)
	  , $expm1  = __webpack_require__(113);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 113 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(9)
	  , sign      = __webpack_require__(109)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(9)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(9)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(105)});

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {sign: __webpack_require__(109)});

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(113)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(9)
	  , expm1   = __webpack_require__(113)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(9)
	  , toIndex        = __webpack_require__(40)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(33)
	  , toLength  = __webpack_require__(38);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(84)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(128)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(129)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(39)
	  , defined   = __webpack_require__(36);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(29)
	  , $export        = __webpack_require__(9)
	  , redefine       = __webpack_require__(19)
	  , hide           = __webpack_require__(11)
	  , has            = __webpack_require__(6)
	  , Iterators      = __webpack_require__(130)
	  , $iterCreate    = __webpack_require__(131)
	  , setToStringTag = __webpack_require__(25)
	  , getPrototypeOf = __webpack_require__(60)
	  , ITERATOR       = __webpack_require__(26)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 130 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(47)
	  , descriptor     = __webpack_require__(18)
	  , setToStringTag = __webpack_require__(25)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(11)(IteratorPrototype, __webpack_require__(26)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(128)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(9)
	  , toLength  = __webpack_require__(38)
	  , context   = __webpack_require__(134)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(135)
	  , defined  = __webpack_require__(36);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(14)
	  , cof      = __webpack_require__(35)
	  , MATCH    = __webpack_require__(26)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(26)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(9)
	  , context  = __webpack_require__(134)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(136)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(92)
	});

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(9)
	  , toLength    = __webpack_require__(38)
	  , context     = __webpack_require__(134)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(136)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(141)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(8)
	  , defined = __webpack_require__(36)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(141)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(141)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(141)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(141)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(141)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(141)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(141)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(141)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(141)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(141)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(141)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(141)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(9)
	  , toObject    = __webpack_require__(59)
	  , toPrimitive = __webpack_require__(17);
	
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(9)
	  , fails   = __webpack_require__(8)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(19)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(26)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(11)(proto, TO_PRIMITIVE, __webpack_require__(159));

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(13)
	  , toPrimitive = __webpack_require__(17)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(46)});

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(21)
	  , $export        = __webpack_require__(9)
	  , toObject       = __webpack_require__(59)
	  , call           = __webpack_require__(162)
	  , isArrayIter    = __webpack_require__(163)
	  , toLength       = __webpack_require__(38)
	  , createProperty = __webpack_require__(164)
	  , getIterFn      = __webpack_require__(165);
	
	$export($export.S + $export.F * !__webpack_require__(166)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(13);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(130)
	  , ITERATOR   = __webpack_require__(26)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(12)
	  , createDesc      = __webpack_require__(18);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(76)
	  , ITERATOR  = __webpack_require__(26)('iterator')
	  , Iterators = __webpack_require__(130);
	module.exports = __webpack_require__(10).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(26)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(9)
	  , createProperty = __webpack_require__(164);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(9)
	  , toIObject = __webpack_require__(33)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(34) != Object || !__webpack_require__(169)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(8);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(9)
	  , html       = __webpack_require__(49)
	  , cof        = __webpack_require__(35)
	  , toIndex    = __webpack_require__(40)
	  , toLength   = __webpack_require__(38)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(8)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(22)
	  , toObject  = __webpack_require__(59)
	  , fails     = __webpack_require__(8)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(169)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(9)
	  , $forEach = __webpack_require__(173)(0)
	  , STRICT   = __webpack_require__(169)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(21)
	  , IObject  = __webpack_require__(34)
	  , toObject = __webpack_require__(59)
	  , toLength = __webpack_require__(38)
	  , asc      = __webpack_require__(174);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(175);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(14)
	  , isArray  = __webpack_require__(46)
	  , SPECIES  = __webpack_require__(26)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $map    = __webpack_require__(173)(1);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $filter = __webpack_require__(173)(2);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $some   = __webpack_require__(173)(3);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $every  = __webpack_require__(173)(4);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(22)
	  , toObject  = __webpack_require__(59)
	  , IObject   = __webpack_require__(34)
	  , toLength  = __webpack_require__(38);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(9)
	  , $reduce = __webpack_require__(181);
	
	$export($export.P + $export.F * !__webpack_require__(169)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(9)
	  , $indexOf      = __webpack_require__(37)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(9)
	  , toIObject     = __webpack_require__(33)
	  , toInteger     = __webpack_require__(39)
	  , toLength      = __webpack_require__(38)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(169)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(186)});
	
	__webpack_require__(187)('copyWithin');

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(59)
	  , toIndex  = __webpack_require__(40)
	  , toLength = __webpack_require__(38);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(26)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(11)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(9);
	
	$export($export.P, 'Array', {fill: __webpack_require__(189)});
	
	__webpack_require__(187)('fill');

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(59)
	  , toIndex  = __webpack_require__(40)
	  , toLength = __webpack_require__(38);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(173)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(9)
	  , $find   = __webpack_require__(173)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(187)(KEY);

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(193)('Array');

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(5)
	  , dP          = __webpack_require__(12)
	  , DESCRIPTORS = __webpack_require__(7)
	  , SPECIES     = __webpack_require__(26)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(187)
	  , step             = __webpack_require__(195)
	  , Iterators        = __webpack_require__(130)
	  , toIObject        = __webpack_require__(33);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(129)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 195 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(5)
	  , inheritIfRequired = __webpack_require__(89)
	  , dP                = __webpack_require__(12).f
	  , gOPN              = __webpack_require__(51).f
	  , isRegExp          = __webpack_require__(135)
	  , $flags            = __webpack_require__(197)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(7) && (!CORRECT_NEW || __webpack_require__(8)(function(){
	  re2[__webpack_require__(26)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(19)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(193)('RegExp');

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(13);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(199);
	var anObject    = __webpack_require__(13)
	  , $flags      = __webpack_require__(197)
	  , DESCRIPTORS = __webpack_require__(7)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(19)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(8)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(7) && /./g.flags != 'g')__webpack_require__(12).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(197)
	});

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(201)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(11)
	  , redefine = __webpack_require__(19)
	  , fails    = __webpack_require__(8)
	  , defined  = __webpack_require__(36)
	  , wks      = __webpack_require__(26);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(201)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(201)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(201)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(135)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(29)
	  , global             = __webpack_require__(5)
	  , ctx                = __webpack_require__(21)
	  , classof            = __webpack_require__(76)
	  , $export            = __webpack_require__(9)
	  , isObject           = __webpack_require__(14)
	  , aFunction          = __webpack_require__(22)
	  , anInstance         = __webpack_require__(206)
	  , forOf              = __webpack_require__(207)
	  , speciesConstructor = __webpack_require__(208)
	  , task               = __webpack_require__(209).set
	  , microtask          = __webpack_require__(210)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(26)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(211)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(25)($Promise, PROMISE);
	__webpack_require__(193)(PROMISE);
	Wrapper = __webpack_require__(10)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(166)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 206 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(21)
	  , call        = __webpack_require__(162)
	  , isArrayIter = __webpack_require__(163)
	  , anObject    = __webpack_require__(13)
	  , toLength    = __webpack_require__(38)
	  , getIterFn   = __webpack_require__(165)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(13)
	  , aFunction = __webpack_require__(22)
	  , SPECIES   = __webpack_require__(26)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(21)
	  , invoke             = __webpack_require__(79)
	  , html               = __webpack_require__(49)
	  , cel                = __webpack_require__(16)
	  , global             = __webpack_require__(5)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(35)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(5)
	  , macrotask = __webpack_require__(209).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(35)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(19);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(213);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(214)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(12).f
	  , create      = __webpack_require__(47)
	  , redefineAll = __webpack_require__(211)
	  , ctx         = __webpack_require__(21)
	  , anInstance  = __webpack_require__(206)
	  , defined     = __webpack_require__(36)
	  , forOf       = __webpack_require__(207)
	  , $iterDefine = __webpack_require__(129)
	  , step        = __webpack_require__(195)
	  , setSpecies  = __webpack_require__(193)
	  , DESCRIPTORS = __webpack_require__(7)
	  , fastKey     = __webpack_require__(23).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(5)
	  , $export           = __webpack_require__(9)
	  , redefine          = __webpack_require__(19)
	  , redefineAll       = __webpack_require__(211)
	  , meta              = __webpack_require__(23)
	  , forOf             = __webpack_require__(207)
	  , anInstance        = __webpack_require__(206)
	  , isObject          = __webpack_require__(14)
	  , fails             = __webpack_require__(8)
	  , $iterDetect       = __webpack_require__(166)
	  , setToStringTag    = __webpack_require__(25)
	  , inheritIfRequired = __webpack_require__(89);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(213);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(214)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(173)(0)
	  , redefine     = __webpack_require__(19)
	  , meta         = __webpack_require__(23)
	  , assign       = __webpack_require__(70)
	  , weak         = __webpack_require__(217)
	  , isObject     = __webpack_require__(14)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(214)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(211)
	  , getWeak           = __webpack_require__(23).getWeak
	  , anObject          = __webpack_require__(13)
	  , isObject          = __webpack_require__(14)
	  , anInstance        = __webpack_require__(206)
	  , forOf             = __webpack_require__(207)
	  , createArrayMethod = __webpack_require__(173)
	  , $has              = __webpack_require__(6)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(217);
	
	// 23.4 WeakSet Objects
	__webpack_require__(214)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(9)
	  , $typed       = __webpack_require__(220)
	  , buffer       = __webpack_require__(221)
	  , anObject     = __webpack_require__(13)
	  , toIndex      = __webpack_require__(40)
	  , toLength     = __webpack_require__(38)
	  , isObject     = __webpack_require__(14)
	  , ArrayBuffer  = __webpack_require__(5).ArrayBuffer
	  , speciesConstructor = __webpack_require__(208)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(8)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(193)(ARRAY_BUFFER);

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(5)
	  , hide   = __webpack_require__(11)
	  , uid    = __webpack_require__(20)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(5)
	  , DESCRIPTORS    = __webpack_require__(7)
	  , LIBRARY        = __webpack_require__(29)
	  , $typed         = __webpack_require__(220)
	  , hide           = __webpack_require__(11)
	  , redefineAll    = __webpack_require__(211)
	  , fails          = __webpack_require__(8)
	  , anInstance     = __webpack_require__(206)
	  , toInteger      = __webpack_require__(39)
	  , toLength       = __webpack_require__(38)
	  , gOPN           = __webpack_require__(51).f
	  , dP             = __webpack_require__(12).f
	  , arrayFill      = __webpack_require__(189)
	  , setToStringTag = __webpack_require__(25)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9);
	$export($export.G + $export.W + $export.F * !__webpack_require__(220).ABV, {
	  DataView: __webpack_require__(221).DataView
	});

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(7)){
	  var LIBRARY             = __webpack_require__(29)
	    , global              = __webpack_require__(5)
	    , fails               = __webpack_require__(8)
	    , $export             = __webpack_require__(9)
	    , $typed              = __webpack_require__(220)
	    , $buffer             = __webpack_require__(221)
	    , ctx                 = __webpack_require__(21)
	    , anInstance          = __webpack_require__(206)
	    , propertyDesc        = __webpack_require__(18)
	    , hide                = __webpack_require__(11)
	    , redefineAll         = __webpack_require__(211)
	    , toInteger           = __webpack_require__(39)
	    , toLength            = __webpack_require__(38)
	    , toIndex             = __webpack_require__(40)
	    , toPrimitive         = __webpack_require__(17)
	    , has                 = __webpack_require__(6)
	    , same                = __webpack_require__(72)
	    , classof             = __webpack_require__(76)
	    , isObject            = __webpack_require__(14)
	    , toObject            = __webpack_require__(59)
	    , isArrayIter         = __webpack_require__(163)
	    , create              = __webpack_require__(47)
	    , getPrototypeOf      = __webpack_require__(60)
	    , gOPN                = __webpack_require__(51).f
	    , getIterFn           = __webpack_require__(165)
	    , uid                 = __webpack_require__(20)
	    , wks                 = __webpack_require__(26)
	    , createArrayMethod   = __webpack_require__(173)
	    , createArrayIncludes = __webpack_require__(37)
	    , speciesConstructor  = __webpack_require__(208)
	    , ArrayIterators      = __webpack_require__(194)
	    , Iterators           = __webpack_require__(130)
	    , $iterDetect         = __webpack_require__(166)
	    , setSpecies          = __webpack_require__(193)
	    , arrayFill           = __webpack_require__(189)
	    , arrayCopyWithin     = __webpack_require__(186)
	    , $DP                 = __webpack_require__(12)
	    , $GOPD               = __webpack_require__(52)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(224)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(9)
	  , aFunction = __webpack_require__(22)
	  , anObject  = __webpack_require__(13)
	  , rApply    = (__webpack_require__(5).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(8)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(9)
	  , create     = __webpack_require__(47)
	  , aFunction  = __webpack_require__(22)
	  , anObject   = __webpack_require__(13)
	  , isObject   = __webpack_require__(14)
	  , fails      = __webpack_require__(8)
	  , bind       = __webpack_require__(78)
	  , rConstruct = (__webpack_require__(5).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(12)
	  , $export     = __webpack_require__(9)
	  , anObject    = __webpack_require__(13)
	  , toPrimitive = __webpack_require__(17);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(8)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(9)
	  , gOPD     = __webpack_require__(52).f
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(13);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(131)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(52)
	  , getPrototypeOf = __webpack_require__(60)
	  , has            = __webpack_require__(6)
	  , $export        = __webpack_require__(9)
	  , isObject       = __webpack_require__(14)
	  , anObject       = __webpack_require__(13);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(52)
	  , $export  = __webpack_require__(9)
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(9)
	  , getProto = __webpack_require__(60)
	  , anObject = __webpack_require__(13);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(9)
	  , anObject      = __webpack_require__(13)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(244)});

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(51)
	  , gOPS     = __webpack_require__(44)
	  , anObject = __webpack_require__(13)
	  , Reflect  = __webpack_require__(5).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(9)
	  , anObject           = __webpack_require__(13)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(12)
	  , gOPD           = __webpack_require__(52)
	  , getPrototypeOf = __webpack_require__(60)
	  , has            = __webpack_require__(6)
	  , $export        = __webpack_require__(9)
	  , createDesc     = __webpack_require__(18)
	  , anObject       = __webpack_require__(13)
	  , isObject       = __webpack_require__(14);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(9)
	  , setProto = __webpack_require__(74);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(9)
	  , $includes = __webpack_require__(37)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(187)('includes');

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(9)
	  , $at     = __webpack_require__(128)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(251);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(38)
	  , repeat   = __webpack_require__(92)
	  , defined  = __webpack_require__(36);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(9)
	  , $pad    = __webpack_require__(251);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(84)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(9)
	  , defined     = __webpack_require__(36)
	  , toLength    = __webpack_require__(38)
	  , isRegExp    = __webpack_require__(135)
	  , getFlags    = __webpack_require__(197)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(131)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(28)('asyncIterator');

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(28)('observable');

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(9)
	  , ownKeys        = __webpack_require__(244)
	  , toIObject      = __webpack_require__(33)
	  , gOPD           = __webpack_require__(52)
	  , createProperty = __webpack_require__(164);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(9)
	  , $values = __webpack_require__(260)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(31)
	  , toIObject = __webpack_require__(33)
	  , isEnum    = __webpack_require__(45).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(9)
	  , $entries = __webpack_require__(260)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(59)
	  , aFunction       = __webpack_require__(22)
	  , $defineProperty = __webpack_require__(12);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(29)|| !__webpack_require__(8)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(5)[K];
	});

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(9)
	  , toObject        = __webpack_require__(59)
	  , aFunction       = __webpack_require__(22)
	  , $defineProperty = __webpack_require__(12);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(59)
	  , toPrimitive              = __webpack_require__(17)
	  , getPrototypeOf           = __webpack_require__(60)
	  , getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(9)
	  , toObject                 = __webpack_require__(59)
	  , toPrimitive              = __webpack_require__(17)
	  , getPrototypeOf           = __webpack_require__(60)
	  , getOwnPropertyDescriptor = __webpack_require__(52).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(7) && $export($export.P + __webpack_require__(263), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(9);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(268)('Map')});

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(76)
	  , from    = __webpack_require__(269);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(207);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(9);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(268)('Set')});

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(9);
	
	$export($export.S, 'System', {global: __webpack_require__(5)});

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(9)
	  , cof     = __webpack_require__(35);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(9);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(278)
	  , anObject                  = __webpack_require__(13)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(212)
	  , $export = __webpack_require__(9)
	  , shared  = __webpack_require__(24)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(216)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , getPrototypeOf         = __webpack_require__(60)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(215)
	  , from                    = __webpack_require__(269)
	  , metadata                = __webpack_require__(278)
	  , anObject                = __webpack_require__(13)
	  , getPrototypeOf          = __webpack_require__(60)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(278)
	  , anObject                = __webpack_require__(13)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , getPrototypeOf         = __webpack_require__(60)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(278)
	  , anObject               = __webpack_require__(13)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(278)
	  , anObject                  = __webpack_require__(13)
	  , aFunction                 = __webpack_require__(22)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(9)
	  , microtask = __webpack_require__(210)()
	  , process   = __webpack_require__(5).process
	  , isNode    = __webpack_require__(35)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(9)
	  , global      = __webpack_require__(5)
	  , core        = __webpack_require__(10)
	  , microtask   = __webpack_require__(210)()
	  , OBSERVABLE  = __webpack_require__(26)('observable')
	  , aFunction   = __webpack_require__(22)
	  , anObject    = __webpack_require__(13)
	  , anInstance  = __webpack_require__(206)
	  , redefineAll = __webpack_require__(211)
	  , hide        = __webpack_require__(11)
	  , forOf       = __webpack_require__(207)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(193)('Observable');

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(5)
	  , $export    = __webpack_require__(9)
	  , invoke     = __webpack_require__(79)
	  , partial    = __webpack_require__(290)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(291)
	  , invoke    = __webpack_require__(79)
	  , aFunction = __webpack_require__(22);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(5);

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(9)
	  , $task   = __webpack_require__(209);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(194)
	  , redefine      = __webpack_require__(19)
	  , global        = __webpack_require__(5)
	  , hide          = __webpack_require__(11)
	  , Iterators     = __webpack_require__(130)
	  , wks           = __webpack_require__(26)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = Object.create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function(arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return Promise.resolve(value.arg).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" ||
	              (method === "throw" && delegate.iterator[method] === undefined)) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(
	            delegate.iterator[method],
	            delegate.iterator,
	            arg
	          );
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = arg;
	
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(295)))

/***/ },
/* 295 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(297);
	module.exports = __webpack_require__(10).RegExp.escape;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(9)
	  , $re     = __webpack_require__(298)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 298 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(300);
	__webpack_require__(301);
	__webpack_require__(302);

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "index.html";

/***/ },
/* 301 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(308), __webpack_require__(442), __webpack_require__(443), __webpack_require__(444), __webpack_require__(445), __webpack_require__(446), __webpack_require__(447), __webpack_require__(448), __webpack_require__(451), __webpack_require__(452), __webpack_require__(453), __webpack_require__(454), __webpack_require__(455), __webpack_require__(456), __webpack_require__(457),
	
	// physics modules
	__webpack_require__(303), __webpack_require__(458), __webpack_require__(489), __webpack_require__(492), __webpack_require__(494), __webpack_require__(496), __webpack_require__(498), __webpack_require__(500), __webpack_require__(502), __webpack_require__(504), __webpack_require__(505), __webpack_require__(507), __webpack_require__(508), __webpack_require__(510), __webpack_require__(512), __webpack_require__(513), __webpack_require__(515)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, PhaseMatch, config, tplPMUI, tplParametersPanel, tplPlotOpts, textHeatMapAsCSV, textLinePlotAsCSV, doT, _jqui, _bstt, _dk, _jqtags, customCheckbox, converter, Panel,
	
	// physics modules
	Parameters, jsaUI, jsahomUI, ksUI, xyUI, schmidtUI, msUI, curvesUI, jsa2homUI, jsahomBunchUI, efficiencyUI, heraldingUI, heralding2dUI, heralding1dUI, heralding1dUIAdv, heraldingPumpFocusPosition, testingUI) {
	
	    'use strict';
	
	    var tplHeatMapAsCSV = doT.template(textHeatMapAsCSV, $.extend({}, doT.templateSettings, { strip: false }));
	    var tplLinePlotAsCSV = doT.template(textLinePlotAsCSV, $.extend({}, doT.templateSettings, { strip: false }));
	
	    // Note: conversions moved to converter module
	    tplParametersPanel = tplParametersPanel.bind({ PhaseMatch: PhaseMatch, converter: converter });
	    tplPlotOpts = tplPlotOpts.bind({ PhaseMatch: PhaseMatch, converter: converter });
	
	    /**
	     * Page-level Mediator
	     * @module PMUI
	     * @implements {Stapes}
	     */
	    var Mediator = Stapes.subclass({
	
	        /**
	         * Mediator Constructor
	         * @return {void}
	         */
	        constructor: function constructor() {
	
	            var self = this;
	
	            self.initParameters();
	            self.initUI();
	            self.initPlotOpts();
	            self.initEvents();
	            self.initModules();
	
	            $(function () {
	                self.emit('domready');
	            });
	
	            // var delay = 1000;
	            // setTimeout(self.initParameters(), delay);
	            //
	            //
	            // setTimeout(self.initUI(),delay*2);
	            //
	            //
	            // setTimeout(self.initPlotOpts(), delay*3);
	            //
	            // setTimeout(self.initEvents(), delay*4);
	            //
	            // setTimeout(self.initModules(), delay*6);
	            //
	            //
	            // setTimeout($(function(){
	            //     self.emit('domready');
	            // }),delay*8);
	        },
	
	        /**
	         * Initialize events
	         * @return {void}
	         */
	        initEvents: function initEvents() {
	
	            var self = this;
	
	            self.on({
	
	                'domready': self.onDomReady,
	
	                'ready': function ready() {
	
	                    // default
	                    // self.load('testing');
	                    self.load('jsa');
	
	                    self.emit('info', 'Application Loaded');
	                },
	
	                'resize': function resize() {
	
	                    if (self._curr) {
	                        self._curr.resize();
	                    }
	                },
	
	                'calculate': function calculate() {
	
	                    self.emit('info', 'recalculating...');
	                },
	
	                'info': function info(msg) {
	                    if (!msg) {
	                        return;
	                    }
	
	                    self.elLogs.append('<p>' + msg + '</p>');
	                },
	
	                'create': function create(key) {
	
	                    var mod = self.get(key);
	
	                    if (mod.on) {
	
	                        mod.on({
	
	                            'export-csv': function exportCsv(data) {
	
	                                var lineArray = [];
	                                // lineArray.push(data.title + '\n'); //Plot title
	                                lineArray.push("Parameters");
	
	                                // Cycle throught he relevant properties
	                                var pm = self.parameters.getAll();
	                                lineArray.push(["Crystal:", pm.crystal].join(' '));
	                                lineArray.push(["PM Type:", pm.type].join(' '));
	                                lineArray.push(["Crystal Length (m):", pm.L].join(' '));
	                                lineArray.push(["Crystal Theta (rad):", pm.theta].join(' '));
	                                lineArray.push(["Crystal Phi (rad):", pm.phi].join(' '));
	                                lineArray.push(["Crystal Temperature (C):", pm.temp].join(' '));
	                                if (pm.enable_pp) {
	                                    lineArray.push(["Poling Period (m):", pm.poling_period].join(' '));
	                                    if (pm.calc_apodization) {
	                                        lineArray.push(["Number of apodization steps:", pm.apodization].join(' '));
	                                        lineArray.push(["Apodization FWHM (m)", pm.apodization_FWHM].join(' '));
	                                    }
	                                }
	
	                                lineArray.push(["Pump Wavelength (m):", pm.lambda_p].join(' '));
	                                lineArray.push(["Signal Wavelength (m):", pm.lambda_s].join(' '));
	                                lineArray.push(["Idler Wavelength (m):", pm.lambda_i].join(' '));
	                                lineArray.push(["Pump Bandwidth FWHM (m):", pm.lambda_bw].join(' '));
	                                lineArray.push(["Signal Angle Internal (rad):", pm.theta_s].join(' '));
	                                lineArray.push(["Idler Angle Internal (rad):", pm.theta_i].join(' '));
	                                lineArray.push(["Signal Angle External (rad):", pm.theta_s_e].join(' '));
	                                lineArray.push(["Idler Angle External (rad):", pm.theta_i_e].join(' '));
	                                lineArray.push(["Pump Waist Radius(1/e^2) (m):", pm.W].join(' '));
	                                lineArray.push(["Signal Waist Radius(1/e^2) (m):", pm.W_sx].join(' '));
	                                lineArray.push(["Idler Waist Radius(1/e^2) (m):", pm.W_ix].join(' '));
	                                lineArray.push(["Signal/Idler Focus Position inside crystal (m):", pm.L + pm.z0s].join(' '));
	                                lineArray.push('\n');
	
	                                var tpl = {
	                                    PhaseMatch: PhaseMatch
	                                };
	
	                                if (data.type === 'heat-map') {
	
	                                    tpl.render = tplHeatMapAsCSV;
	                                    lineArray.push("x: " + data.x.label);
	                                    lineArray.push(data.x.values.join(','));
	                                    lineArray.push("y: " + data.y.label);
	                                    lineArray.push(data.y.values.join(','));
	                                    lineArray.push("Data");
	                                } else {
	
	                                    tpl.render = tplLinePlotAsCSV;
	
	                                    // ... too many datas...
	                                    var dataNew;
	                                    $.each(data.data, function (idx, series) {
	                                        if (idx === 0) {
	                                            // create an array of coordinates
	                                            // [
	                                            //      [ xval, yval ],
	                                            //      ...
	                                            // ]
	                                            dataNew = $.map(series.data, function (el) {
	                                                return [[el.x, el.y]]; // jquery is weird...
	                                            });
	                                            return;
	                                        }
	
	                                        // append series yvals
	                                        $.each(series.data, function (i, el) {
	                                            dataNew[i].push(el.y);
	                                        });
	                                    });
	                                    // add titles
	                                    var titles = $.map(data.data, function (series) {
	                                        return series.title;
	                                    });
	                                    titles.unshift(data.x.label);
	                                    dataNew.unshift(titles);
	                                    data.data = dataNew;
	                                }
	
	                                // Turn the data itself into a CSV format
	                                data.data.forEach(function (infoArray, index) {
	                                    var line = infoArray.join(",");
	                                    lineArray.push(line);
	                                });
	
	                                var csvContent = lineArray.join("\n");
	                                var encodedUri = encodeURI(csvContent);
	                                var filename = 'spdcalc_data.csv';
	                                var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	                                if (navigator.msSaveBlob) {
	                                    // IE 10+
	                                    navigator.msSaveBlob(blob, filename);
	                                } else {
	                                    var link = document.createElement("a");
	                                    if (link.download !== undefined) {
	                                        // feature detection
	                                        // Browsers that support HTML5 download attribute
	                                        var url = URL.createObjectURL(blob);
	                                        link.setAttribute("href", url);
	                                        link.setAttribute("download", filename);
	                                        link.style.visibility = 'hidden';
	                                        document.body.appendChild(link);
	                                        link.click();
	                                        document.body.removeChild(link);
	                                    }
	                                }
	
	                                // var link = document.createElement("a");
	                                // link.setAttribute("href", encodedUri);
	                                // link.setAttribute("download", "data.csv");
	                                // document.body.appendChild(link); // Required for FF
	
	                                // link.click();
	
	                                // var csv = tpl.render({
	                                //     meta: self.parameters.getAll(),
	                                //     plot: data
	                                // });
	
	                                // var ans = csv({
	                                //     meta: self.parameters.getAll(),
	                                //     plot: data
	                                // });
	
	
	                                // return;
	                                // console.log("INSIDE:", csvContent);
	
	                                // document.location = 'data:Application/octet-stream,' + window.encodeURIComponent(csvContent);
	                            }
	                        });
	                    }
	                }
	            });
	
	            self.parameters.on({
	                'refresh': function refresh(key) {
	
	                    if (!self.autocalc) {
	                        return;
	                    }
	
	                    self.emit('calculate');
	                }
	            });
	
	            self.parameters.on('refresh', function () {
	
	                this.each(function (val, key) {
	
	                    // refresh parameter values in the html
	                    var el = self.elParameters.find('[name="' + key + '"]'),
	                        unit = el.data('unit');
	
	                    if (unit) {
	                        val = converter.to(unit, val);
	                    }
	
	                    // keeps the plot options from incorrectly refreshing if
	                    // autocalc plot options is checked.
	                    if (self.elPlotOpts.find('[name="' + key + '"]').length > 0) {
	
	                        if (!self.plotOpts.get('autocalc_plotopts')) {
	                            el.val(val);
	                        }
	                    } else {
	                        el.val(val);
	                    }
	                });
	            });
	
	            //////////////////////////////////////////////
	            // collapse buttons
	            self.el.on('click', '.collapse-ctrl', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            //////////////////////////////////////////////////////////////////////////////////
	            // autocalc checkbox
	            self.el.on('change', '#autocalc', function () {
	
	                var enabled = $(this).is(':checked');
	                $('.ctrl-calc').prop('disabled', enabled);
	                self.autocalc = enabled;
	            });
	
	            //////////////////////////////////////////////////////////////////////////////////
	            // autocalc focus checkbox
	            // self.el.on('change', '#autocalfocus', function(){
	
	            //     var enabled = $(this).is(':checked');
	            //     $('#z0s').prop('disabled', !enabled);
	            //     self.autocalfocus = enabled;
	            // });
	
	            //////////////////////////////////////////////////////////////////////////////////
	            // Enable the periodic poling options
	            self.el.on('change', '#enable-calc-pp', function () {
	
	                var enabled = $(this).is(':checked');
	                $('#periodic-poling-options').find('input, textarea, button, select').prop('disabled', !enabled);
	                self.calcpp = enabled;
	            });
	
	            // calculate button
	            self.el.on('click', '.ctrl-calc', function () {
	
	                self.emit('calculate');
	            });
	
	            // parameters fields
	            self.elParameters.on('change', 'input[type="text"], select', function () {
	
	                var $this = $(this),
	                    key = $this.attr('name'),
	                    val = $this.val(),
	                    parse = $this.data('parse'),
	                    unit = $this.data('unit');
	
	                if (parse === 'float') {
	                    val = parseFloat(val);
	                } else if (parse === 'int') {
	                    val = ~~val;
	                }
	
	                if (unit) {
	                    val = converter.from(unit, val);
	                }
	
	                // update the corresponding property in the parameters object
	
	                self.parameters.set(key, val);
	            });
	
	            self.elParameters.on('change', 'input[type="checkbox"]', function () {
	                var $this = $(this),
	                    key = $this.attr('name'),
	                    val = $this.is(':checked');
	
	                // update the corresponding boolean property in the parameters object
	                self.parameters.set(key, val);
	            });
	
	            var to;
	            $(window).on('resize', function () {
	
	                if (to) {
	                    clearTimeout(to);
	                }
	
	                // wait until stopped resizing before triggering resize
	                to = setTimeout(function () {
	
	                    self.emit('resize');
	                }, 100);
	            });
	        },
	
	        initUI: function initUI() {
	
	            var self = this;
	            self.el = $(tplPMUI());
	
	            self.elMain = self.el.find('#main');
	            self.elParameters = self.el.find('#parameters');
	
	            self.elLogs = self.el.find('#logs');
	            self.elDocs = self.el.find('#docs');
	
	            // init parameters panel
	            self.elParameters.append($(tplParametersPanel(self.parameters.getAll())));
	
	            // self.elPlotOpts = self.el.find('#plot-opts');
	            self.elPlotOpts = self.elParameters.find('#plot-opts');
	
	            self.autocalc = self.elParameters.find('#autocalc').is(':checked');
	
	            self.calcpp = self.elParameters.find('enable-calc-pp').is(':checked');
	            self.autocalc = true;
	            // self.calcpp = true;
	        },
	
	        initParameters: function initParameters() {
	
	            var self = this;
	            self.parameters = Parameters();
	        },
	
	        initPlotOpts: function initPlotOpts() {
	
	            var self = this;
	
	            self.plotOpts = Panel({
	                data: {
	                    'autocalc_plotopts': true
	                }
	            });
	
	            self.elPlotOpts.html(tplPlotOpts(self.plotOpts.getAll()));
	            customCheckbox(self.elPlotOpts);
	            self.plotOpts.attachView(self.elPlotOpts);
	        },
	
	        initModules: function initModules() {
	
	            var self = this;
	
	            // JSA
	            self.set('jsa', jsaUI());
	            // JSA-HOM
	            self.set('jsa-hom', jsahomUI());
	            // Kitchen Sink
	            self.set('kitchen_sink', ksUI());
	            // XY
	            self.set('xy', xyUI());
	            // Schmidt Spectral Purity
	            self.set('schmidt-2d', schmidtUI());
	            // Mode solver view
	            self.set('modesolver', msUI());
	            // Phase matching curves view
	            self.set('curves', curvesUI());
	            // Two source hom
	            self.set('jsa-2hom', jsa2homUI());
	            // HOM bunching
	            self.set('jsa-hom-bunch', jsahomBunchUI());
	            // Coupling effiency map
	            self.set('efficiency', efficiencyUI());
	            // Heralding Efficeny for a given set of parameters
	            self.set('heralding', heraldingUI());
	            // 2D Heralding Efficeny for a given set of parameters
	            self.set('heralding2d', heralding2dUI());
	            // 1D Heralding Efficeny for a given set of parameters
	            self.set('heralding1d', heralding1dUI());
	            // 1D Heralding Efficeny for a given set of parameters. Includes Rates
	            self.set('heralding1dAdv', heralding1dUIAdv());
	            // Heralding efficiency as a function of crytal focus position
	            self.set('heraldingPumpFocusPosition', heraldingPumpFocusPosition());
	            // Testing Module
	            self.set('testing', testingUI());
	        },
	
	        /**
	         * Load a particular UI
	         * @param  {String} id The UI id
	         * @return {self}
	         */
	        load: function load(id) {
	
	            var self = this,
	                mod = self.get(id);
	
	            if (!mod) {
	                return this;
	            }
	
	            self.emit('info', 'Loading ' + id + ' module');
	
	            if (self._curr) {
	                self._curr.disconnect(self);
	            }
	
	            self._curr = mod;
	
	            // inject containers
	            self.elMain.children().detach();
	            self.elMain.append(mod.getMainPanel());
	
	            mod.connect(self);
	
	            self.elDocs.empty();
	
	            if (mod.tplDoc) {
	                self.elDocs.html(mod.tplDoc());
	            }
	
	            if (window.MathJax) {
	                window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
	            }
	
	            self.emit('resize');
	
	            return this;
	        },
	
	        /**
	         * DomReady Callback
	         * @return {void}
	         */
	        onDomReady: function onDomReady() {
	
	            var self = this;
	
	            // append the main ui elements
	            $('#pm-ui').empty().append(self.el);
	            customCheckbox(self.el);
	
	            // display type select box
	            self.el.find('#ui-modules').dropkick({
	                change: function change(value, label) {
	
	                    self.load(value);
	                }
	            });
	
	            // display Phasematch type select box
	            self.elParameters.find('select').dropkick({
	                change: function change(value, label) {
	
	                    var $this = $(this),
	                        key = $this.attr('name'),
	                        parse = $this.data('parse');
	
	                    if (parse === 'float') {
	                        value = parseFloat(value);
	                    }
	                    // update the corresponding property in the parameters object
	                    self.parameters.set(key, value);
	                }
	            });
	
	            self.el.on('click', '.ctrl-share', function (e) {
	                e.preventDefault();
	
	                var url = window.location.origin + window.location.pathname + '#' + self.parameters.serialize();
	
	                $('#share-url').val(url).show().focus().select();
	            });
	
	            $(window).on('click', function (e) {
	
	                var tgt = $(e.target);
	
	                // close all dropdowns on body click
	                $('.dk_open').removeClass('dk_open');
	
	                // if ( ! $(e.target).is('#share-url, .ctrl-share') ){
	                //     $('#share-url').hide();
	                //     // $('#share-url').show();
	                // }
	            });
	
	            //////////////////////////////////////////////////////
	            // Setup the tooltips
	            //
	            $.each(config.tooltips, function (label, html) {
	
	                self.elParameters.find('label.' + label).tooltip({
	                    title: html,
	                    html: true,
	                    placement: 'top'
	                });
	            });
	
	            self.emit('ready');
	        }
	
	    });
	
	    return new Mediator();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(308), __webpack_require__(441)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, PhaseMatch, Hash) {
	
	    'use strict';
	
	    var debounce = function debounce(fn, delay, ctx) {
	
	        var to, ret;
	
	        delay = delay || 100;
	        ctx = ctx || this;
	
	        return function () {
	
	            clearTimeout(to);
	
	            var args = Array.prototype.slice.call(arguments);
	
	            to = setTimeout(function () {
	
	                ret = fn.apply(ctx, args);
	            }, 100);
	
	            return ret;
	        };
	    };
	
	    var con = PhaseMatch.constants;
	    var defaults = {};
	
	    var types = {
	        'number': '+',
	        'boolean': '!',
	        'string': '~'
	    };
	    var typesVals = ['+', '!', '~'];
	
	    /**
	     * @module Parameters
	     * @implements {Stapes}
	     */
	    var Parameters = Stapes.subclass({
	
	        /**
	         * Mediator Constructor
	         * @return {void}
	         */
	        constructor: function constructor() {
	
	            var self = this;
	
	            // setup props
	            self.props = new PhaseMatch.SPDCprop(self.getHashVals());
	
	            self.initEvents();
	
	            self.checkautocalc();
	            self.set(self.props.get());
	
	            // this ensures that .refresh() calls
	            // get throttled so they don't do double refreshes
	
	            self.refresh = debounce(self.refresh, 100, self);
	            self.checkautocalc = debounce(self.checkautocalc, 100, self);
	        },
	
	        initEvents: function initEvents() {
	
	            var self = this;
	
	            self.on({
	
	                'change': function change(key) {
	
	                    var val = self.get(key);
	                    self.props.set(key, val);
	
	                    if (key === 'theta_s_e') {
	                        var theta_s = PhaseMatch.find_internal_angle(self.props, "signal");
	                        // console.log("theta_s int", theta_s*180/Math.PI);
	                        self.props.set("theta_s", theta_s);
	                        // self.props.update_all_angles();
	                        // set the internal idler angle
	                        console.log("setting internal signal:", theta_s * 180 / Math.PI);
	                        self.props.optimum_idler();
	                        console.log("setting internal idler 1:", self.props.theta_i * 180 / Math.PI);
	                        // self.props.optimum_idler();
	                        // console.log("setting internal idler 2:", self.props.theta_i *180/Math.PI);
	                        // // set the external idler angle
	                        // var theta_i_e = PhaseMatch.find_external_angle(self.props,"idler");
	                        // console.log("setting intnerna signal:", theta_s *180/Math.PI);
	                        // console.log("setting internal idler:", self.props.theta_i *180/Math.PI);
	
	                        // self.props.set("theta_i_e", theta_i_e);
	                    }
	                    if (key === 'theta_i_e') {
	                        var theta_i = PhaseMatch.find_internal_angle(self.props, "idler");
	                        // console.log("theta_s int", val);
	                        self.props.set("theta_i", theta_i);
	                    }
	
	                    self.checkautocalc();
	                    self.refresh();
	                }
	            });
	        },
	
	        getHashVals: function getHashVals() {
	
	            var self = this,
	                vals = Hash.get(),
	                key,
	                val,
	                tp,
	                obj = {};
	
	            for (key in vals) {
	
	                val = vals[key];
	                tp = val && val.substr(0, 1);
	
	                if (val && $.inArray(tp, typesVals) > -1) {
	
	                    val = val.substr(1);
	
	                    switch (tp) {
	                        case '+':
	                            val = parseFloat(val);
	                            break;
	                        case '!':
	                            val = val === 'true';
	                            break;
	                    }
	
	                    obj[key] = val;
	                }
	            }
	
	            return obj;
	        },
	
	        serialize: function serialize() {
	
	            var self = this,
	                ser = '',
	                key,
	                val,
	                props = self.props.get(),
	                tp,
	                pfx;
	
	            for (key in props) {
	
	                val = props[key];
	                tp = typeof val === 'undefined' ? 'undefined' : _typeof(val);
	                pfx = types[tp];
	
	                if (pfx && val !== null && val !== '') {
	                    ser += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(pfx + val);
	                }
	            }
	
	            return ser.substr(1);
	        },
	
	        checkautocalc: function checkautocalc() {
	
	            var self = this;
	
	            if (self.props.autocalctheta) {
	                self.props.auto_calc_Theta(self.props);
	            }
	
	            if (self.props.autocalcpp) {
	                self.props.calc_poling_period(self.props);
	                // console.log("poling period: ", self.props.poling_period);
	            }
	
	            if (self.props.autocalfocus) {
	                self.props.auto_calc_collection_focus(self.props);
	                // console.log("poling period: ", self.props.poling_period);
	            }
	        },
	
	        // resync all values in the original self.props object
	        // into the wrapper
	        refresh: function refresh() {
	
	            var self = this,
	                vals = self.props.get();
	
	            for (var key in vals) {
	
	                // true is for "quiet". Don't trigger change events
	                self.set(key, vals[key], true);
	            }
	
	            // emit a final refresh event
	            self.emit('refresh');
	        },
	
	        getProps: function getProps() {
	
	            var self = this;
	            return self.props;
	        }
	    });
	
	    return function (cfg) {
	
	        return new Parameters(cfg);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(305);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(306);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v2.2.4
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-05-20T17:23Z
	 */
	
	(function( global, factory ) {
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Support: Firefox 18+
	// Can't be in strict mode, several libs including ASP.NET trace
	// the stack via arguments.caller.callee and Firefox dies if
	// you try to trace through "use strict" call chains. (#13335)
	//"use strict";
	var arr = [];
	
	var document = window.document;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var support = {};
	
	
	
	var
		version = "2.2.4",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android<4.1
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([\da-z])/gi,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// Start with an empty selector
		selector: "",
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
			return num != null ?
	
				// Return just the one element from the set
				( num < 0 ? this[ num + this.length ] : this[ num ] ) :
	
				// Return all the elements in a clean array
				slice.call( this );
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
			ret.context = this.context;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// parseFloat NaNs numeric-cast false positives (null|true|false|"")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			// adding 1 corrects loss of precision from parseFloat (#15100)
			var realStringObj = obj && obj.toString();
			return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
		},
	
		isPlainObject: function( obj ) {
			var key;
	
			// Not plain objects:
			// - Any object or value whose internal [[Class]] property is not "[object Object]"
			// - DOM nodes
			// - window
			if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
				return false;
			}
	
			// Not own constructor property must be Object
			if ( obj.constructor &&
					!hasOwn.call( obj, "constructor" ) &&
					!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
				return false;
			}
	
			// Own properties are enumerated firstly, so to speed up,
			// if last one is own, then all properties are own
			for ( key in obj ) {}
	
			return key === undefined || hasOwn.call( obj, key );
		},
	
		isEmptyObject: function( obj ) {
			var name;
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android<4.0, iOS<6 (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			var script,
				indirect = eval;
	
			code = jQuery.trim( code );
	
			if ( code ) {
	
				// If the code includes a valid, prologue position
				// strict mode pragma, execute code by injecting a
				// script tag into the document.
				if ( code.indexOf( "use strict" ) === 1 ) {
					script = document.createElement( "script" );
					script.text = code;
					document.head.appendChild( script ).parentNode.removeChild( script );
				} else {
	
					// Otherwise, avoid the DOM node creation, insertion
					// and removal by using an indirect global eval
	
					indirect( code );
				}
			}
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE9-11+
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android<4.1
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	// JSHint would error on this code due to the Symbol not being defined in ES5.
	// Defining this global in .jshintrc would create a danger of using the global
	// unguarded in another place, it seems safer to just disable JSHint for these
	// three lines.
	/* jshint ignore: start */
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	/* jshint ignore: end */
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: iOS 8.2 (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.2.1
	 * http://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2015-10-17
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// General-purpose constants
		MAX_NEGATIVE = 1 << 31,
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// http://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
		rescape = /'|\\/g,
	
		// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		};
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, nidselect, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rescape, "\\$&" );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
						while ( i-- ) {
							groups[i] = nidselect + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created div and expects a boolean result
	 */
	function assert( fn ) {
		var div = document.createElement("div");
	
		try {
			return !!fn( div );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( div.parentNode ) {
				div.parentNode.removeChild( div );
			}
			// release memory in IE
			div = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				( ~b.sourceIndex || MAX_NEGATIVE ) -
				( ~a.sourceIndex || MAX_NEGATIVE );
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, parent,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( (parent = document.defaultView) && parent.top !== parent ) {
			// Support: IE 11
			if ( parent.addEventListener ) {
				parent.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( parent.attachEvent ) {
				parent.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( div ) {
			div.className = "i";
			return !div.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( div ) {
			div.appendChild( document.createComment("") );
			return !div.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( div ) {
			docElem.appendChild( div ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID find and filter
		if ( support.getById ) {
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var m = context.getElementById( id );
					return m ? [ m ] : [];
				}
			};
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
		} else {
			// Support: IE6/7
			// getElementById is not reliable as a find shortcut
			delete Expr.find["ID"];
	
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See http://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( div ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// http://bugs.jquery.com/ticket/12359
				docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( div.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !div.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibing-combinator selector` fails
				if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( div ) {
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				div.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( div.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( !div.querySelectorAll(":enabled").length ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				div.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( div ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( div, "div" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( div, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": function( elem ) {
				return elem.disabled === false;
			},
	
			"disabled": function( elem ) {
				return elem.disabled === true;
			},
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			checkNonElements = base && dir === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( (oldCache = uniqueCache[ dir ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ dir ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					support.getById && context.nodeType === 9 && documentIsHTML &&
					Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( div1 ) {
		// Should return 1, but returns 4 (following)
		return div1.compareDocumentPosition( document.createElement("div") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( div ) {
		div.innerHTML = "<a href='#'></a>";
		return div.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( div ) {
		div.innerHTML = "<input/>";
		div.firstChild.setAttribute( "value", "" );
		return div.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( div ) {
		return div.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				/* jshint -W018 */
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
	
		}
	
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
	
		}
	
		if ( typeof qualifier === "string" ) {
			if ( risSimple.test( qualifier ) ) {
				return jQuery.filter( qualifier, elements, not );
			}
	
			qualifier = jQuery.filter( qualifier, elements );
		}
	
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		return elems.length === 1 && elem.nodeType === 1 ?
			jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
			jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
				return elem.nodeType === 1;
			} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i,
				len = this.length,
				ret = [],
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			// Needed because $( selector, context ) becomes $( context ).find( selector )
			ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
			ret.selector = this.selector ? this.selector + " " + selector : selector;
			return ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						// Support: Blackberry 4.6
						// gEBID returns nodes no longer in the document (#6963)
						if ( elem && elem.parentNode ) {
	
							// Inject the element directly into the jQuery object
							this.length = 1;
							this[ 0 ] = elem;
						}
	
						this.context = document;
						this.selector = selector;
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this.context = this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			if ( selector.selector !== undefined ) {
				this.selector = selector.selector;
				this.context = selector.context;
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
					jQuery( selectors, context || this.context ) :
					0;
	
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
					// Always skip document fragments
					if ( cur.nodeType < 11 && ( pos ?
						pos.index( cur ) > -1 :
	
						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
						matched.push( cur );
						break;
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnotwhite = ( /\S+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, listener list, final state
					[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
					[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					then: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
								var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
	
								// deferred[ done | fail | progress ] for forwarding actions to newDefer
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this === promise ? newDefer.promise() : this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Keep pipe for back-compat
			promise.pipe = promise.then;
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 3 ];
	
				// promise[ done | fail | progress ] = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add( function() {
	
						// state = [ resolved | rejected ]
						state = stateString;
	
					// [ reject_list | resolve_list ].disable; progress_list.lock
					}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
				}
	
				// deferred[ resolve | reject | notify ]
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
					return this;
				};
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( subordinate /* , ..., subordinateN */ ) {
			var i = 0,
				resolveValues = slice.call( arguments ),
				length = resolveValues.length,
	
				// the count of uncompleted subordinates
				remaining = length !== 1 ||
					( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
				// the master Deferred.
				// If resolveValues consist of only a single Deferred, just use that.
				deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
				// Update function for both resolve and progress values
				updateFunc = function( i, contexts, values ) {
					return function( value ) {
						contexts[ i ] = this;
						values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( values === progressValues ) {
							deferred.notifyWith( contexts, values );
						} else if ( !( --remaining ) ) {
							deferred.resolveWith( contexts, values );
						}
					};
				},
	
				progressValues, progressContexts, resolveContexts;
	
			// Add listeners to Deferred subordinates; treat others as resolved
			if ( length > 1 ) {
				progressValues = new Array( length );
				progressContexts = new Array( length );
				resolveContexts = new Array( length );
				for ( ; i < length; i++ ) {
					if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
						resolveValues[ i ].promise()
							.progress( updateFunc( i, progressContexts, progressValues ) )
							.done( updateFunc( i, resolveContexts, resolveValues ) )
							.fail( deferred.reject );
					} else {
						--remaining;
					}
				}
			}
	
			// If we're not waiting on anything, resolve the master
			if ( !remaining ) {
				deferred.resolveWith( resolveContexts, resolveValues );
			}
	
			return deferred.promise();
		}
	} );
	
	
	// The deferred used on DOM ready
	var readyList;
	
	jQuery.fn.ready = function( fn ) {
	
		// Add the callback
		jQuery.ready.promise().done( fn );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
	
			// Trigger any bound ready events
			if ( jQuery.fn.triggerHandler ) {
				jQuery( document ).triggerHandler( "ready" );
				jQuery( document ).off( "ready" );
			}
		}
	} );
	
	/**
	 * The ready event handler and self cleanup method
	 */
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	jQuery.ready.promise = function( obj ) {
		if ( !readyList ) {
	
			readyList = jQuery.Deferred();
	
			// Catch cases where $(document).ready() is called
			// after the browser event has already occurred.
			// Support: IE9-10 only
			// Older IE sometimes signals "interactive" too soon
			if ( document.readyState === "complete" ||
				( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
				// Handle it asynchronously to allow scripts the opportunity to delay ready
				window.setTimeout( jQuery.ready );
	
			} else {
	
				// Use the handy event callback
				document.addEventListener( "DOMContentLoaded", completed );
	
				// A fallback to window.onload, that will always work
				window.addEventListener( "load", completed );
			}
		}
		return readyList.promise( obj );
	};
	
	// Kick off the DOM ready check even if the user does not
	jQuery.ready.promise();
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		return chainable ?
			elems :
	
			// Gets
			bulk ?
				fn.call( elems ) :
				len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		/* jshint -W018 */
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		register: function( owner, initial ) {
			var value = initial || {};
	
			// If it is a node unlikely to be stringify-ed or looped over
			// use plain assignment
			if ( owner.nodeType ) {
				owner[ this.expando ] = value;
	
			// Otherwise secure it in a non-enumerable, non-writable property
			// configurability must be true to allow the property to be
			// deleted with the delete operator
			} else {
				Object.defineProperty( owner, this.expando, {
					value: value,
					writable: true,
					configurable: true
				} );
			}
			return owner[ this.expando ];
		},
		cache: function( owner ) {
	
			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( !acceptData( owner ) ) {
				return {};
			}
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			if ( typeof data === "string" ) {
				cache[ data ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
				owner[ this.expando ] && owner[ this.expando ][ key ];
		},
		access: function( owner, key, value ) {
			var stored;
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				stored = this.get( owner, key );
	
				return stored !== undefined ?
					stored : this.get( owner, jQuery.camelCase( key ) );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i, name, camel,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key === undefined ) {
				this.register( owner );
	
			} else {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If "name" is an array of keys...
					// When data is initially created, via ("key", "val") signature,
					// keys will be converted to camelCase.
					// Since there is no way to tell _how_ a key was added, remove
					// both plain key and camelCase key. #12786
					// This will only penalize the array argument path.
					name = key.concat( key.map( jQuery.camelCase ) );
				} else {
					camel = jQuery.camelCase( key );
	
					// Try the string as a key before any manipulation
					if ( key in cache ) {
						name = [ key, camel ];
					} else {
	
						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						name = camel;
						name = name in cache ?
							[ name ] : ( name.match( rnotwhite ) || [] );
					}
				}
	
				i = name.length;
	
				while ( i-- ) {
					delete cache[ name[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <= 35-45+
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://code.google.com/p/chromium/issues/detail?id=378607
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = data === "true" ? true :
						data === "false" ? false :
						data === "null" ? null :
	
						// Only convert to a number if it doesn't change the string
						+data + "" === data ? +data :
						rbrace.test( data ) ? jQuery.parseJSON( data ) :
						data;
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE11+
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data, camelKey;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// with the key as-is
					data = dataUser.get( elem, key ) ||
	
						// Try to find dashed key if it exists (gh-2779)
						// This is for 2.2.x only
						dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );
	
					if ( data !== undefined ) {
						return data;
					}
	
					camelKey = jQuery.camelCase( key );
	
					// Attempt to get data from the cache
					// with the key camelized
					data = dataUser.get( elem, camelKey );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, camelKey, undefined );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				camelKey = jQuery.camelCase( key );
				this.each( function() {
	
					// First, attempt to store a copy or reference of any
					// data that might've been store with a camelCased key.
					var data = dataUser.get( this, camelKey );
	
					// For HTML5 data-* attribute interop, we have to
					// store property names with dashes in a camelCase form.
					// This might not apply to all properties...*
					dataUser.set( this, camelKey, value );
	
					// *... In the case of properties that might _actually_
					// have dashes, we need to also store a copy of that
					// unchanged property.
					if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
						dataUser.set( this, key, value );
					}
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHidden = function( elem, el ) {
	
			// isHidden might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
			return jQuery.css( elem, "display" ) === "none" ||
				!jQuery.contains( elem.ownerDocument, elem );
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() { return tween.cur(); } :
				function() { return jQuery.css( elem, prop, "" ); },
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([\w:-]+)/ );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE9
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE9-11+
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret = typeof context.getElementsByTagName !== "undefined" ?
				context.getElementsByTagName( tag || "*" ) :
				typeof context.querySelectorAll !== "undefined" ?
					context.querySelectorAll( tag || "*" ) :
				[];
	
		return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
			jQuery.merge( [ context ], ret ) :
			ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android<4.1, PhantomJS<2
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0-4.3, Safari<=5.1
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Safari<=5.1, Android<4.2
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE<=11+
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE9
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnotwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( event ) {
	
			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( event );
	
			var i, j, ret, matched, handleObj,
				handlerQueue = [],
				args = slice.call( arguments ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, matches, sel, handleObj,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Support (at least): Chrome, IE9
			// Find delegate handlers
			// Black-hole SVG <use> instance trees (#13180)
			//
			// Support: Firefox<=42+
			// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
			if ( delegateCount && cur.nodeType &&
				( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
						matches = [];
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matches[ sel ] === undefined ) {
								matches[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matches[ sel ] ) {
								matches.push( handleObj );
							}
						}
						if ( matches.length ) {
							handlerQueue.push( { elem: cur, handlers: matches } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		// Includes some event props shared by KeyEvent and MouseEvent
		props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
			"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),
	
		fixHooks: {},
	
		keyHooks: {
			props: "char charCode key keyCode".split( " " ),
			filter: function( event, original ) {
	
				// Add which for key events
				if ( event.which == null ) {
					event.which = original.charCode != null ? original.charCode : original.keyCode;
				}
	
				return event;
			}
		},
	
		mouseHooks: {
			props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
				"screenX screenY toElement" ).split( " " ),
			filter: function( event, original ) {
				var eventDoc, doc, body,
					button = original.button;
	
				// Calculate pageX/Y if missing and clientX/Y available
				if ( event.pageX == null && original.clientX != null ) {
					eventDoc = event.target.ownerDocument || document;
					doc = eventDoc.documentElement;
					body = eventDoc.body;
	
					event.pageX = original.clientX +
						( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
						( doc && doc.clientLeft || body && body.clientLeft || 0 );
					event.pageY = original.clientY +
						( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
						( doc && doc.clientTop  || body && body.clientTop  || 0 );
				}
	
				// Add which for click: 1 === left; 2 === middle; 3 === right
				// Note: button is not normalized, so don't use it
				if ( !event.which && button !== undefined ) {
					event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
				}
	
				return event;
			}
		},
	
		fix: function( event ) {
			if ( event[ jQuery.expando ] ) {
				return event;
			}
	
			// Create a writable copy of the event object and normalize some properties
			var i, prop, copy,
				type = event.type,
				originalEvent = event,
				fixHook = this.fixHooks[ type ];
	
			if ( !fixHook ) {
				this.fixHooks[ type ] = fixHook =
					rmouseEvent.test( type ) ? this.mouseHooks :
					rkeyEvent.test( type ) ? this.keyHooks :
					{};
			}
			copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
			event = new jQuery.Event( originalEvent );
	
			i = copy.length;
			while ( i-- ) {
				prop = copy[ i ];
				event[ prop ] = originalEvent[ prop ];
			}
	
			// Support: Cordova 2.5 (WebKit) (#13255)
			// All events should have a target; Cordova deviceready doesn't
			if ( !event.target ) {
				event.target = document;
			}
	
			// Support: Safari 6.0+, Chrome<28
			// Target should not be a text node (#504, #13143)
			if ( event.target.nodeType === 3 ) {
				event.target = event.target.parentNode;
			}
	
			return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android<4.0
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://code.google.com/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,
	
		// Support: IE 10-11, Edge 10240+
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Manipulating tables requires a tbody
	function manipulationTarget( elem, content ) {
		return jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?
	
			elem.getElementsByTagName( "tbody" )[ 0 ] ||
				elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
			elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android<4.1, PhantomJS<2
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <= 35-45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
	
		// Keep domManip exposed until 3.0 (gh-2225)
		domManip: domManip,
	
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: QtWebKit
				// .get() because push.apply(_, arraylike) throws
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	
	var iframe,
		elemdisplay = {
	
			// Support: Firefox
			// We have to pre-define these values for FF (#10227)
			HTML: "block",
			BODY: "block"
		};
	
	/**
	 * Retrieve the actual display of a element
	 * @param {String} name nodeName of the element
	 * @param {Object} doc Document object
	 */
	
	// Called only from within defaultDisplay
	function actualDisplay( name, doc ) {
		var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),
	
			display = jQuery.css( elem[ 0 ], "display" );
	
		// We don't have any data stored on the element,
		// so use "detach" method as fast way to get rid of the element
		elem.detach();
	
		return display;
	}
	
	/**
	 * Try to determine the default display value of an element
	 * @param {String} nodeName
	 */
	function defaultDisplay( nodeName ) {
		var doc = document,
			display = elemdisplay[ nodeName ];
	
		if ( !display ) {
			display = actualDisplay( nodeName, doc );
	
			// If the simple way fails, read from inside an iframe
			if ( display === "none" || !display ) {
	
				// Use the already-created iframe if possible
				iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
					.appendTo( doc.documentElement );
	
				// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
				doc = iframe[ 0 ].contentDocument;
	
				// Support: IE
				doc.write();
				doc.close();
	
				display = actualDisplay( nodeName, doc );
				iframe.detach();
			}
	
			// Store the correct default display
			elemdisplay[ nodeName ] = display;
		}
	
		return display;
	}
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var documentElement = document.documentElement;
	
	
	
	( function() {
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE9-11+
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
			div.style.cssText =
	
				// Support: Firefox<29, Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
		}
	
		jQuery.extend( support, {
			pixelPosition: function() {
	
				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
	
				// Support: Android 4.0-4.3
				// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
				// since that compresses better and they're computed together anyway.
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
	
				// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
				if ( boxSizingReliableVal == null ) {
					computeStyleTests();
				}
				return reliableMarginLeftVal;
			},
			reliableMarginRight: function() {
	
				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );
	
				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
	
					// Support: Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;box-sizing:content-box;" +
					"display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				documentElement.appendChild( container );
	
				ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );
	
				documentElement.removeChild( container );
				div.removeChild( marginDiv );
	
				return ret;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
		ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;
	
		// Support: Opera 12.1x only
		// Fall back to style even without computed
		// computed is undefined for elems on document fragments
		if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}
	
		// Support: IE9
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// http://dev.w3.org/csswg/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE9-11+
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i = extra === ( isBorderBox ? "border" : "content" ) ?
	
			// If we already have the right measurement, avoid augmentation
			4 :
	
			// Otherwise initialize for horizontal or vertical properties
			name === "width" ? 1 : 0,
	
			val = 0;
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var valueIsBorderBox = true,
			val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	function showHide( elements, show ) {
		var display, elem, hidden,
			values = [],
			index = 0,
			length = elements.length;
	
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			values[ index ] = dataPriv.get( elem, "olddisplay" );
			display = elem.style.display;
			if ( show ) {
	
				// Reset the inline display of this element to learn if it is
				// being hidden by cascaded rules or not
				if ( !values[ index ] && display === "none" ) {
					elem.style.display = "";
				}
	
				// Set elements which have been overridden with display: none
				// in a stylesheet to whatever the default browser style is
				// for such an element
				if ( elem.style.display === "" && isHidden( elem ) ) {
					values[ index ] = dataPriv.access(
						elem,
						"olddisplay",
						defaultDisplay( elem.nodeName )
					);
				}
			} else {
				hidden = isHidden( elem );
	
				if ( display !== "none" || !hidden ) {
					dataPriv.set(
						elem,
						"olddisplay",
						hidden ? display : jQuery.css( elem, "display" )
					);
				}
			}
		}
	
		// Set the display of most of the elements in a second loop
		// to avoid the constant reflow
		for ( index = 0; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
			if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
				elem.style.display = show ? values[ index ] || "" : "none";
			}
		}
	
		return elements;
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// Support: IE9-11+
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
						elem.offsetWidth === 0 ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// Support: Android 2.3
	jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
		function( elem, computed ) {
			if ( computed ) {
				return swap( elem, { "display": "inline-block" },
					curCSS, [ elem, "marginRight" ] );
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		},
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHidden( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE9
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4 ; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		/* jshint validthis: true */
		var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHidden( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Handle queue: false promises
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Height/width overflow pass
		if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	
			// Make sure that nothing sneaks out
			// Record all 3 overflow attributes because IE9-10 do not
			// change the overflow attribute when overflowX and
			// overflowY are set to the same value
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Set display property to inline-block for height/width
			// animations on inline elements that are having width/height animated
			display = jQuery.css( elem, "display" );
	
			// Test default display if display is currently "none"
			checkDisplay = display === "none" ?
				dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;
	
			if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
				style.display = "inline-block";
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// show/hide pass
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.exec( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// If there is dataShow left over from a stopped hide or show
					// and we are going to proceed with show, we should pretend to be hidden
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
	
			// Any non-fx value stops us from restoring the original display value
			} else {
				display = undefined;
			}
		}
	
		if ( !jQuery.isEmptyObject( orig ) ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", {} );
			}
	
			// Store state if its toggle - enables .stop().toggle() to "reverse"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}
			if ( hidden ) {
				jQuery( elem ).show();
			} else {
				anim.done( function() {
					jQuery( elem ).hide();
				} );
			}
			anim.done( function() {
				var prop;
	
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
			for ( prop in orig ) {
				tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
	
				if ( !( prop in dataShow ) ) {
					dataShow[ prop ] = tween.start;
					if ( hidden ) {
						tween.end = tween.start;
						tween.start = prop === "width" || prop === "height" ? 1 : 0;
					}
				}
			}
	
		// If this is a noop like .hide().hide(), restore an overwritten display value
		} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
			style.display = display;
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length ; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length ; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnotwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length ; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
			opt.duration : opt.duration in jQuery.fx.speeds ?
				jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHidden ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		window.clearInterval( timerId );
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: iOS<=5.1, Android<=4.2+
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE<=11+
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: Android<=2.3
		// Options inside disabled selects are incorrectly marked as disabled
		select.disabled = true;
		support.optDisabled = !opt.disabled;
	
		// Support: IE<=11+
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// All attributes are lowercase
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				name = name.toLowerCase();
				hooks = jQuery.attrHooks[ name ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name, propName,
				i = 0,
				attrNames = value && value.match( rnotwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					propName = jQuery.propFix[ name ] || name;
	
					// Boolean attributes get special treatment (#10870)
					if ( jQuery.expr.match.bool.test( name ) ) {
	
						// Set corresponding property to false
						elem[ propName ] = false;
					}
	
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle;
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ name ];
				attrHandle[ name ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					name.toLowerCase() :
					null;
				attrHandle[ name ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					return tabindex ?
						parseInt( tabindex, 10 ) :
						rfocusable.test( elem.nodeName ) ||
							rclickable.test( elem.nodeName ) && elem.href ?
								0 :
								-1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
	var rclass = /[\t\r\n\f]/g;
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnotwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 &&
						( " " + curValue + " " ).replace( rclass, " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = jQuery.trim( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnotwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + getClass( elem ) + " " ).replace( rclass, " " )
						.indexOf( className ) > -1
				) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g,
		rspaces = /[\x20\t\r\n\f]+/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					return typeof ret === "string" ?
	
						// Handle most common string cases
						ret.replace( rreturn, "" ) :
	
						// Handle cases where value is null/undef or number
						ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE10-11+
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
				}
			},
			select: {
				get: function( elem ) {
					var value, option,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one" || index < 0,
						values = one ? null : [],
						max = one ? index + 1 : options.length,
						i = index < 0 ?
							max :
							one ? index : 0;
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								( support.optDisabled ?
									!option.disabled : option.getAttribute( "disabled" ) === null ) &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome, Safari
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Support: Android 2.3
	// Workaround failure to string-cast null input
	jQuery.parseJSON = function( data ) {
		return JSON.parse( data + "" );
	};
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE9
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rhash = /#.*$/,
		rts = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
			// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": jQuery.parseJSON,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// The jqXHR state
				state = 0,
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( state === 2 ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return state === 2 ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						var lname = name.toLowerCase();
						if ( !state ) {
							name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( !state ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( state < 2 ) {
								for ( code in map ) {
	
									// Lazy-add the new callback in a way that preserves old ones
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							} else {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR ).complete = completeDeferred.add;
			jqXHR.success = jqXHR.done;
			jqXHR.error = jqXHR.fail;
	
			// Remove hash character (#7531: and string promotion)
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE8-11+
				// IE throws exception if url is malformed, e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE8-11+
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( state === 2 ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			cacheURL = s.url;
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add anti-cache in url if needed
				if ( s.cache === false ) {
					s.url = rts.test( cacheURL ) ?
	
						// If there is already a '_' parameter, set its value
						cacheURL.replace( rts, "$1_=" + nonce++ ) :
	
						// Otherwise add one to the end
						cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
				}
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			for ( i in { success: 1, error: 1, complete: 1 } ) {
				jqXHR[ i ]( s[ i ] );
			}
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( state === 2 ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					state = 1;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Propagate exception as error if not done
					if ( state < 2 ) {
						done( -1, e );
	
					// Simply rethrow otherwise
					} else {
						throw e;
					}
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Called once
				if ( state === 2 ) {
					return;
				}
	
				// State is "done" now
				state = 2;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapAll( html.call( this, i ) );
				} );
			}
	
			if ( this[ 0 ] ) {
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function() {
			return this.parent().each( function() {
				if ( !jQuery.nodeName( this, "body" ) ) {
					jQuery( this ).replaceWith( this.childNodes );
				}
			} ).end();
		}
	} );
	
	
	jQuery.expr.filters.hidden = function( elem ) {
		return !jQuery.expr.filters.visible( elem );
	};
	jQuery.expr.filters.visible = function( elem ) {
	
		// Support: Opera <= 12.12
		// Opera reports offsetWidths and offsetHeights less than zero on some elements
		// Use OR instead of AND as the element is not visible if either is true
		// See tickets #10406 and #13132
		return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
	};
	
	
	
	
	var r20 = /%20/g,
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, value ) {
	
				// If value is a function, invoke it and return its value
				value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
				s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
			};
	
		// Set traditional to true for jQuery <= 1.3.2 behavior.
		if ( traditional === undefined ) {
			traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" ).replace( r20, "+" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				return val == null ?
					null :
					jQuery.isArray( val ) ?
						jQuery.map( val, function( val ) {
							return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
						} ) :
						{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE9
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE9
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE9
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( !data || typeof data !== "string" ) {
			return null;
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
		context = context || document;
	
		var parsed = rsingleTag.exec( data ),
			scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	// Keep a copy of the old load method
	var _load = jQuery.fn.load;
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		if ( typeof url !== "string" && _load ) {
			return _load.apply( this, arguments );
		}
	
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = jQuery.trim( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.filters.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win,
				elem = this[ 0 ],
				box = { top: 0, left: 0 },
				doc = elem && elem.ownerDocument;
	
			if ( !doc ) {
				return;
			}
	
			docElem = doc.documentElement;
	
			// Make sure it's not a disconnected DOM node
			if ( !jQuery.contains( docElem, elem ) ) {
				return box;
			}
	
			box = elem.getBoundingClientRect();
			win = getWindow( doc );
			return {
				top: box.top + win.pageYOffset - docElem.clientTop,
				left: box.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari<7-8+, Chrome<37-44+
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
						// isn't a whole lot we can do. See pull request at this URL for discussion:
						// https://github.com/jquery/jquery/pull/764
						return elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable, null );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
		size: function() {
			return this.length;
		}
	} );
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	return jQuery;
	}));


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	//
	//  ____  _                           _
	// / ___|| |_ __ _ _ __   ___  ___   (_)___  (*)
	// \___ \| __/ _` | '_ \ / _ \/ __|  | / __|
	//  ___) | || (_| | |_) |  __/\__ \_ | \__ \
	// |____/ \__\__,_| .__/ \___||___(_)/ |___/
	//              |_|              |__/
	//
	// (*) the Javascript MVC microframework that does just enough
	//
	// (c) Hay Kranen < hay@bykr.org >
	// Released under the terms of the MIT license
	// < http://en.wikipedia.org/wiki/MIT_License >
	//
	// Stapes.js : http://hay.github.com/stapes
	;(function() {
	    'use strict';
	
	    var VERSION = "1.0.0";
	
	    // Global counter for all events in all modules (including mixed in objects)
	    var guid = 1;
	
	    // Makes _.create() faster
	    if (!Object.create) {
	        var CachedFunction = function(){};
	    }
	
	    // So we can use slice.call for arguments later on
	    var slice = Array.prototype.slice;
	
	    // Private attributes and helper functions, stored in an object so they
	    // are overwritable by plugins
	    var _ = {
	        // Properties
	        attributes : {},
	
	        eventHandlers : {
	            "-1" : {} // '-1' is used for the global event handling
	        },
	
	        guid : -1,
	
	        // Methods
	        addEvent : function(event) {
	            // If we don't have any handlers for this type of event, add a new
	            // array we can use to push new handlers
	            if (!_.eventHandlers[event.guid][event.type]) {
	                _.eventHandlers[event.guid][event.type] = [];
	            }
	
	            // Push an event object
	            _.eventHandlers[event.guid][event.type].push({
	                "guid" : event.guid,
	                "handler" : event.handler,
	                "scope" : event.scope,
	                "type" : event.type
	            });
	        },
	
	        addEventHandler : function(argTypeOrMap, argHandlerOrScope, argScope) {
	            var eventMap = {},
	                scope;
	
	            if (typeof argTypeOrMap === "string") {
	                scope = argScope || false;
	                eventMap[ argTypeOrMap ] = argHandlerOrScope;
	            } else {
	                scope = argHandlerOrScope || false;
	                eventMap = argTypeOrMap;
	            }
	
	            for (var eventString in eventMap) {
	                var handler = eventMap[eventString];
	                var events = eventString.split(" ");
	
	                for (var i = 0, l = events.length; i < l; i++) {
	                    var eventType = events[i];
	                    _.addEvent.call(this, {
	                        "guid" : this._guid || this._.guid,
	                        "handler" : handler,
	                        "scope" : scope,
	                        "type" : eventType
	                    });
	                }
	            }
	        },
	
	        addGuid : function(object, forceGuid) {
	            if (object._guid && !forceGuid) return;
	
	            object._guid = guid++;
	
	            _.attributes[object._guid] = {};
	            _.eventHandlers[object._guid] = {};
	        },
	
	        // This is a really small utility function to save typing and produce
	        // better optimized code
	        attr : function(guid) {
	            return _.attributes[guid];
	        },
	
	        clone : function(obj) {
	            var type = _.typeOf(obj);
	
	            if (type === 'object') {
	                return _.extend({}, obj);
	            }
	
	            if (type === 'array') {
	                return obj.slice(0);
	            }
	        },
	
	        create : function(proto) {
	            if (Object.create) {
	                return Object.create(proto);
	            } else {
	                CachedFunction.prototype = proto;
	                return new CachedFunction();
	            }
	        },
	
	        createSubclass : function(props, includeEvents) {
	            props = props || {};
	            includeEvents = includeEvents || false;
	
	            var superclass = props.superclass.prototype;
	
	            // Objects always have a constructor, so we need to be sure this is
	            // a property instead of something from the prototype
	            var realConstructor = props.hasOwnProperty('constructor') ? props.constructor : function(){};
	
	            function constructor() {
	                // Be kind to people forgetting new
	                if (!(this instanceof constructor)) {
	                    throw new Error("Please use 'new' when initializing Stapes classes");
	                }
	
	                // If this class has events add a GUID as well
	                if (this.on) {
	                    _.addGuid( this, true );
	                }
	
	                realConstructor.apply(this, arguments);
	            }
	
	            if (includeEvents) {
	                _.extend(superclass, Events);
	            }
	
	            constructor.prototype = _.create(superclass);
	            constructor.prototype.constructor = constructor;
	
	            _.extend(constructor, {
	                extend : function() {
	                    return _.extendThis.apply(this, arguments);
	                },
	
	                // We can't call this 'super' because that's a reserved keyword
	                // and fails in IE8
	                'parent' : superclass,
	
	                proto : function() {
	                    return _.extendThis.apply(this.prototype, arguments);
	                },
	
	                subclass : function(obj) {
	                    obj = obj || {};
	                    obj.superclass = this;
	                    return _.createSubclass(obj);
	                }
	            });
	
	            // Copy all props given in the definition to the prototype
	            for (var key in props) {
	                if (key !== 'constructor' && key !== 'superclass') {
	                    constructor.prototype[key] = props[key];
	                }
	            }
	
	            return constructor;
	        },
	
	        emitEvents : function(type, data, explicitType, explicitGuid) {
	            explicitType = explicitType || false;
	            explicitGuid = explicitGuid || this._guid;
	
	            // #30: make a local copy of handlers to prevent problems with
	            // unbinding the event while unwinding the loop
	            var handlers = slice.call(_.eventHandlers[explicitGuid][type]);
	
	            for (var i = 0, l = handlers.length; i < l; i++) {
	                // Clone the event to prevent issue #19
	                var event = _.extend({}, handlers[i]);
	                var scope = (event.scope) ? event.scope : this;
	
	                if (explicitType) {
	                    event.type = explicitType;
	                }
	
	                event.scope = scope;
	                event.handler.call(event.scope, data, event);
	            }
	        },
	
	        // Extend an object with more objects
	        extend : function() {
	            var args = slice.call(arguments);
	            var object = args.shift();
	
	            for (var i = 0, l = args.length; i < l; i++) {
	                var props = args[i];
	                for (var key in props) {
	                    object[key] = props[key];
	                }
	            }
	
	            return object;
	        },
	
	        // The same as extend, but uses the this value as the scope
	        extendThis : function() {
	            var args = slice.call(arguments);
	            args.unshift(this);
	            return _.extend.apply(this, args);
	        },
	
	        // from http://stackoverflow.com/a/2117523/152809
	        makeUuid : function() {
	            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	                var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
	                return v.toString(16);
	            });
	        },
	
	        removeAttribute : function(keys, silent) {
	            silent = silent || false;
	
	            // Split the key, maybe we want to remove more than one item
	            var attributes = _.trim(keys).split(" ")
	                ,mutateData = {}
	                ;
	
	            // Actually delete the item
	            for (var i = 0, l = attributes.length; i < l; i++) {
	                var key = _.trim(attributes[i]);
	
	                if (key) {
	                    // Store data for mutate event
	                    mutateData.key = key;
	                    mutateData.oldValue = _.attr(this._guid)[key];
	
	                    delete _.attr(this._guid)[key];
	
	                    // If 'silent' is set, do not throw any events
	                    if (!silent) {
	                        this.emit('change', key);
	                        this.emit('change:' + key);
	                        this.emit('mutate', mutateData);
	                        this.emit('mutate:' + key, mutateData);
	                        this.emit('remove', key);
	                        this.emit('remove:' + key);
	                    }
	
	                    // clean up
	                    delete mutateData.oldValue;
	                }
	            }
	        },
	
	        removeEventHandler : function(type, handler) {
	            var handlers = _.eventHandlers[this._guid];
	
	            if (type && handler) {
	                // Remove a specific handler
	                handlers = handlers[type];
	                if (!handlers) return;
	
	                for (var i = 0, l = handlers.length, h; i < l; i++) {
	                    h = handlers[i].handler;
	                    if (h && h === handler) {
	                        handlers.splice(i--, 1);
	                        l--;
	                    }
	                }
	            } else if (type) {
	                // Remove all handlers for a specific type
	                delete handlers[type];
	            } else {
	                // Remove all handlers for this module
	                _.eventHandlers[this._guid] = {};
	            }
	        },
	
	        setAttribute : function(key, value, silent) {
	            silent = silent || false;
	
	            // We need to do this before we actually add the item :)
	            var itemExists = this.has(key);
	            var oldValue = _.attr(this._guid)[key];
	
	            // Is the value different than the oldValue? If not, ignore this call
	            if (value === oldValue) {
	                return;
	            }
	
	            // Actually add the item to the attributes
	            _.attr(this._guid)[key] = value;
	
	            // If 'silent' flag is set, do not throw any events
	            if (silent) {
	                return;
	            }
	
	            // Throw a generic event
	            this.emit('change', key);
	
	            // And a namespaced event as well, NOTE that we pass value instead of
	            // key here!
	            this.emit('change:' + key, value);
	
	            // Throw namespaced and non-namespaced 'mutate' events as well with
	            // the old value data as well and some extra metadata such as the key
	            var mutateData = {
	                "key" : key,
	                "newValue" : value,
	                "oldValue" : (typeof oldValue !== 'undefined') ? oldValue : null
	            };
	
	            this.emit('mutate', mutateData);
	            this.emit('mutate:' + key, mutateData);
	
	            // Also throw a specific event for this type of set
	            var specificEvent = itemExists ? 'update' : 'create';
	
	            this.emit(specificEvent, key);
	
	            // And a namespaced event as well, NOTE that we pass value instead of key
	            this.emit(specificEvent + ':' + key, value);
	        },
	
	        trim : function(str) {
	            return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	        },
	
	        typeOf : function(val) {
	            if (val === null || typeof val === "undefined") {
	                // This is a special exception for IE, in other browsers the
	                // method below works all the time
	                return String(val);
	            } else {
	                return Object.prototype.toString.call(val).replace(/\[object |\]/g, '').toLowerCase();
	            }
	        },
	
	        updateAttribute : function(key, fn, silent) {
	            var item = this.get(key);
	
	            // In previous versions of Stapes we didn't have the check for object,
	            // but still this worked. In 0.7.0 it suddenly doesn't work anymore and
	            // we need the check. Why? I have no clue.
	            var type = _.typeOf(item);
	
	            if (type === 'object' || type === 'array') {
	                item = _.clone(item);
	            }
	
	            var newValue = fn.call(this, item, key);
	            _.setAttribute.call(this, key, newValue, silent || false);
	        }
	    };
	
	    // Can be mixed in later using Stapes.mixinEvents(object);
	    var Events = {
	        emit : function(types, data) {
	            data = (typeof data === "undefined") ? null : data;
	
	            var splittedTypes = types.split(" ");
	
	            for (var i = 0, l = splittedTypes.length; i < l; i++) {
	                var type = splittedTypes[i];
	
	                // First 'all' type events: is there an 'all' handler in the
	                // global stack?
	                if (_.eventHandlers[-1].all) {
	                    _.emitEvents.call(this, "all", data, type, -1);
	                }
	
	                // Catch all events for this type?
	                if (_.eventHandlers[-1][type]) {
	                    _.emitEvents.call(this, type, data, type, -1);
	                }
	
	                if (typeof this._guid === 'number') {
	                    // 'all' event for this specific module?
	                    if (_.eventHandlers[this._guid].all) {
	                        _.emitEvents.call(this, "all", data, type);
	                    }
	
	                    // Finally, normal events :)
	                    if (_.eventHandlers[this._guid][type]) {
	                        _.emitEvents.call(this, type, data);
	                    }
	                }
	            }
	        },
	
	        off : function() {
	            _.removeEventHandler.apply(this, arguments);
	        },
	
	        on : function() {
	            _.addEventHandler.apply(this, arguments);
	        }
	    };
	
	    _.Module = function() {
	
	    };
	
	    _.Module.prototype = {
	        each : function(fn, ctx) {
	            var attr = _.attr(this._guid);
	            for (var key in attr) {
	                var value = attr[key];
	                fn.call(ctx || this, value, key);
	            }
	        },
	
	        extend : function() {
	            return _.extendThis.apply(this, arguments);
	        },
	
	        filter : function(fn) {
	            var filtered = [];
	            var attributes = _.attr(this._guid);
	
	            for (var key in attributes) {
	                if ( fn.call(this, attributes[key], key)) {
	                    filtered.push( attributes[key] );
	                }
	            }
	
	            return filtered;
	        },
	
	        get : function(input) {
	            if (typeof input === "string") {
	                // If there is more than one argument, give back an object,
	                // like Underscore's pick()
	                if (arguments.length > 1) {
	                    var results = {};
	
	                    for (var i = 0, l = arguments.length; i < l; i++) {
	                        var key = arguments[i];
	                        results[key] = this.get(key);
	                    }
	
	                    return results;
	                } else {
	                    return this.has(input) ? _.attr(this._guid)[input] : null;
	                }
	            } else if (typeof input === "function") {
	                var items = this.filter(input);
	                return (items.length) ? items[0] : null;
	            }
	        },
	
	        getAll : function() {
	            return _.clone( _.attr(this._guid) );
	        },
	
	        getAllAsArray : function() {
	            var arr = [];
	            var attributes = _.attr(this._guid);
	
	            for (var key in attributes) {
	                var value = attributes[key];
	
	                if (_.typeOf(value) === "object" && !value.id) {
	                    value.id = key;
	                }
	
	                arr.push(value);
	            }
	
	            return arr;
	        },
	
	        has : function(key) {
	            return (typeof _.attr(this._guid)[key] !== "undefined");
	        },
	
	        map : function(fn, ctx) {
	            var mapped = [];
	            this.each(function(value, key) {
	                mapped.push( fn.call(ctx || this, value, key) );
	            }, ctx || this);
	            return mapped;
	        },
	
	        // Akin to set(), but makes a unique id
	        push : function(input, silent) {
	            if (_.typeOf(input) === "array") {
	                for (var i = 0, l = input.length; i < l; i++) {
	                    _.setAttribute.call(this, _.makeUuid(), input[i], silent || false);
	                }
	            } else {
	                _.setAttribute.call(this, _.makeUuid(), input, silent || false);
	            }
	
	            return this;
	        },
	
	        remove : function(input, silent) {
	            if (typeof input === 'undefined') {
	                // With no arguments, remove deletes all attributes
	                _.attributes[this._guid] = {};
	                this.emit('change remove');
	            } else if (typeof input === "function") {
	                this.each(function(item, key) {
	                    if (input(item)) {
	                        _.removeAttribute.call(this, key, silent);
	                    }
	                });
	            } else {
	                // nb: checking for exists happens in removeAttribute
	                _.removeAttribute.call(this, input, silent || false);
	            }
	
	            return this;
	        },
	
	        set : function(objOrKey, valueOrSilent, silent) {
	            if (typeof objOrKey === "object") {
	                for (var key in objOrKey) {
	                    _.setAttribute.call(this, key, objOrKey[key], valueOrSilent || false);
	                }
	            } else {
	                _.setAttribute.call(this, objOrKey, valueOrSilent, silent || false);
	            }
	
	            return this;
	        },
	
	        size : function() {
	            var size = 0;
	            var attr = _.attr(this._guid);
	
	            for (var key in attr) {
	                size++;
	            }
	
	            return size;
	        },
	
	        update : function(keyOrFn, fn, silent) {
	            if (typeof keyOrFn === "string") {
	                _.updateAttribute.call(this, keyOrFn, fn, silent || false);
	            } else if (typeof keyOrFn === "function") {
	                this.each(function(value, key) {
	                    _.updateAttribute.call(this, key, keyOrFn);
	                });
	            }
	
	            return this;
	        }
	    };
	
	    var Stapes = {
	        "_" : _, // private helper functions and properties
	
	        "extend" : function() {
	            return _.extendThis.apply(_.Module.prototype, arguments);
	        },
	
	        "mixinEvents" : function(obj) {
	            obj = obj || {};
	
	            _.addGuid(obj);
	
	            return _.extend(obj, Events);
	        },
	
	        "on" : function() {
	            _.addEventHandler.apply(this, arguments);
	        },
	
	        "subclass" : function(obj, classOnly) {
	            classOnly = classOnly || false;
	            obj = obj || {};
	            obj.superclass = classOnly ? function(){} : _.Module;
	            return _.createSubclass(obj, !classOnly);
	        },
	
	        "version" : VERSION
	    };
	
	    // This library can be used as an AMD module, a Node.js module, or an
	    // old fashioned global
	    if (true) {
	        // Server
	        if (typeof module !== "undefined" && module.exports) {
	            exports = module.exports = Stapes;
	        }
	        exports.Stapes = Stapes;
	    } else if (typeof define === "function" && define.amd) {
	        // AMD
	        define(function() {
	            return Stapes;
	        });
	    } else {
	        // Global scope
	        window.Stapes = Stapes;
	    }
	})();


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	
	var PhaseMatch = {
	    constants: __webpack_require__(309),
	    nelderMead: __webpack_require__(310),
	    svdcmp: __webpack_require__(311),
	    Crystals: __webpack_require__(313)
	};
	
	module.exports = PhaseMatch;
	
	// assign math helpers to PhaseMatch
	var helpers = __webpack_require__(312);
	var sq = helpers.sq;
	Object.assign(PhaseMatch, helpers);
	
	// assign pm functions
	var pm = __webpack_require__(416);
	Object.assign(PhaseMatch, pm);
	
	// assign momentum functions
	var pm_momentum = __webpack_require__(417);
	Object.assign(PhaseMatch, pm_momentum);
	
	// assign properties tools
	var pm_props = __webpack_require__(418);
	Object.assign(PhaseMatch, pm_props);
	
	// assign plot helpers
	var pm_plot = __webpack_require__(440);
	Object.assign(PhaseMatch, pm_plot);

/***/ },
/* 309 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Constants accessible to PhaseMatch internally
	 */
	var nm = Math.pow(10, -9);
	var um = Math.pow(10, -6);
	var pm = Math.pow(10, -12);
	var mu = 1;
	var c = 2.99792458 * Math.pow(10, 8) * mu;
	var twoPI = 2 * Math.PI;
	var e0 = 8.854 * Math.pow(10, -12);
	
	module.exports = {
	    // user accessible constants
	    um: um,
	    nm: nm,
	    pm: pm,
	    c: c,
	    e0: e0,
	    twoPI: twoPI
	};

/***/ },
/* 310 */
/***/ function(module, exports) {

	'use strict';
	
	//Implementation of Nelder-Mead Simplex Linear Optimizer
	//  TODO: Robust Unit Test of 2D Function Optimizations
	//  TODO: Extend to support functions beyond the 2D Space
	
	function Simplex(vertices) {
	    this.vertices = vertices;
	    this.centroid = null;
	    this.reflect_point = null; //Reflection point, updated on each iteration
	    this.reflect_cost = null;
	    this.expand_point = null;
	    this.expand_cost = null;
	    this.contract_point = null;
	    this.contract_cost = null;
	}
	
	//sort the vertices of Simplex by their objective value as defined by objFunc
	Simplex.prototype.sortByCost = function (objFunc) {
	    this.vertices.sort(function (a, b) {
	        var a_cost = objFunc(a),
	            b_cost = objFunc(b);
	
	        if (a_cost < b_cost) {
	            return -1;
	        } else if (a_cost > b_cost) {
	            return 1;
	        } else {
	            return 0;
	        }
	    });
	};
	
	//find the centroid of the simplex (ignoring the vertex with the worst objective value)
	Simplex.prototype.updateCentroid = function (objFunc) {
	    this.sortByCost(objFunc); //vertices must be in order of best..worst
	
	    var centroid_n = this.vertices.length - 1,
	        centroid_sum = 0,
	        i;
	    for (i = 0; i < centroid_n; i += 1) {
	        centroid_sum += this.vertices[i];
	    }
	
	    this.centroid = centroid_sum / centroid_n;
	};
	
	Simplex.prototype.updateReflectPoint = function (objFunc) {
	    var worst_point = this.vertices[this.vertices.length - 1];
	    this.reflect_point = this.centroid + (this.centroid - worst_point); // 1*(this.centroid - worst_point), 1 removed to make jslint happy
	    this.reflect_cost = objFunc(this.reflect_point);
	};
	
	Simplex.prototype.updateExpandPoint = function (objFunc) {
	    var worst_point = this.vertices[this.vertices.length - 1];
	    this.expand_point = this.centroid + 2 * (this.centroid - worst_point);
	    this.expand_cost = objFunc(this.expand_point);
	};
	
	Simplex.prototype.updateContractPoint = function (objFunc) {
	    var worst_point = this.vertices[this.vertices.length - 1];
	    this.contract_point = this.centroid + 0.5 * (this.centroid - worst_point);
	    this.contract_cost = objFunc(this.contract_point);
	};
	
	//assumes sortByCost has been called prior!
	Simplex.prototype.getVertexCost = function (objFunc, option) {
	    if (option === 'worst') {
	        return objFunc(this.vertices[this.vertices.length - 1]);
	    } else if (option === 'secondWorst') {
	        return objFunc(this.vertices[this.vertices.length - 2]);
	    } else if (option === 'best') {
	        return objFunc(this.vertices[0]);
	    }
	};
	
	Simplex.prototype.reflect = function () {
	    this.vertices[this.vertices.length - 1] = this.reflect_point; //replace the worst vertex with the reflect vertex
	};
	
	Simplex.prototype.expand = function () {
	    this.vertices[this.vertices.length - 1] = this.expand_point; //replace the worst vertex with the expand vertex
	};
	
	Simplex.prototype.contract = function () {
	    this.vertices[this.vertices.length - 1] = this.contract_point; //replace the worst vertex with the contract vertex
	};
	
	Simplex.prototype.reduce = function () {
	    var best_x = this.vertices[0],
	        a;
	    for (a = 1; a < this.vertices.length; a += 1) {
	        this.vertices[a] = best_x + 0.5 * (this.vertices[a] - best_x); //0.1 + 0.5(0.1-0.1)
	    }
	};
	
	var nelderMead = function nelderMead(objFunc, x0, numIters) {
	
	    //This is our Simplex object that will mutate based on the behavior of the objective function objFunc
	    var S = new Simplex([x0, x0 + 1, x0 + 2]),
	        itr,
	        x;
	
	    for (itr = 0; itr < numIters; itr += 1) {
	
	        S.updateCentroid(objFunc); //needs to know which objFunc to hand to sortByCost
	        S.updateReflectPoint(objFunc);
	
	        x = S.vertices[0];
	
	        if (S.reflect_cost < S.getVertexCost(objFunc, 'secondWorst') && S.reflect_cost > S.getVertexCost(objFunc, 'best')) {
	            S.reflect();
	        } else if (S.reflect_cost < S.getVertexCost(objFunc, 'best')) {
	            //new point is better than previous best: expand
	
	            S.updateExpandPoint(objFunc);
	
	            if (S.expand_cost < S.reflect_cost) {
	                S.expand();
	            } else {
	                S.reflect();
	            }
	        } else {
	            //new point was worse than all current points: contract
	
	            S.updateContractPoint(objFunc);
	
	            if (S.contract_cost < S.getVertexCost(objFunc, 'worst')) {
	                S.contract();
	            } else {
	                S.reduce();
	            }
	        }
	    }
	
	    return x;
	};
	
	module.exports = nelderMead;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*
	Copyright (c) 2012 Juan Mellado
	
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
	*/
	
	/*
	References:
	- "Numerical Recipes in C - Second Edition"
	  http://www.nr.com/
	*/
	
	var helpers = __webpack_require__(312);
	
	var pythag = function pythag(a, b) {
	  var at = Math.abs(a),
	      bt = Math.abs(b),
	      ct;
	
	  if (at > bt) {
	    ct = bt / at;
	    return at * Math.sqrt(1.0 + ct * ct);
	  }
	
	  if (0.0 === bt) {
	    return 0.0;
	  }
	
	  ct = at / bt;
	  return bt * Math.sqrt(1.0 + ct * ct);
	};
	
	var sign = function sign(a, b) {
	  return b >= 0.0 ? Math.abs(a) : -Math.abs(a);
	};
	
	var svdcmp = function svdcmp(a) {
	  var flag,
	      i,
	      its,
	      j,
	      jj,
	      k,
	      l,
	      nm,
	      anorm = 0.0,
	      c,
	      f,
	      g = 0.0,
	      h,
	      s,
	      scale = 0.0,
	      x,
	      y,
	      z,
	      rv1 = [];
	
	  var m = a.length; //number of rows
	  var n = a[0].length; // number of cols
	
	  var v = helpers.zeros(m, n);
	  // var v = cloneDeep(a);
	  var w = [];
	
	  //Householder reduction to bidiagonal form
	  for (i = 0; i < n; ++i) {
	    l = i + 1;
	    rv1[i] = scale * g;
	    g = s = scale = 0.0;
	    if (i < m) {
	      for (k = i; k < m; ++k) {
	        scale += Math.abs(a[k][i]);
	      }
	      if (0.0 !== scale) {
	        for (k = i; k < m; ++k) {
	          a[k][i] /= scale;
	          s += a[k][i] * a[k][i];
	        }
	        f = a[i][i];
	        g = -sign(Math.sqrt(s), f);
	        h = f * g - s;
	        a[i][i] = f - g;
	        for (j = l; j < n; ++j) {
	          for (s = 0.0, k = i; k < m; ++k) {
	            s += a[k][i] * a[k][j];
	          }
	          f = s / h;
	          for (k = i; k < m; ++k) {
	            a[k][j] += f * a[k][i];
	          }
	        }
	        for (k = i; k < m; ++k) {
	          a[k][i] *= scale;
	        }
	      }
	    }
	    w[i] = scale * g;
	    g = s = scale = 0.0;
	    if (i < m && i !== n - 1) {
	      for (k = l; k < n; ++k) {
	        scale += Math.abs(a[i][k]);
	      }
	      if (0.0 !== scale) {
	        for (k = l; k < n; ++k) {
	          a[i][k] /= scale;
	          s += a[i][k] * a[i][k];
	        }
	        f = a[i][l];
	        g = -sign(Math.sqrt(s), f);
	        h = f * g - s;
	        a[i][l] = f - g;
	        for (k = l; k < n; ++k) {
	          rv1[k] = a[i][k] / h;
	        }
	        for (j = l; j < m; ++j) {
	          for (s = 0.0, k = l; k < n; ++k) {
	            s += a[j][k] * a[i][k];
	          }
	          for (k = l; k < n; ++k) {
	            a[j][k] += s * rv1[k];
	          }
	        }
	        for (k = l; k < n; ++k) {
	          a[i][k] *= scale;
	        }
	      }
	    }
	    anorm = Math.max(anorm, Math.abs(w[i]) + Math.abs(rv1[i]));
	  }
	
	  //Acumulation of right-hand transformation
	  for (i = n - 1; i >= 0; --i) {
	    if (i < n - 1) {
	      if (0.0 !== g) {
	        for (j = l; j < n; ++j) {
	          v[j][i] = a[i][j] / a[i][l] / g;
	        }
	        for (j = l; j < n; ++j) {
	          for (s = 0.0, k = l; k < n; ++k) {
	            s += a[i][k] * v[k][j];
	          }
	          for (k = l; k < n; ++k) {
	            v[k][j] += s * v[k][i];
	          }
	        }
	      }
	      for (j = l; j < n; ++j) {
	        v[i][j] = v[j][i] = 0.0;
	      }
	    }
	    v[i][i] = 1.0;
	    g = rv1[i];
	    l = i;
	  }
	
	  //Acumulation of left-hand transformation
	  for (i = Math.min(n, m) - 1; i >= 0; --i) {
	    l = i + 1;
	    g = w[i];
	    for (j = l; j < n; ++j) {
	      a[i][j] = 0.0;
	    }
	    if (0.0 !== g) {
	      g = 1.0 / g;
	      for (j = l; j < n; ++j) {
	        for (s = 0.0, k = l; k < m; ++k) {
	          s += a[k][i] * a[k][j];
	        }
	        f = s / a[i][i] * g;
	        for (k = i; k < m; ++k) {
	          a[k][j] += f * a[k][i];
	        }
	      }
	      for (j = i; j < m; ++j) {
	        a[j][i] *= g;
	      }
	    } else {
	      for (j = i; j < m; ++j) {
	        a[j][i] = 0.0;
	      }
	    }
	    ++a[i][i];
	  }
	
	  //Diagonalization of the bidiagonal form
	  for (k = n - 1; k >= 0; --k) {
	    for (its = 1; its <= 30; ++its) {
	      flag = true;
	      for (l = k; l >= 0; --l) {
	        nm = l - 1;
	        if (Math.abs(rv1[l]) + anorm === anorm) {
	          flag = false;
	          break;
	        }
	        if (Math.abs(w[nm]) + anorm === anorm) {
	          break;
	        }
	      }
	      if (flag) {
	        c = 0.0;
	        s = 1.0;
	        for (i = l; i <= k; ++i) {
	          f = s * rv1[i];
	          if (Math.abs(f) + anorm === anorm) {
	            break;
	          }
	          g = w[i];
	          h = pythag(f, g);
	          w[i] = h;
	          h = 1.0 / h;
	          c = g * h;
	          s = -f * h;
	          for (j = 0; j < m; ++j) {
	            y = a[j][nm];
	            z = a[j][i];
	            a[j][nm] = y * c + z * s;
	            a[j][i] = z * c - y * s;
	          }
	        }
	      }
	
	      //Convergence
	      z = w[k];
	      if (l === k) {
	        if (z < 0.0) {
	          w[k] = -z;
	          for (j = 0; j < n; ++j) {
	            v[j][k] = -v[j][k];
	          }
	        }
	        break;
	      }
	
	      if (30 === its) {
	        return false;
	      }
	
	      //Shift from bottom 2-by-2 minor
	      x = w[l];
	      nm = k - 1;
	      y = w[nm];
	      g = rv1[nm];
	      h = rv1[k];
	      f = ((y - z) * (y + z) + (g - h) * (g + h)) / (2.0 * h * y);
	      g = pythag(f, 1.0);
	      f = ((x - z) * (x + z) + h * (y / (f + sign(g, f)) - h)) / x;
	
	      //Next QR transformation
	      c = s = 1.0;
	      for (j = l; j <= nm; ++j) {
	        i = j + 1;
	        g = rv1[i];
	        y = w[i];
	        h = s * g;
	        g = c * g;
	        z = pythag(f, h);
	        rv1[j] = z;
	        c = f / z;
	        s = h / z;
	        f = x * c + g * s;
	        g = g * c - x * s;
	        h = y * s;
	        y *= c;
	        for (jj = 0; jj < n; ++jj) {
	          x = v[jj][j];
	          z = v[jj][i];
	          v[jj][j] = x * c + z * s;
	          v[jj][i] = z * c - x * s;
	        }
	        z = pythag(f, h);
	        w[j] = z;
	        if (0.0 !== z) {
	          z = 1.0 / z;
	          c = f * z;
	          s = h * z;
	        }
	        f = c * g + s * y;
	        x = c * y - s * g;
	        for (jj = 0; jj < m; ++jj) {
	          y = a[jj][j];
	          z = a[jj][i];
	          a[jj][j] = y * c + z * s;
	          a[jj][i] = z * c - y * s;
	        }
	      }
	      rv1[l] = 0.0;
	      rv1[k] = f;
	      w[k] = x;
	    }
	  }
	
	  return { U: a, W: w, V: v };
	};
	
	module.exports = svdcmp;

/***/ },
/* 312 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * General internal math helper functions
	 */
	var helpers = {};
	
	var sq = helpers.sq = function sq(x) {
	    return x * x;
	    // return Math.pow(x,2);
	};
	
	/*
	 * A series of helper functions
	 */
	helpers.Sum = function Sum(A) {
	    var total = 0;
	    var l = A.length;
	    for (var i = 0; i < l; i++) {
	        total += A[i];
	    }
	    return total;
	};
	
	/*
	 * Reverses a typed array
	 */
	helpers.reverse = function reverse(A) {
	    var rev = new Float64Array(A.length);
	    var l = A.length;
	    for (var i = 0; i < l; i++) {
	        rev[i] = A[l - 1 - i];
	    }
	    return rev;
	};
	
	/* Note:
	    Use: Math.max.apply(null, [1,5,2,7,8])
	    instead of creating your own
	 */
	
	helpers.Transpose = function Transpose(A, dim) {
	    var Trans = new Float64Array(dim * dim);
	    var l = A.length;
	    for (var i = 0; i < l; i++) {
	        var index_c = i % dim;
	        var index_r = Math.floor(i / dim);
	        //swap rows with columns
	        Trans[index_c * dim + index_r] = A[i];
	    }
	    return Trans;
	};
	
	helpers.AntiTranspose = function Transpose(A, dim) {
	    var Trans = new Float64Array(dim * dim);
	    var l = A.length;
	    for (var i = 0; i < l; i++) {
	        var index_c = i % dim;
	        var index_r = Math.floor(i / dim);
	        //swap rows with columns
	        Trans[(dim - 1 - index_c) * dim + (dim - 1 - index_r)] = A[i];
	    }
	    return Trans;
	};
	
	helpers.linspace = function linspace(xstart, xstop, npts) {
	    var A = new Float64Array(npts);
	    var diff = (xstop - xstart) / (npts - 1);
	    var curVal = 0;
	    for (var i = 0; i < npts; i++) {
	        A[i] = xstart + i * diff;
	    }
	    return A;
	};
	
	helpers.create_2d_array = function create_2d_array(data, dimx, dimy) {
	    var data2D = [];
	    var index = 0;
	
	    for (var i = 0; i < dimy; i++) {
	        var row = new Float64Array(dimx);
	        for (var j = 0; j < dimx; j++) {
	            row[j] = data[index];
	            index += 1;
	        }
	        data2D[i] = row;
	    }
	    return data2D;
	};
	
	helpers.create_2d_array_view = function create_2d_array_view(data, dimx, dimy) {
	    var data2D = [];
	
	    if (data.buffer && data.buffer.byteLength) {
	
	        for (var i = 0; i < dimy; i++) {
	
	            data2D[i] = new Float64Array(data.buffer, i * 16, dimx);
	        }
	    } else {
	
	        return null;
	    }
	
	    return data2D;
	};
	
	helpers.zeros = function zeros(dimx, dimy) {
	    var data2D = [];
	    var index = 0;
	
	    for (var i = 0; i < dimy; i++) {
	        var row = new Float64Array(dimx);
	        for (var j = 0; j < dimx; j++) {
	            row[j] = 0;
	        }
	        data2D[i] = row;
	    }
	    return data2D;
	};
	
	/*
	 * Takes an array and normalizes it using the max value in the array.
	 */
	helpers.normalize = function normalize(data) {
	    var maxval = Math.max.apply(null, data);
	    var n = data.length;
	
	    for (var i = 0; i < n; i++) {
	        data[i] = data[i] / maxval;
	    }
	    return data;
	};
	
	/*
	 * Takes an array and normalizes it to a given value.
	 */
	helpers.normalizeToVal = function normalizeToVal(data, maxval) {
	    // var maxval = Math.max.apply(null,data);
	    var n = data.length;
	
	    for (var i = 0; i < n; i++) {
	        data[i] = data[i] / maxval;
	    }
	    return data;
	};
	
	/*
	 * Faster method for finding the max from an array
	 */
	helpers.max = function max(data) {
	    var counter = data.length,
	        maxd = -1 * Infinity,
	        member;
	
	    while (counter--) {
	        member = data[counter];
	        if (maxd < member) {
	            maxd = member;
	        }
	    }
	    return maxd;
	};
	
	/*
	* Create a special purpose, high speed version of Simpson's rule to
	* integrate the z direction in the phasematching function. The function
	* returns two arguments corresponding to the real and imag components of
	* the number being summed.
	*/
	
	/*
	 * The weights for the 1D Simpson's rule.
	 */
	helpers.NintegrateWeights = function NintegrateWeights(n) {
	    var weights = new Array(n + 1);
	    weights[0] = 1;
	    weights[n] = 1;
	    for (var i = 1; i < n; i++) {
	        if (i % 2 === 0) {
	            //even case
	            weights[i] = 2;
	        } else {
	            weights[i] = 4;
	        }
	    }
	    return weights;
	};
	
	/*
	Perform a numerical 1D integration using Simpson's rule.
	
	f(x) is the function to be evaluated
	a,b are the x start and stop points of the range
	
	The 1D simpson's integrator has weights that are of the form
	(1 4 2 4 ... 2 4 1)
	 */
	helpers.Nintegrate2arg = function Nintegrate2arg(f, a, b, dx, n, w) {
	    // we remove the check of n being even for speed. Be careful to only
	    // input n that are even.
	
	    dx = (b - a) / n;
	    var result_real = 0;
	    var result_imag = 0;
	
	    for (var j = 0; j < n + 1; j++) {
	        var feval = f(a + j * dx); // f must return two element array
	        result_real += feval[0] * w[j];
	        result_imag += feval[1] * w[j];
	    }
	
	    return [result_real * dx / 3, result_imag * dx / 3];
	};
	
	/*
	Perform a numerical 1D integration using Simpson's rule.
	
	f(x) is the function to be evaluated
	a,b are the x start and stop points of the range
	
	The 1D simpson's integrator has weights that are of the form
	(1 4 2 4 ... 2 4 1)
	 */
	helpers.Nintegrate = function Nintegrate(f, a, b, n) {
	    if (n % 2 !== 0) {
	        n = n + 1; //guarantee that n is even
	    }
	
	    var weights = new Array(n + 1);
	    weights[0] = 1;
	    weights[n] = 1;
	    for (var i = 1; i < n; i++) {
	        if (i % 2 === 0) {
	            //even case
	            weights[i] = 2;
	        } else {
	            weights[i] = 4;
	        }
	    }
	
	    // if (n<50){
	    //     console.log(weights);
	    // }
	
	    var dx = (b - a) / n;
	    var result = 0;
	
	    for (var j = 0; j < n + 1; j++) {
	        result += f(a + j * dx) * weights[j];
	    }
	
	    return result * dx / 3;
	};
	
	/*
	Perform a numerical 2D integration using Simpson's rule.
	Calculate the array of weights for Simpson's rule.
	 */
	helpers.Nintegrate2DWeights = function Nintegrate2DWeights(n) {
	
	    if (n % 2 !== 0) {
	        n = n + 1; //guarantee that n is even
	    }
	
	    var weights = new Array(n + 1);
	    weights[0] = 1;
	    weights[n] = 1;
	    for (var i = 1; i < n; i++) {
	        if (i % 2 === 0) {
	            //even case
	            weights[i] = 2;
	        } else {
	            weights[i] = 4;
	        }
	    }
	
	    return weights;
	};
	
	/*
	Perform a numerical 2D integration using Simpson's rule.
	http://math.fullerton.edu/mathews/n2003/simpsonsrule2dmod.html
	http://www.mathworks.com/matlabcentral/fileexchange/23204-2d-simpsons-integrator/content/simp2D.m
	
	Assume a square grid of nxn points.
	f(x,y) is the function to be evaluated
	a,b are the x start and stop points of the range
	c,d are the y start and stop points of the range
	The 2D simpson's integrator has weights that are most easily determined
	by taking the outer product of the vector of weights for the 1D simpson's
	rule. For example let's say we have the vector (1 4 2 4 2 4 1) for 6 intervals.
	In 2D we now get an array of weights that is given by:
	   | 1  4  2  4  2  4  1 |
	   | 4 16  8 16  8 16  4 |
	   | 2  8  4  8  4  8  2 |
	   | 4 16  8 16  8 16  4 |
	   | 2  8  4  8  4  8  2 |
	   | 4 16  8 16  8 16  4 |
	   | 1  4  2  4  2  4  1 |
	Notice how the usual 1D simpson's weights appear around the sides of the array
	 */
	helpers.Nintegrate2D = function Nintegrate2D(f, a, b, c, d, n, w) {
	    var weights;
	
	    if (n % 2 !== 0) {
	        n = n + 1; //guarantee that n is even
	    }
	
	    if (w === null || w === undefined) {
	        weights = new Array(n + 1);
	        weights[0] = 1;
	        weights[n] = 1;
	        for (var i = 1; i < n; i++) {
	            if (i % 2 === 0) {
	                //even case
	                weights[i] = 2;
	            } else {
	                weights[i] = 4;
	            }
	        }
	    } else {
	        weights = w;
	    }
	
	    // if (n<50){
	    //     console.log(weights);
	    // }
	
	    var dx = (b - a) / n;
	    var dy = (d - c) / n;
	    var result = 0;
	
	    for (var j = 0; j < n + 1; j++) {
	        for (var k = 0; k < n + 1; k++) {
	            result += f(a + j * dx, c + k * dy) * weights[j] * weights[k];
	        }
	    }
	
	    return result * dx * dy / 9;
	};
	
	/*
	 * Special version of Simpsons 2D integral for use with the mode solver.
	 * Accepts a function that returns two arguments. Integrates thses two results
	 * separately. For speed, we strip out the weights code and assume it is provided.
	 */
	
	helpers.Nintegrate2DModeSolver = function Nintegrate2DModeSolver(f, a, b, c, d, n, w) {
	
	    var weights = w;
	
	    var dx = (b - a) / n;
	    var dy = (d - c) / n;
	    var result1 = 0;
	    var result2 = 0;
	    var result = 0;
	
	    for (var j = 0; j < n + 1; j++) {
	        for (var k = 0; k < n + 1; k++) {
	            // console.log(f(a +j*dx, c+k*dy)*weights[k] );
	            result = f(a + j * dx, c + k * dy);
	            result1 += result[0] * weights[j] * weights[k];
	            result2 += result[1] * weights[j] * weights[k];
	        }
	    }
	
	    return [result1 * dx * dy / 9, result2 * dx * dy / 9];
	};
	
	/*
	Calculate the array of weights for Simpson's 3/8 rule.
	 */
	helpers.Nintegrate2DWeights_3_8 = function Nintegrate2DWeights_3_8(n) {
	    // if (n%3 !== 0){
	    //     n = n+n%3; //guarantee that n is divisible by 3
	    // }
	
	    // n = n+(3- n%3) -3; //guarantee that n is divisible by 3
	
	    // console.log(n);
	
	    var weights = new Array(n + 1);
	    weights[0] = 1;
	    weights[n + 1] = 1;
	    for (var i = 1; i < n + 1; i++) {
	        if (i % 3 === 0) {
	            weights[i] = 2;
	        } else {
	            weights[i] = 3;
	        }
	    }
	    return weights;
	};
	
	/*
	Perform a numerical 2D integration using Simpson's 3/8 rule.
	
	Assume a square grid of nxn points.
	f(x,y) is the function to be evaluated
	a,b are the x start and stop points of the range
	c,d are the y start and stop points of the range
	The 2D simpson's integrator has weights that are most easily determined
	by taking the outer product of the vector of weights for the 1D simpson's
	rule. For example let's say we have the vector (1 4 2 4 2 4 1) for 6 intervals.
	In 2D we now get an array of weights that is given by:
	   | 1  3  3  2  3  3  2  1 | and so on
	
	 */
	helpers.Nintegrate2D_3_8 = function Nintegrate2D_3_8(f, a, b, c, d, n, w) {
	    var weights;
	    // n = n+(3- n%3); //guarantee that n is divisible by 3
	
	    if (w === null || w === undefined) {
	        weights = helpers.Nintegrate2DWeights_3_8(n);
	    } else {
	        weights = w;
	    }
	
	    if (n < 50) {
	        // console.log(weights);
	    }
	
	    var dx = (b - a) / n;
	    var dy = (d - c) / n;
	    var result = 0;
	
	    for (var j = 0; j < n + 2; j++) {
	        for (var k = 0; k < n + 2; k++) {
	            // console.log("inside Simpsons. J: " +j.toString() + ", k:" + k.toString() + ", result:" +result.toString());
	            result += f(a + j * dx, c + k * dy) * weights[j] * weights[k];
	        }
	    }
	
	    return result * dx * dy * 9 / 64;
	};
	
	/*
	A modification of Simpson's 2-Dimensional 3/8th's rule for the double integral
	over length that must be done in the singles caluclation. A custom function is
	being written to greatly speed up the calculation. The return is the real and
	imaginary parts. Make sure N is divisible by 3.
	*/
	helpers.Nintegrate2D_3_8_singles = function Nintegrate2D_3_8_singles(f, fz1, a, b, c, d, n, w) {
	    var weights = w;
	    // n = n+(3- n%3); //guarantee that n is divisible by 3
	
	    var dx = (b - a) / n,
	        dy = (d - c) / n,
	        result1 = 0,
	        result2 = 0,
	        scale = dx * dy * 9 / 64;
	
	    for (var j = 0; j < n + 2; j++) {
	        var x = a + j * dx,
	            Cz1 = fz1(x);
	
	        for (var k = 0; k < n + 2; k++) {
	            var y = c + k * dy,
	                result = f(x, y, Cz1),
	                weight = weights[j] * weights[k];
	            result1 += result[0] * weight;
	            result2 += result[1] * weight;
	        }
	    }
	
	    return [result1 * scale, result2 * scale];
	};
	
	helpers.RiemannSum2D = function RiemannSum2D(f, a, b, c, d, n) {
	    var dx = (b - a) / n;
	    var dy = (d - c) / n;
	    var result = 0;
	
	    for (var j = 0; j < n; j++) {
	        for (var k = 0; k < n; k++) {
	            result += f(a + j * dx, c + k * dy);
	        }
	    }
	
	    return result * dx * dy;
	};
	
	// Complex number handling
	helpers.cmultiplyR = function cmultiplyR(a, b, c, d) {
	    return a * c - b * d;
	};
	
	helpers.cmultiplyI = function cmultiplyI(a, b, c, d) {
	    return a * d + b * c;
	};
	
	helpers.cdivideR = function cdivideR(a, b, c, d) {
	    return (a * c + b * d) / (c * c + d * d);
	};
	
	helpers.cdivideI = function cdivideI(a, b, c, d) {
	    return (b * c - a * d) / (c * c + d * d);
	};
	
	helpers.caddR = function caddR(a, ai, b, bi) {
	    return a + b;
	};
	
	helpers.caddI = function caddI(a, ai, b, bi) {
	    return ai + bi;
	};
	
	// Returns real part of the principal square root of a complex number
	helpers.csqrtR = function csqrtR(a, ai) {
	    // var rSqrt = Math.sqrt(Math.sqrt((a*a)+(ai*ai)));
	    // var arg = Math.atan2(ai,a)*0.5;
	    // var real = rSqrt*Math.cos(arg);
	    // // return real;
	    // return helpers.sign(real)*real; //returns the real value
	    var r = Math.sqrt(a * a + ai * ai);
	    var realNum = a + r;
	    var real = realNum / Math.sqrt(2 * realNum);
	    return real;
	};
	
	// Returns imag part of the principal square root of a complex number
	helpers.csqrtI = function csqrtI(a, ai) {
	    // var rSqrt = Math.sqrt(Math.sqrt((a*a)+(ai*ai)));
	    // var arg = Math.atan2(ai,a)*.5;
	    // var real = rSqrt*Math.cos(arg);
	    // var imag = rSqrt*Math.sin(arg);
	    // // return imag;
	    // return helpers.sign(real)*imag; //returns the imag value
	
	    var r = Math.sqrt(a * a + ai * ai);
	    var realNum = a + r;
	    var imag = ai / Math.sqrt(2 * realNum);
	    return imag;
	};
	
	// Returns imag part of the principal square root of a complex number
	helpers.csqrt = function csqrt(a, ai) {
	    // var rSqrt = Math.sqrt(Math.sqrt((a*a)+(ai*ai)));
	    // var arg = Math.atan2(ai,a)*.5;
	    // var real = rSqrt*Math.cos(arg);
	    // var imag = rSqrt*Math.sin(arg);
	    // // return imag;
	    // return helpers.sign(real)*imag; //returns the imag value
	
	    var r = Math.sqrt(a * a + ai * ai);
	    var realNum = a + r;
	    var imag = ai / Math.sqrt(2 * realNum);
	    var real = realNum / Math.sqrt(2 * realNum);
	    return [real, imag];
	};
	
	// http://jsperf.com/signs/3
	helpers.sign = function sign(x) {
	    return typeof x === 'number' ? x ? x < 0 ? -1 : 1 : x === x ? 0 : NaN : NaN;
	};
	
	module.exports = helpers;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var crystals = {};
	var cloneDeep = __webpack_require__(314);
	var sq = __webpack_require__(312).sq;
	
	// defaults defined for every crystal
	var defaults = {
	
	    name: 'Unnamed Crystal',
	    temp: 20,
	    info: '',
	
	    indicies: function indicies() {
	        return [1, 1, 1];
	    }
	};
	
	// get and set crystal db entries
	
	var Crystals = function Crystals(key, create) {
	
	    // invalid args
	    if (!key) {
	        return null;
	    }
	
	    if (!create && !(key in crystals)) {
	
	        throw 'Crystal type "' + key + ' not yet defined.';
	    }
	
	    if (create) {
	
	        if (key in crystals) {
	
	            throw 'Crystal type "' + key + ' already defined.';
	        }
	
	        crystals[key] = Object.assign({}, defaults, create, { id: key });
	    }
	
	    return cloneDeep(crystals[key]);
	};
	
	// get all crystal keynames
	Crystals.keys = function () {
	
	    return Object.keys(crystals);
	};
	
	/**
	 * These are the properties that are used to calculate phasematching
	 */
	
	/**
	 * BBO indicies.
	 */
	Crystals('BBO-1', {
	    name: 'BBO ref 1',
	    // info: '',
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	        // http://www.newlightphotonics.com/bbo-properties.html & Alan Migdall
	        var no = Math.sqrt(2.7359 + 0.01878 / (lambda_sq - 0.01822) - 0.01354 * lambda_sq);
	        var ne = Math.sqrt(2.3753 + 0.01224 / (lambda_sq - 0.01667) - 0.01516 * lambda_sq);
	
	        //from Newlight Photonics
	        var dno = -9.3e-6;
	        var dne = -16.6e-6;
	
	        no = no + (temp - 20.0) * dno;
	        ne = ne + (temp - 20.0) * dne;
	
	        return [no, no, ne];
	    }
	});
	
	/**
	 * KTP indicies.
	 */
	Crystals('KTP-3', {
	    name: 'KTP ref 1',
	    // info: 'H. Vanherzeele, J. D. Bierlein, F. C. Zumsteg, Appl. Opt., 27, 3314 (1988)',
	    info: 'Includes Franco Wong"s modificatin.  http://dx.doi.org/10.1063/1.1668320, http://www.redoptronics.com/KTP-crystal.html',
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	
	        // http://www.redoptronics.com/KTP-crystal.html
	        var nx = Math.sqrt(2.10468 + 0.89342 * lambda_sq / (lambda_sq - 0.04438) - 0.01036 * lambda_sq);
	        var ny;
	
	        if (lambda < 1.2) {
	            ny = Math.sqrt(2.14559 + 0.87629 * lambda_sq / (lambda_sq - 0.0485) - 0.01173 * lambda_sq);
	        } else {
	            ny = Math.sqrt(2.0993 + 0.922683 * lambda_sq / (lambda_sq - 0.0467695) - 0.0138408 * lambda_sq);
	        }
	
	        var nz = Math.sqrt(1.9446 + 1.3617 * lambda_sq / (lambda_sq - 0.047) - 0.01491 * lambda_sq);
	
	        var dnx = 1.1e-5;
	        var dny = 1.3e-5;
	        var dnz = 1.6e-5;
	
	        nx = nx + (temp - 20.0) * dnx;
	        ny = ny + (temp - 20.0) * dny;
	        nz = nz + (temp - 20.0) * dnz;
	
	        // var no = Math.sqrt(2.7359 + 0.01878/ (sq(lambda) - 0.01822) - 0.01354*sq(lambda));
	        // var ne = Math.sqrt(2.3753 + 0.01224 / (sq(lambda) - 0.01667) - 0.01516*sq(lambda));
	
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * BiBO indicies.
	 */
	Crystals('BiBO-1', {
	    name: 'BiBO ref 1',
	    info: 'http://www.newlightphotonics.com/bibo-properties.html',
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	        //Alan Migdal's program
	        // var nx = Math.sqrt(3.0740 + 0.0323/(sq(lambda)-0.0316) - 0.01337*sq(lambda) );
	        // var ny = Math.sqrt(3.1685 + 0.0373/(sq(lambda)-0.0346) - 0.01750*sq(lambda) );
	        // var nz = Math.sqrt(3.6545 + 0.0511/(sq(lambda)-0.0371) - 0.0226*sq(lambda)  );
	
	        //http://www.crystech.com/products/crystals/nlocrystals/BIBO.htm
	        // var nx = Math.sqrt(3.0740+0.0323/(sq(lambda)-0.0316)-0.01337*sq(lambda));
	        // var ny = Math.sqrt(3.1685+0.0373/(sq(lambda)-0.0346)-0.01750*sq(lambda));
	        // var nz = Math.sqrt(3.6545+0.0511/(sq(lambda)-0.0371)-0.0226*sq(lambda));
	
	        // http://www.newlightphotonics.com/bibo-properties.html
	        var nx = Math.sqrt(3.0740 + 0.0323 / (lambda_sq - 0.0316) - 0.01337 * lambda_sq);
	        var ny = Math.sqrt(3.1685 + 0.0373 / (lambda_sq - 0.0346) - 0.01750 * lambda_sq);
	        var nz = Math.sqrt(3.6545 + 0.0511 / (lambda_sq - 0.0371) - 0.0226 * lambda_sq);
	
	        // var dnx = 4.8e-5;
	        // var dny = 4.4e-6;
	        // var dnz = -2.69e-5;
	        // nx = nx + (temp -20.0)*dnx;
	        // ny = ny + (temp -20.0)*dny;
	        // nz = nz + (temp -20.0)*dnz;
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * LiNbO3 indicies.
	 */
	Crystals('LiNbO3-1', {
	    name: 'LiNbO3 ref 1',
	    info: 'http://www.newlightphotonics.com/bibo-properties.html',
	    type: 'Negative Uniaxial',
	    cls: 'class_3m',
	    lambda_min: 0.4 * 1e-9,
	    lambda_max: 3.4 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	        //Alan Migdal's program & http://www.redoptronics.com/linbo3-crystals.html
	        var nx = Math.sqrt(4.9048 - 0.11768 / (0.04750 - lambda_sq) - 0.027169 * lambda_sq);
	        var ny = nx;
	        var nz = Math.sqrt(4.5820 - 0.099169 / (0.044432 - lambda_sq) - 0.021950 * lambda_sq);
	
	        // http://www.redoptronics.com/linbo3-crystals.html
	        // var nx = Math.sqrt(4.9048+0.11768/(sq(lambda) - 0.04750) - 0.027169 * sq(lambda));
	        // var ny = nx
	        // var nz = Math.sqrt(4.5820+0.099169/(sq(lambda)- 0.04443) - 0.021950 * sq(lambda));
	
	        //http://www.newlightphotonics.com/LN-crystal.html
	        var dnx = -0.874e-6;
	        var dny = dnx;
	        var dnz = 39.073e-6;
	
	        nx = nx + (temp - 20.0) * dnx;
	        ny = ny + (temp - 20.0) * dny;
	        nz = nz + (temp - 20.0) * dnz;
	
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * LiNbO3 MGO doped indicies.
	 */
	Crystals('LiNB-MgO', {
	    name: 'LiNbO3 (5% MgO doped)',
	    info: 'Applied Physics B May 2008,Volume 91,Issue 2,pp 343-348',
	    type: '',
	    cls: '',
	    lambda_min: 440 * 1e-9,
	    lambda_max: 4000 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var F = (temp - 24.5) * (temp + 570.82);
	
	        // Coefficients for the extraordinary index
	        var a1 = 5.756,
	            a2 = 0.0983,
	            a3 = 0.2020,
	            a4 = 189.32,
	            a5 = 12.52,
	            a6 = 1.32e-2,
	            b1 = 2.86e-6,
	            b2 = 4.7e-8,
	            b3 = 6.113e-8,
	            b4 = 1.516e-4;
	        var l2 = lambda * lambda;
	        var nz = Math.sqrt(a1 + b1 * F + (a2 + b2 * F) / (l2 - sq(a3 + b3 * F)) + (a4 + b4 * F) / (l2 - sq(a5)) - a6 * l2);
	
	        // Coefficients for the oridnary index
	        a1 = 5.653;
	        a2 = 0.1185;
	        a3 = 0.2091;
	        a4 = 89.61;
	        a5 = 10.85;
	        a6 = 1.97e-2;
	        b1 = 7.941e-7;
	        b2 = 3.134e-8;
	        b3 = -4.641e-9;
	        b4 = -2.188e-6;
	
	        var nx = Math.sqrt(a1 + b1 * F + (a2 + b2 * F) / (l2 - sq(a3 + b3 * F)) + (a4 + b4 * F) / (l2 - sq(a5)) - a6 * l2);
	        var ny = nx;
	
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * LiNbO3 indicies.
	 */
	Crystals('KDP-1', {
	    name: 'KDP ref 1',
	    info: 'http://www.newlightphotonics.com/KDP-crystal.html',
	    type: 'Negative Uniaxial',
	    cls: 'class_3m',
	    lambda_min: 200 * 1e-9,
	    lambda_max: 1500 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	
	        //Alan Migdal's program & http://www.redoptronics.com/linbo3-crystals.html
	        // var nx = Math.sqrt( 4.9048 - 0.11768/(0.04750 - sq(lambda)) - 0.027169*sq(lambda) );
	        var nx = Math.sqrt(2.259276 + 13.005522 * lambda_sq / (lambda_sq - 400) + 0.01008956 / (lambda_sq - 0.012942625));
	        var ny = nx;
	        // var nz = Math.sqrt( 4.5820 - 0.099169/(0.044432 - lambda_sq) -  0.021950*lambda_sq );
	        var nz = Math.sqrt(2.132668 + 3.2279924 * lambda_sq / (lambda_sq - 400) + 0.008637494 / (lambda_sq - 0.012281043));
	
	        // http://www.redoptronics.com/linbo3-crystals.html
	        // var nx = Math.sqrt(4.9048+0.11768/(sq(lambda) - 0.04750) - 0.027169 * sq(lambda));
	        // var ny = nx
	        // var nz = Math.sqrt(4.5820+0.099169/(sq(lambda)- 0.04443) - 0.021950 * sq(lambda));
	
	        //http://www.newlightphotonics.com/LN-crystal.html
	        var dnx = -0.874e-6;
	        var dny = dnx;
	        var dnz = 39.073e-6;
	
	        nx = nx + (temp - 20.0) * dnx;
	        ny = ny + (temp - 20.0) * dny;
	        nz = nz + (temp - 20.0) * dnz;
	
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * AGGaSe2
	 */
	Crystals('AgGaSe2-1', {
	    name: 'AgGaSe2 Ref 1',
	    info: 'H. Kildal, J. Mikkelsen, Opt. Commun. 9, 315 (1973)',
	    type: '',
	    cls: '',
	    lambda_min: 1000 * 1e-9,
	    lambda_max: 13500 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	
	        var nx = Math.sqrt(3.9362 + 2.9113 / (1 - sq(0.38821 / lambda)) + 1.7954 / (1 - sq(40 / lambda))),
	            ny = nx,
	            nz = Math.sqrt(3.3132 + 3.3616 / (1 - sq(0.38201 / lambda)) + 1.7677 / (1 - sq(40 / lambda)));
	
	        // http://www.redoptronics.com/AgGaS2-AgGaSe2.html
	        var dnx = 15e-5,
	            dny = dnx,
	            dnz = 15e-5;
	
	        nx = nx + (temp - 20.0) * dnx;
	        ny = ny + (temp - 20.0) * dny;
	        nz = nz + (temp - 20.0) * dnz;
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * AGGaSe2
	 */
	Crystals('AgGaSe2-2', {
	    name: 'AgGaSe2 Ref 2',
	    info: 'G. C. Bhar, Appl. Opt., 15, 305 (1976)',
	    type: '',
	    cls: '',
	    lambda_min: 1000 * 1e-9,
	    lambda_max: 13500 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	
	        var nx = Math.sqrt(4.6453 + 2.2057 / (1 - sq(0.43347 / lambda)) + 1.8377 / (1 - sq(40 / lambda))),
	            ny = nx,
	            nz = Math.sqrt(5.2912 + 1.3970 / (1 - sq(0.53339 / lambda)) + 1.9282 / (1 - sq(40 / lambda)));
	
	        // Got temperature coefficients fro:
	        // http://www.redoptronics.com/AgGaS2-AgGaSe2.html
	        var dnx = 15e-5,
	            dny = dnx,
	            dnz = 15e-5;
	
	        nx = nx + (temp - 20.0) * dnx;
	        ny = ny + (temp - 20.0) * dny;
	        nz = nz + (temp - 20.0) * dnz;
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * AgGaS2
	 */
	Crystals('AgGaS2-1', {
	    name: 'AgGaS2 Ref 1',
	    info: 'G. C. Bhar, Appl. Opt., 15, 305 (1976)',
	    type: '',
	    cls: '',
	    lambda_min: 500 * 1e-9,
	    lambda_max: 13000 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	
	        var nx = Math.sqrt(3.628 + 2.1686 * lambda_sq / (lambda_sq - 0.1003) + 2.1753 * lambda_sq / (lambda_sq - 950)),
	            ny = nx,
	            nz = Math.sqrt(4.0172 + 1.5274 * lambda_sq / (lambda_sq - 0.131) + 2.1699 * lambda_sq / (lambda_sq - 950));
	
	        // Got temperature coefficients fro:
	        // http://www.redoptronics.com/AgGaS2-AgGaSe2.html
	        var dnx = 15.4e-5,
	            dny = dnx,
	            dnz = 15.5e-5;
	
	        nx = nx + (temp - 20.0) * dnx;
	        ny = ny + (temp - 20.0) * dny;
	        nz = nz + (temp - 20.0) * dnz;
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * LiIO3 ref 1
	 */
	Crystals('LiIO3-1', {
	    name: 'LiIO3 Ref 1',
	    info: 'B. F. Levine, C. G. Bethea: Appl. Phys. Lett. 20, 272 (1972)',
	    type: 'Negative Uniaxial',
	    cls: 'Class 6',
	    lambda_min: 300 * 1e-9,
	    lambda_max: 5000 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	
	        var nx = Math.sqrt(2.03132 + 1.37623 / (1 - 0.0350832 / lambda_sq) + 1.06745 / (1 - 169 / lambda_sq)),
	            ny = nx,
	            nz = Math.sqrt(1.83086 + 1.08807 / (1.0 - 0.031381 / lambda_sq) + 0.554582 / (1.0 - 158.76 / lambda_sq));
	        return [nx, ny, nz];
	    }
	});
	
	/**
	 * LiIO3 ref 2
	 */
	Crystals('LiIO3-2', {
	    name: 'LiIO3 Ref 2',
	    info: 'K. Takizawa, M. Okada, S. Leiri, Opt. Commun., 23, 279 (1977)',
	    type: 'Negative Uniaxial',
	    cls: 'Class 6',
	    lambda_min: 300 * 1e-9,
	    lambda_max: 5000 * 1e-9,
	    indicies: function indicies(lambda, temp) {
	        lambda = lambda * 1e6; //Convert for Sellmeir Coefficients
	        var lambda_sq = sq(lambda);
	
	        var nx = Math.sqrt(3.4095 + 0.047664 / (lambda_sq - 0.033991)),
	            ny = nx,
	            nz = Math.sqrt(2.9163 + 0.034514 / (lambda_sq - 0.031034));
	        return [nx, ny, nz];
	    }
	});
	
	module.exports = Crystals;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(315);
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(316),
	    arrayEach = __webpack_require__(356),
	    assignValue = __webpack_require__(357),
	    baseAssign = __webpack_require__(360),
	    cloneBuffer = __webpack_require__(383),
	    copyArray = __webpack_require__(384),
	    copySymbols = __webpack_require__(385),
	    getAllKeys = __webpack_require__(388),
	    getTag = __webpack_require__(391),
	    initCloneArray = __webpack_require__(397),
	    initCloneByTag = __webpack_require__(398),
	    initCloneObject = __webpack_require__(413),
	    isArray = __webpack_require__(368),
	    isBuffer = __webpack_require__(369),
	    isObject = __webpack_require__(334),
	    keys = __webpack_require__(362);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var props = isArr ? undefined : (isFull ? getAllKeys : keys)(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(317),
	    stackClear = __webpack_require__(325),
	    stackDelete = __webpack_require__(326),
	    stackGet = __webpack_require__(327),
	    stackHas = __webpack_require__(328),
	    stackSet = __webpack_require__(329);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(318),
	    listCacheDelete = __webpack_require__(319),
	    listCacheGet = __webpack_require__(322),
	    listCacheHas = __webpack_require__(323),
	    listCacheSet = __webpack_require__(324);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 318 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(320);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(321);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 321 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(320);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(320);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(320);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(317);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 326 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 327 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 328 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(317),
	    Map = __webpack_require__(330),
	    MapCache = __webpack_require__(341);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(331),
	    root = __webpack_require__(337);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(332),
	    getValue = __webpack_require__(340);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(333),
	    isMasked = __webpack_require__(335),
	    isObject = __webpack_require__(334),
	    toSource = __webpack_require__(339);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(334);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(336);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(337);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(338);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 338 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 339 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 340 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(342),
	    mapCacheDelete = __webpack_require__(350),
	    mapCacheGet = __webpack_require__(353),
	    mapCacheHas = __webpack_require__(354),
	    mapCacheSet = __webpack_require__(355);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(343),
	    ListCache = __webpack_require__(317),
	    Map = __webpack_require__(330);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(344),
	    hashDelete = __webpack_require__(346),
	    hashGet = __webpack_require__(347),
	    hashHas = __webpack_require__(348),
	    hashSet = __webpack_require__(349);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(345);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(331);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 346 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(345);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(345);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(345);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(351);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(352);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(351);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(351);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(351);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 356 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(358),
	    eq = __webpack_require__(321);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(359);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(331);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(361),
	    keys = __webpack_require__(362);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(357),
	    baseAssignValue = __webpack_require__(358);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(363),
	    baseKeys = __webpack_require__(378),
	    isArrayLike = __webpack_require__(382);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(364),
	    isArguments = __webpack_require__(365),
	    isArray = __webpack_require__(368),
	    isBuffer = __webpack_require__(369),
	    isIndex = __webpack_require__(372),
	    isTypedArray = __webpack_require__(373);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 364 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(366),
	    isObjectLike = __webpack_require__(367);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(367);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && objectToString.call(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 367 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 368 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(337),
	    stubFalse = __webpack_require__(371);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(370)(module)))

/***/ },
/* 370 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 372 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(374),
	    baseUnary = __webpack_require__(376),
	    nodeUtil = __webpack_require__(377);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(375),
	    isObjectLike = __webpack_require__(367);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 375 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(338);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(370)(module)))

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(379),
	    nativeKeys = __webpack_require__(380);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 379 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(381);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 381 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(333),
	    isLength = __webpack_require__(375);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(337);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(370)(module)))

/***/ },
/* 384 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(361),
	    getSymbols = __webpack_require__(386);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(381),
	    stubArray = __webpack_require__(387);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	module.exports = getSymbols;


/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(389),
	    getSymbols = __webpack_require__(386),
	    keys = __webpack_require__(362);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(390),
	    isArray = __webpack_require__(368);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 390 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(392),
	    Map = __webpack_require__(330),
	    Promise = __webpack_require__(393),
	    Set = __webpack_require__(394),
	    WeakMap = __webpack_require__(395),
	    baseGetTag = __webpack_require__(396),
	    toSource = __webpack_require__(339);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(331),
	    root = __webpack_require__(337);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(331),
	    root = __webpack_require__(337);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(331),
	    root = __webpack_require__(337);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(331),
	    root = __webpack_require__(337);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 396 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 397 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(399),
	    cloneDataView = __webpack_require__(401),
	    cloneMap = __webpack_require__(402),
	    cloneRegExp = __webpack_require__(406),
	    cloneSet = __webpack_require__(407),
	    cloneSymbol = __webpack_require__(410),
	    cloneTypedArray = __webpack_require__(412);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(400);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(337);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(399);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(403),
	    arrayReduce = __webpack_require__(404),
	    mapToArray = __webpack_require__(405);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 403 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 404 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 405 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 406 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(408),
	    arrayReduce = __webpack_require__(404),
	    setToArray = __webpack_require__(409);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 408 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 409 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(411);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(337);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(399);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(414),
	    getPrototype = __webpack_require__(415),
	    isPrototype = __webpack_require__(379);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(334);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(381);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Phasematching Library
	 * This is the file that will evolve into the lambda_ibrary of functions to compute phasematching.
	 */
	
	module.exports = {};
	
	var con = __webpack_require__(309);
	var helpers = __webpack_require__(312);
	var sq = helpers.sq;
	var pmLibMomentum = __webpack_require__(417);
	var properties = __webpack_require__(418);
	var svdcmp = __webpack_require__(311);
	var nelderMead = __webpack_require__(310);
	var PlotHelpers = __webpack_require__(440);
	
	/*
	 * calc_delK()
	 * Gets the index of refraction depending on phasematching type
	 * All angles in radians.
	 * P is SPDC Properties object
	 */
	
	module.exports.calc_delK = function calc_delK(P) {
	
	    var twoPI = Math.PI * 2;
	    var n_p = P.n_p;
	    var n_s = P.n_s;
	    var n_i = P.n_i;
	    var sinThetaS = Math.sin(P.theta_s);
	    var sinThetaI = Math.sin(P.theta_i);
	    var invLambdaS = 1 / P.lambda_s;
	    var invLambdaI = 1 / P.lambda_i;
	
	    // Directions of the signal and idler photons in the pump coordinates
	    var Ss = [sinThetaS * Math.cos(P.phi_s), sinThetaS * Math.sin(P.phi_s), Math.cos(P.theta_s)];
	    var Si = [sinThetaI * Math.cos(P.phi_i), sinThetaI * Math.sin(P.phi_i), Math.cos(P.theta_i)];
	
	    var delKx = twoPI * (n_s * Ss[0] * invLambdaS + n_i * Si[0] * invLambdaI);
	    var delKy = twoPI * (n_s * Ss[1] * invLambdaS + n_i * Si[1] * invLambdaI);
	    var delKz = twoPI * (n_p / P.lambda_p - n_s * Ss[2] * invLambdaS - n_i * Si[2] * invLambdaI);
	
	    if (P.enable_pp) {
	        delKz -= twoPI / (P.poling_period * P.poling_sign);
	    }
	
	    return [delKx, delKy, delKz];
	};
	
	/*
	 * calc_PM_tz
	 * Returns Phasematching function for the transverse and longitudinal directions
	 */
	
	module.exports.calc_PM_tz = function calc_PM_tz(P) {
	    var lambda_p = P.lambda_p; //store the original lambda_p
	    var n_p = P.n_p;
	
	    P.lambda_p = 1 / (1 / P.lambda_s + 1 / P.lambda_i);
	    P.n_p = P.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	    var delK = module.exports.calc_delK(P);
	
	    P.lambda_p = lambda_p; //set back to the original lambda_p
	    P.n_p = n_p;
	
	    var arg = P.L / 2 * delK[2];
	
	    var PMz_real = 0;
	    var PMz_imag = 0;
	
	    // var convfromFWHM = 1/(2 * Math.sqrt(2*Math.log(2))); //convert from FWHM
	    // var convfromFWHM = 1/(2 * Math.sqrt(Math.log(2)));
	    // Need to convert my 1/e^2 definition. I am using the definition
	    // E = exp(-x^2/(sqrt(2)*W)) vs the standard E = exp(-x^2/W)).
	    // Therefore W -> sqrt(2)*W
	    var convtoproppergaussian = 1 * Math.sqrt(2); // Use 1/e^2 in intensity.
	    // var convtoFWHM = 2*(Math.sqrt(Math.log(2)/2));
	
	    var W_s, W_i;
	
	    if (P.calcfibercoupling) {
	        W_s = P.W_sx;
	        W_i = P.W_ix;
	        // W_s = 2*Math.asin( Math.cos(P.theta_s_e)*Math.sin(P.W_sx/2)/(P.n_s * Math.cos(P.theta_s)));
	        // W_i = 2*Math.asin( Math.cos(P.theta_i_e)*Math.sin(P.W_ix/2)/(P.n_i * Math.cos(P.theta_i)));
	    } else {
	        W_s = Math.pow(2, 20); //Arbitrary large number
	        W_i = Math.pow(2, 20); //Arbitrary large number
	    }
	
	    // // Setup constants
	    var Wp_SQ = sq(P.W * convtoproppergaussian); // convert from FWHM to sigma
	    var Ws_SQ = sq(W_s * convtoproppergaussian); // convert from FWHM to sigma
	    var Wi_SQ = sq(W_i * convtoproppergaussian); // convert from FWHM to sigma @TODO: Change to P.W_i
	
	    // // Setup constants
	    // var Wp_SQ = sq(P.W * convtoFWHM); // convert from sigma to FWHM
	    // var Ws_SQ = sq(W_s * convtoFWHM); // convert from sigma to FWHM
	    // var Wi_SQ = sq(W_i * convtoFWHM); // convert from sigma to FWHM @TODO: Change to P.W_i
	
	    var COS_2THETAs = Math.cos(2 * P.theta_s);
	    var COS_2THETAi = Math.cos(2 * P.theta_i);
	    var COS_2PHIs = Math.cos(2 * P.phi_s);
	    var COS_THETAs = Math.cos(P.theta_s);
	    var COS_THETAi = Math.cos(P.theta_i);
	    var COS_PHIs = Math.cos(P.phi_s);
	
	    var SIN_2THETAs = Math.sin(2 * P.theta_s);
	    var SIN_2THETAi = Math.sin(2 * P.theta_i);
	    var SIN_2PHIs = Math.sin(2 * P.phi_s);
	    var SIN_THETAs = Math.sin(P.theta_s);
	    var SIN_THETAi = Math.sin(P.theta_i);
	    var SIN_PHIs = Math.sin(P.phi_s);
	    var COS_2THETAi_minus_PHIs = Math.cos(2 * (P.theta_i - P.phi_s));
	    var COS_2THETAs_minus_PHIs = Math.cos(2 * (P.theta_s - P.phi_s));
	    var COS_2THETAs_plus_PHIs = Math.cos(2 * (P.theta_s + P.phi_s));
	    var COS_2THETAi_plus_PHIs = Math.cos(2 * (P.theta_i + P.phi_s));
	    var COS_2THETAi_plus_THETAs = Math.cos(2 * (P.theta_i + P.theta_s));
	    var SIN_2THETAi_plus_THETAs = Math.sin(2 * (P.theta_i + P.theta_s));
	    var SIN_THETAi_plus_THETAs = Math.sin(P.theta_i + P.theta_s);
	
	    var RHOpx = P.walkoff_p; //pump walkoff angle.
	    // var RHOpx = 0; //pump walkoff angle.
	
	    RHOpx = -RHOpx; //Take the negative value. This is due to how things are defined later.
	
	    // Deal with the constant term without z dependence
	    // Expanded version where W_s does not have to equal W_i
	
	    var Anum1a = (6 + 2 * COS_2THETAi + COS_2THETAi_minus_PHIs - 2 * COS_2PHIs + COS_2THETAi_plus_PHIs) * sq(delK[0]);
	    var Anum1b = 8 * sq(SIN_THETAi) * SIN_2PHIs * delK[0] * delK[1];
	    var Anum1c = (6 + 2 * COS_2THETAi - COS_2THETAi_minus_PHIs + 2 * COS_2PHIs - COS_2THETAi_plus_PHIs) * sq(delK[1]);
	    var Anum1 = Anum1a + Anum1b + Anum1c;
	
	    var Anum2a = 8 * (sq(delK[0]) + sq(delK[1]));
	    var Anum2b = (6 + 2 * COS_2THETAs + COS_2THETAs_minus_PHIs + COS_2THETAs_plus_PHIs - 2 * COS_2PHIs) * sq(delK[0]);
	    var Anum2c = 8 * sq(SIN_THETAi) * SIN_2PHIs * delK[0] * delK[1];
	    var Anum2d = (6 + 2 * COS_2THETAs - COS_2THETAs_minus_PHIs - COS_2THETAs_plus_PHIs + 2 * COS_2PHIs) * sq(delK[1]);
	    var Anum2e = Anum2b + Anum2c + Anum2d;
	
	    var Anum1rr = Wp_SQ * Ws_SQ * (Anum1a + Anum1b + Anum1c);
	    var Anum2arr = 8 * Ws_SQ * (sq(delK[0]) + sq(delK[1]));
	    var Anum2rr = Wi_SQ * (Anum2arr + Wp_SQ * Anum2e);
	    var Anum = Wi_SQ * Ws_SQ * Wp_SQ * (Anum1rr + Anum2rr);
	
	    // var Aden = 16*(Wp_SQ*Ws_SQ + Wi_SQ*(Wp_SQ+Ws_SQ))*( sq(COS_THETAi)*Wp_SQ*Ws_SQ + Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ));
	    // var A = Anum / Aden;
	
	    var ki = P.n_i * 2 * Math.PI / P.lambda_i;
	    var ks = P.n_s * 2 * Math.PI / P.lambda_s;
	    var kp = P.n_p * 2 * Math.PI / P.lambda_p;
	
	    // Deal with the z term coefficient. It is imaginary. Version with W_s and W_i independent
	    var Bnum1 = 4 * (SIN_2THETAi * SIN_PHIs * delK[0] + COS_PHIs * SIN_2THETAi * delK[1] + 2 * sq(COS_THETAi) * delK[2]);
	
	    var Bnum2a = 4 * ((SIN_2THETAi - SIN_2THETAs) * SIN_PHIs * delK[0] + COS_PHIs * (SIN_2THETAi - SIN_2THETAs) * delK[1] + (2 + COS_2THETAi + COS_2THETAs) * delK[2]);
	    var Bnum2b = 4 * (3 + COS_2THETAi) * delK[2] + delK[0] * (4 * SIN_2THETAi * SIN_PHIs + (6 + 2 * COS_2THETAi + COS_2THETAi_minus_PHIs - 2 * COS_2PHIs + COS_2THETAi_plus_PHIs) * RHOpx) + 8 * COS_PHIs * SIN_THETAi * delK[1] * (COS_THETAi + SIN_THETAi * SIN_PHIs * RHOpx);
	
	    var Bnum3a1 = -4 * (SIN_2THETAs * SIN_PHIs * delK[0] + COS_PHIs * SIN_2THETAs * delK[1] - 2 * sq(COS_THETAs) * delK[2]);
	    var Bnum3a2 = 8 * (delK[2] + delK[1] * RHOpx);
	    var Bnum3b = 4 * (3 + COS_2THETAs) * delK[2] + delK[0] * (-4 * SIN_2THETAs * SIN_PHIs + (6 + 2 * COS_2THETAs + COS_2THETAs_minus_PHIs - 2 * COS_2PHIs + COS_2THETAs_plus_PHIs) * RHOpx) + 8 * COS_PHIs * SIN_THETAs * delK[1] * (-COS_THETAs + SIN_THETAs * SIN_PHIs * RHOpx);
	
	    // var Bnum1 = 4*sq(Wp_SQ)*sq(Ws_SQ)*(SIN_2THETAi*SIN_PHIs*delK[0] + COS_PHIs*SIN_2THETAi*delK[1] +2*sq(COS_THETAi)*delK[2]);
	    // var Bnum2a = 4*Wp_SQ*((SIN_2THETAi - SIN_2THETAs)*SIN_PHIs*delK[0] +COS_PHIs*(SIN_2THETAi- SIN_2THETAs)*delK[1] + (2+COS_2THETAi+COS_2THETAs)*delK[2]);       // var Bnum2b = Ws_SQ*(4*(3 + COS_2THETAi)*delK[2] +delK[0]*(4*SIN_2THETAi*SIN_PHIs + (6+2*COS_2THETAi+COS_2THETAi_minus_PHIs-2*COS_2PHIs+COS_2THETAi_plus_PHIs)*RHOpx) +8*COS_PHIs*SIN_THETAi*delK[1]*(COS_THETAi+SIN_THETAi*SIN_PHIs*RHOpx));
	    // var Bnum2b = Ws_SQ*(4*(3 + COS_2THETAi)*delK[2] +delK[0]*(4*SIN_2THETAi*SIN_PHIs + (6+2*COS_2THETAi+COS_2THETAi_minus_PHIs-2*COS_2PHIs+COS_2THETAi_plus_PHIs)*RHOpx) +8*COS_PHIs*SIN_THETAi*delK[1]*(COS_THETAi+SIN_THETAi*SIN_PHIs*RHOpx));
	    // var Bnum2 = Wi_SQ*Wp_SQ*Ws_SQ*(Bnum2a + Bnum2b);
	    // var Bnum2 = Wi_SQ*Wp_SQ*Ws_SQ*(Bnum2a + Bnum2b);
	    // var Bnum3a = -4*sq(Wp_SQ)*(SIN_2THETAs*SIN_PHIs*delK[0]+COS_PHIs*SIN_2THETAs*delK[1]-2*sq(COS_THETAs)*delK[2]) + 8*sq(Ws_SQ)*(delK[2]+delK[1]*RHOpx);
	    // var Bnum3b = Wp_SQ* Ws_SQ*(4*(3 + COS_2THETAs)*delK[2] +delK[0]*(-4*SIN_2THETAs*SIN_PHIs + (6+2*COS_2THETAs+COS_2THETAs_minus_PHIs-2*COS_2PHIs+COS_2THETAs_plus_PHIs)*RHOpx) +8*COS_PHIs*SIN_THETAs*delK[1]*(-COS_THETAs+SIN_THETAs*SIN_PHIs*RHOpx));
	    // var Bnum3 = sq(Wi_SQ)*(Bnum3a + Bnum3b);
	
	
	    // var Bnum = Bnum1 + Bnum2 +Bnum3;
	    // var B = 2*Bnum / (Aden);
	
	    //start z dependence on B
	    // var Bnum1 = 4*sq(Wp_SQ)*sq(Ws_SQ)*(SIN_2THETAi*SIN_PHIs*delK[0] + COS_PHIs*SIN_2THETAi*delK[1] +2*sq(COS_THETAi)*delK[2]);
	
	
	    // var B = BR;
	
	
	    // Deal with the z^2 term coefficient. It is real. Drop all terms where the walkoff angle is squared (small angle approx)
	    // version where W_s and W_i are different
	    var Cnum = sq(SIN_THETAi_plus_THETAs) * Wp_SQ + Ws_SQ * (sq(SIN_THETAi) - SIN_2THETAi * SIN_PHIs * RHOpx) + Wi_SQ * (sq(SIN_THETAs) + SIN_2THETAs * SIN_PHIs * RHOpx);
	
	    var Cnuma = sq(SIN_THETAi_plus_THETAs);
	    var Cnumb = sq(SIN_THETAi) - SIN_2THETAi * SIN_PHIs * RHOpx;
	    var Cnumc = sq(SIN_THETAs) + SIN_2THETAs * SIN_PHIs * RHOpx;
	
	    // var Cden = 2*(sq(COS_THETAi)*Wp_SQ+Wi_SQ*(COS_THETAs*Wp_SQ+Ws_SQ));
	    // var Cden = 2*(sq(COS_THETAi)*Wp_SQ*Ws_SQ +Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ));
	    // var C = Cnum / Cden;
	
	
	    // var Cnum = sq(SIN_THETAi_plus_THETAs)*Wp_SQ + Ws_SQ*(sq(SIN_THETAi) - SIN_2THETAi*SIN_PHIs*RHOpx)+Wi_SQ*(sq(SIN_THETAs)+SIN_2THETAs*SIN_PHIs*RHOpx);
	
	
	    // // Now calculate the normalization coefficients.
	    // // First the constant that remains after analytically integrating over x
	    var xconst1,
	        yconst1,
	        yconst2,
	        xconst,
	        yconst,
	        pi2 = 2 * Math.PI,
	        gaussnorm;
	
	    if (P.singles) {
	        xconst1 = 1 / Wp_SQ;
	        xconst1 += (sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs)) / Ws_SQ;
	        xconst = Math.sqrt(2 * Math.PI) / Math.sqrt(xconst1);
	
	        // Next the constant that remains after analytically integrating over y
	        yconst1 = (Wp_SQ + Ws_SQ) * (sq(COS_THETAs) * Wp_SQ + Ws_SQ);
	        yconst2 = Wp_SQ * Ws_SQ * ((sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs)) * Wp_SQ + Ws_SQ);
	        yconst = Math.sqrt(2 * Math.PI) / Math.sqrt(yconst1 / yconst2);
	
	        // Normalization from the Gaussian terms in the integral.
	        gaussnorm = 1 / Math.sqrt(pi2 * Ws_SQ) * (1 / Math.sqrt(pi2 * Wp_SQ));
	    } else {
	        xconst1 = (sq(COS_PHIs) + sq(COS_THETAi) * sq(SIN_PHIs)) / Wi_SQ;
	        xconst1 += 1 / Wp_SQ;
	        xconst1 += (sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs)) / Ws_SQ;
	        xconst = Math.sqrt(2 * Math.PI) / Math.sqrt(xconst1);
	
	        // Next the constant that remains after analytically integrating over y
	        yconst1 = (Wp_SQ * Ws_SQ + Wi_SQ * (Wp_SQ + Ws_SQ)) * sq(COS_THETAi) * Wp_SQ * Ws_SQ + Wi_SQ * (sq(COS_THETAs) * Wp_SQ + Ws_SQ);
	        yconst2 = Wi_SQ * Wp_SQ * Ws_SQ * ((sq(COS_PHIs) + sq(COS_THETAi) * sq(SIN_PHIs)) * Wp_SQ * Ws_SQ + Wi_SQ * ((sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs)) * Wp_SQ + Ws_SQ));
	        yconst = Math.sqrt(2 * Math.PI) / Math.sqrt(yconst1 / yconst2);
	
	        // Normalization from the Gaussian terms in the integral.
	        gaussnorm = 1 / Math.sqrt(pi2 * Ws_SQ) * (1 / Math.sqrt(pi2 * Wi_SQ)) * (1 / Math.sqrt(pi2 * Wp_SQ));
	    }
	
	    var pmzcoeff = 0,
	        bw;
	
	    if (P.calc_apodization && P.enable_pp) {
	        // var apodization_coeff = P.apodization_coeff;
	        bw = P.apodization_FWHM / 2.3548;
	    } else {
	        bw = Math.pow(2, 20);
	    }
	
	    ///////////////////////////////////////////
	    var calczterms = function calczterms(z) {
	        var Q_sR = Ws_SQ,
	            Q_sI = -2 * z / ks,
	            Q_iR = Wi_SQ,
	            Q_iI = -2 * z / ki,
	            Q_pR = Wp_SQ,
	            Q_pI = 2 * z / kp,
	            Q_sR_SQ = helpers.cmultiplyR(Q_sR, Q_sI, Q_sR, Q_sI),
	            Q_sI_SQ = helpers.cmultiplyI(Q_sR, Q_sI, Q_sR, Q_sI),
	            Q_iR_SQ = helpers.cmultiplyR(Q_iR, Q_iI, Q_iR, Q_iI),
	            Q_iI_SQ = helpers.cmultiplyI(Q_iR, Q_iI, Q_iR, Q_iI),
	            Q_pR_SQ = helpers.cmultiplyR(Q_pR, Q_pI, Q_pR, Q_pI),
	            Q_pI_SQ = helpers.cmultiplyI(Q_pR, Q_pI, Q_pR, Q_pI);
	
	        var Q_isR = helpers.cmultiplyR(Q_iR, Q_iI, Q_sR, Q_sI);
	        var Q_isI = helpers.cmultiplyI(Q_iR, Q_iI, Q_sR, Q_sI);
	
	        var Q_ispR = helpers.cmultiplyR(Q_pR, Q_pI, Q_isR, Q_isI);
	        var Q_ispI = helpers.cmultiplyI(Q_pR, Q_pI, Q_isR, Q_isI);
	
	        var Q_ipR = helpers.cmultiplyR(Q_iR, Q_iI, Q_pR, Q_pI);
	        var Q_ipI = helpers.cmultiplyI(Q_iR, Q_iI, Q_pR, Q_pI);
	
	        var Q_spR = helpers.cmultiplyR(Q_sR, Q_sI, Q_pR, Q_pI);
	        var Q_spI = helpers.cmultiplyI(Q_sR, Q_sI, Q_pR, Q_pI);
	
	        var Anum1R = Q_spR * Anum1;
	        var Anum1I = Q_spI * Anum1;
	        var Anum2aR = Q_sR * Anum2a;
	        var Anum2aI = Q_sI * Anum2a;
	        // var Anum2 = Wi_SQ*(Anum2a + Wp_SQ*(Anum2b + Anum2c + Anum2d));
	        var Anum2c1R = Q_pR * Anum2e;
	        var Anum2c1I = Q_pI * Anum2e;
	        var Anum2c2R = helpers.caddR(Anum2aR, Anum2aI, Anum2c1R, Anum2c1I);
	        var Anum2c2I = helpers.caddI(Anum2aR, Anum2aI, Anum2c1R, Anum2c1I);
	        var Anum2R = helpers.cmultiplyR(Anum2c2R, Anum2c2I, Q_iR, Q_iI);
	        var Anum2I = helpers.cmultiplyI(Anum2c2R, Anum2c2I, Q_iR, Q_iI);
	        // var Anum = Wi_SQ*Ws_SQ*Wp_SQ*(Anum1 + Anum2);
	        var Anum12R = helpers.caddR(Anum1R, Anum1I, Anum2R, Anum2I);
	        var Anum12I = helpers.caddI(Anum1R, Anum1I, Anum2R, Anum2I);
	        var AnumR = helpers.cmultiplyR(Q_ispR, Q_ispI, Anum12R, Anum12I);
	        var AnumI = helpers.cmultiplyI(Q_ispR, Q_ispI, Anum12R, Anum12I);
	        var Anum = AnumR;
	
	        // var Aden = 16*(Wp_SQ*Ws_SQ + Wi_SQ*(Wp_SQ+Ws_SQ))*( sq(COS_THETAi)*Wp_SQ*Ws_SQ + Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ));
	        var Aden1R = helpers.caddR(Q_spR, Q_spI, Q_ipR, Q_ipI);
	        var Aden1I = helpers.caddI(Q_spR, Q_spI, Q_ipR, Q_ipI);
	        var Aden2R = helpers.caddR(Aden1R, Aden1I, Q_isR, Q_isI);
	        var Aden2I = helpers.caddI(Aden1R, Aden1I, Q_isR, Q_isI);
	        var Aden3R = sq(COS_THETAi) * Q_spR;
	        var Aden3I = sq(COS_THETAi) * Q_spI;
	        var Aden4R = sq(COS_THETAs) * Q_ipR;
	        var Aden4I = sq(COS_THETAs) * Q_ipI;
	        var Aden5R = helpers.caddR(Aden3R, Aden3I, Aden4R, Aden4I);
	        var Aden5I = helpers.caddI(Aden3R, Aden3I, Aden4R, Aden4I);
	        var Aden6R = helpers.caddR(Aden5R, Aden5I, Q_isR, Q_isI);
	        var Aden6I = helpers.caddI(Aden5R, Aden5I, Q_isR, Q_isI);
	        var AdenR = 16 * helpers.cmultiplyR(Aden6R, Aden6I, Aden2R, Aden2I);
	        var AdenI = 16 * helpers.cmultiplyI(Aden6R, Aden6I, Aden2R, Aden2I);
	
	        var AR = helpers.cdivideR(AnumR, AnumI, AdenR, AdenI);
	        var AI = helpers.cdivideI(AnumR, AnumI, AdenR, AdenI);
	
	        var Bnum1aR = Q_pR_SQ * Bnum1;
	        var Bnum1aI = Q_pI_SQ * Bnum1;
	        var Bnum1R = helpers.cmultiplyR(Bnum1aR, Bnum1aI, Q_sR_SQ, Q_sI_SQ);
	        var Bnum1I = helpers.cmultiplyI(Bnum1aR, Bnum1aI, Q_sR_SQ, Q_sI_SQ);
	        // var Bnum2a = 4*Wp_SQ*((SIN_2THETAi - SIN_2THETAs)*SIN_PHIs*delK[0] +COS_PHIs*(SIN_2THETAi- SIN_2THETAs)*delK[1] + (2+COS_2THETAi+COS_2THETAs)*delK[2]);
	        var Bnum2aR = Q_pR * Bnum2a;
	        var Bnum2aI = Q_pI * Bnum2a;
	        // var Bnum2b = Ws_SQ*(4*(3 + COS_2THETAi)*delK[2] +delK[0]*(4*SIN_2THETAi*SIN_PHIs + (6+2*COS_2THETAi+COS_2THETAi_minus_PHIs-2*COS_2PHIs+COS_2THETAi_plus_PHIs)*RHOpx) +8*COS_PHIs*SIN_THETAi*delK[1]*(COS_THETAi+SIN_THETAi*SIN_PHIs*RHOpx));
	        var Bnum2bR = Q_sR * Bnum2b;
	        var Bnum2bI = Q_sI * Bnum2b;
	        // var Bnum2 = Wi_SQ*Wp_SQ*Ws_SQ*(Bnum2a + Bnum2b);
	        var Bnum2cR = helpers.caddR(Bnum2aR, Bnum2aI, Bnum2bR, Bnum2bI);
	        var Bnum2cI = helpers.caddI(Bnum2aR, Bnum2aI, Bnum2bR, Bnum2bI);
	        var Bnum2R = helpers.cmultiplyR(Bnum2cR, Bnum2cI, Q_ispR, Q_ispI);
	        var Bnum2I = helpers.cmultiplyI(Bnum2cR, Bnum2cI, Q_ispR, Q_ispI);
	        // var Bnum3a = -4*sq(Wp_SQ)*(SIN_2THETAs*SIN_PHIs*delK[0]+COS_PHIs*SIN_2THETAs*delK[1]-2*sq(COS_THETAs)*delK[2]) + 8*sq(Ws_SQ)*(delK[2]+delK[1]*RHOpx);
	        var Bnum3a1R = Bnum3a1 * Q_pR_SQ;
	        var Bnum3a1I = Bnum3a1 * Q_pI_SQ;
	        var Bnum3a2R = Bnum3a2 * Q_sR_SQ;
	        var Bnum3a2I = Bnum3a2 * Q_sI_SQ;
	        var Bnum3aR = helpers.caddR(Bnum3a1R, Bnum3a1I, Bnum3a2R, Bnum3a2I);
	        var Bnum3aI = helpers.caddI(Bnum3a1R, Bnum3a1I, Bnum3a2R, Bnum3a2I);
	        // var Bnum3b = Wp_SQ* Ws_SQ*(4*(3 + COS_2THETAs)*delK[2] +delK[0]*(-4*SIN_2THETAs*SIN_PHIs + (6+2*COS_2THETAs+COS_2THETAs_minus_PHIs-2*COS_2PHIs+COS_2THETAs_plus_PHIs)*RHOpx) +8*COS_PHIs*SIN_THETAs*delK[1]*(-COS_THETAs+SIN_THETAs*SIN_PHIs*RHOpx));
	        var Bnum3bR = Bnum3b * Q_spR;
	        var Bnum3bI = Bnum3b * Q_spI;
	        // var Bnum3 = sq(Wi_SQ)*(Bnum3a + Bnum3b);
	        var Bnum3cR = helpers.caddR(Bnum3aR, Bnum3aI, Bnum3bR, Bnum3bI);
	        var Bnum3cI = helpers.caddI(Bnum3aR, Bnum3aI, Bnum3bR, Bnum3bI);
	        var Bnum3R = helpers.cmultiplyR(Bnum3cR, Bnum3cI, Q_iR_SQ, Q_iI_SQ);
	        var Bnum3I = helpers.cmultiplyI(Bnum3cR, Bnum3cI, Q_iR_SQ, Q_iI_SQ);
	        // var Bnum = Bnum1 + Bnum2 +Bnum3;
	        var BnumaR = helpers.caddR(Bnum1R, Bnum1I, Bnum2R, Bnum2I);
	        var BnumaI = helpers.caddI(Bnum1R, Bnum1I, Bnum2R, Bnum2I);
	        var BnumR = helpers.caddR(BnumaR, BnumaI, Bnum3R, Bnum3I);
	        var BnumI = helpers.caddI(BnumaR, BnumaI, Bnum3R, Bnum3I);
	        // var B = 2*Bnum / (Aden);
	        var BR = 2 * helpers.cdivideR(BnumR, BnumI, AdenR, AdenI);
	        var BI = 2 * helpers.cdivideI(BnumR, BnumI, AdenR, AdenI);
	
	        var CnumaR = Q_pR * Cnuma,
	            CnumaI = Q_pI * Cnuma,
	            CnumbR = Q_sR * Cnumb,
	            CnumbI = Q_sI * Cnumb,
	            CnumcR = Q_iR * Cnumc,
	            CnumcI = Q_iI * Cnumc,
	            CnumdR = helpers.caddR(CnumaR, CnumaI, CnumbR, CnumbI),
	            CnumdI = helpers.caddI(CnumaR, CnumaI, CnumbR, CnumbI),
	            CnumR = helpers.caddR(CnumdR, CnumdI, CnumcR, CnumcI),
	            CnumI = helpers.caddI(CnumdR, CnumdI, CnumcR, CnumcI);
	
	        // var Cden = 2*(sq(COS_THETAi)*Wp_SQ*Ws_SQ +Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ));
	        var CdenaR = sq(COS_THETAi) * Q_spR,
	            CdenaI = sq(COS_THETAi) * Q_spI,
	            CdenbR = sq(COS_THETAs) * Q_ipR,
	            CdenbI = sq(COS_THETAs) * Q_ipI,
	            CdencR = helpers.caddR(CdenaR, CdenaI, CdenbR, CdenbI),
	            CdencI = helpers.caddI(CdenaR, CdenaI, CdenbR, CdenbI),
	            CdenR = 2 * helpers.caddR(CdencR, CdencI, Q_isR, Q_isI),
	            CdenI = 2 * helpers.caddI(CdencR, CdencI, Q_isR, Q_isI);
	
	        var CR = helpers.cdivideR(CnumR, CnumI, CdenR, CdenI),
	            CI = helpers.cdivideI(CnumR, CnumI, CdenR, CdenI);
	
	        // var coeff1R = helpers.caddR(Q_isR, Q_isI, Q_ipR, Q_ipI);
	        // var coeff1I = helpers.caddI(Q_isR, Q_isI, Q_ipR, Q_ipI);
	
	        // var coeffinvR = helpers.caddR(coeff1R, coeff1I, Q_spR, Q_spI);
	        // var coeffinvI = helpers.caddI(coeff1R, coeff1I, Q_spR, Q_spI);
	        // // Math.sqrt(Wp_SQ*Ws_SQ*Wi_SQ)
	        // var coeffR = helpers.cdivideR(Math.sqrt(Wp_SQ*Ws_SQ*Wi_SQ), 0, coeffinvR, coeffinvI);
	        // var coeffI = helpers.cdivideI(Math.sqrt(Wp_SQ*Ws_SQ*Wi_SQ), 0, coeffinvR, coeffinvI);
	
	        // gaussnorm = (1/Math.sqrt(pi2 * Ws_SQ)) * (1/Math.sqrt(pi2 * Wi_SQ)) * (1/Math.sqrt(pi2 * Wp_SQ));
	        var gN = sq(1 / Math.sqrt(Math.PI * 2)) * 1 / Math.sqrt(Math.PI * 2),
	            gaussR = helpers.cdivideR(gN * Math.sqrt(Ws_SQ * Wi_SQ * Wp_SQ), 0, Q_ispR, Q_ispI),
	            gaussI = helpers.cdivideI(gN * Math.sqrt(Ws_SQ * Wi_SQ * Wp_SQ), 0, Q_ispR, Q_ispI);
	
	        // xconst1 = (sq(COS_PHIs) + sq(COS_THETAi)*sq(SIN_PHIs))/Wi_SQ;
	        var xconst1R = helpers.cdivideR(sq(COS_PHIs) + sq(COS_THETAi) * sq(SIN_PHIs), 0, Q_iR, Q_iI),
	            xconst1I = helpers.cdivideI(sq(COS_PHIs) + sq(COS_THETAi) * sq(SIN_PHIs), 0, Q_iR, Q_iI),
	
	        // xconst1 += 1/Wp_SQ;
	        xconst2R = helpers.cdivideR(1, 0, Q_pR, Q_pI),
	            xconst2I = helpers.cdivideI(1, 0, Q_pR, Q_pI),
	            xconst3R = helpers.caddR(xconst1R, xconst1I, xconst2R, xconst2I),
	            xconst3I = helpers.caddI(xconst1R, xconst1I, xconst2R, xconst2I),
	
	        // xconst1 += (sq(COS_PHIs) + sq(COS_THETAs)*sq(SIN_PHIs))/Ws_SQ;
	        xconst4R = helpers.cdivideR(sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs), 0, Q_sR, Q_sI),
	            xconst4I = helpers.cdivideI(sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs), 0, Q_sR, Q_sI),
	            xconst5R = helpers.caddR(xconst3R, xconst3I, xconst4R, xconst4I),
	            xconst5I = helpers.caddI(xconst3R, xconst3I, xconst4R, xconst4I),
	
	        // Math.sqrt(xconst1);
	        xconst6R = helpers.csqrtR(xconst5R, xconst5I),
	            xconst6I = helpers.csqrtI(xconst5R, xconst5I),
	
	        // xconst = Math.sqrt(2*Math.PI)/Math.sqrt(xconst1);
	        xconstR = helpers.cdivideR(Math.sqrt(2 * Math.PI), 0, xconst6R, xconst6I),
	            xconstI = helpers.cdivideI(Math.sqrt(2 * Math.PI), 0, xconst6R, xconst6I);
	
	        // yconst numerator
	        // yconst1 = (Wp_SQ*Ws_SQ + Wi_SQ*(Wp_SQ+Ws_SQ))*(sq(COS_THETAi)*Wp_SQ*Ws_SQ + Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ ));
	        //
	        // (Wp_SQ*Ws_SQ + Wi_SQ*(Wp_SQ+Ws_SQ))
	        //
	        var ynum1R = helpers.caddR(Q_spR, Q_spI, Q_ipR, Q_ipI),
	            ynum1I = helpers.caddI(Q_spR, Q_spI, Q_ipR, Q_ipI),
	            ynum2R = helpers.caddR(ynum1R, ynum1I, Q_isR, Q_isI),
	            ynum2I = helpers.caddI(ynum1R, ynum1I, Q_isR, Q_isI),
	
	        // (sq(COS_THETAi))*Wp_SQ*Ws_SQ + Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ )
	        ynum3R = helpers.caddR(sq(COS_THETAs) * Q_ipR, sq(COS_THETAs) * Q_ipI, Q_isR, Q_isI),
	            ynum3I = helpers.caddI(sq(COS_THETAs) * Q_ipR, sq(COS_THETAs) * Q_ipI, Q_isR, Q_isI),
	            ynum4R = helpers.caddR(ynum3R, ynum3I, sq(COS_THETAi) * Q_spR, sq(COS_THETAi) * Q_spI),
	            ynum4I = helpers.caddI(ynum3R, ynum3I, sq(COS_THETAi) * Q_spR, sq(COS_THETAi) * Q_spI),
	
	        // (Wp_SQ*Ws_SQ + Wi_SQ*(Wp_SQ+Ws_SQ))*(sq(COS_THETAi)*Wp_SQ*Ws_SQ + Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ ));
	        ynumR = helpers.cmultiplyR(ynum2R, ynum2I, ynum4R, ynum4I),
	            ynumI = helpers.cmultiplyI(ynum2R, ynum2I, ynum4R, ynum4I);
	
	        // // yconst denominator
	        // // yconst2 = Wi_SQ*Wp_SQ*Ws_SQ*((sq(COS_PHIs)+sq(COS_THETAi)*sq(SIN_PHIs))*Wp_SQ*Ws_SQ + Wi_SQ* (( sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs)) *Wp_SQ +Ws_SQ));
	        var c1 = sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs),
	            yden1R = helpers.caddR(c1 * Q_ipR, c1 * Q_ipI, Q_isR, Q_isI),
	            yden1I = helpers.caddI(c1 * Q_ipR, c1 * Q_ipI, Q_isR, Q_isI),
	            c2 = sq(COS_PHIs) + sq(COS_THETAi) * sq(SIN_PHIs),
	            yden2R = helpers.caddR(c2 * Q_spR, c2 * Q_spI, yden1R, yden1I),
	            yden2I = helpers.caddI(c2 * Q_spR, c2 * Q_spI, yden1R, yden1I),
	            ydenR = helpers.cmultiplyR(Q_ispR, Q_ispI, yden2R, yden2I),
	            ydenI = helpers.cmultiplyI(Q_ispR, Q_ispI, yden2R, yden2I);
	
	        // yconst = Math.sqrt(2*Math.PI)/Math.sqrt(yconst1/yconst2);
	        var yconstd1R = helpers.cdivideR(ynumR, ynumI, ydenR, ydenI),
	            yconstd1I = helpers.cdivideI(ynumR, ynumI, ydenR, ydenI),
	            yconstd2R = helpers.csqrtR(yconstd1R, yconstd1I),
	            yconstd2I = helpers.csqrtI(yconstd1R, yconstd1I),
	            yconstR = helpers.cdivideR(Math.sqrt(2 * Math.PI), 0, yconstd2R, yconstd2I),
	            yconstI = helpers.cdivideI(Math.sqrt(2 * Math.PI), 0, yconstd2R, yconstd2I);
	
	        var coeffaR = helpers.cmultiplyR(gaussR, gaussI, xconstR, xconstI),
	            coeffaI = helpers.cmultiplyI(gaussR, gaussI, xconstR, xconstI),
	            coeffR = helpers.cmultiplyR(coeffaR, coeffaI, yconstR, yconstI),
	            coeffI = helpers.cmultiplyI(coeffaR, coeffaI, yconstR, yconstI);
	
	        // // Next the constant that remains after analytically integrating over y
	        // yconst1 = (Wp_SQ*Ws_SQ + Wi_SQ*(Wp_SQ+Ws_SQ))*(sq(COS_THETAi))*Wp_SQ*Ws_SQ + Wi_SQ*(sq(COS_THETAs)*Wp_SQ+Ws_SQ );
	        // yconst2 = Wi_SQ*Wp_SQ*Ws_SQ*((sq(COS_PHIs)+sq(COS_THETAi)*sq(SIN_PHIs))*Wp_SQ*Ws_SQ + Wi_SQ* (( sq(COS_PHIs) + sq(COS_THETAs) * sq(SIN_PHIs)) *Wp_SQ +Ws_SQ));
	        // yconst = Math.sqrt(2*Math.PI)/Math.sqrt(yconst1/yconst2);
	
	        // // Normalization from the Gaussian terms in the integral.
	        // gaussnorm = (1/Math.sqrt(pi2 * Ws_SQ)) * (1/Math.sqrt(pi2 * Wi_SQ)) * (1/Math.sqrt(pi2 * Wp_SQ));
	
	        return [AR, AI, BR, BI, CR, CI, coeffR, coeffI];
	        // return [1,0, BR, BI, CR, CI];
	    };
	
	    ///////////////////////////////////////////
	    var zintfunc = function zintfunc(z) {
	        // var pmzcoeff = Math.exp(-sq(z)*C - 1/2*sq(z/bw));
	        // var real = pmzcoeff*Math.cos(B*z);
	        // var imag = pmzcoeff*Math.sin(B*z);
	        // Set up waist values
	
	        var terms = calczterms(z);
	
	        var AR = terms[0],
	            AI = terms[1],
	            BR = terms[2],
	            BI = terms[3],
	            CR = terms[4],
	            CI = terms[5],
	            coeffR = terms[6],
	            coeffI = terms[7];
	
	        var pmzcoeff = Math.exp(-1 / 2 * sq(z / bw)); // apodization
	        pmzcoeff = pmzcoeff * Math.exp(-sq(z) * CR - z * BI - AR);
	        var realE = pmzcoeff * Math.cos(-sq(z) * CI + z * BR - AI);
	        var imagE = pmzcoeff * Math.sin(-sq(z) * CI + z * BR - AI);
	
	        var real = helpers.cmultiplyR(realE, imagE, coeffR, coeffI);
	        var imag = helpers.cmultiplyI(realE, imagE, coeffR, coeffI);
	
	        return [real, imag];
	    };
	
	    var PMt;
	    if (P.calcfibercoupling) {
	        var dz = P.L / P.numzint;
	        var pmintz = helpers.Nintegrate2arg(zintfunc, -P.L / 2, P.L / 2, dz, P.numzint, P.zweights);
	        PMz_real = pmintz[0] / P.L;
	        PMz_imag = pmintz[1] / P.L;
	        PMt = 1;
	    } else {
	        var PMzNorm1 = Math.sin(arg) / arg;
	        // var PMz_real =  PMzNorm1 * Math.cos(arg);
	        // var PMz_imag = PMzNorm1 * Math.sin(arg);
	        PMz_real = PMzNorm1;
	        PMz_imag = 0;
	        PMt = Math.exp(-0.5 * (sq(delK[0]) + sq(delK[1])) * sq(P.W));
	    }
	    // var PMz_real = helpers.Nintegrate(zintReal,-P.L/2, P.L/2,numz)/P.L;
	    // var PMz_imag = helpers.Nintegrate(zintImag,-P.L/2, P.L/2,numz)/P.L;
	
	    // console.log(zintReal(0), bw);
	    // console.log(PMz_real, PMz_imag);
	
	
	    if (P.use_guassian_approx) {
	        // console.log('approx');
	        PMz_real = Math.exp(-0.193 * sq(arg));
	        PMz_imag = 0;
	    }
	
	    // Phasematching along transverse directions
	    // var PMt = Math.exp(-0.5*(sq(delK[0]) + sq(delK[1]))*sq(P.W));
	    // console.log(A);
	    // var PMt = Math.exp(-A);
	    // var PMt = 1;
	    // var PMt = Math.exp(-A) * xconst * yconst *gaussnorm;
	    return [PMz_real, PMz_imag, PMt];
	};
	
	/*
	 * pump_spectrum
	 * Returns the pump mode
	 */
	module.exports.pump_spectrum = function pump_spectrum(P) {
	    // @TODO: Need to move the pump bandwidth to someplace that is cached.
	    var p_bw = 2 * Math.PI * con.c / sq(P.lambda_p) * P.p_bw; //* n_p; //convert from wavelength to w
	    p_bw = p_bw / (2 * Math.sqrt(Math.log(2))); //convert from FWHM
	    var alpha = Math.exp(-1 / 2 * sq(2 * Math.PI * con.c * (1 / P.lambda_s + 1 / P.lambda_i - 1 / P.lambda_p) / p_bw));
	    return alpha;
	};
	
	/*
	 * phasematch()
	 * Gets the index of refraction depending on phasematching type
	 * P is SPDC Properties object
	 */
	module.exports.phasematch = function phasematch(P) {
	
	    // var pm = module.exports.calc_PM_tz(P);
	    // var pm = pmLibMomentum.calc_PM_tz_k_singles(P);
	    // var todeg = 180/Math.PI;
	    // console.log("Inside phasematch:  Theta_s: " + (P.theta_s*todeg).toString() + ", Theta_i: " + (P.theta_i*todeg).toString() );
	    var pm = pmLibMomentum.calc_PM_tz_k_coinc(P);
	    // Longitundinal components of PM.
	    var PMz_real = pm[0];
	    var PMz_imag = pm[1];
	    // Transverse component of PM
	    var PMt = pm[2];
	
	    var C_check = pm[3];
	    // console.log(C_check);
	    // if (C_check>0.5){
	    //     console.log("approx not valid," C_check);
	    // }
	    // Pump spectrum
	    var alpha = module.exports.pump_spectrum(P);
	    // var alpha = 1;
	
	    //return the real and imaginary parts of Phase matching function
	    return [alpha * PMt * PMz_real, alpha * PMt * PMz_imag, C_check];
	};
	
	/*
	 * phasematch()
	 * Gets the index of refraction depending on phasematching type
	 * P is SPDC Properties object
	 */
	module.exports.phasematch_coinc = function phasematch_coinc(P) {
	
	    var pm = pmLibMomentum.calc_PM_tz_k_coinc(P);
	    // Longitundinal components of PM.
	    var PMz_real = pm[0];
	    var PMz_imag = pm[1];
	    // Transverse component of PM
	    var PMt = pm[2];
	
	    var C_check = pm[3];
	
	    // Pump spectrum
	    var alpha = module.exports.pump_spectrum(P);
	    // var alpha = 1;
	
	    //return the real and imaginary parts of Phase matching function
	    return [alpha * PMt * PMz_real, alpha * PMt * PMz_imag, C_check];
	};
	
	/*
	 * phasematch_singles()
	 * Gets the index of refraction depending on phasematching type for the singles
	 * Rate for the signal photon.
	 * P is SPDC Properties object
	 */
	module.exports.phasematch_singles = function phasematch_singles(P) {
	
	    var pm = pmLibMomentum.calc_PM_tz_k_singles(P);
	    // Longitundinal components of PM.
	    var PMz_real = pm[0];
	    var PMz_imag = pm[1];
	    // Transverse component of PM
	    var PMt = pm[2];
	
	    var C_check = pm[3];
	    // console.log(C_check);
	    // if (C_check>0.5){
	    //     console.log("approx not valid," C_check);
	    // }
	    // Pump spectrum
	    var alpha = module.exports.pump_spectrum(P);
	    alpha = sq(alpha);
	    // var alpha = 1;
	
	    //return the real and imaginary parts of Phase matching function
	    return [alpha * PMt * PMz_real, alpha * PMt * PMz_imag, C_check];
	};
	
	/*
	 * phasematch_Int_Phase()
	 * Gets the index of refraction depending on phasematching type
	 * P is SPDC Properties object
	 */
	module.exports.phasematch_Int_Phase = function phasematch_Int_Phase(P) {
	
	    // PM is a complex array. First element is real part, second element is imaginary.
	    var PM = module.exports.phasematch(P);
	
	    var C_check = PM[2];
	
	    // var PMInt = sq(PM[0]) + sq(PM[1])
	
	    if (P.phase) {
	        var PMang = Math.atan2(PM[1], PM[0]) + Math.PI;
	        // need to figure out an elegant way to apodize the phase. Leave out for now
	        // var x = PMInt<0.01
	        // var AP = PMInt
	        // var AP[x] = 0.
	        // var x = PMInt >0
	        // var AP[x] = 1.
	
	        // PM = PMang * AP;
	        PM = PMang * 180 / Math.PI;
	    } else {
	        // console.log  ("calculating Intensity")
	        PM = sq(PM[0]) + sq(PM[1]);
	    }
	    // console.log(PM)
	    return { "phasematch": PM };
	};
	
	/*
	 * phasematch_Int_Phase()
	 * Gets the index of refraction depending on phasematching type
	 * P is SPDC Properties object
	 */
	module.exports.phasematch_Int_Phase_Singles = function phasematch_Int_Phase_Singles(P) {
	
	    // PM is a complex array. First element is real part, second element is imaginary.
	    var PM = module.exports.phasematch_singles(P);
	
	    var C_check = PM[2];
	
	    // var PMInt = sq(PM[0]) + sq(PM[1])
	
	    if (P.phase) {
	        var PMang = Math.atan2(PM[1], PM[0]) + Math.PI;
	        // need to figure out an elegant way to apodize the phase. Leave out for now
	        // var x = PMInt<0.01
	        // var AP = PMInt
	        // var AP[x] = 0.
	        // var x = PMInt >0
	        // var AP[x] = 1.
	
	        // PM = PMang * AP;
	        PM = PMang * 180 / Math.PI;
	    } else {
	        // console.log  ("calculating Intensity")
	        PM = sq(PM[0]) + sq(PM[1]);
	    }
	    // console.log(PM)
	    return { "phasematch": PM };
	};
	
	/*
	 * Normalization function for the joint spectrums
	 */
	module.exports.normalize_joint_spectrum = function normalize_joint_spectrum(props) {
	    // Find the optimum phase matching condition. This will be when delK = 0 and everything is collinear.
	    // Need to calculate optimum poling period and crystal angle.
	    var P = props.clone();
	    P.theta_s = 0;
	    P.theta_i = 0;
	    P.theta_s_e = 0;
	    P.theta_i_e = 0;
	    P.update_all_angles();
	
	    if (props.enable_pp) {
	        P.calc_poling_period();
	    } else {
	        P.auto_calc_Theta();
	    }
	
	    var norm = module.exports.phasematch_Int_Phase(P)['phasematch'];
	    return norm;
	};
	
	/*
	 * Normalization function for the joint spectrum of the Singles rate
	 */
	module.exports.normalize_joint_spectrum_singles = function normalize_joint_spectrum_singles(props) {
	    // Find the optimum phase matching condition. This will be when delK = 0 and everything is collinear.
	    // Need to calculate optimum poling period and crystal angle.
	    var P = props.clone();
	    P.theta_s = 0;
	    P.theta_i = 0;
	    P.theta_s_e = 0;
	    P.theta_i_e = 0;
	    P.update_all_angles();
	
	    if (props.enable_pp) {
	        P.calc_poling_period();
	    } else {
	        P.auto_calc_Theta();
	    }
	
	    var convfromFWHM = Math.sqrt(2) // Use 1/e^2 in intensity.
	    ,
	        Wi_SQ = Math.pow(P.W_sx * convfromFWHM, 2) // convert from FWHM to sigma @TODO: Change to P.W_i
	    ,
	        PHI_s = 1 / Math.cos(P.theta_s_e);
	
	    //console.log("Wi squared: ", Wi_SQ*PHI_s);
	
	    var norm = module.exports.phasematch_Int_Phase_Singles(P)['phasematch']; //*(Wi_SQ*PHI_s);
	    return norm;
	};
	
	/*
	 * calc_HOM_JSA()
	 * Calculates the Joint Spectra Amplitude of the HOM at a particluar time delay
	 * P is SPDC Properties object
	 * ls_start ... li_stop are the signal/idler wavelength ranges to calculate over
	 * delT is the time delay between signal and idler
	 */
	module.exports.calc_HOM_rate = function calc_HOM_rate(ls_start, ls_stop, li_start, li_stop, delT, JSA, dim) {
	
	    var lambda_s = helpers.linspace(ls_start, ls_stop, dim);
	    var lambda_i = helpers.linspace(li_stop, li_start, dim);
	
	    var rate = 0;
	
	    var PM_JSA1_real = JSA['PM_JSA1_real'];
	    var PM_JSA1_imag = JSA['PM_JSA1_imag'];
	    var PM_JSA2_real = JSA['PM_JSA2_real'];
	    var PM_JSA2_imag = JSA['PM_JSA2_imag'];
	
	    var N = dim * dim;
	    var JSI = new Float64Array(N);
	
	    for (var i = 0; i < N; i++) {
	        var index_s = i % dim;
	        var index_i = Math.floor(i / dim);
	
	        var ARG = 2 * Math.PI * con.c * (1 / lambda_s[index_s] - 1 / lambda_i[index_i]) * delT;
	        var Tosc_real = Math.cos(ARG);
	        var Tosc_imag = Math.sin(ARG);
	
	        var arg2_real = Tosc_real * PM_JSA2_real[index_s][index_i] - Tosc_imag * PM_JSA2_imag[index_s][index_i];
	        // rate = arg2_real;
	        var arg2_imag = Tosc_real * PM_JSA2_imag[index_s][index_i] + Tosc_imag * PM_JSA2_real[index_s][index_i];
	
	        var PM_real = (PM_JSA1_real[index_s][index_i] - arg2_real) / 2; ///Math.sqrt(2);
	        var PM_imag = (PM_JSA1_imag[index_s][index_i] - arg2_imag) / 2; //Math.sqrt(2);
	
	        var val = sq(PM_real) + sq(PM_imag);
	        JSI[i] = val;
	        rate += val;
	    }
	
	    return { "rate": rate, "JSI": JSI };
	};
	
	/*
	 * calc_HOM_bunch_JSA()
	 * Calculates the Joint Spectra Amplitude of the HOM at a particluar time delay
	 * P is SPDC Properties object
	 * ls_start ... li_stop are the signal/idler wavelength ranges to calculate over
	 * delT is the time delay between signal and idler
	 */
	module.exports.calc_HOM_bunch_rate = function calc_HOM_rate(ls_start, ls_stop, li_start, li_stop, delT, JSA, dim) {
	
	    var lambda_s = helpers.linspace(ls_start, ls_stop, dim);
	    var lambda_i = helpers.linspace(li_stop, li_start, dim);
	
	    var rate = 0;
	
	    var PM_JSA1_real = JSA['PM_JSA1_real'];
	    var PM_JSA1_imag = JSA['PM_JSA1_imag'];
	    var PM_JSA2_real = JSA['PM_JSA2_real'];
	    var PM_JSA2_imag = JSA['PM_JSA2_imag'];
	
	    var N = dim * dim;
	    var JSI = new Float64Array(N);
	
	    for (var i = 0; i < N; i++) {
	        var index_s = i % dim;
	        var index_i = Math.floor(i / dim);
	
	        var ARG = 2 * Math.PI * con.c * (1 / lambda_s[index_s] - 1 / lambda_i[index_i]) * delT;
	        var Tosc_real = Math.cos(ARG);
	        var Tosc_imag = Math.sin(ARG);
	
	        var arg2_real = Tosc_real * PM_JSA2_real[index_s][index_i] - Tosc_imag * PM_JSA2_imag[index_s][index_i];
	        // rate = arg2_real;
	        var arg2_imag = Tosc_real * PM_JSA2_imag[index_s][index_i] + Tosc_imag * PM_JSA2_real[index_s][index_i];
	
	        var PM_real = (PM_JSA1_real[index_s][index_i] + arg2_real) / 2; ///Math.sqrt(2);
	        var PM_imag = (PM_JSA1_imag[index_s][index_i] + arg2_imag) / 2; //Math.sqrt(2);
	
	        var val = sq(PM_real) + sq(PM_imag);
	        JSI[i] = val;
	        rate += val;
	    }
	
	    return { "rate": rate, "JSI": JSI };
	};
	/*
	 * calc_HOM_scan()
	 * Calculates the HOM probability of coincidences over range of times.
	 * P is SPDC Properties object
	 * delT is the time delay between signal and idler
	 */
	module.exports.calc_HOM_scan = function calc_HOM_scan(P, t_start, t_stop, ls_start, ls_stop, li_start, li_stop, dim, dip) {
	    // console.log(dip);
	    // dip = dip || true;
	    // console.log(dip);
	
	
	    var npts = 100; //number of points to pass to the calc_HOM_JSA
	
	    var delT = helpers.linspace(t_start, t_stop, dim);
	
	    var HOM_values = helpers.linspace(t_start, t_stop, dim);
	    var PM_JSA1 = PlotHelpers.calc_JSA(P, ls_start, ls_stop, li_start, li_stop, npts);
	    var PM_JSA2 = PlotHelpers.calc_JSA(P, li_start, li_stop, ls_start, ls_stop, npts);
	
	    var PM_JSA1_real = helpers.create_2d_array(PM_JSA1[0], npts, npts);
	    var PM_JSA1_imag = helpers.create_2d_array(PM_JSA1[1], npts, npts);
	    var PM_JSA2_real = helpers.create_2d_array(helpers.AntiTranspose(PM_JSA2[0], npts), npts, npts);
	    var PM_JSA2_imag = helpers.create_2d_array(helpers.AntiTranspose(PM_JSA2[1], npts), npts, npts);
	
	    var JSA = {
	        'PM_JSA1_real': PM_JSA1_real,
	        'PM_JSA1_imag': PM_JSA1_imag,
	        'PM_JSA2_real': PM_JSA2_real,
	        'PM_JSA2_imag': PM_JSA2_imag
	    };
	
	    var PM_JSI = PlotHelpers.calc_JSI(P, ls_start, ls_stop, li_start, li_stop, npts);
	
	    // Calculate normalization
	    var N = helpers.Sum(PM_JSI),
	        rate;
	
	    for (var i = 0; i < dim; i++) {
	        if (dip) {
	            rate = module.exports.calc_HOM_rate(ls_start, ls_stop, li_start, li_stop, delT[i], JSA, npts);
	        } else {
	            rate = module.exports.calc_HOM_bunch_rate(ls_start, ls_stop, li_start, li_stop, delT[i], JSA, npts);
	        }
	
	        HOM_values[i] = rate["rate"] / N;
	    }
	    return HOM_values;
	};
	
	/*
	 * calc_HOM_scan()
	 * Calculates the HOM probability of coincidences over range of times.
	 * P is SPDC Properties object
	 * delT is the time delay between signal and idler
	 */
	module.exports.calc_HOM_scan_p = function calc_HOM_scan(P, delT, ls_start, ls_stop, li_start, li_stop, npts, dip) {
	    // console.log(dip);
	    // dip = dip || true;
	    // console.log(dip);
	
	
	    // var npts = 50;  //number of points to pass to the calc_HOM_JSA
	    var dim = delT.length;
	
	    // var delT = helpers.linspace(t_start, t_stop, dim);
	
	    var HOM_values = new Float64Array(dim);
	    var PM_JSA1 = PlotHelpers.calc_JSA(P, ls_start, ls_stop, li_start, li_stop, npts);
	    var PM_JSA2 = PlotHelpers.calc_JSA(P, li_start, li_stop, ls_start, ls_stop, npts);
	
	    var PM_JSA1_real = helpers.create_2d_array(PM_JSA1[0], npts, npts);
	    var PM_JSA1_imag = helpers.create_2d_array(PM_JSA1[1], npts, npts);
	    var PM_JSA2_real = helpers.create_2d_array(helpers.AntiTranspose(PM_JSA2[0], npts), npts, npts);
	    var PM_JSA2_imag = helpers.create_2d_array(helpers.AntiTranspose(PM_JSA2[1], npts), npts, npts);
	
	    var JSA = {
	        'PM_JSA1_real': PM_JSA1_real,
	        'PM_JSA1_imag': PM_JSA1_imag,
	        'PM_JSA2_real': PM_JSA2_real,
	        'PM_JSA2_imag': PM_JSA2_imag
	    };
	
	    var PM_JSI = PlotHelpers.calc_JSI(P, ls_start, ls_stop, li_start, li_stop, npts);
	
	    // Calculate normalization
	    var N = helpers.Sum(PM_JSI),
	        rate;
	
	    for (var i = 0; i < dim; i++) {
	        if (dip) {
	            rate = module.exports.calc_HOM_rate(ls_start, ls_stop, li_start, li_stop, delT[i], JSA, npts);
	        } else {
	            rate = module.exports.calc_HOM_bunch_rate(ls_start, ls_stop, li_start, li_stop, delT[i], JSA, npts);
	        }
	
	        HOM_values[i] = rate["rate"] / N;
	    }
	    return HOM_values;
	};
	
	/*
	 * calc_HOM_JSA()
	 * Calculates the Joint Spectra Amplitude of the HOM at a particluar time delay
	 * P is SPDC Properties object
	 * ls_start ... li_stop are the signal/idler wavelength ranges to calculate over
	 * delT is the time delay between signal and idler
	 */
	module.exports.calc_HOM_JSA = function calc_HOM_JSA(P, ls_start, ls_stop, li_start, li_stop, delT, dim, dip) {
	    var PM_JSA1 = PlotHelpers.calc_JSA(P, ls_start, ls_stop, li_start, li_stop, dim);
	    var PM_JSA2 = PlotHelpers.calc_JSA(P, li_start, li_stop, ls_start, ls_stop, dim);
	
	    var PM_JSA1_real = helpers.create_2d_array(PM_JSA1[0], dim, dim);
	    var PM_JSA1_imag = helpers.create_2d_array(PM_JSA1[1], dim, dim);
	    var PM_JSA2_real = helpers.create_2d_array(helpers.AntiTranspose(PM_JSA2[0], dim), dim, dim);
	    var PM_JSA2_imag = helpers.create_2d_array(helpers.AntiTranspose(PM_JSA2[1], dim), dim, dim);
	
	    var JSA = {
	        'PM_JSA1_real': PM_JSA1_real,
	        'PM_JSA1_imag': PM_JSA1_imag,
	        'PM_JSA2_real': PM_JSA2_real,
	        'PM_JSA2_imag': PM_JSA2_imag
	    };
	
	    var JSI;
	
	    if (dip) {
	        JSI = module.exports.calc_HOM_rate(ls_start, ls_stop, li_start, li_stop, delT, JSA, dim);
	    } else {
	        JSI = module.exports.calc_HOM_bunch_rate(ls_start, ls_stop, li_start, li_stop, delT, JSA, dim);
	    }
	
	    return JSI["JSI"];
	};
	
	/*
	 * calc_2HOM_rate()
	 * Calculates the coincidence rate for two source HOM at a given time value
	 * P is SPDC Properties object
	 * PM_JSA is the joint spectral amplitude:
	 */
	module.exports.calc_2HOM_rate = function calc_HOM_rate(delT, ls_start, ls_stop, li_start, li_stop, PM_JSA_real, PM_JSA_imag, dim) {
	
	    var lambda_s = helpers.linspace(ls_start, ls_stop, dim);
	    var lambda_i = helpers.linspace(li_start, li_stop, dim);
	    var rate_ss = 0;
	    var rate_ii = 0;
	    var rate_si = 0;
	
	    // var PM_JSA_real = helpers.create_2d_array(PM_JSA[0], dim, dim);
	    // var PM_JSA_imag = helpers.create_2d_array(PM_JSA[1], dim, dim);
	
	    // Now create the ws, wi arrays for the two crystals. Because the crystals are identical, we can get away with
	    // using just one array for both ws and wi.
	
	    // loop over ws1
	    var twoPiCdelT = 2 * Math.PI * con.c * delT;
	
	    for (var j = 0; j < dim; j++) {
	
	        var lambda_s_j_inv = 1 / lambda_s[j];
	
	        // loop over wi1
	        for (var k = 0; k < dim; k++) {
	            var A_real = PM_JSA_real[j][k];
	            var A_imag = PM_JSA_imag[j][k];
	
	            var lambda_s_k_inv = 1 / lambda_s[k];
	
	            // loop over ws2
	            for (var l = 0; l < dim; l++) {
	                var C_real = PM_JSA_real[l][k];
	                var C_imag = PM_JSA_imag[l][k];
	
	                // for the signal signal phase
	                var lambda_i_l_inv = 1 / lambda_i[l];
	                var ARG_ss = twoPiCdelT * (lambda_s_j_inv - lambda_i_l_inv);
	                var Phase_ss_real = Math.cos(ARG_ss);
	                var Phase_ss_imag = Math.sin(ARG_ss);
	
	                // loop over wi2
	                for (var m = 0; m < dim; m++) {
	
	                    // for the idler idler phase
	                    var lambda_i_m_inv = 1 / lambda_i[m];
	                    var ARG_ii = twoPiCdelT * (lambda_s_k_inv - lambda_i_m_inv);
	                    var Phase_ii_real = Math.cos(ARG_ii);
	                    var Phase_ii_imag = Math.sin(ARG_ii);
	
	                    // for the signal/idler phase
	                    var ARG_si = twoPiCdelT * (lambda_s_j_inv - lambda_i_m_inv);
	                    var Phase_si_real = Math.cos(ARG_si);
	                    var Phase_si_imag = Math.sin(ARG_si);
	
	                    var B_real = PM_JSA_real[l][m];
	                    var B_imag = PM_JSA_imag[l][m];
	
	                    var D_real = PM_JSA_real[j][m];
	                    var D_imag = PM_JSA_imag[j][m];
	
	                    var Arg1_real = A_real * B_real - A_imag * B_imag;
	                    var Arg1_imag = A_real * B_imag + A_imag * B_real; //minus here b/c of complex conjugate
	
	                    var Arg2_real = C_real * D_real - C_imag * D_imag;
	                    var Arg2_imag = C_real * D_imag + C_imag * D_real; //minus here b/c of complex conjugate
	
	                    var Intf_ss_real = (Arg1_real - (Phase_ss_real * Arg2_real - Phase_ss_imag * Arg2_imag)) * 0.5;
	                    var Intf_ss_imag = (Arg1_imag - (Phase_ss_real * Arg2_imag + Phase_ss_imag * Arg2_real)) * 0.5;
	
	                    var Intf_ii_real = (Arg1_real - (Phase_ii_real * Arg2_real - Phase_ii_imag * Arg2_imag)) * 0.5;
	                    var Intf_ii_imag = (Arg1_imag - (Phase_ii_real * Arg2_imag + Phase_ii_imag * Arg2_real)) * 0.5;
	
	                    var Intf_si_real = (Arg1_real - (Phase_si_real * Arg2_real - Phase_si_imag * Arg2_imag)) * 0.5;
	                    var Intf_si_imag = (Arg1_imag - (Phase_si_real * Arg2_imag + Phase_si_imag * Arg2_real)) * 0.5;
	
	                    rate_ss += sq(Intf_ss_real) + sq(Intf_ss_imag);
	                    rate_ii += sq(Intf_ii_real) + sq(Intf_ii_imag);
	                    rate_si += sq(Intf_si_real) + sq(Intf_si_imag);
	                    // rate += HOM_real;
	                }
	            }
	        }
	    }
	    return { "ii": rate_ss, "ss": rate_ii, "si": rate_si };
	};
	
	/*
	 * calc_2HOM_norm()
	 * Calculates the normalization value
	 * P is SPDC Properties object
	 */
	module.exports.calc_2HOM_norm = function calc_HOM_norm(PM_JSA_real, PM_JSA_imag, dim) {
	    var rate = 0;
	
	    // var PM_JSA_real = helpers.create_2d_array(PM_JSA[0], dim, dim);
	    // var PM_JSA_imag = helpers.create_2d_array(PM_JSA[1], dim, dim);
	
	    // Now create the ws, wi arrays for the two crystals. Because the crystals are identical, we can get away with
	    // using just one array for both ws and wi.
	    // loop over ws1
	    for (var j = 0; j < dim; j++) {
	
	        // loop over wi1
	        for (var k = 0; k < dim; k++) {
	            var A_real = PM_JSA_real[j][k];
	            var A_imag = PM_JSA_imag[j][k];
	
	            // loop over ws2
	            for (var l = 0; l < dim; l++) {
	                // var C_real = PM_JSA_real[l][k];
	                // var C_imag = PM_JSA_imag[l][k];
	
	                // loop over wi2
	                for (var m = 0; m < dim; m++) {
	                    var B_real = PM_JSA_real[l][m];
	                    var B_imag = PM_JSA_imag[l][m];
	
	                    var Arg1_real = A_real * B_real - A_imag * B_imag;
	                    var Arg1_imag = A_real * B_imag + A_imag * B_real;
	
	                    rate += Arg1_real * Arg1_real + Arg1_imag * Arg1_imag;
	                }
	            }
	        }
	    }
	    return rate;
	};
	
	/*
	 * calc_2HOM_scan()
	 * Calculates the HOM probability of coincidences over range of times for two identical sources.
	 * P is SPDC Properties object
	 * delT is the time delay between signal and idler
	 */
	module.exports.calc_2HOM_scan = function calc_HOM_scan(P, t_start, t_stop, ls_start, ls_stop, li_start, li_stop, dim) {
	
	    var npts = 30; //number of points to pass to PlotHelpers.calc_JSA()
	    // dim = 20;
	    var delT = helpers.linspace(t_start, t_stop, dim);
	
	    var HOM_values_ss = new Float64Array(dim);
	    var HOM_values_ii = new Float64Array(dim);
	    var HOM_values_si = new Float64Array(dim);
	
	    var PM_JSA = PlotHelpers.calc_JSA(P, ls_start, ls_stop, li_start, li_stop, npts); // Returns the complex JSA
	
	    var PM_JSA_real = helpers.create_2d_array(PM_JSA[0], npts, npts);
	    var PM_JSA_imag = helpers.create_2d_array(PM_JSA[1], npts, npts);
	
	    // Calculate normalization
	    var N = module.exports.calc_2HOM_norm(PM_JSA_real, PM_JSA_imag, npts);
	    // var N = 1;
	
	    for (var i = 0; i < dim; i++) {
	        // PM_JSA = module.exports.calc_HOM_JSA(P, ls_start, ls_stop, li_start, li_stop, delT[i], npts);
	        // var total = helpers.Sum(PM_JSA)/N;
	        var rates = module.exports.calc_2HOM_rate(delT[i], ls_start, ls_stop, li_start, li_stop, PM_JSA_real, PM_JSA_imag, npts);
	        HOM_values_ss[i] = rates["ss"] / N;
	        HOM_values_ii[i] = rates["ii"] / N;
	        HOM_values_si[i] = rates["si"] / N;
	    }
	
	    return { "ss": HOM_values_ss, "ii": HOM_values_ii, "si": HOM_values_si };
	};
	
	/*
	 * calc_2HOM_scan()
	 * Calculates the HOM probability of coincidences over range of times for two identical sources.
	 * P is SPDC Properties object
	 * delT is the time delay between signal and idler
	 */
	module.exports.calc_2HOM_scan_p = function calc_HOM_scan(P, delT, ls_start, ls_stop, li_start, li_stop, dim) {
	
	    var npts = 30; //number of points to pass to PlotHelpers.calc_JSA()
	    // dim = 20;
	    // var delT = helpers.linspace(t_start, t_stop, dim);
	    dim = delT.length;
	
	    var HOM_values_ss = new Float64Array(dim);
	    var HOM_values_ii = new Float64Array(dim);
	    var HOM_values_si = new Float64Array(dim);
	
	    var PM_JSA = PlotHelpers.calc_JSA(P, ls_start, ls_stop, li_start, li_stop, npts); // Returns the complex JSA
	
	    var PM_JSA_real = helpers.create_2d_array(PM_JSA[0], npts, npts);
	    var PM_JSA_imag = helpers.create_2d_array(PM_JSA[1], npts, npts);
	
	    // Calculate normalization
	    var N = module.exports.calc_2HOM_norm(PM_JSA_real, PM_JSA_imag, npts);
	    // var N = 1;
	
	    for (var i = 0; i < dim; i++) {
	        // PM_JSA = module.exports.calc_HOM_JSA(P, ls_start, ls_stop, li_start, li_stop, delT[i], npts);
	        // var total = helpers.Sum(PM_JSA)/N;
	        var rates = module.exports.calc_2HOM_rate(delT[i], ls_start, ls_stop, li_start, li_stop, PM_JSA_real, PM_JSA_imag, npts);
	        HOM_values_ss[i] = rates["ss"] / N;
	        HOM_values_ii[i] = rates["ii"] / N;
	        HOM_values_si[i] = rates["si"] / N;
	    }
	
	    // return {"ss":HOM_values_ss, "ii":HOM_values_ii, "si":HOM_values_si};
	    return [HOM_values_ss, HOM_values_ii, HOM_values_si];
	};
	
	/*
	 * calc_Schmidt
	 * Calculates the Schmidt number for a 2D matrix
	 * NOTE: The SVD routine has problems with odd dimensions
	 */
	module.exports.calc_Schmidt = function calc_Schmidt(PM) {
	    // var PM2D = helpers.create2Darray(PM, dim,dim);
	
	    var l = PM.length;
	    var PMsqrt = new Array(l),
	        j,
	        i;
	
	    for (i = 0; i < l; i++) {
	        PMsqrt[i] = new Array(l);
	        for (j = 0; j < l; j++) {
	            PMsqrt[i][j] = Math.sqrt(PM[i][j]);
	        }
	    }
	    // console.log(PMsqrt);
	
	    var svd = svdcmp(PMsqrt);
	    // @TODO: add in logic to test if the SVD converged. It will return false if it did not.
	    var D = svd.W;
	    // console.log("D", D);
	    l = D.length;
	    //do the Normalization
	    var Norm = 0;
	    for (j = 0; j < l; j++) {
	        Norm += sq(D[j]);
	    }
	
	    // var Norm = helpers.Sum(D); // Normalization
	    // console.log("normalization", Norm);
	
	    var Kinv = 0;
	    for (i = 0; i < l; i++) {
	        Kinv += sq(sq(D[i]) / Norm); //calculate the inverse of the Schmidt number
	    }
	    return 1 / Kinv;
	};
	
	/**
	 * The following section is where we calculate intelligent guesses for the ranges of the plots.
	 */
	
	/**
	 * [autorange_lambda Calculates intelligent axes limits for lambda signal and idler]
	 * @param  {[type]} props     [description]
	 * @param  {[type]} threshold [description]
	 * @return {[type]}           [description]
	 */
	module.exports.autorange_lambda = function autorange_lambda(props, threshold) {
	    var P = props.clone();
	    P.phi_i = P.phi_s + Math.PI;
	    P.update_all_angles();
	    //eliminates sinc side lobes which cause problems.
	    P.use_guassian_approx = true;
	
	    var PMmax = module.exports.phasematch_Int_Phase(P);
	    // console.log("PMax : ",Math.sqrt(PMmax['phasematch']));
	    // threshold = PMmax*threshold*20;
	    // threshold = threshold;
	    //
	
	
	    threshold = threshold * PMmax['phasematch'];
	    // console.log(th)
	
	    var lambda_limit = function lambda_limit(lambda_s) {
	        P.lambda_s = lambda_s;
	        P.n_s = P.calc_Index_PMType(lambda_s, P.type, P.S_s, "signal");
	        P.lambda_i = 1 / (1 / P.lambda_p - 1 / lambda_s);
	        P.optimum_idler(P);
	
	        var PM = module.exports.phasematch_Int_Phase(P);
	        // console.log(P.lambda_p/1e-9, P.lambda_s/1e-9, P.lambda_i/1e-9, PM)
	        return Math.abs(PM["phasematch"] - threshold);
	    };
	
	    var guess = P.lambda_s - 1e-9;
	    var ans = nelderMead(lambda_limit, guess, 50);
	    var ans2 = 1 / (1 / props.lambda_p - 1 / ans);
	
	    var l1 = Math.min(ans, ans2);
	    var l2 = Math.max(ans, ans2);
	    // console.log(l1/1e-9, l2/1e-9);
	
	    var dif = Math.abs(ans - props.lambda_s);
	    // console.log(PMmax,threshold,ans/1e-9, ans2/1e-9, P.lambda_s/1e-9, dif/1e-9);
	
	    //Now try to find sensible limits. We want to make sure the range of values isn't too big,
	    //but also ensure that if the pump bandwidth is small, that the resulting JSA is visible.
	    //This is important for calculating things like the Hong-Ou-Mandel.
	    var difmax = 2e-9 * P.lambda_p / 775e-9 * P.p_bw / 1e-9;
	
	    // console.log("diff = ", dif/1e-9, difmax/1e-9);
	
	    if (difmax > 35e-9) {
	        difmax = 35e-9;
	    }
	
	    if (dif > difmax) {
	        dif = difmax;
	    }
	
	    var ls_a = props.lambda_s - 10 * dif;
	    var ls_b = props.lambda_s + 10 * dif;
	
	    // var li_a = props.lambda_i - 3 * dif;
	    // var li_b = props.lambda_i + 3 * dif;
	
	    // var ls_a = 1/(1/l1 + 1/l2)*2 - 3 * dif;
	    // var ls_b = 1/(1/l1 + 1/l2)*2 + 3 * dif;
	
	    var li_a = 1 / (1 / P.lambda_p - 1 / ls_b);
	    var li_b = 1 / (1 / P.lambda_p - 1 / ls_a);
	
	    // la = 1500e-9;
	    // lb = 1600e-9;
	
	    // console.log(ls_a/1e-9, ls_b/1e-9);
	    // l1 = l1 -2*dif;
	    // l2 = l2 + 2*dif;
	
	    return {
	        lambda_s: {
	            min: Math.min(ls_a, ls_b),
	            max: Math.max(ls_a, ls_b)
	        },
	        lambda_i: {
	            min: Math.min(li_a, li_b),
	            max: Math.max(li_a, li_b)
	        }
	    };
	};
	
	module.exports.autorange_delT = function autorange_delT(props, lambda_start, lambda_stop) {
	    // var P = props.clone();
	
	    var gv_s = props.get_group_velocity(props.lambda_s, props.type, props.S_s, "signal");
	    var gv_i = props.get_group_velocity(props.lambda_i, props.type, props.S_i, "idler");
	
	    // var zero_delay = props.L * (1/gv_i - 1/gv_s)/2;
	    var zero_delay = 0;
	    // console.log("minimum of HOM dip = ", zero_delay/1e-15);
	
	    var bw = Math.abs(lambda_stop - lambda_start);
	    var coh_time = 1 / (2 * Math.PI * con.c / sq(lambda_start + bw / 2) * bw);
	
	    var t_start = zero_delay - 40 * coh_time;
	    var t_stop = zero_delay + 40 * coh_time;
	
	    return [zero_delay, t_start, t_stop];
	};
	
	module.exports.autorange_delT_2crystal = function autorange_delT_2crystal(props, lambda_start, lambda_stop) {
	    // var P = props.clone();
	
	    var gv_s = props.get_group_velocity(props.lambda_s, props.type, props.S_s, "signal");
	    var gv_i = props.get_group_velocity(props.lambda_i, props.type, props.S_i, "idler");
	
	    // var zero_delay = props.L * (1/gv_i - 1/gv_s)/2;
	    var zero_delay = 0;
	    // console.log("minimum of HOM dip = ", zero_delay/1e-15);
	
	    var bw = Math.abs(lambda_stop - lambda_start);
	    var coh_time = 1 / (2 * Math.PI * con.c / sq(lambda_start + bw / 2) * bw);
	
	    var t_start = zero_delay - 40 * coh_time;
	    var t_stop = zero_delay + 40 * coh_time;
	
	    return [zero_delay, t_start, t_stop];
	};
	
	module.exports.autorange_theta = function autorange_theta(props) {
	    var P = props.clone();
	    P.update_all_angles();
	    var offset = 2 * Math.PI / 180;
	    var dif = P.theta_s - P.theta_s * 0.3;
	    var theta_start = dif * (1 - 1e-6 / P.W);
	    theta_start = Math.max(0, theta_start);
	    // var theta_end = P.theta_s + P.theta_s*0.4;
	    var theta_end = P.theta_s + (P.theta_s - theta_start);
	    theta_end = Math.max(2 * Math.PI / 180, theta_end);
	    // console.log("Before", theta_start*180/Math.PI, theta_end*180/Math.PI);
	    P.theta_s = theta_start;
	    P.update_all_angles();
	    theta_start = module.exports.find_external_angle(P, "signal");
	
	    P.theta_s = theta_end;
	    P.update_all_angles();
	    theta_end = module.exports.find_external_angle(P, "signal");
	    // console.log("after", theta_start*180/Math.PI, theta_end*180/Math.PI);
	
	    // console.log("optimal theta", theta_start*180/Math.PI, theta_end*theta_start*180/Math.PI);
	
	    return [theta_start, theta_end];
	};
	
	module.exports.autorange_poling_period = function autorange_poling_period(props) {
	    var P = props.clone();
	    P.theta = Math.PI / 2; //set the angle to 0
	    P.update_all_angles();
	    P.calc_poling_period();
	    var diff = 50e-6;
	    var poling_start = P.poling_period - diff;
	    var poling_end = P.poling_period + diff;
	
	    if (poling_start < 0) {
	        poling_start = 1e-6;
	    }
	
	    return [poling_start, poling_end];
	};
	
	module.exports.find_internal_angle = function find_internal_angle(props, photon) {
	    var P = props.clone(),
	        snell_external,
	        guess,
	        min_snells_law;
	
	    if (photon === 'signal') {
	        snell_external = Math.sin(props.theta_s_e);
	
	        min_snells_law = function min_snells_law(theta_internal) {
	            if (theta_internal > Math.PI / 2 || theta_internal < 0) {
	                return 1e12;
	            }
	            P.theta_s = theta_internal;
	
	            P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	            P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	
	            return Math.abs(snell_external - P.n_s * Math.sin(P.theta_s));
	        };
	
	        //Initial guess
	        guess = props.theta_s;
	        // guess = 16*Math.PI/180;
	    }
	    if (photon === 'idler') {
	        // var offset = 0.45/180*Math.PI;
	        // props.theta_i_e = props.theta_i_e + offset;
	
	        snell_external = Math.sin(props.theta_i_e);
	
	        min_snells_law = function min_snells_law(theta_internal) {
	            if (theta_internal > Math.PI / 2 || theta_internal < 0) {
	                return 1e12;
	            }
	            P.theta_i = theta_internal;
	
	            P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	            P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	            return Math.abs(snell_external - P.n_i * Math.sin(P.theta_i));
	        };
	
	        //Initial guess
	        guess = props.theta_i;
	        // guess = 45*Math.PI/180;
	    }
	    var ans = nelderMead(min_snells_law, guess, 40);
	    // console.log("Internal angle is: ", ans*180/Math.PI, props.theta_s*180/Math.PI );
	    return ans;
	};
	
	module.exports.find_external_angle = function find_external_angle(props, photon) {
	    var theta_external = 0,
	        arg;
	
	    if (photon === 'signal') {
	        arg = props.n_s * Math.sin(props.theta_s);
	        theta_external = Math.asin(arg);
	    }
	    if (photon === 'idler') {
	        arg = props.n_i * Math.sin(props.theta_i);
	        theta_external = Math.asin(arg);
	    }
	
	    // console.log("External angle is: ", theta_external*180/Math.PI, props.theta_s*180/Math.PI );
	    return theta_external;
	};
	
	module.exports.swap_signal_idler = function swap_signal_idler(P) {
	    // Swap role of signal and idler. Useful for calculating Idler properties
	    var tempLambda = P.lambda_s,
	        tempTheta = P.theta_s,
	        tempPhis = P.phi_s,
	        tempNs = P.n_s,
	        tempSs = P.S_s,
	        tempW_sx = P.W_sx,
	        tempW_sy = P.W_sy,
	        tempTheta_se = P.theta_s_e;
	
	    // Swap signal with Idler
	    P.lambda_s = P.lambda_i;
	    P.theta_s = P.theta_i;
	    P.phi_s = P.phi_i;
	    P.n_s = P.n_i;
	    P.S_s = P.S_i;
	    P.W_sx = P.W_ix;
	    P.W_sy = P.W_iy;
	    P.theta_s_e = module.exports.find_external_angle(P, "signal");
	
	    // Now replace Idler values with Signal values
	    P.lambda_i = tempLambda;
	    P.theta_i = tempTheta;
	    P.phi_i = tempPhis;
	    P.n_i = tempNs;
	    P.S_i = tempSs;
	    P.W_ix = tempW_sx;
	    P.W_iy = tempW_sy;
	    // P.theta_i_e = tempTheta_se;
	
	    P.update_all_angles();
	    return P;
	};

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Phasematching Library for momentum space calculations
	 */
	
	module.exports = {};
	var ellipticity = 1.0;
	var con = __webpack_require__(309);
	var helpers = __webpack_require__(312);
	var sq = helpers.sq;
	var pmLib = __webpack_require__(416);
	var properties = __webpack_require__(418);
	
	/*
	 * Get the constants and terms used in the calculation of the momentum
	 * space joint spectrum for the coincidences.
	 */
	module.exports.calc_PM_tz_k_coinc = function calc_PM_tz_k_coinc(P) {
	    // console.log("hi");
	    // console.log("\n");
	    // var todeg = 180/Math.PI;
	    // console.log("Inside calc_PM_tz_k_coinc:  Theta_s: " + (P.theta_s*todeg).toString() + ", Theta_i: " + (P.theta_i*todeg).toString() );
	    var toMicrons = 1;
	    // var toMicrons= 1;
	    var lambda_p = P.lambda_p; //store the original lambda_p
	    var n_p = P.n_p;
	
	    var twoPI = 2 * Math.PI,
	        twoPIc = twoPI * con.c * toMicrons;
	
	    var z0 = P.z0p //put pump in middle of the crystal
	    ,
	        z0s = P.z0s //-P.L/(2*Math.cos(P.theta_s_e))
	    ,
	        z0i = P.z0i //-P.L/(2*Math.cos(P.theta_i_e))
	    ;
	
	    // Get the pump index corresponding to the crystal phasematching function
	    // to calculate the K vector mismatch
	    P.lambda_p = 1 / (1 / P.lambda_s + 1 / P.lambda_i);
	    P.n_p = P.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	    // P.calc_walkoff_angles();
	    var RHOpx = P.walkoff_p; //pump walkoff angle.
	    // var RHOpx  = 0;
	
	
	    properties.convertToMicrons(P);
	
	    var omega_s = twoPIc / P.lambda_s,
	        omega_i = twoPIc / P.lambda_i,
	        omega_p = omega_s + omega_i
	    // omega_p = twoPIc / P.lambda_p
	    ;
	
	    // console.log("frequencies2:" + (P.lambda_p*1E9).toString() + ", " + (omega_p/twoPI*1E-9).toString() + ", " + (omega_s*1E-9).toString() + ", " + (omega_i*1E-9).toString() + ", ")
	    // convertToMicrons(P);
	
	    var delK = pmLib.calc_delK(P);
	    var delKx = delK[0],
	        delKy = delK[1],
	        delKz = delK[2];
	
	    // console.log("deltaK:" + delKx.toString() + ", " + delKy.toString() + ", " + delKz.toString() + ", ")
	    var toDeg = 180 / Math.PI;
	    // console.log("angles in calc:", P.theta_s*toDeg, P.theta_s_e*toDeg, P.phi_s*toDeg);
	    // Height of the collected spots from the axis.
	    var hs = Math.tan(P.theta_s) * P.L * 0.5 * Math.cos(P.phi_s),
	        hi = Math.tan(P.theta_i) * P.L * 0.5 * Math.cos(P.phi_i);
	
	    var PMz_real = 0;
	    var PMz_imag = 0;
	
	    // var convfromFWHM = 1*Math.sqrt(2); // Use 1/e^2 in intensity.
	    var convfromFWHM = 1; // Use 1/e^2 in intensity.
	
	
	    // var W_s = 2*Math.asin( Math.cos(P.theta_s_e)*Math.sin(P.W_sx/2)/(P.n_s * Math.cos(P.theta_s))),
	    //     W_i = 2*Math.asin( Math.cos(P.theta_i_e)*Math.sin(P.W_ix/2)/(P.n_i * Math.cos(P.theta_i)));
	
	
	    // Setup constants
	    var Wp_SQ = sq(P.W * convfromFWHM),
	        // convert from FWHM to sigma
	    Ws_SQ = sq(P.W_sx * convfromFWHM),
	        // convert from FWHM to sigma
	    Wi_SQ = sq(P.W_sx * convfromFWHM),
	        // convert from FWHM to sigma @TODO: Change to P.W_i
	    // Ws_SQ = sq(W_s * convfromFWHM), // convert from FWHM to sigma
	    // Wi_SQ = sq(W_i * convfromFWHM) // convert from FWHM to sigma @TODO: Change to P.W_i
	    Wx_SQ = Wp_SQ * sq(ellipticity),
	        Wy_SQ = Wp_SQ;
	
	    // Is this the k vector along the direction of propagation?
	    var k_p = twoPI * P.n_p / P.lambda_p,
	        k_s = twoPI * P.n_s / P.lambda_s,
	        //  * Math.cos(P.theta_s),
	    k_i = twoPI * P.n_i / P.lambda_i // * Math.cos(P.theta_i)
	    ;
	
	    //     var Ss = [ sinThetaS * Math.cos(P.phi_s),  sinThetaS * Math.sin(P.phi_s), Math.cos(P.theta_s)];
	    var PHI_s = sq(1 / Math.cos(P.theta_s_e)),
	        // External angle for the signal???? Is PHI_s z component?
	    PHI_i = sq(1 / Math.cos(P.theta_i_e)),
	        // External angle for the idler????
	    PSI_s = k_s / P.n_s * Math.sin(P.theta_s_e) * Math.cos(P.phi_s),
	        // Looks to be the y component of the ks,i
	    PSI_i = k_i / P.n_i * Math.sin(P.theta_i_e) * Math.cos(P.phi_i);
	
	    var bw; // Apodization 1/e^2
	
	    // Take into account apodized crystals
	    if (P.calc_apodization && P.enable_pp) {
	        bw = P.apodization_FWHM / 2.3548;
	        bw = 2 * bw / P.L; // convert from 0->L to -1 -> 1 for the integral over z
	    } else {
	        bw = Math.pow(2, 20);
	    }
	
	    // Now put the waist of the signal & idler at the center fo the crystal.
	    // W = Wfi.*sqrt( 1 + 2.*1i.*(zi+hi.*sin(thetai_f))./(kif.*Wfi^2));
	    var Ws_r = Ws_SQ,
	        Ws_i = 2 / (k_s / P.n_s) * (z0s + hs * Math.sin(P.theta_s_e) * Math.cos(P.phi_s)),
	        Wi_r = Wi_SQ,
	        Wi_i = 2 / (k_i / P.n_i) * (z0i + hi * Math.sin(P.theta_i_e) * Math.cos(P.phi_i));
	
	    // console.log("Signal WAIST:",Ws_r,Ws_i);
	    // console.log('SIGNAL CALCULATIONS:', hs * Math.sin(P.theta_s_e)*Math.cos(P.phi_s), hi * Math.sin(P.theta_i_e)*Math.cos(P.phi_i) );
	    // console.log("EXTERNAL ANGLES:", P.theta_s_e * toDeg, P.theta_i_e * toDeg);
	
	    // console.log("Theta_s: " + (P.theta_s * 180 / Math.PI).toString() + ", Theta_i: " + (P.theta_i * 180 / Math.PI).toString(), ", PHI_I: " + PHI_i.toString() + ", Psi_I: " + PSI_i.toString() + ", PHI_s: " + PHI_s.toString() + ", Psi_s: " + PSI_s.toString());
	    // console.log("Ks: " + k_s.toString() + "Ki: " + k_i.toString() + "Kp: " + k_p.toString() + "PHI_s: " + PHI_s.toString() + "PSIs: " + PSI_s.toString() );
	    // Now calculate the the coeficients that get repeatedly used. This is from
	    // Karina's code. Assume a symmetric pump waist (Wx = Wy)
	
	    var ks_f = k_s / P.n_s,
	        ki_f = k_i / P.n_i,
	        SIN_THETA_s_e = Math.sin(P.theta_s_e),
	        SIN_THETA_i_e = Math.sin(P.theta_i_e),
	        COS_THETA_s_e = Math.cos(P.theta_s_e),
	        COS_THETA_i_e = Math.cos(P.theta_i_e),
	        TAN_THETA_s_e = Math.tan(P.theta_s_e),
	        TAN_THETA_i_e = Math.tan(P.theta_i_e),
	        COS_PHI_s = Math.cos(P.phi_s),
	        COS_PHI_i = Math.cos(P.phi_i),
	        GAM2s = -0.25 * Ws_SQ,
	        GAM2i = -0.25 * Wi_SQ,
	        GAM1s = GAM2s * PHI_s,
	        GAM1i = GAM2i * PHI_i,
	        GAM3s = -2 * ks_f * GAM1s * SIN_THETA_s_e * COS_PHI_s,
	        GAM3i = -2 * ki_f * GAM1i * SIN_THETA_i_e * COS_PHI_i,
	        GAM4s = -0.5 * ks_f * SIN_THETA_s_e * COS_PHI_s * GAM3s,
	        GAM4i = -0.5 * ki_f * SIN_THETA_i_e * COS_PHI_i * GAM3i,
	        zhs = z0s + hs * SIN_THETA_s_e * COS_PHI_s,
	        zhi = z0i + hi * SIN_THETA_i_e * COS_PHI_i,
	        DEL2s = 0.5 / ks_f * zhs,
	        DEL2i = 0.5 / ki_f * zhi,
	        DEL1s = DEL2s * PHI_s,
	        DEL1i = DEL2i * PHI_i,
	        DEL3s = -hs - zhs * PHI_s * SIN_THETA_s_e * COS_PHI_s,
	        DEL3i = -hi - zhi * PHI_i * SIN_THETA_i_e * COS_PHI_i,
	        DEL4s = 0.5 * ks_f * zhs * sq(TAN_THETA_s_e) - ks_f * z0s,
	        DEL4i = 0.5 * ki_f * zhi * sq(TAN_THETA_i_e) - ki_f * z0i,
	        As_r = -0.25 * Wx_SQ + GAM1s,
	        As_i = -DEL1s,
	        Ai_r = -0.25 * Wx_SQ + GAM1i,
	        Ai_i = -DEL1i,
	        Bs_r = -0.25 * Wy_SQ + GAM2s,
	        Bs_i = -DEL2s,
	        Bi_r = -0.25 * Wy_SQ + GAM2i,
	        Bi_i = -DEL2i,
	        Cs = -0.25 * (P.L / k_s - 2 * z0 / k_p),
	        Ci = -0.25 * (P.L / k_i - 2 * z0 / k_p),
	        Ds = 0.25 * P.L * (1 / k_s - 1 / k_p),
	        Di = 0.25 * P.L * (1 / k_i - 1 / k_p)
	    // ,Es_r =  0.50 * (Ws_r*PHI_s * PSI_s)
	    // ,Es_i =  0.50 * (Ws_i*PHI_i * PSI_s)
	    // ,Ei_r =  0.50 * (Wi_r*PHI_i * PSI_i)
	    // ,Ei_i =  0.50 * (Wi_i*PHI_i * PSI_i)
	    ,
	        mx_real = -0.50 * Wx_SQ,
	        mx_imag = z0 / k_p,
	        my_real = -0.50 * Wy_SQ,
	        my_imag = mx_imag,
	        m = P.L / (2 * k_p),
	        n = 0.5 * P.L * Math.tan(RHOpx),
	        ee = 0.5 * P.L * (k_p + k_s + k_i + twoPI / (P.poling_period * P.poling_sign)),
	        ff = 0.5 * P.L * (k_p - k_s - k_i - twoPI / (P.poling_period * P.poling_sign))
	    // ,hh_r = -0.25 * (Wi_r * PHI_i * sq(PSI_i) + Ws_r * PHI_s * sq(PSI_s))
	    // ,hh_i = -0.25 * (Wi_i * PHI_i * sq(PSI_i) + Ws_i * PHI_s * sq(PSI_s))
	    ,
	        hh_r = GAM4s + GAM4i,
	        hh_i = -(DEL4s + DEL4i);
	
	    // console.log("INSIDE COINCIDENCES");
	
	    // console.log("GAM1s:", GAM1s);
	    // console.log("GAM2s:", GAM2s);
	    // console.log("GAM3s:", GAM3s);
	    // console.log("GAM4s:", GAM4s);
	    // console.log("DEL1s:", DEL1s);
	    // console.log("DEL2s:", DEL2s);
	    // console.log("DEL3s:", DEL3s);
	    // console.log("DEL4s:", DEL4s);
	
	    // console.log("GAM1i:", GAM1i);
	    // console.log("GAM2i:", GAM2i);
	    // console.log("GAM3i:", GAM3i);
	    // console.log("GAM4i:", GAM4i);
	    // console.log("DEL1i:", DEL1i);
	    // console.log("DEL2i:", DEL2i);
	    // console.log("DEL3i:", DEL3i);
	    // console.log("DEL4i:", DEL4i);
	
	    // console.log("hs:", hs, hi, zhs, zhi);
	
	
	    var A1R = As_r,
	        A1IO = As_i + Cs,
	        A1I = 0,
	        A2R = Bs_r,
	        A2IO = Bs_i + Cs,
	        A2I = 0,
	        A3R = Ai_r,
	        A3IO = Ai_i + Ci,
	        A3I = 0,
	        A4R = Bi_r,
	        A4IO = Bi_i + Ci,
	        A4I = 0,
	        A5R = GAM3s,
	        A5I = -DEL3s,
	        A6R = 0,
	        A6IO = n,
	        A6I = 0,
	        A7R = GAM3i,
	        A7I = -DEL3i,
	        A8R = mx_real,
	        A8IO = mx_imag,
	        A8I = 0,
	        A9R = my_real,
	        A9IO = my_imag,
	        A9I = 0,
	        A10R = hh_r,
	        A10IO = hh_i + ee,
	        A10I = 0;
	
	    var zintfunc = function zintfunc(z) {
	        // z = 0;
	        // var terms = calczterms(z);
	        // var A1R = terms[0][0],
	        //     A1I = terms[0][1],
	        //     A2R = terms[1][0],
	        //     A2I = terms[1][1],
	        //     A3R = terms[2][0],
	        //     A3I = terms[2][1],
	        //     A4R = terms[3][0],
	        //     A4I = terms[3][1],
	        //     A5R = terms[4][0],
	        //     A5I = terms[4][1],
	        //     A6R = terms[5][0],
	        //     A6I = terms[5][1],
	        //     A7R = terms[6][0],
	        //     A7I = terms[6][1],
	        //     A8R = terms[7][0],
	        //     A8I = terms[7][1],
	        //     A9R = terms[8][0],
	        //     A9I = terms[8][1],
	        //     A10R = terms[9][0],
	        //     A10I = terms[9][1]
	        //     ;
	
	        var m_z = m * z,
	            Ds_z = Ds * z,
	            Di_z = Di * z,
	            ff_z = ff * z;
	
	        A1I = A1IO + Ds_z;
	        A2I = A2IO + Ds_z;
	        A3I = A3IO + Di_z;
	        A4I = A4IO + Di_z;
	        A6I = A6IO * (1 + z);
	        A8I = A8IO - m_z;
	        A9I = A9IO - m_z;
	        A10I = A10IO + ff_z;
	
	        // (-4 A3 + A8^2/A1)
	        // console.log("hello");
	        // console.log("A1R: " + A1R.toString() + "   A2R: " + A2R.toString()+"A3R: " + A3R.toString() + "   A4R: " + A4R.toString()+"A5R: " + A5R.toString() + "   A6R: " + A6R.toString()+"A7R: " + A7R.toString() + "   A8R: " + A8R.toString()+"A9R: " + A9R.toString() + "   A10R: " + A10R.toString());
	        // First calculate terms in the exponential of the integral
	        //   E^(1/4 (4 A10 - A5^2/A1 - A6^2/A2 - (-2 A1 A7 + A5 A8)^2/(A1 (4 A1 A3 - A8^2)) - (A6^2 (-2 A2 + A9)^2)/(A2 (4 A2 A4 - A9^2)))
	        // )
	
	        // From Karina's code
	        //         % z = (exp((4.*A11 - A2.^2./A1 - A4.^2./A3 - (A10.*A4 - 2.*A3.*A8).^2./(A3.*(-A10.^2 + 4.*A3.*A7)) - (-2.*A1.*A6 + A2.*A9).^2./(A1.*(4.*A1.*A5 - A9.^2)))./4.)./...
	        // %
	        // Kr -> Ka
	        // A1 -> A1
	        // A2 -> A3
	        // A3 -> A5
	        // A4 -> A7
	        // A5 -> A2
	        // A6 -> A4
	        // A6 -> A8
	        // A7 -> A6
	        // A8 -> A9
	        // A9 -> A10
	        // A10 -> A11
	
	        // Ka -> Kr
	        // A1 -> A1
	        // A2 -> A5
	        // A3 -> A2
	        // A4 -> A6
	        // A5 -> A3
	        // A6 -> A7
	        // A7 -> A4
	        // A8 -> A6
	        // A9 -> A8
	        // A10 -> A9
	        // A11 -> A10
	
	        // 4 A10
	        var EXP1R = A10R * 4,
	            EXP1I = A10I * 4,
	
	
	        // A5^2/A1
	        EXP2R_a = helpers.cmultiplyR(A5R, A5I, A5R, A5I),
	            EXP2I_a = helpers.cmultiplyI(A5R, A5I, A5R, A5I),
	            EXP2R = helpers.cdivideR(EXP2R_a, EXP2I_a, A1R, A1I),
	            EXP2I = helpers.cdivideI(EXP2R_a, EXP2I_a, A1R, A1I),
	
	
	        // A6^2/A2
	        EXP3R_a = helpers.cmultiplyR(A6R, A6I, A6R, A6I),
	            EXP3I_a = helpers.cmultiplyI(A6R, A6I, A6R, A6I),
	            EXP3R = helpers.cdivideR(EXP3R_a, EXP3I_a, A2R, A2I),
	            EXP3I = helpers.cdivideI(EXP3R_a, EXP3I_a, A2R, A2I),
	
	
	        // (-2 A1 A7 + A5 A8)^2/ (A1 (4 A1 A3 - A8^2))
	        EXP4Ra_num = -2 * helpers.cmultiplyR(A1R, A1I, A7R, A7I),
	            EXP4Ia_num = -2 * helpers.cmultiplyI(A1R, A1I, A7R, A7I),
	            EXP4Rb_num = helpers.cmultiplyR(A5R, A5I, A8R, A8I),
	            EXP4Ib_num = helpers.cmultiplyI(A5R, A5I, A8R, A8I),
	            EXP4Rc_num = helpers.caddR(EXP4Ra_num, EXP4Ia_num, EXP4Rb_num, EXP4Ib_num),
	            EXP4Ic_num = helpers.caddI(EXP4Ra_num, EXP4Ia_num, EXP4Rb_num, EXP4Ib_num),
	            EXP4R_num = helpers.cmultiplyR(EXP4Rc_num, EXP4Ic_num, EXP4Rc_num, EXP4Ic_num),
	            EXP4I_num = helpers.cmultiplyI(EXP4Rc_num, EXP4Ic_num, EXP4Rc_num, EXP4Ic_num),
	
	        // Denominator
	        EXP4Ra_den = -1 * helpers.cmultiplyR(A8R, A8I, A8R, A8I),
	            EXP4Ia_den = -1 * helpers.cmultiplyI(A8R, A8I, A8R, A8I),
	            EXP4Rb_den = 4 * helpers.cmultiplyR(A1R, A1I, A3R, A3I),
	            EXP4Ib_den = 4 * helpers.cmultiplyI(A1R, A1I, A3R, A3I),
	            EXP4Rc_den = helpers.caddR(EXP4Ra_den, EXP4Ia_den, EXP4Rb_den, EXP4Ib_den),
	            EXP4Ic_den = helpers.caddI(EXP4Ra_den, EXP4Ia_den, EXP4Rb_den, EXP4Ib_den),
	            EXP4R_den = helpers.cmultiplyR(A1R, A1I, EXP4Rc_den, EXP4Ic_den),
	            EXP4I_den = helpers.cmultiplyI(A1R, A1I, EXP4Rc_den, EXP4Ic_den),
	            EXP4R = helpers.cdivideR(EXP4R_num, EXP4I_num, EXP4R_den, EXP4I_den),
	            EXP4I = helpers.cdivideI(EXP4R_num, EXP4I_num, EXP4R_den, EXP4I_den),
	
	
	        // A6^2 (-2 A2 + A9)^2)/(A2 (4 A2 A4 - A9^2)))
	        EXP5Rb_num = helpers.caddR(-2 * A2R, -2 * A2I, A9R, A9I),
	            EXP5Ib_num = helpers.caddI(-2 * A2R, -2 * A2I, A9R, A9I),
	            EXP5Rc_num = helpers.cmultiplyR(EXP5Rb_num, EXP5Ib_num, EXP5Rb_num, EXP5Ib_num),
	            EXP5Ic_num = helpers.cmultiplyI(EXP5Rb_num, EXP5Ib_num, EXP5Rb_num, EXP5Ib_num),
	            EXP5R_num = helpers.cmultiplyR(EXP3R, EXP3I, EXP5Rc_num, EXP5Ic_num),
	            EXP5I_num = helpers.cmultiplyI(EXP3R, EXP3I, EXP5Rc_num, EXP5Ic_num),
	
	        // EXP5R_num  = helpers.cmultiplyR( EXP5Rd_num, EXP5Id_num, EXP5Rd_num, EXP5Id_num),
	        // EXP5I_num  = helpers.cmultiplyI( EXP5Rd_num, EXP5Id_num, EXP5Rd_num, EXP5Id_num),
	        // Denominator
	        EXP5Ra_den = -1 * helpers.cmultiplyR(A9R, A9I, A9R, A9I),
	            EXP5Ia_den = -1 * helpers.cmultiplyI(A9R, A9I, A9R, A9I),
	            EXP5Rb_den = 4 * helpers.cmultiplyR(A2R, A2I, A4R, A4I),
	            EXP5Ib_den = 4 * helpers.cmultiplyI(A2R, A2I, A4R, A4I),
	            EXP5R_den = helpers.caddR(EXP5Ra_den, EXP5Ia_den, EXP5Rb_den, EXP5Ib_den),
	            EXP5I_den = helpers.caddI(EXP5Ra_den, EXP5Ia_den, EXP5Rb_den, EXP5Ib_den),
	
	        // expression for fifth term
	        EXP5R = helpers.cdivideR(EXP5R_num, EXP5I_num, EXP5R_den, EXP5I_den),
	            EXP5I = helpers.cdivideI(EXP5R_num, EXP5I_num, EXP5R_den, EXP5I_den),
	
	
	        // Full expression for term in the exponential
	        EXP6R_a = helpers.caddR(EXP1R, EXP1I, -1 * EXP2R, -1 * EXP2I),
	            EXP6I_a = helpers.caddI(EXP1R, EXP1I, -1 * EXP2R, -1 * EXP2I),
	            EXP6R_b = helpers.caddR(EXP6R_a, EXP6I_a, -1 * EXP3R, -1 * EXP3I),
	            EXP6I_b = helpers.caddI(EXP6R_a, EXP6I_a, -1 * EXP3R, -1 * EXP3I),
	            EXP6R_c = helpers.caddR(EXP6R_b, EXP6I_b, -1 * EXP4R, -1 * EXP4I),
	            EXP6I_c = helpers.caddI(EXP6R_b, EXP6I_b, -1 * EXP4R, -1 * EXP4I),
	            EXPR = 0.25 * helpers.caddR(EXP6R_c, EXP6I_c, -1 * EXP5R, -1 * EXP5I),
	            EXPI = 0.25 * helpers.caddI(EXP6R_c, EXP6I_c, -1 * EXP5R, -1 * EXP5I),
	
	
	        //////////////////////////////////////////////////////////////////////////////
	        // Now deal with the denominator in the integral:
	        // Sqrt[A1 A2 (-4 A3 + A8^2/A1) (-4 A4 + A9^2/A2)]
	
	        // A1 A2
	        DEN1R = helpers.cmultiplyR(A1R, A1I, A2R, A2I),
	            DEN1I = helpers.cmultiplyI(A1R, A1I, A2R, A2I),
	
	
	        // (-4 A3 + A8^2/A1) //Matlab (-4 A7 + A10^2/A3)
	        DEN2R_a = helpers.cdivideR(-1 * EXP4Ra_den, -1 * EXP4Ia_den, A1R, A1I),
	            DEN2I_a = helpers.cdivideI(-1 * EXP4Ra_den, -1 * EXP4Ia_den, A1R, A1I),
	            DEN2R = helpers.caddR(-4 * A3R, -4 * A3I, DEN2R_a, DEN2I_a),
	            DEN2I = helpers.caddI(-4 * A3R, -4 * A3I, DEN2R_a, DEN2I_a),
	
	
	        // (-4 A4 + A9^2/A2)
	        DEN3R_a = helpers.cdivideR(-1 * EXP5Ra_den, -1 * EXP5Ia_den, A2R, A2I),
	            DEN3I_a = helpers.cdivideI(-1 * EXP5Ra_den, -1 * EXP5Ia_den, A2R, A2I),
	            DEN3R = helpers.caddR(-4 * A4R, -4 * A4I, DEN3R_a, DEN3I_a),
	            DEN3I = helpers.caddI(-4 * A4R, -4 * A4I, DEN3R_a, DEN3I_a),
	
	
	        // full expression for denominator
	        DEN4R_a = helpers.cmultiplyR(DEN1R, DEN1I, DEN2R, DEN2I),
	            DEN4I_a = helpers.cmultiplyI(DEN1R, DEN1I, DEN2R, DEN2I),
	            DEN4R_b = helpers.cmultiplyR(DEN4R_a, DEN4I_a, DEN3R, DEN3I),
	            DEN4I_b = helpers.cmultiplyI(DEN4R_a, DEN4I_a, DEN3R, DEN3I),
	            DENR = helpers.csqrtR(DEN4R_b, DEN4I_b),
	            DENI = helpers.csqrtI(DEN4R_b, DEN4I_b),
	
	
	        // Now calculate the full term in the integral.
	        pmzcoeff = Math.exp(-1 / 2 * sq(z / bw)),
	            // apodization
	        // pmzcoeff = 1,
	        // Exponential using Euler's formula
	        coeffR = Math.exp(EXPR),
	
	        // coeffR = 1,
	        EReal = coeffR * pmzcoeff * Math.cos(EXPI),
	            EImag = coeffR * pmzcoeff * Math.sin(EXPI),
	            real = helpers.cdivideR(EReal, EImag, DENR, DENI),
	            imag = helpers.cdivideI(EReal, EImag, DENR, DENI);
	        var EXPRadd = (EXP1R - EXP2R - EXP3R - EXP4R - EXP5R) / 4;
	
	        // console.log("Exponent: ", EXPR, EXPI);
	        // // console.log("4A10: ", EXP1R, EXP1I);
	        // // console.log("A5^2/A1: ", EXP2R, EXP2I);
	        // // console.log("A6^2/A2: ", EXP3R, EXP3I);
	        // // console.log("(-2 A1 A7 + A5 A8)^2:", EXP4R, EXP4I);
	        // // console.log("A6^2 (-2 A2 + A9)^2):", EXP5R, EXP5I);
	        // console.log("Den1: ", DEN1R, DEN1I);
	        // console.log("DEN2: ", DEN2R, DEN2I);
	        // console.log("DEN3: ", DEN3R, DEN3I);
	        // console.log("C9squaredA2:", DEN3R_a, DEN3I_a);
	        // console.log("Denominator: ", DENR, DENI);
	        // console.log("RESULT: ", (0.5*real).toExponential(), (0.5*imag).toExponential());
	        /////////////////////////////////////////////////////////////////
	        // console.log("real: " + EXPR.toString() + "   ExpImag: " + EXPI.toString() + "   DenR: " + DENR.toString() + "   DENI: " + DENI.toString() + " Den1I: " +DEN1I.toString() + " DEN2I: " + DEN2I.toString() + " DEN3I: " + DEN3I.toString() + " A1I: " + A1I.toString() + " A2I: " + A2I.toString() + " A8I: " + A8I.toString() + " A1I: " + A1I.toString() + " A3I: " + A3I.toString());
	        // console.log("real: " + EXPR.toString() + "   ExpImag: " + EXPI.toString() + "   DenR: " + DENR.toString() + "   DENI: " + DENI.toString() + " Den1R: " +DEN1R.toString() + " DEN2R: " + DEN2R.toString() + " DEN3R: " + DEN3R.toString() + " A1R: " + A1R.toString() + " A2R: " + A2R.toString() + " A8R: " + A8R.toString() + " A1R: " + A1R.toString() + " A3R: " + A3R.toString());
	        // console.log("real: " + EXPR.toString() + "   ExpImag: " + EXPI.toString() + " EXP1R: " + EXP1R.toString() + ", EXP2R: " + EXP2R.toString()+ ", EXP3R: " + EXP3R.toString()+ ", EXP4R: " + EXP4R.toString()+ ", EXP5R: " + EXP5R.toString() + " A1R: " + A1R.toString() + " A3R: " + A3R.toString() + "    A5I: " + A5I.toString() + ",    A7I: " + A7I.toString() + " A8R: " + A8R.toString() + ", Exp4R_num: " + EXP4R_num.toString() + ", Exp4I_num: " + EXP4I_num.toString() + ", Exp4R_den: " + EXP4R_den.toString() + ", Exp4I_den: " + EXP4I_den.toString() );
	        // console.log("real: " + real.toString() + " Imag: " + imag.toString());
	
	        return [real, imag];
	    };
	
	    var arg = P.L / 2 * delKz;
	    var PMt = 1;
	
	    if (P.calcfibercoupling) {
	        var dz = 2 / P.numzint;
	        var pmintz = helpers.Nintegrate2arg(zintfunc, -1, 1, dz, P.numzint, P.zweights);
	        // var pmintz = zintfunc(0.5);
	
	        // var dz = 1;
	        // var pmintz = helpers.Nintegrate2arg(zintfunc,-1, 1,dz,1,P.zweights);
	        // PMz_real = pmintz[0]/P.L ;
	        // PMz_imag = pmintz[1]/P.L ;
	        PMz_real = pmintz[0] / 2;
	        PMz_imag = pmintz[1] / 2;
	        // var coeff = (Math.sqrt(omega_s * omega_i)/ (P.n_s * P.n_i));
	        var coeff = 1;
	        PMz_real = PMz_real * coeff;
	        PMz_imag = PMz_imag * coeff;
	    } else {
	        var PMzNorm1 = Math.sin(arg) / arg;
	        // var PMz_real =  PMzNorm1 * Math.cos(arg);
	        // var PMz_imag = PMzNorm1 * Math.sin(arg);
	        PMz_real = PMzNorm1;
	        PMz_imag = 0;
	        PMt = Math.exp(-0.5 * (sq(delK[0]) + sq(delK[1])) * sq(P.W));
	    }
	
	    if (P.use_guassian_approx) {
	        // console.log('approx');
	        PMz_real = Math.exp(-0.193 * sq(arg));
	        PMz_imag = 0;
	    }
	
	    properties.convertToMeters(P);
	    P.lambda_p = lambda_p; //set back to the original lambda_p
	    P.n_p = n_p;
	    // console.log(PMz_real.toString());
	    return [PMz_real, PMz_imag, PMt];
	};
	
	/**********************************************************************
	 * Get the constants and terms used in the calculation of the momentum
	 * space joint spectrum for the singles counts from the Idler.
	 */
	module.exports.calc_PM_tz_k_singles = function calc_PM_tz_k_singles(P) {
	    // console.log("hi");
	    // console.log("\n");
	    var toMicrons = 1;
	    var lambda_p = P.lambda_p; //store the original lambda_p
	    var n_p = P.n_p;
	
	    // console.log("");
	    // console.log("Inside Singles");
	    // console.log(P.lambda_s.toString());
	
	    // // For testing purposes
	    // P.lambda_s = 2 * lambda_p;
	    // P.lambda_i = 2 * lambda_p;
	    // P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	    // P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	
	    var twoPI = 2 * Math.PI,
	        twoPIc = twoPI * con.c * toMicrons;
	
	    var z0 = P.z0p //put pump in middle of the crystal
	    ,
	        z0s = P.z0s // -P.L/(2*Math.cos(P.theta_s_e))
	    ;
	
	    // Get the pump index corresponding to the crystal phasematching function
	    // to calculate the K vector mismatch
	    P.lambda_p = 1 / (1 / P.lambda_s + 1 / P.lambda_i);
	    P.n_p = P.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	    // P.calc_walkoff_angles();
	    var RHOpx = P.walkoff_p; //pump walkoff angle.
	    // var RHOpx = 0
	
	    properties.convertToMicrons(P);
	    var omega_s = twoPIc / P.lambda_s,
	        omega_i = twoPIc / P.lambda_i,
	        omega_p = omega_s + omega_i
	    // omega_p = twoPIc / P.lambda_p
	    ;
	
	    // Height of the collected spots from the axis.
	    var hs = Math.tan(P.theta_s) * P.L * 0.5 * Math.cos(P.phi_s),
	        hi = Math.tan(P.theta_i) * P.L * 0.5 * Math.cos(P.phi_i);
	
	    var PMz_real = 0;
	    var PMz_imag = 0;
	
	    // // Location of the waist for the signal and idler
	    // var z0s = P.L/2;
	    // var z0s = 0;
	
	    // var convfromFWHM = 1*Math.sqrt(2); // Use 1/e^2 in intensity.
	    var convfromFWHM = 1; // Use 1/e^2 in intensity.
	
	
	    // var W_s = 2*Math.asin( Math.cos(P.theta_s_e)*Math.sin(P.W_sx/2)/(P.n_s * Math.cos(P.theta_s))),
	    //     W_i = 2*Math.asin( Math.cos(P.theta_i_e)*Math.sin(P.W_ix/2)/(P.n_i * Math.cos(P.theta_i)));
	
	
	    // Setup constants
	    var Wp_SQ = sq(P.W * convfromFWHM),
	        // convert from FWHM to sigma
	    Ws_SQ = sq(P.W_sx * convfromFWHM),
	        // convert from FWHM to sigma
	    Wi_SQ = sq(P.W_sx * convfromFWHM),
	        // convert from FWHM to sigma @TODO: Change to P.W_i
	    // Ws_SQ = sq(W_s * convfromFWHM), // convert from FWHM to sigma
	    // Wi_SQ = sq(W_i * convfromFWHM) // convert from FWHM to sigma @TODO: Change to P.W_i
	    // Set Wx = Wy for the pump.
	    Wx_SQ = Wp_SQ * sq(ellipticity),
	        Wy_SQ = Wp_SQ;
	
	    // Is this the k vector along the direction of propagation?
	    var k_p = twoPI * P.n_p / P.lambda_p,
	        k_s = twoPI * P.n_s / P.lambda_s,
	        //  * Math.cos(P.theta_s),
	    k_i = twoPI * P.n_i / P.lambda_i // * Math.cos(P.theta_i)
	    ;
	
	    //     var Ss = [ sinThetaS * Math.cos(P.phi_s),  sinThetaS * Math.sin(P.phi_s), Math.cos(P.theta_s)];
	    var PHI_s = sq(1 / Math.cos(P.theta_s_e)),
	        // External angle for the signal???? Is PHI_s z component?
	    // PSI_s = (k_s/P.n_s) * Math.sin(P.theta_s_e) * Math.cos(P.phi_s) // Looks to be the y component of the ks,i
	    PSI_s = 1 * Math.sin(P.theta_s_e) * Math.cos(P.phi_s) // Looks to be the y component of the ks,i
	    ;
	
	    // Now put the waist of the signal & idler at the center fo the crystal.
	    // W = Wfi.*sqrt( 1 + 2.*1i.*(zi+hi.*sin(thetai_f))./(kif.*Wfi^2));
	    // var  Ws_r = Ws_SQ
	    //     ,Ws_i = -2/(omega_s/con.c) * (z0s + hs * Math.sin(P.theta_s_e) )
	    //     ;
	
	    var Ws_r = Ws_SQ,
	        Ws_i = 2 / (k_s / P.n_s) * (z0s + hs * Math.sin(P.theta_s_e) * Math.cos(P.phi_s));
	
	    // console.log("WAIST Imag:", Ws_i);
	
	    var bw; // Apodization 1/e^2
	
	    // Take into account apodized crystals
	    if (P.calc_apodization && P.enable_pp) {
	        bw = P.apodization_FWHM / 2.3548;
	        bw = 2 * bw / P.L; // convert from 0->L to -1 -> 1 for the integral over z
	    } else {
	        bw = Math.pow(2, 20);
	    }
	
	    // Now calculate the the coeficients that get repeatedly used. This is from
	    // Karina's code. Do not assume a symmetric pump waist (Wx = Wy) here. This is inserted in the code above.
	
	    // var  ks_f = (k_s/P.n_s)
	    //     ,SIN_THETA_s_e = Math.sin(P.theta_s_e)
	    //     ,SIN_THETA_i_e = Math.sin(P.theta_i_e)
	    //     ,COS_THETA_s_e = Math.cos(P.theta_s_e)
	    //     ,COS_THETA_i_e = Math.cos(P.theta_i_e)
	    //     ,TAN_THETA_s_e = Math.tan(P.theta_s_e)
	    //     ,TAN_THETA_i_e = Math.tan(P.theta_i_e)
	    //     ,GAM2s = -0.25 * Ws_SQ
	    //     ,GAM1s = GAM2s *PHI_s
	    //     ,GAM3s = -2 * ks_f * GAM1s * SIN_THETA_s_e
	    //     ,GAM4s = -0.5 * ks_f * SIN_THETA_s_e
	    //     ,zhs = z0s + hs * SIN_THETA_s_e
	    //     ,DEL2s = 0.5 / ks_f * zhs
	    //     ,DEL1s = DEL2s * PHI_s
	    //     ,DEL3s = hs - zhs * PHI_s * SIN_THETA_s_e
	    //     ,DEL4s = 0.5*ks_f * zhs * SIN_THETA_s_e * sq(TAN_THETA_s_e) - ks_f * z0s
	
	
	    var ks_f = k_s / P.n_s,
	        SIN_THETA_s_e = Math.sin(P.theta_s_e),
	        COS_THETA_s_e = Math.cos(P.theta_s_e),
	        TAN_THETA_s_e = Math.tan(P.theta_s_e),
	        COS_PHI_s = Math.cos(P.phi_s),
	        GAM2s = -0.25 * Ws_SQ,
	        GAM1s = GAM2s * PHI_s,
	        GAM3s = -2 * ks_f * GAM1s * SIN_THETA_s_e * COS_PHI_s,
	        GAM4s = -0.5 * ks_f * SIN_THETA_s_e * COS_PHI_s * GAM3s,
	        zhs = z0s + hs * SIN_THETA_s_e * COS_PHI_s,
	        DEL2s = 0.5 / ks_f * zhs,
	        DEL1s = DEL2s * PHI_s,
	        DEL3s = -hs - zhs * PHI_s * SIN_THETA_s_e * COS_PHI_s,
	        DEL4s = 0.5 * ks_f * zhs * sq(TAN_THETA_s_e) - ks_f * z0s,
	        KpKs = k_p * k_s,
	        L = P.L
	    // ,C0 = Ws_SQ * PHI_s
	
	    // ,C0_r = -4 * GAM1s
	    // ,C0_i = 4 * DEL1s
	    // ,C1_r = KpKs * (Wx_SQ + C0_r)
	    // ,C1_i = KpKs * (C0_i)
	    // ,C2_r = C0_r * PSI_s
	    // ,C2_i = C0_i * PSI_s
	    ,
	        C7 = k_p - k_s - k_i - twoPI / (P.poling_period * P.poling_sign),
	        C3 = P.L * C7,
	        C4 = P.L * (1 / k_i - 1 / k_p),
	        C5 = k_s / k_p
	    // ,C6_r = KpKs * (Ws_r + Wy_SQ)
	    // ,C6_i = KpKs * Ws_i
	    // ,C6_r = KpKs * (Wy_SQ -4*GAM2s)
	    // ,C6_i = 4*KpKs * GAM2s
	    ,
	        C9 = k_p * Wx_SQ,
	        C10 = k_p * Wy_SQ,
	        LRho = L * RHOpx,
	        LRho_sq = sq(LRho);
	    // Imaginary Terms
	    var alpha1R = 4 * KpKs * GAM1s,
	        alpha1I = -4 * KpKs * DEL1s,
	        alpha2R = 4 * KpKs * GAM2s,
	        alpha2I = -4 * KpKs * DEL2s,
	        alpha3R = GAM3s,
	        alpha3I = -DEL3s
	    // Complex conjugates
	    ,
	        alpha1cR = alpha1R,
	        alpha1cI = -alpha1I,
	        alpha2cR = alpha2R,
	        alpha2cI = -alpha2I,
	        alpha3cR = alpha3R,
	        alpha3cI = -alpha3I;
	
	    // M1R = -2 * DEL3s
	    //     ,M1I = -2 * GAM3s
	    //     ,M2R = M1R //M2 is the complex conjugate of M1
	    //     ,M2I = -M2I
	    // //      M1R = 2*hs + C2_i
	    // //     ,M1I = -C2_r
	    // //     ,M2R = 2*hs - C2_i
	    // //     ,M2I = C2_r
	    //     ,M1_SQR = helpers.cmultiplyR( M1R, M1I, M1R, M1I)
	    //     ,M1_SQI = helpers.cmultiplyI( M1R, M1I, M1R, M1I)
	    //     ,M2_SQR = helpers.cmultiplyR( M2R, M2I, M2R, M2I)
	    //     ,M2_SQI = helpers.cmultiplyI( M2R, M2I, M2R, M2I)
	    //     ;
	
	    // As a function of z1 along the crystal, calculate the z1-dependent coefficients
	    var calcz1terms = function calcz1terms(z1) {
	        // z1=0;
	        // Represent complex numbers as a two-array. x[0] = Real, x[1] = Imag
	        var A1 = 2 * z0 - L * z1,
	            B1 = 1 - z1,
	            B3 = 1 + z1;
	        return [A1, B1, B3];
	
	        // return [D1R, D1I, D3R, D3I, H1R, H1I, H3R, H3I, P1R, P1I, P3R, P3I, Q1R, Q1I, Q3R, Q3I, A1, B1, B3];
	    };
	
	    // // As a function of z2 along the crystal, calculate the z2-dependent coefficients
	    // var calcz2terms = function(z2){
	    //     // z2 = 0;
	    //     // Represent complex numbers as a two-array. x[0] = Real, x[1] = Imag
	    //     var  A2 = 2 * z0 - L*z2
	    //         ,B2 = (1 - z2)
	    //         ,B4 = (1 + z2)
	    //     ;
	    //     return [A2, B2, B4];
	    //     // return [D2R, D2I, D4R, D4I, H2R, H2I, H4R, H4I, P2R, P2I, P4R, P4I, Q2R, Q2I, Q4R, Q4I, A2, B2, B4];
	    // };
	
	    var zintfunc = function zintfunc(z1, z2, Cz1) {
	        // z1 = 0;
	        // z2 =0;
	        // Get the terms that depend only on z2. We already have the terms depending only on z1 in Cz1
	        // var  Cz2 = calcz2terms(z2)
	        var B0 = z1 - z2
	        // From Cz1
	        ,
	            A1 = Cz1[0],
	            B1 = Cz1[1],
	            B3 = Cz1[2]
	
	        // terms that depend on z2
	        ,
	            A2 = 2 * z0 - L * z2,
	            B2 = 1 - z2,
	            B4 = 1 + z2
	
	        // Now terms that depend on both z1 and z2
	        ,
	            B6a = C4 * B0,
	            gamma1I = -k_p * L * B1 + k_s * A1,
	            gamma2I = -k_p * L * B2 + k_s * A2,
	            HaR = alpha1R,
	            HaI = alpha1I + gamma1I,
	            HbR = alpha2R,
	            HbI = alpha2I + gamma1I,
	            HcR = alpha1cR,
	            HcI = alpha1cI - gamma2I,
	            HdR = alpha2cR,
	            HdI = alpha2cI - gamma2I,
	            AA1R = (HaR - C9 * k_s) / (4 * KpKs),
	            AA1I = HaI / (4 * KpKs),
	            AA2R = (HcR - C9 * k_s) / (4 * KpKs),
	            AA2I = HcI / (4 * KpKs),
	            BB1R = (HbR - C10 * k_s) / (4 * KpKs),
	            BB1I = HbI / (4 * KpKs),
	            BB2R = (HdR - C10 * k_s) / (4 * KpKs),
	            BB2I = HdI / (4 * KpKs)
	
	        // Now for the denominators that show up in EE, FF, GG, HH, and II
	        ,
	            X11R = C9 * k_s - HaR,
	            X11I = -HaI,
	            X12R = -HcI,
	            X12I = HcR - C9 * k_s,
	            Y21R = C10 * k_s - HbR,
	            Y21I = -HbI,
	            Y22R = -HdI,
	            Y22I = HdR - C10 * k_s
	
	        //Now to calculate the term EE
	        // EE = 1/4*(-  2*Wx^2 + I B6a + C5/X11*(C9 - I A1)^2 - I C5/X12*(C9 + I A2)^2  )
	
	        ,
	            EE1R = helpers.cmultiplyR(A1, C9, A1, C9),
	            EE1I = helpers.cmultiplyI(A1, C9, A1, C9),
	            EE2R = helpers.cmultiplyR(A2, -C9, A2, -C9),
	            EE2I = helpers.cmultiplyI(A2, -C9, A2, -C9),
	            EE3R = C5 * helpers.cdivideR(EE1R, EE1I, X11R, X11I),
	            EE3I = C5 * helpers.cdivideI(EE1R, EE1I, X11R, X11I),
	            EE4R = C5 * helpers.cdivideR(EE2R, EE2I, X12R, X12I),
	            EE4I = C5 * helpers.cdivideI(EE2R, EE2I, X12R, X12I),
	            EE5R = helpers.cmultiplyR(0, 1, EE4R, EE4I),
	            EE5I = helpers.cmultiplyI(0, 1, EE4R, EE4I),
	            EER = 0.25 * (-2 * Wx_SQ - EE3R + EE5R),
	            EEI = 0.25 * (B6a - EE3I + EE5I)
	
	        //Now to calculate the term FF
	        // FF = 1/4*(-2*Wy^2 + I B6a - C5/Y21 *(I C10 + A1)^2 + I C5/Y22 *(-I C10 + A2)^2)
	        ,
	            FF1R = helpers.cmultiplyR(A1, C10, A1, C10),
	            FF1I = helpers.cmultiplyI(A1, C10, A1, C10),
	            FF2R = helpers.cmultiplyR(A2, -C10, A2, -C10),
	            FF2I = helpers.cmultiplyI(A2, -C10, A2, -C10),
	            FF3R = C5 * helpers.cdivideR(FF1R, FF1I, Y21R, Y21I),
	            FF3I = C5 * helpers.cdivideI(FF1R, FF1I, Y21R, Y21I),
	            FF4R = C5 * helpers.cdivideR(FF2R, FF2I, Y22R, Y22I),
	            FF4I = C5 * helpers.cdivideI(FF2R, FF2I, Y22R, Y22I),
	            FF5R = helpers.cmultiplyR(0, 1, FF4R, FF4I),
	            FF5I = helpers.cmultiplyI(0, 1, FF4R, FF4I),
	            FFR = 0.25 * (-2 * Wy_SQ - FF3R + FF5R),
	            FFI = 0.25 * (B6a - FF3I + FF5I)
	
	        //Now to calculate the term GG
	        // GG = ks*( \[Alpha]3c/X12 *(I C9 - A2)  +  \[Alpha]3/X11 *(-C9 + I A1));
	        ,
	            GG1R = helpers.cmultiplyR(-C9, A1, alpha3R, alpha3I),
	            GG1I = helpers.cmultiplyI(-C9, A1, alpha3R, alpha3I),
	            GG2R = helpers.cdivideR(GG1R, GG1I, X11R, X11I),
	            GG2I = helpers.cdivideI(GG1R, GG1I, X11R, X11I),
	            GG3R = helpers.cmultiplyR(-A2, C9, alpha3cR, alpha3cI),
	            GG3I = helpers.cmultiplyI(-A2, C9, alpha3cR, alpha3cI),
	            GG4R = helpers.cdivideR(GG3R, GG3I, X12R, X12I),
	            GG4I = helpers.cdivideI(GG3R, GG3I, X12R, X12I),
	            GGR = k_s * (GG2R + GG4R),
	            GGI = k_s * (GG2I + GG4I)
	
	        //Now to calculate the term HH
	        // HH = L * \[Rho]/2 *(I B0 + ks*(B3/Y21 *(-I C10 - A1)  +  B4/Y22 *(C10 + I A2)));
	        // HH = L * \[Rho]/2 *(I B0 + ks*(B3/Y21 *(-I C10 - A1)  +  B4/Y22 *(C10 + I A2)));
	        ,
	            HH2R = B4 * helpers.cdivideR(C10, A2, Y22R, Y22I),
	            HH2I = B4 * helpers.cdivideI(C10, A2, Y22R, Y22I),
	            HH4R = B3 * helpers.cdivideR(-A1, -C10, Y21R, Y21I),
	            HH4I = B3 * helpers.cdivideI(-A1, -C10, Y21R, Y21I),
	            HHR = 0.5 * LRho * (k_s * (HH2R + HH4R)),
	            HHI = 0.5 * LRho * (B0 + k_s * (HH2I + HH4I))
	
	        //Now to calculate the term II
	        // II = IIrho + IIgam + IIdelk
	        // IIrho = 1/4* ks*kp*L^2*\[Rho]^2 ( -B3^2/Y21 +I B4^2/Y22)
	        // IIgam = kp*ks*(\[Alpha]3^2/X11 - I \[Alpha]3c^2/X12)
	        // IIdelk = 2 \[CapitalGamma]4s + 0.5 I (C3*B0)
	
	        ,
	            IIrho1R = B4 * B4 * helpers.cdivideR(0, 1, Y22R, Y22I),
	            IIrho1I = B4 * B4 * helpers.cdivideI(0, 1, Y22R, Y22I),
	            IIrho2R = B3 * B3 * helpers.cdivideR(1, 0, Y21R, Y21I),
	            IIrho2I = B3 * B3 * helpers.cdivideI(1, 0, Y21R, Y21I),
	            IIrhoR = 0.25 * LRho_sq * (IIrho1R - IIrho2R),
	            IIrhoI = 0.25 * LRho_sq * (IIrho1I - IIrho2I),
	            IIgam1R = helpers.cmultiplyR(alpha3R, alpha3I, alpha3R, alpha3I),
	            IIgam1I = helpers.cmultiplyI(alpha3R, alpha3I, alpha3R, alpha3I),
	            IIgam2R = helpers.cdivideR(IIgam1R, IIgam1I, X11R, X11I),
	            IIgam2I = helpers.cdivideI(IIgam1R, IIgam1I, X11R, X11I),
	            IIgam3R = helpers.cmultiplyR(alpha3cR, alpha3cI, alpha3cR, alpha3cI),
	            IIgam3I = helpers.cmultiplyI(alpha3cR, alpha3cI, alpha3cR, alpha3cI),
	            IIgam4R = helpers.cdivideR(IIgam3R, IIgam3I, X12R, X12I),
	            IIgam4I = helpers.cdivideI(IIgam3R, IIgam3I, X12R, X12I),
	            IIgamR = IIgam2R + IIgam4I,
	            IIgamI = IIgam2I - IIgam4R,
	            IIR = 2 * GAM4s + KpKs * (IIrhoR + IIgamR),
	            III = 0.5 * (C3 * B0) + KpKs * (IIrhoI + IIgamI)
	
	        // Now calculate terms in the numerator
	        // Exp(-(GG^2/(4 EE)) - HH^2/(4 FF) + II)
	        ,
	            EXP1R = helpers.cmultiplyR(GGR, GGI, GGR, GGI),
	            EXP1I = helpers.cmultiplyI(GGR, GGI, GGR, GGI),
	            EXP2R = -helpers.cdivideR(EXP1R, EXP1I, EER, EEI) / 4,
	            EXP2I = -helpers.cdivideI(EXP1R, EXP1I, EER, EEI) / 4,
	            EXP3R = helpers.cmultiplyR(HHR, HHI, HHR, HHI),
	            EXP3I = helpers.cmultiplyI(HHR, HHI, HHR, HHI),
	            EXP4R = helpers.cdivideR(EXP3R, EXP3I, -4 * FFR, -4 * FFI),
	            EXP4I = helpers.cdivideI(EXP3R, EXP3I, -4 * FFR, -4 * FFI),
	            EXPR = EXP2R + EXP4R + IIR,
	            EXPI = EXP2I + EXP4I + III
	
	        // Now calculate terms in the DENominator
	        // 8 * Sqrt[AA1 BB1 AA2 BB2 EE FF]
	        ,
	            Den1R = helpers.cmultiplyR(AA1R, AA1I, BB1R, BB1I),
	            Den1I = helpers.cmultiplyI(AA1R, AA1I, BB1R, BB1I),
	            Den2R = helpers.cmultiplyR(AA2R, AA2I, BB2R, BB2I),
	            Den2I = helpers.cmultiplyI(AA2R, AA2I, BB2R, BB2I),
	            Den3R = helpers.cmultiplyR(EER, EEI, FFR, FFI),
	            Den3I = helpers.cmultiplyI(EER, EEI, FFR, FFI),
	            Den4R = helpers.cmultiplyR(Den1R, Den1I, Den2R, Den2I),
	            Den4I = helpers.cmultiplyI(Den1R, Den1I, Den2R, Den2I),
	            Den5R = helpers.cmultiplyR(Den4R, Den4I, Den3R, Den3I),
	            Den5I = helpers.cmultiplyI(Den4R, Den4I, Den3R, Den3I),
	            DenR = 8 * helpers.csqrtR(Den5R, Den5I),
	            DenI = 8 * helpers.csqrtI(Den5R, Den5I)
	
	        // Now calculate the full term in the integral.
	        // @TODO: Not sure how to correctly handle the apodization in the double length integral
	        ,
	            pmzcoeff = Math.exp(-1 / 2 * (z1 * z1 / (bw * bw))) * Math.exp(-1 / 2 * (z2 * z2 / (bw * bw))) // apodization
	        // ,pmzcoeff = 1
	        // Exponential using Euler's formula
	        ,
	            coeffR = Math.exp(EXPR)
	        // ,coeffR = 1
	        ,
	            EReal = coeffR * pmzcoeff * Math.cos(EXPI),
	            EImag = coeffR * pmzcoeff * Math.sin(EXPI)
	
	        // ,real = coeffR
	        // ,imag = 0
	
	        ,
	            real = 0.5 * helpers.cdivideR(EReal, EImag, DenR, DenI),
	            imag = 0.5 * helpers.cdivideI(EReal, EImag, DenR, DenI)
	
	        // console.log("Int: " + IIR.toString() + ", " + III.toString() + ", " + EReal.toString() + ", " + EImag.toString());
	
	        // ,real = 1 * EReal
	        // ,imag = 1 * EImag
	        ;
	
	        // console.log("X11:", X11R, X11I);
	        // console.log("X12:", X12R, X12I);
	        // console.log("Y21:", Y21R, Y21I);
	        // console.log("Y22:", Y22R, Y22I);
	        // console.log("Gamma1 ", gamma1I);
	        // console.log("Gamma2 ", gamma2I);
	        // console.log("AA1:", AA1R, AA1I);
	        // console.log("BB1:",BB1R, BB1I);
	        // console.log("AA2:", AA2R, AA2I);
	        // console.log("BB2:",BB2R, BB2I);
	        // console.log("EE: ", EER, EEI);
	        // console.log("FF: ", FFR, FFI);
	        // console.log("GG: ", GGR, GGI);
	        // console.log("HH: ", HHR, HHI);
	        // console.log("II: ", IIR, III);
	        // console.log("Exponent: ", EXPR, EXPI);
	        // console.log("Denominator: ", DenR, DenI);
	        // console.log("RESULT: ", real*0.5, imag*0.5);
	        // console.log("Den4 ", Den4R, Den4I);
	        // console.log("Den3 ", Den3R, Den3I);
	        // console.log("Den5 ", Den5R, Den5I);
	        // console.log("Wx_2 ", Wx_SQ, Wy_SQ);
	        // console.log("A1, A2", A1, A2);
	        // console.log("C9", C9, C9*k_s);
	        // console.log("C5", C5);
	        // console.log("FF4:", FF4R, FF4I);
	        // console.log("FF5:", FF5R, FF5I);
	        // console.log("FF3:", FF3R, FF3I);
	        // console.log("Y21:", Y21R, Y21I);
	        // console.log("Y21+Y22:", -2*Wy_SQ - FF3R + FF5R, B6a - FF3I + FF5I);
	        // console.log("FFother:", -2*Wy_SQ, B6a);
	
	
	        // console.log("B1, B2: ", B1, B2);
	        // console.log("A1, A2: ", A1, A2);
	
	        // console.log("GG^2/4EE", -EXP2R, -EXP2I);
	        // console.log("HH^2/4FF", -EXP4R, -EXP4I);
	        // // console.log("Rho: ", RHOpx);
	
	        // // ,IIR = 0.25 * (-2*C2_r*PSI_s - KpKs*(RHOpx*RHOpx*(Q3R + Q4R) + Q1R + Q2R))
	        // //  III = 0.25 * (-2*C2_i*PSI_s + 2*C7*B6 - KpKs*(RHOpx*RHOpx*(Q3I + Q4I) + Q1I + Q2I))
	        // console.log("C2_i:", C2_i);
	        // console.log("C7:", C7);
	        // console.log("B6:", B6);
	        // // console.log("Q1I:", Q1I);
	        // // console.log("Q2I:", Q2I);
	        // // console.log("Q3I:", Q3I);
	        // // console.log("Q4I:", Q4I);
	        // // console.log("B3,B4:", B3, B4, B1, B2);
	        // // console.log("H3:", H3R, H3I);
	        // // console.log("H1:", H1R, H1I);
	        // console.log(P.theta*180/Math.PI);
	
	        // console.log("numerator: " + EReal.toString() + " , " + EImag.toString() +' , ' + coeffR.toString() + ' , ' + EXPI.toString());
	        // console.log("denominator: " + DenR.toString() + " , " + DenI.toString() );
	        // console.log("1: " + A1R.toString() + "   2: " + A2R.toString() + "   3: " + A3R.toString() + "   4: " + A7R.toString() + "   5: " + A8R.toString() + "   6: " + A9R.toString() );
	
	        // real = 1;
	        // real = 0;
	        return [real, imag];
	    };
	
	    var delK = pmLib.calc_delK(P);
	    var delKx = delK[0],
	        delKy = delK[1],
	        delKz = delK[2];
	
	    var arg = P.L / 2 * delKz;
	
	    var PMt = 1;
	    if (P.calcfibercoupling) {
	        var dz = 2 / P.numz2Dint;
	        var pmintz = helpers.Nintegrate2D_3_8_singles(zintfunc, calcz1terms, -1, 1, -1, 1, P.numz2Dint, P.z2Dweights);
	        // var  z1 = 0
	        //     ,z2 = 0.5
	        // var z1 = 0.5
	        //     ,z2 = -0.7
	        //     ;
	        // var pmintz = zintfunc(z1,z2, calcz1terms(z1));
	
	        // console.log("Int: " + pmintz[0].toString() + ", " + pmintz[1].toString() + ", " + P.z2Dweights.length.toString());
	        // var dz = 1;
	        // var pmintz = helpers.Nintegrate2arg(zintfunc,-1, 1,dz,1,P.zweights);
	        // PMz_real = pmintz[0]/P.L ;
	        // PMz_imag = pmintz[1]/P.L ;
	        PMz_real = pmintz[0] / 2;
	        PMz_imag = pmintz[1] / 2;
	        // var coeff = ((omega_s * omega_i)/ (P.n_s * P.n_i));
	        var coeff = 1;
	        PMz_real = PMz_real * coeff;
	        PMz_imag = PMz_imag * coeff;
	    } else {
	        var PMzNorm1 = Math.sin(arg) / arg;
	        // var PMz_real =  PMzNorm1 * Math.cos(arg);
	        // var PMz_imag = PMzNorm1 * Math.sin(arg);
	        PMz_real = PMzNorm1;
	        PMz_imag = 0;
	        PMt = Math.exp(-0.5 * (sq(delK[0]) + sq(delK[1])) * sq(P.W));
	    }
	    // console.log("Inside calculation");
	    // console.log("Int: " + PMz_real.toString() + ", " + PMz_imag.toString());
	
	    if (P.use_guassian_approx) {
	        PMz_real = Math.exp(-0.193 * sq(arg));
	        PMz_imag = 0;
	    }
	    properties.convertToMeters(P);
	    P.lambda_p = lambda_p; //set back to the original lambda_p
	    P.n_p = n_p;
	
	    // console.log("real: " + PMz_real.toString() + " imag: " + PMz_imag.toString());
	
	
	    return [PMz_real, PMz_imag, PMt];
	};

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	* These are the properties that are used to calculate phasematching
	*/
	
	var properties = {};
	module.exports = properties;
	
	var cloneDeep = __webpack_require__(314);
	var assignWith = __webpack_require__(419);
	var pick = __webpack_require__(430);
	var con = __webpack_require__(309);
	var helpers = __webpack_require__(312);
	var sq = helpers.sq;
	var Crystals = __webpack_require__(313);
	var nelderMead = __webpack_require__(310);
	var pmLib = __webpack_require__(416);
	var PlotHelpers = __webpack_require__(440);
	
	// These are the names associated with the types
	// The "type" property is stored as an integer
	properties.PMTypes = ["Type 0:   o -> o + o", "Type 0:   e -> e + e", "Type 1:   e -> o + o", "Type 2:   e -> e + o", "Type 2:   e -> o + e"];
	
	properties.apodization_L = [];
	properties.apodization_coeff = [];
	
	var spdcDefaults = {
	    lambda_p: 775 * con.nm,
	    lambda_s: 1550 * con.nm,
	    lambda_i: 1550 * 775 * con.nm / (1550 - 775),
	    type: "Type 2:   e -> e + o",
	    theta: 90 * Math.PI / 180,
	    phi: 0,
	    theta_s: 0,
	    theta_i: 0,
	    theta_s_e: 0 * Math.PI / 180,
	    theta_i_e: 0,
	    phi_s: 0,
	    phi_i: Math.PI,
	    L: 2000 * con.um,
	    W: 100 * con.um,
	    p_bw: 5.35 * con.nm,
	    walkoff_p: 0,
	    W_sx: 100 * con.um,
	    W_sy: 100 * con.um,
	    W_ix: 100 * con.um,
	    W_iy: 100 * con.um,
	    phase: false,
	    brute_force: false,
	    brute_dim: 50,
	    autocalctheta: false,
	    autocalcpp: true,
	    poling_period: 1000000,
	    poling_sign: 1,
	    calc_apodization: false,
	    apodization: 30,
	    apodization_FWHM: 1600 * con.um,
	    use_guassian_approx: false,
	    crystal: Crystals('KTP-3'),
	    temp: 20,
	    enable_pp: true,
	    calcfibercoupling: true,
	    singles: false,
	    autocalfocus: true,
	    z0s: -2000 / 2 * con.um,
	    deff: 1.0 * con.pm,
	    Pav: 1e-3
	
	    // z0: 2000/2 * con.um
	};
	
	var spdcDefaultKeys = Object.keys(spdcDefaults);
	
	// deep copy callback to extend deeper into object
	var cloneCallback = function cloneCallback(a, b) {
	
	    var type = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	    if (type === 'object' || type === 'array') {
	
	        return cloneDeep(b);
	    }
	
	    return b !== undefined ? b : a;
	};
	
	/**
	 * SPDCprop
	 */
	var SPDCprop = function SPDCprop(cfg) {
	    this.init(cfg);
	};
	
	SPDCprop.prototype = {
	
	    init: function init(cfg) {
	
	        // set properties or fall back to defaults
	        this.set(Object.assign({}, spdcDefaults, cfg));
	        this.update_all_angles();
	
	        // Find internal angles for signal and idler
	        this.theta_s = pmLib.find_internal_angle(this, "signal");
	        this.theta_i = pmLib.find_internal_angle(this, "idler");
	        // console.log("Angle diff at beginning: ", (this.theta_s - this.theta_i)*180/Math.PI);
	        // this.theta_s = 0;
	
	        // //Other functions that do not need to be included in the default init
	        // this.S_p = this.calc_Coordinate_Transform(this.theta, this.phi, 0, 0);
	        // this.S_s = this.calc_Coordinate_Transform(this.theta, this.phi, this.theta_s, this.phi_s);
	        // this.S_i = this.calc_Coordinate_Transform(this.theta, this.phi, this.theta_i, this.phi_i);
	
	        // this.n_p = this.calc_Index_PMType(this.lambda_p, this.type, this.S_p, "pump");
	        // this.n_s = this.calc_Index_PMType(this.lambda_s, this.type, this.S_s, "signal");
	        // this.n_i = this.calc_Index_PMType(this.lambda_i, this.type, this.S_i, "idler");
	
	        // this.optimum_idler();
	        this.update_all_angles();
	
	        // set the external angle of the idler
	        // this.theta_i_e = pmLib.find_external_angle(this, "idler");
	        // console.log("From init external angle is: ", this.theta_i_e *180/Math.PI, this.theta_s_e *180/Math.PI, this.theta_i *180/Math.PI, this.theta_s *180/Math.PI);
	
	        //set the apodization length and Gaussian profile
	        this.set_apodization_L();
	        this.set_apodization_coeff();
	
	        // this.numzint = 16;
	        // this.zweights = helpers.NintegrateWeights(this.numzint);
	
	        this.set_zint();
	
	        // this.auto_calc_Theta();
	        // this.theta_s = 8.624324930009333* Math.PI/180;
	        if (this.autocalctheta) {
	            this.auto_calc_Theta();
	        }
	
	        //this.auto_calc_collection_focus();
	
	        // Set the positions of the signal, idler, pump waists
	        this.z0p = 0 * con.um;
	        this.z0s = -1 * this.L / 2;
	        this.z0i = this.z0s;
	
	        // console.log(this.zweights);
	    },
	
	    calc_Coordinate_Transform: function calc_Coordinate_Transform(theta, phi, theta_s, phi_s) {
	        //Should save some calculation time by defining these variables.
	        var SIN_THETA = Math.sin(theta);
	        var COS_THETA = Math.cos(theta);
	        var SIN_THETA_S = Math.sin(theta_s);
	        var COS_THETA_S = Math.cos(theta_s);
	        var SIN_PHI = Math.sin(phi);
	        var COS_PHI = Math.cos(phi);
	
	        var SIN_PHI_S = Math.sin(phi_s);
	        var COS_PHI_S = Math.cos(phi_s);
	
	        var S_x = SIN_THETA_S * COS_PHI_S;
	        var S_y = SIN_THETA_S * SIN_PHI_S;
	        var S_z = COS_THETA_S;
	
	        // Transform from the lambda_p coordinates to crystal coordinates
	        var SR_x = COS_THETA * COS_PHI * S_x - SIN_PHI * S_y + SIN_THETA * COS_PHI * S_z;
	        var SR_y = COS_THETA * SIN_PHI * S_x + COS_PHI * S_y + SIN_THETA * SIN_PHI * S_z;
	        var SR_z = -SIN_THETA * S_x + COS_THETA * S_z;
	
	        // Normalambda_ize the unit vector
	        // @TODO: When theta = 0, Norm goes to infinity. This messes up the rest of the calculations. In this
	        // case I think the correct behaviour is for Norm = 1 ?
	        var Norm = Math.sqrt(sq(S_x) + sq(S_y) + sq(S_z));
	        var Sx = SR_x / Norm;
	        var Sy = SR_y / Norm;
	        var Sz = SR_z / Norm;
	
	        return [Sx, Sy, Sz];
	    },
	
	    calc_Index_PMType: function calc_Index_PMType(lambda, Type, S, photon) {
	        // console.log(properties.PMTypes[0]);
	        var ind = this.crystal.indicies(lambda, this.temp); //can I move this out to speed it up?
	
	        var nx_squared_inv = 1 / sq(ind[0]);
	        var ny_squared_inv = 1 / sq(ind[1]);
	        var nz_squared_inv = 1 / sq(ind[2]);
	
	        var Sx_squared = sq(S[0]);
	        var Sy_squared = sq(S[1]);
	        var Sz_squared = sq(S[2]);
	
	        var B = Sx_squared * (ny_squared_inv + nz_squared_inv) + Sy_squared * (nx_squared_inv + nz_squared_inv) + Sz_squared * (nx_squared_inv + ny_squared_inv);
	        var C = Sx_squared * (ny_squared_inv * nz_squared_inv) + Sy_squared * (nx_squared_inv * nz_squared_inv) + Sz_squared * (nx_squared_inv * ny_squared_inv);
	        var D = sq(B) - 4 * C;
	
	        var nslow = Math.sqrt(2 / (B + Math.sqrt(D)));
	        var nfast = Math.sqrt(2 / (B - Math.sqrt(D)));
	
	        // var phit= this.phi*180/Math.PI;
	
	        var n = 1;
	
	        switch (Type) {
	            case properties.PMTypes[0]:
	                n = nfast;
	                break;
	            case properties.PMTypes[1]:
	                n = nslow;
	                break;
	            case properties.PMTypes[2]:
	                if (photon === "pump") {
	                    n = nslow;
	                } else {
	                    n = nfast;
	                }
	                break;
	            case properties.PMTypes[3]:
	                if (photon === "idler") {
	                    n = nfast;
	                } else {
	                    n = nslow;
	                }
	                break;
	            case properties.PMTypes[4]:
	                if (photon === "signal") {
	                    n = nfast;
	                } else {
	                    n = nslow;
	                }
	                break;
	            default:
	                throw "Error: bad PMType specified";
	        }
	
	        return n;
	    },
	
	    update_all_angles: function update_all_angles() {
	        var props = this;
	        // console.log("old pump index", props.n_p);
	
	        props.S_p = props.calc_Coordinate_Transform(props.theta, props.phi, 0, 0);
	        props.S_s = props.calc_Coordinate_Transform(props.theta, props.phi, props.theta_s, props.phi_s);
	
	        props.n_p = props.calc_Index_PMType(props.lambda_p, props.type, props.S_p, "pump");
	        props.n_s = props.calc_Index_PMType(props.lambda_s, props.type, props.S_s, "signal");
	        // console.log("new pump index", props.n_p);
	
	        props.optimum_idler();
	        // set the external idler angle
	        props.theta_i_e = pmLib.find_external_angle(props, "idler");
	        // props.S_i = props.calc_Coordinate_Transform(props.theta, props.phi, props.theta_i, props.phi_i);
	        // props.n_i = props.calc_Index_PMType(props.lambda_i, props.type, props.S_i, "idler");
	        // console.log(props.n_s, props.n_s, props.n_i);
	        // props.calc_walkoff_angles();
	    },
	
	    get_group_velocity: function get_group_velocity(lambda, Type, S, photon) {
	        // var props = this;
	        var bw = 1e-11;
	        // var P = props.clone();
	
	        var n1 = this.calc_Index_PMType(lambda - bw, Type, S, photon);
	        var n2 = this.calc_Index_PMType(lambda + bw, Type, S, photon);
	
	        var dn = (n2 - n1) / (2 * bw);
	
	        var gv = con.c / (n1 - lambda * dn);
	
	        return gv;
	    },
	
	    auto_calc_Theta: function auto_calc_Theta() {
	        this.lambda_i = 1 / (1 / this.lambda_p - 1 / this.lambda_s);
	        var props = this;
	
	        var min_delK = function min_delK(x) {
	            if (x > Math.PI / 2 || x < 0) {
	                return 1e12;
	            }
	            props.theta = x;
	            props.theta_s = pmLib.find_internal_angle(props, "signal");
	            props.update_all_angles(props);
	            var delK = pmLib.calc_delK(props);
	            // Returning all 3 delK components can lead to errors in the search
	            // return Math.sqrt(sq(delK[0]) + sq(delK[1]) + sq(delK[2]) );
	            return Math.sqrt(sq(delK[2]));
	        };
	
	        var guess = Math.PI / 6;
	        var startTime = new Date();
	        // var theta_s = props.theta_s;
	        // var theta_s_e = props.theta_s_e;
	        // props.theta_s_e = theta_s_e +0.01;
	        // pmLib.find_internal_angle(props, "signal");
	        // props.theta_s = theta_s + 0.01;
	        var ans = nelderMead(min_delK, guess, 30);
	        // props.theta = ans;
	        // props.theta_s_e = theta_s_e;
	        // pmLib.find_internal_angle(props, "signal");
	        // props.theta_s = theta_s;
	        // Run again wiht better initial conditions based on previous optimization
	        ans = nelderMead(min_delK, ans, 30);
	        var endTime = new Date();
	
	        var timeDiff = (endTime - startTime) / 1000;
	        // console.log("Theta autocalc = ", timeDiff, ans);
	        // props.theta = ans;
	        // console.log("After autocalc: ", props.theta_i * 180/Math.PI);
	        props.update_all_angles(props);
	
	        // props.calcfibercoupling = fiber;
	        // calculate the walkoff angle
	        this.calc_walkoff_angles();
	        // console.log("Walkoff:", this.walkoff_p*180/Math.PI);
	    },
	
	    calc_poling_period: function calc_poling_period() {
	        var props = this;
	        this.lambda_i = 1 / (1 / this.lambda_p - 1 / this.lambda_s);
	        props.poling_period = Math.pow(2, 30); // Set this to a large number
	        props.update_all_angles(props);
	        if (props.enable_pp) {
	            var P = props.clone();
	
	            var find_pp = function find_pp(x) {
	                // if (x<0){ return 1e12;}  // arbitrary large number
	                P.poling_period = x;
	                // Calculate the angle for the idler photon
	                P.optimum_idler();
	                var delK = pmLib.calc_delK(P);
	                return Math.sqrt(sq(delK[2]));
	                // return Math.sqrt(sq(delK[2]) +sq(delK[0])+ sq(delK[1]));
	            };
	
	            var delK_guess = pmLib.calc_delK(P)[2];
	            var guess = 2 * Math.PI / delK_guess;
	
	            if (guess < 0) {
	                P.poling_sign = -1;
	                guess = guess * -1;
	            } else {
	                P.poling_sign = 1;
	            }
	
	            //finds the minimum theta
	            var startTime = new Date();
	            nelderMead(find_pp, guess, 100);
	            var endTime = new Date();
	            //console.log("calculation time for periodic poling calc", endTime - startTime, props.poling_period);
	
	            props.poling_period = P.poling_period;
	            props.poling_sign = P.poling_sign;
	            props.calc_walkoff_angles();
	        }
	    },
	
	    auto_calc_collection_focus: function auto_calc_collection_focus() {
	        console.log("Calculating Signal/idler focus position");
	        this.lambda_i = 1 / (1 / this.lambda_p - 1 / this.lambda_s);
	        var props = this;
	        props.update_all_angles();
	
	        var bw = 0.01,
	            ls_start = this.lambda_s - this.lambda_s * bw,
	            ls_stop = this.lambda_s + this.lambda_s * bw,
	            li_start = this.lambda_i - this.lambda_i * bw,
	            li_stop = this.lambda_i + this.lambda_i * bw,
	            dim = 2,
	            lambda_s = helpers.linspace(ls_start, ls_stop, dim),
	            lambda_i = helpers.linspace(li_start, li_stop, dim);
	
	        props.nslices = 10;
	
	        var max_coinc = function max_coinc(focus) {
	            if (focus > 0 || focus < -1 * props.L) {
	                return 1e12;
	            }
	
	            props.z0s = focus;
	            props.z0i = focus;
	            //PlotHelpers.calc_heralding_plot_focus_position_p = function calc_heralding_plot_focus_position_p(props, WsRange, ls_start, ls_stop, li_start, li_stop, n){
	            var JSI_coinc = PlotHelpers.calc_JSI_p(props, lambda_s, lambda_i, dim, 1);
	            var coinc = helpers.Sum(JSI_coinc);
	            // console.log(coinc, focus*1e6);
	            return 1 / (coinc + 1);
	        };
	
	        var guess = -this.L / 2;
	        var startTime = new Date();
	        var ans = nelderMead(max_coinc, guess, 40);
	
	        // Run again with better initial conditions based on previous optimization
	        // ans = nelderMead(max_coinc, ans, 20);
	        var endTime = new Date();
	
	        var timeDiff = (endTime - startTime) / 1000;
	
	        this.z0s = ans;
	        this.z0i = this.z0s;
	
	        // // calculate the walkoff angle
	        // this.calc_walkoff_angles();
	        // // console.log("Walkoff:", this.walkoff_p*180/Math.PI);
	    },
	
	    optimum_idler: function optimum_idler() {
	        var P = this;
	
	        var delKpp = P.lambda_s / (P.poling_period * P.poling_sign);
	
	        P.phi_i = P.phi_s + Math.PI;
	
	        var arg = sq(P.n_s) + sq(P.n_p * P.lambda_s / P.lambda_p);
	        arg += -2 * P.n_s * P.n_p * (P.lambda_s / P.lambda_p) * Math.cos(P.theta_s) - 2 * P.n_p * P.lambda_s / P.lambda_p * delKpp;
	        arg += 2 * P.n_s * Math.cos(P.theta_s) * delKpp + sq(delKpp);
	        arg = Math.sqrt(arg);
	
	        var arg2 = P.n_s * Math.sin(P.theta_s) / arg;
	
	        var theta_i = Math.asin(arg2);
	
	        // Test without the PP
	
	        // arg = sq(P.n_s) + sq(P.n_p*P.lambda_s/P.lambda_p);
	        // arg += -2*P.n_s*P.n_p*(P.lambda_s/P.lambda_p)*Math.cos(P.theta_s);
	        // arg = Math.sqrt(arg);
	        // arg2 = P.n_s*Math.sin(P.theta_s)/arg;
	        // theta_i = Math.asin(arg2);
	
	
	        // return theta_i;
	
	        P.theta_i = theta_i;
	        //Update the index of refraction for the idler
	        P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	        P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	        // console.log("External angle of the idler is:", pmLib.find_external_angle(P,"idler")*180/Math.PI );
	        // P.theta_i_e = pmLib.find_external_angle(P,"idler");
	    },
	
	    optimum_signal: function optimum_signal() {
	        var P = this;
	
	        var delKpp = P.lambda_i / (P.poling_period * P.poling_sign);
	
	        var arg = sq(P.n_i) + sq(P.n_p * P.lambda_i / P.lambda_p);
	        arg += -2 * P.n_i * P.n_p * (P.lambda_i / P.lambda_p) * Math.cos(P.theta_i) - 2 * P.n_p * P.lambda_i / P.lambda_p * delKpp;
	        arg += 2 * P.n_i * Math.cos(P.theta_i) * delKpp + sq(delKpp);
	        arg = Math.sqrt(arg);
	
	        var arg2 = P.n_i * Math.sin(P.theta_i) / arg;
	
	        var theta_s = Math.asin(arg2);
	        // return theta_i;
	        P.theta_s = theta_s;
	        //Update the index of refraction for the idler
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	    },
	
	    brute_force_theta_i: function brute_force_theta_i() {
	        var props = this;
	
	        var min_PM = function min_PM(x) {
	            if (x > Math.PI / 2 || x < 0) {
	                return 1e12;
	            }
	            props.theta_i = x;
	
	            props.S_i = props.calc_Coordinate_Transform(props.theta, props.phi, props.theta_i, props.phi_i);
	            props.n_i = props.calc_Index_PMType(props.lambda_i, props.type, props.S_i, "idler");
	
	            var PMtmp = pmLib.phasematch_Int_Phase(props);
	            return 1 - PMtmp[0];
	        };
	
	        //Initial guess
	        props.optimum_idler();
	        var guess = props.theta_i;
	        // var startTime = new Date();
	
	        var ans = nelderMead(min_PM, guess, 25);
	    },
	
	    brute_force_theta_s: function brute_force_theta_s() {
	        var props = this;
	
	        var min_PM = function min_PM(x) {
	            if (x > Math.PI / 2 || x < 0) {
	                return 1e12;
	            }
	            props.theta_s = x;
	
	            props.S_s = props.calc_Coordinate_Transform(props.theta, props.phi, props.theta_s, props.phi_s);
	            props.n_s = props.calc_Index_PMType(props.lambda_s, props.type, props.S_s, "signal");
	
	            var PMtmp = pmLib.phasematch_Int_Phase(props);
	            return 1 - PMtmp[0];
	        };
	
	        //Initial guess
	        props.optimum_signal();
	        var guess = props.theta_s;
	
	        var ans = nelderMead(min_PM, guess, 25);
	    },
	
	    set_apodization_L: function set_apodization_L() {
	        this.apodization_L = helpers.linspace(-this.L / 2, this.L / 2, this.apodization + 1);
	    },
	
	    set_apodization_coeff: function set_apodization_coeff() {
	        // var bw = this.apodization_FWHM /(2 * Math.sqrt(2*Math.log(2))); //convert from FWHM
	        var bw = this.apodization_FWHM / 2.3548;
	        var dim = this.apodization_L.length;
	        this.apodization_coeff = [];
	        var delL = Math.abs(this.apodization_L[0] - this.apodization_L[1]);
	        for (var i = 0; i < dim; i++) {
	            this.apodization_coeff[i] = Math.exp(-sq(this.apodization_L[i] / bw) / 2);
	        }
	
	        var total = helpers.Sum(this.apodization_coeff);
	
	        //normalize
	        // for (i=0; i<dim; i++){
	        //     this.apodization_coeff[i] = this.apodization_coeff[i]/total;
	        // }
	    },
	
	    get_rates_constant: function get_rates_constant() {
	        var bw_pump = 2 * Math.PI * con.c * (1 / (this.lambda_p - this.p_bw / 2) - 1 / (this.lambda_p + this.p_bw / 2)) * Math.sqrt(2) / (2 * Math.sqrt(Math.log(2)));
	        var N_num = Math.pow(2, 1.5) * Math.pow(this.deff, 2) * Math.pow(this.L, 2) * this.Pav;
	        var N_den = Math.pow(Math.PI, 0.5) * con.e0 * Math.pow(con.c, 3) * bw_pump;
	        var N = N_num / N_den;
	        console.log(N, Math.pow(this.deff, 2) * Math.pow(this.L, 2), this.Pav);
	        return N;
	    },
	
	    set_zint: function set_zint() {
	        var zslice = 100e-6 * Math.pow(this.L / 2500e-6, 0.5);
	
	        if (zslice < 100e-6) {
	            zslice = 100e-6;
	        }
	
	        if (zslice > 500e-6) {
	            zslice = 500e-6;
	        }
	        // if (this.L < 5000e-6){
	        //     zslice = 100e-6;
	        // }
	        // if ((this.L > 5000e-6)&&(this.L < 15000e-6)){
	        //     zslice = 150e-6
	        // }
	        // else{
	        //     zslice = 300e-6
	        // }
	        // var zslice = 300e-6; //length of each crystal slice
	        var nslices = Math.round(this.L / zslice);
	        if (nslices < 4) {
	            nslices = 4;
	        }
	
	        // console.log(nslices);
	        //console.log("number slices");
	        // if (nslices>30){
	        //     nslices = 30;
	        // }
	        // nslices =nslices*1;
	        if (nslices % 2 !== 0) {
	            nslices += 1;
	        }
	        this.numzint = nslices;
	        // this.numzint = 10;
	
	        this.zweights = helpers.NintegrateWeights(this.numzint);
	        var n = this.numzint;
	        // var n = 3;
	        n = n + (3 - n % 3); //guarantee that n is divisible by 3
	        this.z2Dweights = helpers.Nintegrate2DWeights_3_8(n);
	        this.numz2Dint = n;
	        //console.log(nslices);
	    },
	
	    calc_walkoff_angles: function calc_walkoff_angles() {
	        // Calculate the pump walkoff angle
	        var P = this;
	        var ne_p = this.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	        var origin_theta = P.theta;
	
	        //calculate the derivative
	        var deltheta = 0.1 * Math.PI / 180;
	
	        var theta = P.theta - deltheta / 2;
	        this.S_p = this.calc_Coordinate_Transform(theta, this.phi, this.theta_s, this.theta_i);
	        var ne1_p = this.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	        theta = theta + deltheta;
	        this.S_p = this.calc_Coordinate_Transform(theta, this.phi, this.theta_s, this.theta_i);
	        var ne2_p = this.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	        //set back to original theta
	        theta = origin_theta;
	        this.S_p = this.calc_Coordinate_Transform(theta, this.phi, this.theta_s, this.theta_i);
	
	        this.walkoff_p = -1 / ne_p * (ne1_p - ne2_p) / deltheta;
	        // console.log("Walkoff:", this.walkoff_p*180/Math.PI);
	        // this.walkoff_p = 0;
	    },
	
	    swap_signal_idler: function swap_signal_idler() {
	        // Swap role of signal and idler. Useful for calculating Idler properties
	        // this.update_all_angles();
	        // @ToDO: Do not swap the role of the signal/idler waists. In the code the idler waist
	        // is always set to be 100 um and is never updated to be equal to the signal waist until
	        // the actual phasematching function is called. Therefore switching the waists will yield
	        // the wrong result here. Need to fix this if we ever decide to handle asymmetric coupling
	        // geometries where the signal and idler can have different waists.
	        var P = this,
	            tempLambda = P.lambda_s,
	            tempTheta = P.theta_s,
	            tempPhis = P.phi_s,
	            tempNs = P.n_s,
	            tempSs = P.S_s
	        // ,tempW_sx = P.W_sx
	        // ,tempW_sy = P.W_sy
	        ,
	            tempTheta_se = P.theta_s_e;
	
	        // Swap signal with Idler
	        P.lambda_s = P.lambda_i;
	        P.theta_s = P.theta_i;
	        P.phi_s = P.phi_i;
	        P.n_s = P.n_i;
	        P.S_s = P.S_i;
	        // P.W_sx = P.W_ix;
	        // P.W_sy = P.W_iy;
	        // console.log("Theta external before swap: ", P.theta_s_e * 180/Math.PI);
	        // P.theta_s_e = pmLib.find_external_angle(P, "signal");
	        P.theta_s_e = P.theta_i_e;
	        // console.log("Theta external after swap: ", P.theta_s_e * 180/Math.PI);
	        // console.log("");
	
	
	        // Now replace Idler values with Signal values
	        P.lambda_i = tempLambda;
	        P.theta_i = tempTheta;
	        P.phi_i = tempPhis;
	        P.n_i = tempNs;
	        P.S_i = tempSs;
	        // P.W_ix = tempW_sx;
	        // P.W_iy = tempW_sy;
	        P.theta_i_e = tempTheta_se;
	
	        // Is this the right thing to do? Do I need to do this?
	        // Change the phasematching type if it is type II
	        if (P.type === "Type 2:   e -> e + o") {
	            // console.log("switching");
	            P.type = "Type 2:   e -> o + e";
	        } else if (P.type === "Type 2:   e -> o + e") {
	            // console.log("other way");
	            P.type = "Type 2:   e -> e + o";
	        }
	
	        // P.update_all_angles();
	    },
	
	    /**
	     * Set config value or many values that are allowed (ie: defined in spdcDefaults )
	     * @param {String|Object} name The key name to set, or a config object with key: value pairs
	     * @param {Mixed} val  The value to set
	     */
	    set: function set(name, val) {
	
	        var self = this;
	
	        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	
	                for (var _iterator = Object.entries(name)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var _step$value = _slicedToArray(_step.value, 2);
	
	                    var n = _step$value[0];
	                    var _val = _step$value[1];
	
	                    self.set(n, _val);
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return this;
	        } else {
	
	            // set the value
	            if (name in spdcDefaults) {
	
	                if (name === 'type') {
	
	                    val = val;
	                } else if (name === 'crystal' && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) !== 'object') {
	
	                    val = Crystals(val);
	                    // this.calc_walkoff_angles();
	                }
	
	                if (name === 'poling_period') {
	                    if (val === 0 || isNaN(val)) {
	                        val = Math.pow(2, 30);
	                    }
	                }
	
	                if (name === 'apodization') {
	                    if (val < 31) {
	                        val = 31;
	                    }
	                    // val = 25;
	                }
	
	                // if (name === 'poling_period'){
	                //     if (isNaN(val)){
	                //         val = Math.pow(2,30);
	                //     }
	                // }
	
	                if (name === 'z0s') {
	                    // Match the idler waist position to that of the signal
	                    // this.z0s = val - this.L;
	                    this.z0i = val;
	                }
	
	                this[name] = val;
	
	                if (name === 'apodization' || name === 'apodization_FWHM' || name === 'L') {
	                    //} || name = 'calc_apodization')){
	                    if (isNaN(this["apodization"]) || isNaN(this["apodization_FWHM"]) || isNaN(this["L"])) {
	                        return;
	                    }
	                    this.set_apodization_L();
	                    this.set_apodization_coeff();
	                }
	
	                if (name === "L") {
	                    this.set_zint();
	                }
	
	                // if (name === 'L'){
	                //     this.set
	                // }
	
	            }
	        }
	
	        // @TODO: add logic for refreshing autocalc values?
	
	        // for chaining calls
	        return this;
	    },
	
	    /**
	     * Gets all, or single property
	     * @param {String} key (optional) key name of single property to return
	     * @return {Mixed} Property value (if specified) or object containing all setable properties
	     */
	    get: function get(key) {
	
	        if (key) {
	
	            return key in spdcDefaults ? cloneDeep(this[key]) : undefined;
	        }
	
	        var vals = cloneDeep(pick(this, spdcDefaultKeys));
	        vals.crystal = vals.crystal.id;
	        return vals;
	    },
	
	    /**
	     * Create a clone of self
	     * @return {SPDCprop} The cloned properties object
	     */
	    clone: function clone() {
	
	        var clone = Object.create(SPDCprop.prototype);
	
	        assignWith(clone, this, cloneCallback);
	
	        return clone;
	    }
	};
	
	/*
	 * To deal with possible floating point errors, convert from meters to microns before performing the calculations.
	 */
	properties.convertToMicrons = function convertToMicrons(props) {
	    var P = props
	    // ,mu = 1E6
	    ,
	        mu = 1;
	
	    // // P.L = P.L*mu;
	    // console.log("Length: " + (P.L * mu).toString());
	    P.lambda_p = P.lambda_p * mu;
	    P.lambda_s = P.lambda_s * mu;
	    P.lambda_i = P.lambda_i * mu;
	    P.W = P.W * mu;
	    P.p_bw = P.p_bw * mu;
	    P.W_sx = P.W_sx * mu;
	    P.W_ix = P.W_ix * mu;
	    // console.log("P.L about to set");
	    P.L = P.L * mu;
	    // // console.log("set P.L");
	    // P.poling_period = P.poling_period * mu;
	    // P.apodization_FWHM = P.apodization_FWHM * mu;
	
	    // P.update_all_angles();
	    // P.set_apodization_L();
	    // P.set_apodization_coeff();
	    // P.set_zint();
	
	    return P;
	};
	
	properties.convertToMeters = function convertToMeters(props) {
	    var P = props
	    // ,mu = 1E-6
	    ,
	        mu = 1;
	
	    // // P.L = P.L*mu;
	    // console.log("Length: " + (P.L * mu).toString());
	    P.lambda_p = P.lambda_p * mu;
	    P.lambda_s = P.lambda_s * mu;
	    P.lambda_i = P.lambda_i * mu;
	    P.W = P.W * mu;
	    P.p_bw = P.p_bw * mu;
	    P.W_sx = P.W_sx * mu;
	    P.W_ix = P.W_ix * mu;
	    // console.log("P.L about to set");
	    P.L = P.L * mu;
	    // // console.log("set P.L");
	    // P.poling_period = P.poling_period * mu;
	    // P.apodization_FWHM = P.apodization_FWHM * mu;
	
	    // P.update_all_angles();
	    // P.set_apodization_L();
	    // P.set_apodization_coeff();
	    // P.set_zint();
	
	    return P;
	};
	
	properties.SPDCprop = SPDCprop;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(361),
	    createAssigner = __webpack_require__(420),
	    keys = __webpack_require__(362);
	
	/**
	 * This method is like `_.assign` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignInWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keys(source), object, customizer);
	});
	
	module.exports = assignWith;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(421),
	    isIterateeCall = __webpack_require__(429);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(422),
	    overRest = __webpack_require__(423),
	    setToString = __webpack_require__(425);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 422 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(424);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 424 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(426),
	    shortOut = __webpack_require__(428);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(427),
	    defineProperty = __webpack_require__(359),
	    identity = __webpack_require__(422);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 427 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 428 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 500,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(321),
	    isArrayLike = __webpack_require__(382),
	    isIndex = __webpack_require__(372),
	    isObject = __webpack_require__(334);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(431),
	    basePick = __webpack_require__(432),
	    flatRest = __webpack_require__(434),
	    toKey = __webpack_require__(438);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(props, toKey));
	});
	
	module.exports = pick;


/***/ },
/* 431 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(433);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(358);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      baseAssignValue(result, key, value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(435),
	    overRest = __webpack_require__(423),
	    setToString = __webpack_require__(425);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(436);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(390),
	    isFlattenable = __webpack_require__(437);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(411),
	    isArguments = __webpack_require__(365),
	    isArray = __webpack_require__(368);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(439);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(367);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Constants accessible to PhaseMatch internally
	 */
	
	var PlotHelpers = module.exports = {};
	var helpers = __webpack_require__(312);
	var sq = helpers.sq;
	var con = __webpack_require__(309);
	var pmLib = __webpack_require__(416);
	var properties = __webpack_require__(418);
	
	PlotHelpers.calc_JSA = function calc_JSA(props, ls_start, ls_stop, li_start, li_stop, dim) {
	
	    props.update_all_angles();
	    // // console.log(props.lambda_i/1e-9, props.lambda_s/1e-9, props.theta_s*180/Math.PI, props.theta_i*180/Math.PI);
	    var P = props.clone();
	    // // console.log(P.theta_i*180/Math.PI, P.phi_i*180/Math.PI);
	    // P.theta_i = 0.6*Math.PI/180;
	    P.phi_i = P.phi_s + Math.PI;
	    P.update_all_angles();
	    P.optimum_idler(P);
	
	    // P.S_p = P.calc_Coordinate_Transform(P.theta, P.phi, 0, 0);
	    // P.n_p = P.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	
	    var todeg = 180 / Math.PI;
	    // // console.log(P.phi_i*todeg, P.phi_s*todeg);
	    // P.theta_i = P.theta_s;
	    // var centerpm = pmLib.phasematch(P);
	    // // console.log(sq(centerpm[0]) + sq(centerpm[1]));
	
	
	    var i;
	    var lambda_s = helpers.linspace(ls_start, ls_stop, dim);
	    var lambda_i = helpers.linspace(li_stop, li_start, dim);
	
	    var N = dim * dim;
	    var PMreal = new Float64Array(N);
	    var PMimag = new Float64Array(N);
	
	    var maxpm = 0;
	
	    // calculate normalization
	    var PMN = pmLib.phasematch(P);
	    var norm = Math.sqrt(sq(PMN[0]) + sq(PMN[1]));
	
	    for (i = 0; i < N; i++) {
	        var index_s = i % dim;
	        var index_i = Math.floor(i / dim);
	
	        P.lambda_s = lambda_s[index_s];
	        P.lambda_i = lambda_i[index_i];
	
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	        P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	        var PM = pmLib.phasematch(P);
	        PMreal[i] = PM[0] / norm;
	        PMimag[i] = PM[1] / norm;
	        // C_check = PM[2];
	        // if (PM[i]>maxpm){maxpm = PM[i];}
	    }
	
	    // // console.log("Approx Check, ", C_check);
	    return [PMreal, PMimag];
	};
	
	PlotHelpers.calc_JSI = function calc_JSI(props, ls_start, ls_stop, li_start, li_stop, dim) {
	    var N = dim * dim;
	
	    var JSI = new Float64Array(N);
	
	    var JSA = PlotHelpers.calc_JSA(props, ls_start, ls_stop, li_start, li_stop, dim);
	
	    for (var i = 0; i < N; i++) {
	
	        JSI[i] = sq(JSA[0][i]) + sq(JSA[1][i]);
	    }
	    JSI = helpers.normalize(JSI);
	    return JSI;
	};
	
	PlotHelpers.calc_JSA_p = function calc_JSA_p(props, lambda_s, lambda_i, dim, norm) {
	    // norm = 1;
	    props.update_all_angles();
	    // // console.log(props.lambda_i/1e-9, props.lambda_s/1e-9, props.theta_s*180/Math.PI, props.theta_i*180/Math.PI);
	    var P = props.clone();
	    // // console.log(P.theta_i*180/Math.PI, P.phi_i*180/Math.PI);
	    // P.theta_i = 0.6*Math.PI/180;
	    P.phi_i = P.phi_s + Math.PI;
	    P.update_all_angles();
	    P.optimum_idler(P);
	
	    // P = properties.convertToMicrons(P);
	
	    // P.S_p = P.calc_Coordinate_Transform(P.theta, P.phi, 0, 0);
	    // P.n_p = P.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	
	    var todeg = 180 / Math.PI;
	
	    // // console.log("Inside JSA_p:  Theta_s: " + (P.theta_s*todeg).toString() + ", Theta_i: " + (P.theta_i*todeg).toString() );
	    // // console.log(P.phi_i*todeg, P.phi_s*todeg);
	    // P.theta_i = P.theta_s;
	    // var centerpm = pmLib.phasematch(P);
	    // // console.log(sq(centerpm[0]) + sq(centerpm[1]));
	
	
	    var i;
	    // var lambda_s = helpers.linspace(ls_start, ls_stop, dim);
	    // var lambda_i = helpers.linspace(li_stop, li_start, dim);
	
	    var N = lambda_s.length * lambda_i.length;
	    var PMreal = new Float64Array(N);
	    var PMimag = new Float64Array(N);
	
	    var maxpm = 0;
	    var twoPIc = 2 * Math.PI * con.c;
	
	    // calculate normalization
	    // var PMN = pmLib.phasematch(P);
	    // var norm = Math.sqrt(sq(PMN[0]) + sq(PMN[1]));
	
	
	    for (var j = 0; j < lambda_i.length; j++) {
	        for (i = 0; i < lambda_s.length; i++) {
	            var index_s = i;
	            var index_i = j;
	
	            P.lambda_s = lambda_s[index_s];
	            P.lambda_i = lambda_i[index_i];
	
	            P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	            P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	            // P.lambda_s = P.lambda_s *1E6;
	            // P.lambda_i = P.lambda_i *1E6;
	
	            var PM = pmLib.phasematch(P);
	            var omega_s = twoPIc / P.lambda_s,
	                omega_i = twoPIc / P.lambda_i,
	                n_squared = sq(P.n_s * P.n_i)
	            // ,lomega = Math.sqrt(omega_s * omega_i /n_squared)
	            ,
	                lomega = 1;
	            PMreal[i + lambda_s.length * j] = PM[0] * lomega / norm;
	            PMimag[i + lambda_s.length * j] = PM[1] * lomega / norm;
	        }
	    }
	
	    // // console.log("JSA coinc Max: " + helpers.max(PMreal).toString());
	    // // console.log("Approx Check, ", C_check);
	    return [PMreal, PMimag];
	};
	
	PlotHelpers.calc_JSI_p = function calc_JSI_p(props, lambda_s, lambda_i, dim, norm) {
	    var N = lambda_s.length * lambda_i.length;
	    var JSI = new Float64Array(N);
	    var JSA = PlotHelpers.calc_JSA_p(props, lambda_s, lambda_i, dim, norm);
	
	    for (var i = 0; i < N; i++) {
	
	        JSI[i] = sq(JSA[0][i]) + sq(JSA[1][i]);
	    }
	    // JSI = helpers.normalize(JSI);
	
	    return JSI;
	};
	
	// Calculate and return the coincidence rate
	PlotHelpers.calc_JSI_rates_p = function calc_JSI_rates_p(props, lambda_s, lambda_i, dim, norm) {
	    var N = lambda_s.length * lambda_i.length;
	    var JSI = new Float64Array(N);
	    var JSA = PlotHelpers.calc_JSA_p(props, lambda_s, lambda_i, dim, 1);
	    var dw_s = (lambda_s[lambda_s.length - 1] - lambda_s[0]) / lambda_s.length;
	    var dw_i = (lambda_i[lambda_i.length - 1] - lambda_i[0]) / lambda_i.length;
	
	    var Ws_SQ = Math.pow(props.W_sx, 2),
	        PHI_s = 1 / Math.cos(props.theta_s_e),
	        PHI_i = 1 / Math.cos(props.theta_i_e),
	        twoPIc = 2 * Math.PI * con.c,
	        omega_s = twoPIc / props.lambda_s,
	        omega_i = twoPIc / props.lambda_i
	    // ,pumpScale = Math.pow(props.W,2) // May need to later include the ellipticity parameter
	    ,
	        scale = sq(props.W_sx) * PHI_s * sq(props.W_ix) * PHI_i * sq(props.W),
	        inv_lambda_s_sq = 0,
	        inv_lambda_i_sq = 0,
	        dlambda_s = Math.abs(lambda_s[lambda_s.length - 1] - lambda_s[0]) / lambda_s.length,
	        dlambda_i = Math.abs(lambda_i[lambda_i.length - 1] - lambda_i[0]) / lambda_i.length
	    // ,norm_sum_s = twoPIc * dlambda_s
	    // ,norm_sum_i = twoPIc * dlambda_i
	    ,
	        lomega = omega_s * omega_i / sq(props.n_s * props.n_i)
	    // ,lomega = 1
	    ,
	        norm_const = props.get_rates_constant();
	
	    // for (var l = 0; l<lambda_s.length; l++){
	    //     inv_lambda_s_sq += 1/sq(lambda_s[l]);
	    // }
	
	    // for (var k = 0; k<lambda_i.length; k++){
	    //     inv_lambda_i_sq += 1/sq(lambda_i[k]);
	    // }
	
	    var d_omega_s = twoPIc * dlambda_s / sq(props.lambda_s);
	    var d_omega_i = twoPIc * dlambda_i / sq(props.lambda_i);
	
	    // var d_omega_s = 1;
	    // var d_omega_i = 1;
	
	    for (var i = 0; i < N; i++) {
	
	        JSI[i] = (sq(JSA[0][i]) + sq(JSA[1][i])) * norm_const * scale * (d_omega_s * d_omega_i) * lomega;
	    }
	
	    // And now we have the scaling.
	
	
	    return JSI;
	};
	
	////////////////////
	//CURRENT
	PlotHelpers.calc_JSI_Singles_p = function calc_JSI_Singles_p(props, lambda_s, lambda_i, dim, norm) {
	
	    props.update_all_angles();
	    // // console.log(props.lambda_i/1e-9, props.lambda_s/1e-9, props.theta_s*180/Math.PI, props.theta_i*180/Math.PI);
	    var P = props.clone();
	    // // console.log(P.theta_i*180/Math.PI, P.phi_i*180/Math.PI);
	    // P.theta_i = 0.6*Math.PI/180;
	    P.phi_i = P.phi_s + Math.PI;
	    P.update_all_angles();
	    P.optimum_idler(P);
	
	    var todeg = 180 / Math.PI;
	
	    var i;
	    var N = lambda_s.length * lambda_i.length;
	    var PMreal_s = new Float64Array(N);
	    var PMimag_s = new Float64Array(N);
	    var PMmag_s = new Float64Array(N);
	
	    var PMreal_i = new Float64Array(N);
	    var PMimag_i = new Float64Array(N);
	    var PMmag_i = new Float64Array(N);
	
	    // var dOmega_s = new Float64Array( lambda_s.length );
	    // var dOmega_i = new Float64Array( lambda_i.length );
	
	
	    var maxpm = 0;
	
	    var Ws_SQ = Math.pow(P.W_sx, 2),
	        Wi_SQ = Math.pow(P.W_ix, 2),
	        PHI_s = 1 / Math.cos(P.theta_s_e),
	        PHI_i = 1 / Math.cos(P.theta_i_e),
	        twoPIc = 2 * Math.PI * con.c,
	        omega_s = twoPIc / P.lambda_s,
	        omega_i = twoPIc / P.lambda_i,
	        dOmega_s,
	        dOmega_i,
	        pumpScale = Math.pow(P.W, 2) // May need to later include the ellipticity parameter
	    ,
	        scale_s = 1 / (Ws_SQ * PHI_s * pumpScale),
	        scale_i = 1 / (Wi_SQ * PHI_i * pumpScale) //assume symmetric coupling geometry
	    ,
	        dlambda_s = Math.abs(lambda_s[lambda_s.length - 1] - lambda_s[0]) / lambda_s.length,
	        dlambda_i = Math.abs(lambda_i[lambda_i.length - 1] - lambda_i[0]) / lambda_i.length,
	        norm_sum_s = twoPIc * dlambda_s,
	        norm_sum_i = twoPIc * dlambda_i,
	        lomega = omega_s * omega_i / sq(props.n_s * props.n_i),
	        norm_const = props.get_rates_constant();
	
	    // calculate normalization
	    // var PMN = pmLib.phasematch(P);
	    // var norm = Math.sqrt(sq(PMN[0]) + sq(PMN[1]));
	
	
	    // var lomega = omega_s * omega_i /sq(props.n_s*props.n_i);
	
	    // dOmega_s = lomega*(twoPIc*Math.abs(1/lambda_s[0] - 1/lambda_s[lambda_s.length-1])/lambda_s.length);
	    // dOmega_i = lomega* (twoPIc*Math.abs(1/lambda_i[0] - 1/lambda_i[lambda_i.length-1])/lambda_i.length);
	
	    for (var j = 0; j < lambda_i.length; j++) {
	        for (i = 0; i < lambda_s.length; i++) {
	            var index_s = i;
	            var index_i = j;
	
	            P.lambda_s = lambda_s[index_s];
	            P.lambda_i = lambda_i[index_i];
	
	            dOmega_s = norm_sum_s / sq(lambda_s[index_s]);
	            dOmega_i = norm_sum_i / sq(lambda_i[index_i]);
	            // var dOmega_s = 1.;
	            // var dOmega_i = 1.;
	            // lomega = 1;
	
	
	            P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	            P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	            // var P_i = P.clone();
	            var PM = pmLib.phasematch_singles(P);
	            PMreal_s[i + lambda_s.length * j] = PM[0] / norm;
	            PMimag_s[i + lambda_s.length * j] = PM[1] / norm;
	            PMmag_s[i + lambda_s.length * j] = Math.sqrt(sq(PMreal_s[i + lambda_s.length * j]) + sq(PMimag_s[i + lambda_s.length * j])) * norm_const * (dOmega_s * dOmega_i) * lomega / scale_s;
	
	            // Now calculate the Idler JSI
	            // The role of the signal and idler get swapped in the calculation
	            // but the signal and idler wavelengths and other properties stay the same
	            // so there is no need to transpose the PMmag_i array.
	            P.swap_signal_idler();
	            var PM_i = pmLib.phasematch_singles(P);
	            P.swap_signal_idler();
	            PMreal_i[i + lambda_s.length * j] = PM_i[0] / norm;
	            PMimag_i[i + lambda_s.length * j] = PM_i[1] / norm;
	            PMmag_i[i + lambda_s.length * j] = Math.sqrt(sq(PMreal_i[i + lambda_s.length * j]) + sq(PMimag_i[i + lambda_s.length * j])) * norm_const * (dOmega_s * dOmega_i) * lomega / scale_i;
	        }
	    }
	
	    // // console.log("Approx Check, ", C_check);
	    // return [PMreal, PMimag];
	    // // console.log(PMmag_i.toString());
	    return [PMmag_s, PMmag_i];
	};
	
	/* This plots the phasematching curve for the signal/idler vs the pump wavelength. It is simialar to the JSA calcualtion.
	*
	*
	*/
	PlotHelpers.calc_PM_Curves = function calc_PM_Curves(props, l_start, l_stop, lp_start, lp_stop, type, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    if (P.brute_force) {
	        dim = P.brute_dim;
	    }
	
	    var i;
	    var lambda_p = helpers.linspace(lp_start, lp_stop, dim);
	    // lambda_s is either the signal or idler wavelength
	    var lambda_s = helpers.linspace(l_stop, l_start, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    if (type === 'signal') {
	        for (i = 0; i < N; i++) {
	            var index_p = i % dim;
	            var index_s = Math.floor(i / dim);
	
	            P.lambda_s = lambda_s[index_s];
	            P.lambda_p = lambda_p[index_p];
	            P.lambda_i = 1 / (1 / P.lambda_p - 1 / P.lambda_s);
	
	            // P.S_p = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_p, P.phi_p);
	            // P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	            // P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	
	            P.n_p = P.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	            P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	            P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	            PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	        }
	    }
	    // // console.log(P.lambda_p, P.lambda_s, P.lambda_i);
	
	    return PM;
	};
	
	/* The crystal theta vs signal wavelength. Somewhat redundant.
	*/
	PlotHelpers.calc_PM_Crystal_Tilt = function calc_PM_Crystal_Tilt(props, ls_start, ls_stop, theta_start, theta_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    // if (P.brute_force){
	    //     dim = P.brute_dim;
	    // }
	
	    var i;
	    // lambda_s is either the signal or idler wavelength
	    var lambda_s = helpers.linspace(ls_stop, ls_start, dim);
	    // internal angle of the optic axis wrt to the pump direction.
	    var theta = helpers.linspace(theta_start, theta_stop, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    for (i = 0; i < N; i++) {
	        var index_theta = i % dim;
	        var index_s = Math.floor(i / dim);
	
	        P.lambda_s = lambda_s[index_s];
	        P.theta = theta[index_theta];
	        P.lambda_i = 1 / (1 / P.lambda_p - 1 / P.lambda_s);
	
	        //crystal has changed angle, so update all angles and indices
	        P.update_all_angles();
	
	        PM[i] = "phasematch";
	    }
	
	    return PM;
	};
	
	/* This plots the phasematching curve for crystal theta and phi.
	*/
	PlotHelpers.calc_PM_Pump_Theta_Phi = function calc_PM_Pump_Theta_Phi(props, theta_start, theta_stop, phi_start, phi_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    // if (P.brute_force){
	    //     dim = P.brute_dim;
	    // }
	
	    var i;
	    var theta = helpers.linspace(theta_start, theta_stop, dim);
	    var phi = helpers.linspace(phi_stop, phi_start, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    for (i = 0; i < N; i++) {
	        var index_theta = i % dim;
	        var index_phi = Math.floor(i / dim);
	
	        P.theta = theta[index_theta];
	        P.phi = phi[index_phi];
	
	        //crystal has changed angle, so update all angles and indices
	        P.update_all_angles();
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	        // if (isNaN(PM[i])){
	        //     // // console.log("theta", P.theta*180/Math.PI, P.phi*180/Math.PI);
	        // }
	    }
	    return PM;
	};
	
	/* This plots the phasematching curve for Poling Period vs crystal theta.
	*/
	PlotHelpers.calc_PM_Pump_Theta_Poling = function calc_PM_Pump_Theta_Poling(props, poling_start, poling_stop, theta_start, theta_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    // if (P.brute_force){
	    //     dim = P.brute_dim;
	    // }
	
	    var i;
	    var poling = helpers.linspace(poling_start, poling_stop, dim);
	    var theta = helpers.linspace(theta_stop, theta_start, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    for (i = 0; i < N; i++) {
	        var index_poling = i % dim;
	        var index_theta = Math.floor(i / dim);
	
	        P.poling_period = poling[index_poling];
	        P.theta = theta[index_theta];
	
	        //crystal has changed angle, so update all angles and indices
	        P.update_all_angles();
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	    }
	    return PM;
	};
	
	// /* Plot the indicies of refraction of the signal, idler, and pump
	// */
	// PlotHelpers.calc_indicies = function calc_indicies(props, dim){
	
	//     props.update_all_angles();
	//     var P = props.clone();
	
	//     // if (P.brute_force){
	//     //     dim = P.brute_dim;
	//     // }
	
	//     var i;
	//     var poling = helpers.linspace(poling_start, poling_stop, dim);
	//     var theta = helpers.linspace(theta_stop, theta_start, dim);
	
	//     var N = dim * dim;
	//     var PM = new Float64Array( N );
	
	
	//     for (i=0; i<N; i++){
	//         var index_poling = i % dim;
	//         var index_theta = Math.floor(i / dim);
	
	//         P.poling_period = poling[index_poling];
	//         P.theta = theta[index_theta];
	
	//         //crystal has changed angle, so update all angles and indices
	//         P.update_all_angles();
	
	//         PM[i] = pmLib.phasematch_Int_Phase(P);
	//     }
	//     return PM;
	// };
	
	
	PlotHelpers.calc_XY = function calc_XY(props, x_start, x_stop, y_start, y_stop, dim) {
	    // // console.log('inside calc_xy',props.phi*180/Math.PI);
	    props.update_all_angles();
	    var P = props.clone();
	    P.lambda_i = 1 / (1 / P.lambda_p - 1 / P.lambda_s);
	    // // console.log(P.lambda_i);
	    // P.update_all_angles();
	    // // console.log(P);
	    // // console.log('After clone',props.phi*180/Math.PI);
	
	    P.phi_i = P.phi_s + Math.PI;
	    P.brute_force = true;
	    if (P.brute_force) {
	        // Check to see if the Rayleigh range is shorter than the crystal.
	        // If so, set the lenght of the crystal to be equal to 2* Rayleigh rang
	        var z0 = Math.PI * P.W * P.W / P.lambda_p;
	        //     //console.log("Rayleigh Range: " + (z0*1e6).toString());
	        if (10 * z0 < P.L) {
	            P.L = 10 * z0;
	        }
	        // dim = P.brute_dim;
	        // dim = 5;
	    }
	
	    // Find the stopping angle to integrate over
	    var int_angles = pmLib.autorange_theta(P);
	    var tstart = int_angles[0];
	    var tstop = int_angles[1];
	    if (P.theta_s * 180 / Math.PI < 4) {
	        tstart = 0;
	    }
	
	    if (tstop < x_stop) {
	        tstop = x_stop;
	    }
	
	    if (tstop < P.theta_i) {
	        tstop = P.theta_i;
	    }
	    // if (tstop < P.theta_s_e){
	    //     tstop =
	    // }
	    // int_angles[1] = (P.theta_s_e - int_angles[0]) + P.theta_s_e;
	    var num_pts_per_deg = 20;
	    var numint = Math.round((tstop - tstart) * 180 / Math.PI * num_pts_per_deg);
	    // if (numint < 100){
	    //     numint = 100;
	    // };
	    //     //console.log("number of integration points: " + numint.toString());
	
	    P.theta_s_e = x_stop;
	    var theta_stop = pmLib.find_internal_angle(P, "signal");
	    var int_weights = helpers.NintegrateWeights(numint),
	        diff = tstop - tstart,
	        dtheta = diff / numint;
	    tstart = 0;
	    tstop = theta_stop;
	
	    // // console.log("theta_stop: " + (theta_stop*180/Math.PI).toString() +', ' + numint.toString() +', ' + diff.toString() +', ' +dtheta.toString() );
	    var i;
	
	    var theta_x_e = helpers.linspace(x_start, x_stop, dim);
	    var theta_y_e = helpers.linspace(y_stop, y_start, dim);
	    var X = theta_x_e;
	    var Y = theta_y_e;
	
	    for (var k = 0; k < dim; k++) {
	        if (theta_x_e[k] < 0) {
	            P.theta_s_e = -1 * theta_x_e[k];
	            X[k] = -1 * pmLib.find_internal_angle(P, "signal");
	            Y[dim - k - 1] = X[k];
	        } else {
	            P.theta_s_e = theta_x_e[k];
	            X[k] = pmLib.find_internal_angle(P, "signal");
	            Y[dim - k - 1] = X[k];
	        }
	    }
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	    var PM_int_results = new Float64Array(numint);
	
	    var startTime = new Date();
	
	    var angintfunct = function angintfunct(theta_i) {
	        // Set theta_i to the input theta, then update the coordinates + the index
	        P.theta_i = theta_i;
	        P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	        P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	        // Now calculate the PM function
	        var pm_result = pmLib.phasematch_Int_Phase(P)["phasematch"];
	        // return [pm_result,0];
	
	        // var pm_result = pmLib.phasematch(P);
	        return pm_result;
	    };
	
	    for (i = 0; i < N; i++) {
	        var index_x = i % dim;
	        var index_y = Math.floor(i / dim);
	
	        P.theta_s = Math.asin(Math.sqrt(sq(X[index_x]) + sq(Y[index_y])));
	        P.phi_s = Math.atan2(Y[index_y], X[index_x]);
	
	        // if (X[index_x] < 0){ P.phi_s += Math.PI;}
	        // if (P.phi_s<0){ P.phi_s += 2*Math.PI;}
	
	        // // console.log(P.theta_s /Math.PI * 180, P.phi_s /Math.PI * 180);
	        P.phi_i = P.phi_s + Math.PI;
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	
	        // P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	        // P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	
	        if (P.brute_force) {
	            // P.brute_force_theta_i(P); //use a search. could be time consuming.
	            // var angintfunct = function(theta_i){
	            //     // Set theta_i to the input theta, then update the coordinates + the index
	            //     P.theta_i = theta_i;
	            //     P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	            //     P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	            //     // Now calculate the PM function
	            //     var pm_result = pmLib.phasematch_Int_Phase(P)["phasematch"];
	            //     // return [pm_result,0];
	            //
	            //     // var pm_result = pmLib.phasematch(P);
	            //     return pm_result;
	
	            for (var j = 0; j < numint; j++) {
	                PM_int_results[j] = angintfunct(tstart + dtheta * j);
	            }
	
	            // PM[i] = Math.max.apply(Math, PM_int_results);
	            PM[i] = helpers.max(PM_int_results);
	            // var pm_int_ang = helpers.Nintegrate2arg(angintfunct,tstart, tstop, dtheta,numint,int_weights);
	            // // console.log("int result: " + pm_int_ang[0].toString());
	            // PM[i] = Math.sqrt(pm_int_ang[0]*pm_int_ang[0] + pm_int_ang[1]*pm_int_ang[1])/diff;
	        } else {
	            //calculate the correct idler angle analytically.
	            // // console.log('hello');
	            P.optimum_idler(P);
	            PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	        }
	
	        // // console.log('inside !',props.phi*180/Math.PI);
	    }
	    P.brute_force = false;
	    var endTime = new Date();
	    var timeDiff = endTime - startTime;
	    //console.log("return" + timeDiff.toString());
	    return PM;
	};
	
	PlotHelpers.calc_XY_both = function calc_XY_both(props, x_start, x_stop, y_start, y_stop, dim) {
	    // // console.log('inside calc_xy',props.phi*180/Math.PI);
	
	    props.update_all_angles();
	    var P = props.clone();
	    P.lambda_i = 1 / (1 / P.lambda_p - 1 / P.lambda_s);
	    // // console.log(P.lambda_i);
	    // P.update_all_angles();
	    // // console.log(P);
	    // // console.log('After clone',props.phi*180/Math.PI);
	
	    P.phi_i = P.phi_s + Math.PI;
	
	    if (P.brute_force) {
	        dim = P.brute_dim;
	    }
	
	    var i;
	
	    var theta_x_e = helpers.linspace(x_start, x_stop, dim);
	    var theta_y_e = helpers.linspace(y_stop, y_start, dim);
	    var X = theta_x_e;
	    var Y = theta_y_e;
	
	    for (var k = 0; k < dim; k++) {
	        if (theta_x_e[k] < 0) {
	            P.theta_s_e = -1 * theta_x_e[k];
	            X[k] = -1 * pmLib.find_internal_angle(P, "signal");
	            Y[dim - k - 1] = X[k];
	        } else {
	            P.theta_s_e = theta_x_e[k];
	            X[k] = pmLib.find_internal_angle(P, "signal");
	            Y[dim - k - 1] = X[k];
	        }
	    }
	
	    var N = dim * dim;
	    var PM = new Float64Array(N),
	        index_x,
	        index_y;
	
	    // Find Signal distribution
	    for (i = 0; i < N; i++) {
	        index_x = i % dim;
	        index_y = Math.floor(i / dim);
	
	        P.theta_s = Math.asin(Math.sqrt(sq(X[index_x]) + sq(Y[index_y])));
	        P.phi_s = Math.atan2(Y[index_y], X[index_x]);
	        P.phi_i = P.phi_s + Math.PI;
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	
	        if (P.brute_force) {
	            P.brute_force_theta_i(P); //use a search. could be time consuming.
	        } else {
	            //calculate the correct idler angle analytically.
	            P.optimum_idler(P);
	        }
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	    }
	
	    // "Type 0:   o -> o + o",
	    //    "Type 0:   e -> e + e",
	    //    "Type 1:   e -> o + o",
	    //    "Type 2:   e -> e + o",
	    //    "Type 2:   e -> o + e"
	
	    // Find Idler distribution
	    if (P.type === "Type 0:   o -> o + o" || P.type === "Type 1:   e -> o + o" || P.type === "Type 0:   e -> e + e") {
	        //swap signal and idler frequencies.
	        var lambda_s = P.lambda_s;
	        P.lambda_s = P.lambda_i;
	        P.lambda_i = lambda_s;
	    }
	    if (P.type === "Type 2:   e -> e + o") {
	        // // console.log("switching");
	        P.type = "Type 2:   e -> o + e";
	    } else if (P.type === "Type 2:   e -> o + e") {
	        // // console.log("other way");
	        P.type = "Type 2:   e -> e + o";
	    }
	
	    for (i = 0; i < N; i++) {
	        index_x = i % dim;
	        index_y = Math.floor(i / dim);
	
	        P.theta_s = Math.asin(Math.sqrt(sq(X[index_x]) + sq(Y[index_y])));
	        P.phi_s = Math.atan2(Y[index_y], X[index_x]);
	        P.phi_i = P.phi_s + Math.PI;
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	
	        if (P.brute_force) {
	            P.brute_force_theta_i(P); //use a search. could be time consuming.
	        } else {
	            //calculate the correct idler angle analytically.
	            P.optimum_idler(P);
	        }
	
	        PM[i] += pmLib.phasematch_Int_Phase(P)["phasematch"];
	    }
	
	    return PM;
	};
	
	PlotHelpers.calc_lambda_s_vs_theta_s = function calc_lambda_s_vs_theta_s(props, l_start, l_stop, t_start, t_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    P.phi_i = P.phi_s + Math.PI;
	
	    if (P.brute_force) {
	        dim = P.brute_dim;
	    }
	
	    var theta_s_e = helpers.linspace(t_stop, t_start, dim);
	    var theta_s = theta_s_e;
	
	    for (var k = 0; k < dim; k++) {
	        P.theta_s_e = theta_s_e[k];
	        theta_s[k] = pmLib.find_internal_angle(P, "signal");
	    }
	    var i;
	    var lambda_s = helpers.linspace(l_start, l_stop, dim);
	    // var theta_s_e = [];
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	    var radtodeg = 180 / Math.PI;
	
	    var startTime = new Date();
	    for (i = 0; i < N; i++) {
	        var index_s = i % dim;
	        var index_i = Math.floor(i / dim);
	
	        P.lambda_s = lambda_s[index_s];
	        P.theta_s = theta_s[index_i];
	        P.lambda_i = 1 / (1 / P.lambda_p - 1 / P.lambda_s);
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	
	        if (P.brute_force) {
	            P.brute_force_theta_i(P); //use a search. could be time consuming.
	        } else {
	            //calculate the correct idler angle analytically.
	            P.optimum_idler(P);
	        }
	
	        // if (i%dim === 0){
	        //     theta_s_e[dim - index_i -1] = pmLib.find_external_angle(P,"signal")*radtodeg;
	        // }
	        // theta_s_e[index_i] = pmLib.find_external_angle(P,"signal")*radtodeg;
	
	        // P.optimum_idler(P); //Need to find the optimum idler for each angle.
	        // P.calc_wbar();
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	        // PM[i] = pmLib.calc_delK(P);
	    }
	    var endTime = new Date();
	    var timeDiff = endTime - startTime;
	    return { data: PM };
	};
	
	PlotHelpers.calc_theta_phi = function calc_theta_phi(props, t_start, t_stop, p_start, p_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	    P.phi_i = P.phi_s + Math.PI;
	
	    var i;
	    var theta = helpers.linspace(t_start, t_stop, dim);
	    var phi = helpers.linspace(p_start, p_stop, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    for (i = 0; i < N; i++) {
	        var index_x = i % dim;
	        var index_y = Math.floor(i / dim);
	
	        P.theta = theta[index_x];
	        P.phi = phi[index_y];
	
	        P.S_p = P.calc_Coordinate_Transform(P.theta, P.phi, 0, 0);
	        P.n_p = P.calc_Index_PMType(P.lambda_p, P.type, P.S_p, "pump");
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	
	        //calcualte the correct idler angle analytically.
	        P.optimum_idler(P);
	        // P.calc_wbar();
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	    }
	    return PM;
	};
	
	PlotHelpers.calc_signal_theta_phi = function calc_calc_signal_theta_phi(props, x_start, x_stop, y_start, y_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    if (P.brute_force) {
	        dim = P.brute_dim;
	    }
	
	    var theta_s_e = helpers.linspace(x_start, x_stop, dim);
	    var X = theta_s_e;
	
	    for (var k = 0; k < dim; k++) {
	        P.theta_s_e = theta_s_e[k];
	        X[k] = pmLib.find_internal_angle(P, "signal");
	    }
	
	    var i;
	    // var X = helpers.linspace(x_start, x_stop, dim);
	    var Y = helpers.linspace(y_start, y_stop, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    var startTime = new Date();
	    for (i = 0; i < N; i++) {
	        var index_x = i % dim;
	        var index_y = Math.floor(i / dim);
	
	        P.theta_s = X[index_x];
	        P.phi_s = Y[index_y];
	
	        // // console.log(P.theta_s /Math.PI * 180, P.phi_s /Math.PI * 180);
	        P.phi_i = P.phi_s + Math.PI;
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        // P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	
	        if (P.brute_force) {
	            P.brute_force_theta_i(P); //use a search. could be time consuming.
	        } else {
	            //calculate the correct idler angle analytically.
	            P.optimum_idler(P);
	        }
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	    }
	    var endTime = new Date();
	    var timeDiff = endTime - startTime;
	    return PM;
	};
	
	PlotHelpers.calc_signal_theta_vs_idler_theta = function calc_signal_theta_vs_idler_theta(props, x_start, x_stop, y_start, y_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    var i;
	
	    var theta_s_e = helpers.linspace(x_start, x_stop, dim);
	    var theta_i_e = helpers.linspace(y_stop, y_start, dim);
	    var X = theta_s_e;
	    var Y = theta_i_e;
	
	    for (var k = 0; k < dim; k++) {
	        P.theta_s_e = theta_s_e[k];
	        X[k] = pmLib.find_internal_angle(P, "signal");
	        P.theta_i_e = theta_i_e[k];
	        Y[k] = pmLib.find_internal_angle(P, "idler");
	        // Y[k] = X[k];
	    }
	
	    // var X = helpers.linspace(x_start, x_stop, dim);
	    // var Y = helpers.linspace(y_stop, y_start, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    var startTime = new Date();
	    for (i = 0; i < N; i++) {
	        var index_x = i % dim;
	        var index_y = Math.floor(i / dim);
	
	        P.theta_s = X[index_x];
	        P.theta_i = Y[index_y];
	
	        // // console.log(P.theta_s /Math.PI * 180, P.phi_s /Math.PI * 180);
	        P.phi_i = P.phi_s + Math.PI;
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	        P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	        // PM[i] = pmLib.calc_delK(P);
	    }
	    var endTime = new Date();
	    var timeDiff = endTime - startTime;
	    return PM;
	};
	
	PlotHelpers.calc_signal_phi_vs_idler_phi = function calc_signal_phi_vs_idler_phi(props, x_start, x_stop, y_start, y_stop, dim) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    var i;
	    var X = helpers.linspace(x_start, x_stop, dim);
	    var Y = helpers.linspace(y_stop, y_start, dim);
	
	    var N = dim * dim;
	    var PM = new Float64Array(N);
	
	    for (i = 0; i < N; i++) {
	        var index_x = i % dim;
	        var index_y = Math.floor(i / dim);
	
	        P.phi_s = X[index_x];
	        P.phi_i = Y[index_y];
	
	        P.S_s = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_s, P.phi_s);
	        P.S_i = P.calc_Coordinate_Transform(P.theta, P.phi, P.theta_i, P.phi_i);
	        P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	        P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	        PM[i] = pmLib.phasematch_Int_Phase(P)["phasematch"];
	    }
	
	    return PM;
	};
	
	/* calc_schmidt_plot
	* Params is a JSON string of the form { x: "L/W/BW", y:"L/W/BW"}
	*/
	PlotHelpers.calc_schmidt_plot = function calc_schmidt_plot(props, x_start, x_stop, y_start, y_stop, ls_start, ls_stop, li_start, li_stop, dim, params) {
	
	    props.update_all_angles();
	    var P = props.clone();
	
	    // if (P.brute_force && dim>P.brute_dim){
	    //     dim = P.brute_dim;
	    // }
	
	    var xrange = helpers.linspace(x_start, x_stop, dim);
	    var yrange = helpers.linspace(y_stop, y_start, dim);
	    var i;
	    var N = dim * dim;
	    var S = new Float64Array(N);
	
	    var dimjsa = 50; //make sure this is even
	
	    var maxpm = 0;
	    var maxschmidt = 10;
	    var x_ideal = 0;
	    var y_ideal = 0;
	
	    for (i = 0; i < N; i++) {
	        var index_s = i % dim;
	        var index_i = Math.floor(i / dim);
	
	        // Figure out what to plot in the x dimension
	        switch (params.x) {
	            case "L":
	                P.L = xrange[index_s];
	                break;
	            case "W":
	                P.W = xrange[index_s];
	                break;
	            case "BW":
	                P.p_bw = xrange[index_s];
	                break;
	            default:
	                throw "Error: x input type";
	        }
	
	        // Figure out what to plot in the y dimension
	        switch (params.y) {
	            case "L":
	                P.L = yrange[index_i];
	                break;
	            case "W":
	                P.W = yrange[index_i];
	                break;
	            case "BW":
	                P.p_bw = yrange[index_i];
	                break;
	            default:
	                throw "Error: y input type";
	        }
	
	        //now calculate the JSI for these values
	        var jsa = PlotHelpers.calc_JSI(P, ls_start, ls_stop, li_start, li_stop, dimjsa);
	        var jsa2d = helpers.create_2d_array(jsa, dimjsa, dimjsa);
	        S[i] = pmLib.calc_Schmidt(jsa2d);
	
	        if (S[i] < maxschmidt) {
	            maxschmidt = S[i];
	            x_ideal = xrange[index_s];
	            y_ideal = yrange[index_i];
	        }
	    }
	
	    // // console.log("max pm value = ", maxpm);
	    // // console.log("Lowest Schmidt = ", maxschmidt, " , X = ", x_ideal, ", Y = ", y_ideal);
	    // // console.log("HOM dip = ",pmLib.calc_HOM_JSA(P, 0e-15));
	
	    return S;
	};
	
	/*
	* calc_schmidt_plot_p
	* Params is a JSON string of the form { x: "L/W/BW", y:"L/W/BW"}
	*/
	PlotHelpers.calc_schmidt_plot_p = function calc_schmidt_plot(props, xrange, yrange, ls_start, ls_stop, li_start, li_stop, dim, params) {
	    props.update_all_angles();
	    var P = props.clone();
	
	    // if (P.brute_force && dim>P.brute_dim){
	    //     dim = P.brute_dim;
	    // }
	
	    // var xrange = helpers.linspace(x_start, x_stop, dim);
	    // var yrange = helpers.linspace(y_stop, y_start, dim);
	    var i;
	    var N = xrange.length * yrange.length;
	    var S = new Float64Array(N);
	
	    var dimjsa = 50; //make sure this is even
	
	    var maxpm = 0;
	    var maxschmidt = 10;
	    var x_ideal = 0;
	    var y_ideal = 0;
	
	    for (i = 0; i < N; i++) {
	        var index_x = i % xrange.length;
	        var index_y = Math.floor(i / xrange.length);
	
	        // Figure out what to plot in the x dimension
	        switch (params.x) {
	            case "L":
	                P.L = xrange[index_x];
	                break;
	            case "W":
	                P.W = xrange[index_x];
	                break;
	            case "BW":
	                P.p_bw = xrange[index_x];
	                break;
	            default:
	                throw "Error: x input type";
	        }
	
	        // Figure out what to plot in the y dimension
	        switch (params.y) {
	            case "L":
	                P.L = yrange[index_y];
	                break;
	            case "W":
	                P.W = yrange[index_y];
	                break;
	            case "BW":
	                P.p_bw = yrange[index_y];
	                break;
	            default:
	                throw "Error: y input type";
	        }
	
	        //now calculate the JSI for these values
	        var jsa = PlotHelpers.calc_JSI(P, ls_start, ls_stop, li_start, li_stop, dimjsa);
	        var jsa2d = helpers.create_2d_array(jsa, dimjsa, dimjsa);
	        S[i] = pmLib.calc_Schmidt(jsa2d);
	        // // console.log(S[i]);
	
	        if (S[i] < maxschmidt) {
	            maxschmidt = S[i];
	            x_ideal = xrange[index_x];
	            y_ideal = yrange[index_y];
	        }
	    }
	
	    // // console.log("max pm value = ", maxpm);
	    // // console.log("Lowest Schmidt = ", maxschmidt, " , X = ", x_ideal, ", Y = ", y_ideal);
	    // // console.log("HOM dip = ",pmLib.calc_HOM_JSA(P, 0e-15));
	    // // console.log(S[0]);
	    return S;
	};
	
	////////////
	//CURRENT
	/*
	* calc_heralding_plot_p
	*/
	PlotHelpers.calc_heralding_plot_p = function calc_heralding_plot_p(props, WpRange, WsRange, ls_start, ls_stop, li_start, li_stop, n) {
	    props.update_all_angles();
	    var P = props.clone(),
	        i,
	        N = WpRange.length * WsRange.length,
	        eff_s = new Float64Array(N),
	        eff_i = new Float64Array(N),
	        singles_s = new Float64Array(N),
	        singles_i = new Float64Array(N),
	        coinc = new Float64Array(N),
	        dim = 15,
	        maxeEff = 0,
	        Ws_ideal = 0,
	        Wp_ideal = 0,
	        Wi_SQ = Math.pow(P.W_sx, 2),
	        PHI_s = 1 / Math.cos(P.theta_s_e)
	    // ,PHI_i = 1/Math.cos(P.theta_s_i)
	    // ,n = n+(3- n%3) //guarantee that n is divisible by 3
	    ,
	        lambdaWeights = helpers.Nintegrate2DWeights_3_8(n)
	    // @@@@@@ For testing purposes
	    ,
	        lambda_s = helpers.linspace(ls_start, ls_stop, dim),
	        lambda_i = helpers.linspace(li_stop, li_start, dim);
	    // ,lambda_s = helpers.linspace(P.lambda_p *2, P.lambda_p *2, dim)
	    // ,lambda_i = helpers.linspace(P.lambda_p *2, P.lambda_p *2, dim)
	
	    n = 15; //make sure this is even
	
	
	    P.phi_i = P.phi_s + Math.PI;
	    P.update_all_angles();
	    P.optimum_idler(P);
	
	    var P_i = P.clone();
	    P_i.swap_signal_idler();
	    var PHI_i = 1 / Math.cos(P_i.theta_s_e);
	
	    ///////////////////////////////////////////////////
	    // function calc_singles_rate(lambda_s, lambda_i ){
	
	    //     // P.update_all_angles();
	    //     // var P = props;
	    //     // P.swap_signal_idler();
	    //     // P.swap_signal_idler();
	    //     P.lambda_s = lambda_s;
	    //     P.lambda_i = lambda_i;
	
	    //     P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	    //     P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	    //     var PM = pmLib.phasematch_singles(P);
	    //     // P.swap_signal_idler();
	    //     // // console.log("inside singles: " + PM[0].toString() + ", i*" + PM[1].toString() + " P.n_p: " +P.n_p.toString() + ", Weights:" + lambdaWeights[0].toString());
	    //     return Math.sqrt(sq(PM[0]) + sq(PM[1]));
	    // };
	
	    // function calc_singles_rate_i(lambda_s, lambda_i ){
	
	    //     // P.update_all_angles();
	    //     // var P = props;
	    //     P_i.lambda_s = lambda_s;
	    //     P_i.lambda_i = lambda_i;
	
	    //     P_i.n_s = P_i.calc_Index_PMType(P_i.lambda_s, P_i.type, P_i.S_s, "signal");
	    //     P_i.n_i = P_i.calc_Index_PMType(P_i.lambda_i, P_i.type, P_i.S_i, "idler");
	
	    //     var PM = pmLib.phasematch_singles(P_i);
	    //     // // console.log("inside singles: " + PM[0].toString() + ", i*" + PM[1].toString() + " P_i.n_p: " +P.n_p.toString() + ", Weights:" + lambdaWeights[0].toString());
	    //     return Math.sqrt(sq(PM[0]) + sq(PM[1]));
	    // };
	
	    // function calc_coinc_rate(lambda_s, lambda_i ){
	
	    //     // P.update_all_angles();
	    //     // var P = props;
	    //     P.lambda_s = lambda_s;
	    //     P.lambda_i = lambda_i;
	
	    //     P.n_s = P.calc_Index_PMType(P.lambda_s, P.type, P.S_s, "signal");
	    //     P.n_i = P.calc_Index_PMType(P.lambda_i, P.type, P.S_i, "idler");
	
	    //     var PM = pmLib.phasematch(P);
	    //     return (sq(PM[0]) + sq(PM[1]));
	    // };
	
	
	    function calc_singles_rate() {
	        var JSI_singles = PlotHelpers.calc_JSI_Singles_p(P, lambda_s, lambda_i, dim, 1);
	
	        // Now, since the calculation is done in terms of omega_s, omega_i, need to figure out
	        // step size of the Riemman sum.
	
	        // for (var i=0; i<lambda_s.length, i++){
	
	        // }
	        // var dw_s = (lambda_s[lambda_s.length-1] - lambda_s[0])/lambda_s.length;
	        // var dw_i = (lambda_i[lambda_i.length-1] - lambda_i[0])/lambda_i.length;
	        // console.log(helpers.Sum(JSI_singles[0]).toString());
	        return [helpers.Sum(JSI_singles[0]), helpers.Sum(JSI_singles[1])];
	    }
	
	    function calc_coinc_rate() {
	
	        // var JSI_coinc = PlotHelpers.calc_JSI_p(P, lambda_s,lambda_i, dim, 1);
	        var JSI_coinc = PlotHelpers.calc_JSI_rates_p(P, lambda_s, lambda_i, dim, 1);
	
	        return helpers.Sum(JSI_coinc);
	    }
	
	    for (i = 0; i < N; i++) {
	        var index_x = i % WpRange.length;
	        var index_y = Math.floor(i / WpRange.length);
	        P.W_sx = WsRange[index_y];
	        P.W_sy = P.W_sx;
	        P.W_ix = WsRange[index_y];
	        P.W_iy = P.W_ix;
	        P.W = WpRange[index_x];
	
	        P_i.W_sx = WsRange[index_y];
	        P_i.W_sy = P_i.W_sx;
	        P_i.W_ix = WsRange[index_y];
	        P_i.W_iy = P_i.W_ix;
	
	        // // Testing out values
	        // P.W_sx = WsRange[index_y];
	        // P.W_sy = P.W_sx;
	        // P.W_ix = WsRange[index_y];
	        // P.W_iy = P.W_ix;
	        // P.W = WpRange[index_x];
	
	        // P_i.W_sx = WsRange[index_y];
	        // P_i.W_sy = P_i.W_sx;
	        // P_i.W_ix = WsRange[index_y];
	        // P_i.W_iy = P_i.W_ix;
	
	        // var singlesRate = helpers.Nintegrate2D_3_8(calc_singles_rate, ls_start, ls_stop, li_start, li_stop, n, lambdaWeights)
	        //     ,coincRate = helpers.Nintegrate2D_3_8(calc_coinc_rate, ls_start, ls_stop, li_start, li_stop, n, lambdaWeights)
	        //     ;
	
	        var singRate = calc_singles_rate(),
	            coincRate = calc_coinc_rate(),
	            singlesRate = singRate[0],
	            idlerSinglesRate = singRate[1];
	
	        // // coincRate = coincRate ;
	        // P.swap_signal_idler();
	        // // var PHI_i = 1/Math.cos(P_i.theta_s_e);
	        // // var idlerSinglesRate = helpers.Nintegrate2D_3_8(calc_singles_rate, li_start, li_stop, ls_start, ls_stop, n, lambdaWeights);
	        // var idlerSinglesRate = calc_singles_rate();
	        // P.swap_signal_idler();
	        // P.swap_signal_idler();
	        // // console.log("singles: " + singlesRate.toString() + ", coinc:" + coincRate.toString());
	        singles_s[i] = singlesRate; // / ( sq(P.W_sx) * PHI_s);
	        singles_i[i] = idlerSinglesRate; // / ( sq(P.W_sx) * PHI_i);
	        coinc[i] = coincRate;
	        eff_i[i] = coincRate / singlesRate; //*( sq(P.W_sx) * PHI_s);
	        eff_s[i] = coincRate / idlerSinglesRate; //  *( sq(P.W_sx) * PHI_i);
	        // // console.log(coincRate.toString() + ', ' + singlesRate.toString());
	
	    }
	    return [eff_i, eff_s, singles_s, singles_i, coinc];
	    // return eff;
	};
	
	/*
	* calc_heralding_plot_focus_position_p
	*/
	PlotHelpers.calc_heralding_plot_focus_position_p = function calc_heralding_plot_focus_position_p(props, WsRange, ls_start, ls_stop, li_start, li_stop, n) {
	    props.update_all_angles();
	    var WpRange = [props.W];
	    var P = props.clone()
	    // ,WpRange = [props.W]
	    ,
	        i,
	        N = WpRange.length * WsRange.length,
	        eff_s = new Float64Array(N),
	        eff_i = new Float64Array(N),
	        singles_s = new Float64Array(N),
	        singles_i = new Float64Array(N),
	        coinc = new Float64Array(N),
	        dim = 15,
	        maxeEff = 0,
	        Ws_ideal = 0,
	        Wp_ideal = 0,
	        Wi_SQ = Math.pow(P.W_sx, 2),
	        PHI_s = 1 / Math.cos(P.theta_s_e)
	    // ,PHI_i = 1/Math.cos(P.theta_s_i)
	    // ,n = n+(3- n%3) //guarantee that n is divisible by 3
	    ,
	        lambdaWeights = helpers.Nintegrate2DWeights_3_8(n)
	    // @@@@@@ For testing purposes
	    ,
	        lambda_s = helpers.linspace(ls_start, ls_stop, dim),
	        lambda_i = helpers.linspace(li_stop, li_start, dim);
	    // ,lambda_s = helpers.linspace(P.lambda_p *2, P.lambda_p *2, dim)
	    // ,lambda_i = helpers.linspace(P.lambda_p *2, P.lambda_p *2, dim)
	
	    n = 16; //make sure this is even
	    // // console.log("NNNNNNNN: " + WsRange.toString());
	    P.phi_i = P.phi_s + Math.PI;
	    P.update_all_angles();
	    P.optimum_idler(P);
	
	    var P_i = P.clone();
	    P_i.swap_signal_idler();
	    var PHI_i = 1 / Math.cos(P_i.theta_s_e);
	
	    function calc_singles_rate() {
	        var JSI_singles = PlotHelpers.calc_JSI_Singles_p(P, lambda_s, lambda_i, dim, 1);
	        // // console.log(helpers.Sum(JSI_singles[0]).toString());
	        return [helpers.Sum(JSI_singles[0]), helpers.Sum(JSI_singles[1])];
	    }
	
	    function calc_coinc_rate() {
	        var JSI_coinc = PlotHelpers.calc_JSI_p(P, lambda_s, lambda_i, dim, 1);
	        return helpers.Sum(JSI_coinc);
	    }
	
	    for (i = 0; i < N; i++) {
	        // var index_x = i % WpRange.length;
	        // var index_y = Math.floor(i / WpRange.length);
	        // P.W_sx = WsRange[index_y];
	        // P.W_sy = P.W_sx;
	        // P.W_ix = WsRange[index_y];
	        // P.W_iy = P.W_ix;
	        // P.W = WpRange[index_x];
	
	        // P_i.W_sx = WsRange[index_y];
	        // P_i.W_sy = P_i.W_sx;
	        // P_i.W_ix = WsRange[index_y];
	        // P_i.W_iy = P_i.W_ix;
	
	        P.z0s = WsRange[i];
	        P.z0i = WsRange[i];
	
	        P_i.z0s = WsRange[i];
	        P_i.z0i = WsRange[i];
	
	        var singRate = calc_singles_rate(),
	            coincRate = calc_coinc_rate(),
	            singlesRate = singRate[0],
	            idlerSinglesRate = singRate[1];
	
	        singles_s[i] = singlesRate; // / ( sq(P.W_sx) * PHI_s);
	        singles_i[i] = idlerSinglesRate; // / ( sq(P.W_sx) * PHI_i);
	        coinc[i] = coincRate;
	        eff_i[i] = coincRate / singlesRate; //*( sq(P.W_sx) * PHI_s);
	        eff_s[i] = coincRate / idlerSinglesRate; //  *( sq(P.W_sx) * PHI_i);
	        // // console.log(coincRate.toString() + ', ' + singlesRate.toString());
	
	    }
	    return [eff_i, eff_s, singles_s, singles_i, coinc];
	    // return eff;
	};

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;//DON'T BE A DICK PUBLIC LICENSE
	// 
	// Version 1, December 2009
	// 
	// Copyright (C) 2011
	// Jonny Strömberg @javve
	// 
	// Everyone is permitted to copy and distribute verbatim or modified copies of this license document, and changing it is allowed as long as the name is changed.
	// 
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
	
	"use strict";
	
	var hash = (function() {
	
	    var fromHash = function() {
	        var params = window.location.hash ? window.location.hash.substr(1).split("&") : [],
	            paramsObject = {};
	
	        for(var i = 0; i < params.length; i++) {
	            var a = params[i].split("=");
	            paramsObject[a[0]] =  decodeURIComponent(a[1]);
	        }
	        return paramsObject;
	    };
	
	    var toHash = function(params) {
	        var str = [];
	        for(var p in params) {
	            str.push(p + "=" + encodeURIComponent(params[p]));
	        }
	        window.location.hash = str.join("&");
	    };
	
	    return {
	        get: function(param) {
	            var params = fromHash();
	            if (param) {
	                return params[param];
	            } else {
	                return params;
	            }
	        },
	        add: function(newParams) {
	            var params = fromHash();
	            for (var p in newParams) {
	                params[p] = newParams[p];
	            }
	            toHash(params);
	        },
	        remove: function(removeParams) {
	            removeParams = (typeof(removeParams)=='string') ? [removeParams] : removeParams;
	            var params = fromHash();
	            for (var i = 0; i < removeParams.length; i++) {
	                delete params[removeParams[i]];
	            }
	            toHash(params);
	        },
	        clear: function() {
	            toHash({});
	        }
	    };
	})();
	
	return hash;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 442 */
/***/ function(module, exports) {

	module.exports = {
		"tooltips": {
			"calc_theta": "<p>Automatically calculate the angle of the pump with respect to the optic axis that yields phase matching.</p>",
			"theta": "<p>Angle of the pump with respect to the optic axis inside the crystal.</p>",
			"phi": "<p>Angle of the pump with respect to the second optic axis (biaxial crystals) inside the crystal.</p>",
			"length": "<p>Length of the crystal.</p>",
			"temperature": "<p>Crystal temperature. This can change the indices of refraction of the crystal.</p>",
			"lambda_p": "<p>Center Wavelength of the pump.</p>",
			"pump_bw": "<p>Spectral bandwidth of the (FWHM) .</p>",
			"waist_p": "<p>Pump waist in the center of the crystal (1/e^2 in Intensity, 1/e in Amplitude).</p>",
			"lambda_s": "<p>Wavelength of the signal. The idler wavelength is automatically calculated based on the pump and signal wavelengths.</p>",
			"theta_s": "<p>Angle of emission of the signal with respect to the pump.</p>",
			"phi_s": "<p>Azimuthal angle of emission.</p>",
			"brute_force": "<p>Calculations are normally performed assuming that the signal and idler emission angles are correlated. When the pump is tightly focused, the signal and idler emission angles can become uncorrelated. In this case, a brute-force search is conducted to try and determine the optimal emission angles. The computation is significantly slower, so proceed with care. When enabling this option, the plot is automatically set to a 50x50 grid.</p>",
			"calc_pp": "<p>Automatically cacluate the poling period required for phase matching.</p>",
			"poling_period": "<p>The poling period. Enter a larger number here (i.e. 100000) if you want to disable periodic poling</p>",
			"calc_apodization": "<p>Apodization changes the profile of the nonlinear interaction inside the crystal. Here a Gaussian apodization profile is used with the center of the Gaussian placed at the center of the crystal. Apodization can reduce the sinc side lobes by gently turning on then off the nonlinear interaction. </p>",
			"apodization_fwhm": "<p>The width of the Gaussian apodization profile inside the crystal.</p>",
			"apodization_steps": "<p>To speed up the apodization calculation, the crystal is divided into a number of sections along the longitudinal direction. This allows the Gaussian profile to be approximated by a series of step functions. The more sections chosen, the more accurate the results will be at the cost of additinal computation time.</p>",
			"calc_plotopts": "<p>Automatically calculate the range of values to be plotted.</p>",
			"grid_size": "<p>The graphs are made up of a 2D square grid of points. The default is a 100x100 grid. Increasing the number of points improves the resolution of the plot, but also increases the computation time.</p>",
			"plot_lambda_s": "<p>The range of signal wavelengths over which to plot or calculate downconversion properties. Changing the wavelength range is equivalent to implementing a square filter.</p>",
			"plot_lambda_i": "<p>The range of idler wavelengths over which to plot or calculate downconversion properties. Changing the wavelength range is equivalent to implementing a square filter.</p>",
			"plot_theta_s": "<p>The range of singal emission angles to plot.</p>",
			"plot_time_delay": "<p>The range of time delays to plot between the signal and idler photon in the Hong-Ou-Mandel interferometer.</p>",
			"plot_crystal_length": "<p>The range of crystal lengths to plot in the spectral purity optimizer.</p>",
			"plot_pump_bw": "<p>The range of pump bandwidths (FWHM) to plot in the spectral purity optimizer.</p>"
		}
	};

/***/ },
/* 443 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="inner"> <div class="navbar navbar-inverse"> <div class="navbar-inner"> <div class="container"> <!-- <h1 class="site-title">SPDCalc</h1> --> <div class="site-logo"> </div> <div class="ui-module-wrap pull-left"> <select tabindex="1" class="span3" id="ui-modules"> <!-- <option value="testing">Testing</option> --> <option value="jsa">Joint Spectral Intensity</option> <option value="curves">Phasematching Curves</option> <!-- <option value="xy">Emission Angle</option> --> <!-- <option values="heralding1d">Heralding Joint Spectrum</option> --> <option value="heralding1dAdv">Heralding vs collection waist</option> <option value="heraldingPumpFocusPosition">Heralding vs focus position</option> <option value="heralding2d">Heralding Optimization</option> <option value="jsa-hom">Hong-Ou-Mandel dip</option> <option value="jsa-hom-bunch">Hong-Ou-Mandel bunching</option> <option value="jsa-2hom">Two Source Hong-Ou-Mandel</option> <!-- <option value="heralding">Heralding Efficency</option> --> <!-- <option value="modesolver">Mode Solver</option> --><!--                     <option value="efficiency">Efficiency map</option> -->                    <option value="schmidt-2d">Spectral Purity Optimization</option> <!-- <option value="kitchen_sink">Kitchen Sink</option> --> </select> </div> <!-- <ul class="nav"> <li> <a href="#"> Dropdown <span class="navbar-unread">1</span> </a> <ul> <li><a href="#">Element One</a></li> <li> <a href="#">Sub menu</a> <ul> <li><a href="#">Element One</a></li> <li><a href="#">Element Two</a></li> <li><a href="#">Element Three</a></li> </ul> </li> <li><a href="#">Element Three</a></li> </ul> </li> <li> <a href="#"> About </a> </li> </ul> --> </div> </div> </div> <div class="upper row"> <div class="options-wrap span3"> <div id="parameters"></div> <div class="row-fluid"> <h2 class="title"></h2> </div> <section class="form-horizontal"> <div class="row-fluid"> <div class="control-group"> <div class="calcbutton"> <button class="btn ctrl-calc">Calculate</button> </div> </div> </div> <div class="row-fluid"> <div class="control-group"> <div class=""> <label class="checkbox" for="autocalc"> Auto calculate <input type="checkbox" value="" id="autocalc" checked="checked"> </label> </div> </div> </div> <div class="row-fluid"> <div class="control-group"> <button class="btn ctrl-share">Share</button> <input type="text" value="" id="share-url"> </div> </div> </section> </div> <!-- <div class="row-fluid"> <h2 class="title"></h2> </div> <section class="form-horizontal"> <div class="control-group "> <div class=""> <button class="btn ctrl-share">Share</button> </div> <div class="controls"> <input type="text" value="" id="share-url"> </div> </div> <div class="control-group"> <div class="calccheckbox"> <label class="checkbox" for="autocalc"> Auto calculate <input type="checkbox" value="" id="autocalc" checked="checked"> </label> </div> </div> <div class="control-group"> <div class="calcbutton"> <button class="btn btn-success ctrl-calc">Calculate</button> </div> </div> </section> </div> --> <div class="right"> <div id="main"></div> </div> </div> <div class="lower"> <!-- <div id="logs"></div> --> <div id="docs"></div> </div></div>';return out;
	}

/***/ },
/* 444 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div> <div class="parameters-wrap"> <div class="row-fluid"> <h2 class="title">Crystal Options</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl" id="collapse-crystal">&#x2296;</button> </div> </div> <section class="form-horizontal"> <div class="control-group"> <!-- <h4>Crystal Properties</h4> --> </div> <div class="control-group"> <select id="crystal-dropdown" name="crystal" class="full"> ';var arr1=this.PhaseMatch.Crystals.keys();if(arr1){var value,index=-1,l1=arr1.length-1;while(index<l1){value=arr1[index+=1];out+=' <option value="'+( value )+'" ';if(value === it.crystal){out+=' selected="selected" ';}out+='>'+( this.PhaseMatch.Crystals(value).name )+'</option> ';} } out+=' </select> </div> <div class="control-group"> <select id="pm-type-dropdown" name="type" class="full"> ';var arr2=this.PhaseMatch.PMTypes;if(arr2){var value,index=-1,l2=arr2.length-1;while(index<l2){value=arr2[index+=1];out+=' <option value="'+(value)+'" ';if(value === it.type){out+=' selected="selected" ';}out+='>'+(value)+'</option> ';} } out+=' </select> </div> <div class="control-group"> <label class="checkbox control-label calc_theta"> Calculate theta <input id="autocalctheta" type="checkbox" class="inputbox" name="autocalctheta" ';if(it.autocalctheta){out+=' checked="checked" ';}out+=' /> </label> </div> <div class="control-group"> <label class="control-label theta"> Theta (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="theta" value="'+( this.converter.to('deg', parseFloat( it.theta )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label phi"> Phi (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="phi" value="'+( this.converter.to('deg', parseFloat( it.phi )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label length"> Length (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="L" value="'+( this.converter.to('micro', parseFloat( it.L )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label temperature"> Temperature </label> <div class="controls"> <input type="text" data-parse="float" class="inputbox" name="temp" value="'+( parseFloat( it.temp ) )+'" /> </div> </div> </section> </div> <!-- Pump properties --><div class="parameters-wrap collapsed"> <div class="row-fluid"> <h2 class="title">Pump Options</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl" id="collapse-pump">&#x2295;</button> </div> </div> <section class="form-horizontal"> <div class="control-group"> <!-- <h4>Pump Properties</h4> --> </div> <div class="control-group"> <label class="control-label lambda_p"> Wavelength (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="lambda_p" value="'+( this.converter.to('nano', parseFloat( it.lambda_p )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label pump_bw"> Bandwidth FWHM (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="p_bw" value="'+( this.converter.to('nano', parseFloat( it.p_bw )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label waist_p"> Waist 1/e^2 (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="W" value="'+( this.converter.to('micro', parseFloat( it.W )) )+'" /> </div> </div> </section></div><div class="parameters-wrap collapsed"> <div class="row-fluid"> <h2 class="title">Signal Options</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl" id="collapse-signal">&#x2295;</button> </div> </div> <!-- Signal Properties --> <section class="form-horizontal"> <div class="control-group"> <!-- <h4>Signal Properties</h4> --> </div> <div class="control-group"> <label class="checkbox control-label fibercouple"> Enable fiber coupling <input id="fibercouple" type="checkbox" class="inputbox" name="calcfibercoupling" ';if(it.calcfibercoupling){out+=' checked="checked" ';}out+=' /> </label> </div> <div class="control-group"> <label class="control-label lambda_s"> Wavelength (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="lambda_s" value="'+( this.converter.to('nano', parseFloat( it.lambda_s )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label theta_s"> Theta (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="theta_s_e" value="'+( this.converter.to('deg', parseFloat( it.theta_s_e )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label phi_s"> Phi (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="phi_s" value="'+( this.converter.to('deg', parseFloat( it.phi_s )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Waist 1/e^2 (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="W_sx" value="'+( this.converter.to('micro', parseFloat( it.W_sx )) )+'" /> </div> </div> <div class="control-group"> <label class="checkbox control-label calc_focus"> Automatically find optimal waist position <input id="autocalfocus" type="checkbox" class="inputbox" name="autocalfocus" ';if(it.autocalfocus){out+=' checked="checked" ';}out+=' /> </label> </div> <div class="control-group"> <label class="control-label z0s"> Waist Position (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="z0s" value="'+( this.converter.to('micro', parseFloat( it.z0s )) )+'" /> </div> </div> <!--  <div class="control-group"> <label class="control-label"> Waist y dir (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="W_sy" value="'+( this.converter.to('deg', parseFloat( it.W_sy )) )+'" /> </div> </div> --> <!-- <div class="control-group"> <label class="checkbox control-label brute_force"> Brute force calculation <input id="brute_force" type="checkbox" class="inputbox" name="brute_force" ';if(it.brute_force){out+=' checked="checked" ';}out+=' /> </label> </div> --> </section></div> <!-- Periodic Poling Properties --> <div class="parameters-wrap collapsed"> <div class="row-fluid"> <h2 class="title">Periodic Poling</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl" id="collapse-poling">&#x2295;</button> </div> </div> <section class="form-horizontal"> <div class="control-group"> <!-- <h4>Periodic Poling</h4> --> </div> <div class="control-group"> <label class="checkbox control-label"> Enable periodic poling <input type="checkbox" data-parse="float" class="checkbox" id="enable-calc-pp" name="enable_pp" ';if(it.enable_pp){out+=' checked="checked" ';}out+=' /> </label> </div> <div id="periodic-poling-options"><!-- Start the periodic poling group  --> <div class="control-group"> <label class="checkbox control-label calc-pp"> Calculate poling period <input type="checkbox" data-parse="float" id="autocalcppid" class="checkbox" name="autocalcpp" ';if(it.autocalcpp){out+=' checked="checked" ';}out+=' /> </label> </div> <div class="control-group"> <label class="control-label poling_period"> Poling period (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="poling_period" value="'+( this.converter.to('micro', parseFloat( it.poling_period )) )+'" /> </div> </div> <div class="control-group"> <label class="checkbox control-label calc_apodization"> Enable apodization <input type="checkbox" data-parse="float" class="checkbox" name="calc_apodization" ';if(it.calc_apodization){out+=' checked="checked" ';}out+=' /> </label> </div> <div class="control-group "> <label class="control-label apodization_fwhm"> Apodization FWHM (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="apodization_FWHM" value="'+( this.converter.to('micro', parseFloat( it.apodization_FWHM )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label apodization_steps"> Apodization steps </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="apodization" value="'+(  parseFloat( it.apodization ) )+'" /> </div> </div><!-- end the periodic poling group  --> </section> </div> <div class="parameters-wrap collapsed last-parameters"> <div class="row-fluid"> <h2 class="title">Plot Options</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl" id="collapse-plotopts">&#x2295;</button> </div> </div> <div id="plot-opts"></div> </div></div>';return out;
	}

/***/ },
/* 445 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<section class="form-horizontal"> <!-- Plot Options --> <!-- <h3>Plot Options</h3> --> <div class="control-group"> <label class="checkbox control-label calc_plotopts" for="autocalc_plotopts"> Auto calculate plot options <input type="checkbox" name="autocalc_plotopts" id="autocalc_plotopts" ';if(it.autocalc_plotopts){out+='checked="checked"';}out+='> </label> </div> <div id="plot-opt-grid_size"> <div class="control-group"> <label class="control-label grid_size"> Grid size </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="grid_size" value="'+( parseFloat( it.grid_size ) )+'" /> </div> </div> </div> <!-- Grid size for 2D heralding plot. --> <div id="plot-opt-grid_size_heralding"> <div class="control-group"> <label class="control-label grid_size"> Grid size </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="grid_size_heralding" value="'+( parseFloat( it.grid_size_heralding ) )+'" /> </div> </div> </div> <!-- Grid size for 2D heralding plot. --> <div id="plot-opt-grid_size_heralding_JSI"> <div class="control-group"> <label class="control-label grid_size"> Grid size </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="grid_size_heralding_JSI" value="'+( parseFloat( it.grid_size_heralding_JSI ) )+'" /> </div> </div> </div> <div id="plot-opt-T_2HOM"> <div class="control-group"> <label class="control-label T_2HOM"> Number of time delay points </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="T_2HOM" value="'+( parseFloat( it.T_2HOM ) )+'" /> </div> </div> </div> <div id="plot-opt-npts-heralding-waist"> <div class="control-group"> <label class="control-label T_2HOM"> Number of collection waist points </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="n_pts_eff_1d" value="'+( parseFloat( it.n_pts_eff_1d ) )+'" /> </div> </div> </div> <div id="plot-opt-grid_size_ms"> <div class="control-group"> <label class="control-label grid_size_ms"> Grid size </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="grid_size_ms" value="'+( parseFloat( it.grid_size_ms ) )+'" /> </div> </div> </div> <div id="plot-opt-grid_size_schmidt"> <div class="control-group"> <label class="control-label grid_size_schmidt"> Grid size </label> <div class="controls"> <input type="text" data-parse="float" data-unit="" class="inputbox" name="grid_size_schmidt" value="'+( parseFloat( it.grid_size_schmidt ) )+'" /> </div> </div> </div> <div id="plot-opt-signal-wavelength"> <label class="plot_lambda_s">Signal Wavelength</label> <div class="control-group"> <label class="control-label"> Start (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="ls_start" value="'+( this.converter.to('nano', parseFloat( it.ls_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="ls_stop" value="'+( this.converter.to('nano', parseFloat( it.ls_stop )) )+'" /> </div> </div> </div> <div id="plot-opt-idler-wavelength"> <label class="plot_lambda_i">Idler Wavelength</label> <div class="control-group"> <label class="control-label"> Start (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="li_start" value="'+( this.converter.to('nano', parseFloat( it.li_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="li_stop" value="'+( this.converter.to('nano', parseFloat( it.li_stop )) )+'" /> </div> </div> </div> <div id="plot-opt-pump-wavelength"> <label class="plot_lambda_p">Pump Wavelength</label> <div class="control-group"> <label class="control-label"> Start (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="lp_start" value="'+( this.converter.to('nano', parseFloat( it.lp_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="lp_stop" value="'+( this.converter.to('nano', parseFloat( it.lp_stop )) )+'" /> </div> </div> </div> <div id="plot-opt-theta"> <label class="plot_theta_s">Signal Theta Range</label> <div class="control-group"> <label class="control-label"> Start (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="theta_start" value="'+( this.converter.to('deg', parseFloat( it.theta_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="theta_stop" value="'+( this.converter.to('deg', parseFloat( it.theta_stop )) )+'" /> </div> </div> </div> <div id="plot-opt-time-delay"> <label class="plot_time_delay">Time Delay Range</label> <div class="control-group"> <label class="control-label"> Start (fs) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="femto" class="inputbox" name="delT_start" value="'+( this.converter.to('femto', parseFloat( it.delT_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (fs) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="femto" class="inputbox" name="delT_stop" value="'+( this.converter.to('femto', parseFloat( it.delT_stop )) )+'" /> </div> </div> </div> <!-- Now for the spectral purity calculator parameters.--> <!-- Crystal Length --> <div id="plot-opt-xtal_length_range"> <label class="plot_crystal_length">Crystal Length Range</label> <div class="control-group"> <label class="control-label"> Start (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="xtal_l_start" value="'+( this.converter.to('micro', parseFloat( it.xtal_l_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="xtal_l_stop" value="'+( this.converter.to('micro', parseFloat( it.xtal_l_stop )) )+'" /> </div> </div> </div> <!-- Pump Bandwidth range --> <div id="plot-opt-pump_bw_range"> <label class="plot_pump_bw">Pump Bandwidth Range</label> <div class="control-group"> <label class="control-label"> Start (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="bw_start" value="'+( this.converter.to('nano', parseFloat( it.bw_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="bw_stop" value="'+( this.converter.to('nano', parseFloat( it.bw_stop )) )+'" /> </div> </div> </div> <!-- Theta range to plot for PM curves --> <div id="plot-opt-pump-theta"> <label class="plot_pump_theta">Crystal Theta Range</label> <div class="control-group"> <label class="control-label"> Start (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="pump_theta_start" value="'+( this.converter.to('deg', parseFloat( it.pump_theta_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="pump_theta_stop" value="'+( this.converter.to('deg', parseFloat( it.pump_theta_stop )) )+'" /> </div> </div> </div> <!-- Pump Phi range to plot for PM curves --> <div id="plot-opt-pump-phi"> <label class="plot_pump_phi">Crystal Phi Range</label> <div class="control-group"> <label class="control-label"> Start (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="pump_phi_start" value="'+( this.converter.to('deg', parseFloat( it.pump_phi_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="deg" class="inputbox" name="pump_phi_stop" value="'+( this.converter.to('deg', parseFloat( it.pump_phi_stop )) )+'" /> </div> </div> </div> <!-- Poling Period range to plot for PM curves --> <div id="plot-opt-poling-period"> <label class="plot_poling_period">Poling Period Range</label> <div class="control-group"> <label class="control-label"> Start (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="poling_period_start" value="'+( this.converter.to('micro', parseFloat( it.poling_period_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="poling_period_stop" value="'+( this.converter.to('micro', parseFloat( it.poling_period_stop )) )+'" /> </div> </div> </div> <!-- Signal Wavelength Range for the Phasematching curves.  --> <div id="plot-opt-pm-signal-wavelength"> <label class="plot_pm_signal_wavelength">Signal Wavelength Range</label> <div class="control-group"> <label class="control-label"> Start (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="pm_signal_wavelength_start" value="'+( this.converter.to('nano', parseFloat( it.pm_signal_wavelength_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (deg) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="pm_signal_wavelength_stop" value="'+( this.converter.to('nano', parseFloat( it.pm_signal_wavelength_stop )) )+'" /> </div> </div> </div> <!-- Modesolver Signal bandwidth.  --> <div id="plot-opt-collection-bw"> <!-- <label class="plot_pm_signal_wavelength">Signal Wavelength Range</label> --> <div class="control-group"> <label class="control-label"> FWHM Filter bandwidth (nm) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="nano" class="inputbox" name="collection_bw" value="'+( this.converter.to('nano', parseFloat( it.collection_bw )) )+'" /> </div> </div> </div> <!-- Pump Waist Range for the Heralding 2D calculations --> <div id="plot-opt-pump-waist"> <label class="plot_wp">Pump Waist (1/e^2)</label> <div class="control-group"> <label class="control-label"> Start (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="Wp_start" value="'+( this.converter.to('micro', parseFloat( it.Wp_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="Wp_stop" value="'+( this.converter.to('micro', parseFloat( it.Wp_stop )) )+'" /> </div> </div> </div> <!-- Signal Waist Range for the Heralding 2D calculations --> <div id="plot-opt-signal-waist"> <label class="plot_ws">Signal Waist (1/e^2)</label> <div class="control-group"> <label class="control-label"> Start (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="Ws_start" value="'+( this.converter.to('micro', parseFloat( it.Ws_start )) )+'" /> </div> </div> <div class="control-group"> <label class="control-label"> Stop (um) </label> <div class="controls"> <input type="text" data-parse="float" data-unit="micro" class="inputbox" name="Ws_stop" value="'+( this.converter.to('micro', parseFloat( it.Ws_stop )) )+'" /> </div> </div> </div></section>';return out;
	}

/***/ },
/* 446 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out=''+(it.plot.title)+'Crystal: '+(it.meta.crystal)+'Pump Wavelength: '+(it.meta.lambda_p)+'Signal Wavelength: '+(it.meta.lambda_s)+'Idler Wavelength: '+(it.meta.lambda_i)+'PM Type: '+( this.PhaseMatch.PMTypes[ it.meta.type ] )+'Theta: '+(it.meta.theta)+'Phi: '+(it.meta.phi)+'Theta Signal: '+(it.meta.theta_s)+'Theta Idler: '+(it.meta.theta_i)+'Phi Signal: '+(it.meta.phi_s)+'Phi Idler: '+(it.meta.phi_i)+'Poling Period: '+(it.meta.poling_period)+'L: '+(it.meta.L)+'W: '+(it.meta.W)+'Pump Bandwidth: '+(it.meta.p_bw)+'Phase: '+(it.meta.phase)+'Apodization: '+(it.meta.apodization)+'Apodization FWHM: '+(it.meta.apodization_FWHM)+(it.plot.x.label);var arr1=it.plot.x.values;if(arr1){var val,idx=-1,l1=arr1.length-1;while(idx<l1){val=arr1[idx+=1];out+=', '+( val );} } out+=''+(it.plot.y.label);var arr2=it.plot.y.values;if(arr2){var val,idx=-1,l2=arr2.length-1;while(idx<l2){val=arr2[idx+=1];out+=', '+( val );} } var arr3=it.plot.data;if(arr3){var cols,row=-1,l3=arr3.length-1;while(row<l3){cols=arr3[row+=1];out+=''+( row );var arr4=cols;if(arr4){var val,col=-1,l4=arr4.length-1;while(col<l4){val=arr4[col+=1];out+=', '+( val );} } } } return out;
	}

/***/ },
/* 447 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out=''+(it.plot.title)+'Crystal: '+(it.meta.crystal)+'Pump Wavelength: '+(it.meta.lambda_p)+'Signal Wavelength: '+(it.meta.lambda_s)+'Idler Wavelength: '+(it.meta.lambda_i)+'PM Type: '+( this.PhaseMatch.PMTypes[ it.meta.type ] )+'Theta: '+(it.meta.theta)+'Phi: '+(it.meta.phi)+'Theta Signal: '+(it.meta.theta_s)+'Theta Idler: '+(it.meta.theta_i)+'Phi Signal: '+(it.meta.phi_s)+'Phi Idler: '+(it.meta.phi_i)+'Poling Period: '+(it.meta.poling_period)+'L: '+(it.meta.L)+'W: '+(it.meta.W)+'Pump Bandwidth: '+(it.meta.p_bw)+'Phase: '+(it.meta.phase)+'Apodization: '+(it.meta.apodization)+'Apodization FWHM: '+(it.meta.apodization_FWHM)+(it.plot.x.label)+', '+(it.plot.y.label);var arr1=it.plot.data;if(arr1){var val,idx=-1,l1=arr1.length-1;while(idx<l1){val=arr1[idx+=1];var arr2=val;if(arr2){var coord,i=-1,l2=arr2.length-1;while(i<l2){coord=arr2[i+=1];out+=''+(coord);if(i < val.length - 1){out+=', ';}} } } } return out;
	}

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	/* doT + auto-compilation of doT templates
	 *
	 * 2012, Laura Doktorova, https://github.com/olado/doT
	 * Licensed under the MIT license
	 *
	 * Compiles .def, .dot, .jst files found under the specified path.
	 * It ignores sub-directories.
	 * Template files can have multiple extensions at the same time.
	 * Files with .def extension can be included in other files via {{#def.name}}
	 * Files with .dot extension are compiled into functions with the same name and
	 * can be accessed as renderer.filename
	 * Files with .jst extension are compiled into .js files. Produced .js file can be
	 * loaded as a commonJS, AMD module, or just installed into a global variable
	 * (default is set to window.render).
	 * All inline defines defined in the .jst file are
	 * compiled into separate functions and are available via _render.filename.definename
	 *
	 * Basic usage:
	 * var dots = require("dot").process({path: "./views"});
	 * dots.mytemplate({foo:"hello world"});
	 *
	 * The above snippet will:
	 * 1. Compile all templates in views folder (.dot, .def, .jst)
	 * 2. Place .js files compiled from .jst templates into the same folder.
	 *    These files can be used with require, i.e. require("./views/mytemplate").
	 * 3. Return an object with functions compiled from .dot templates as its properties.
	 * 4. Render mytemplate template.
	 */
	
	var fs = __webpack_require__(449),
		doT = module.exports = __webpack_require__(450);
	
	doT.process = function(options) {
		//path, destination, global, rendermodule, templateSettings
		return new InstallDots(options).compileAll();
	};
	
	function InstallDots(o) {
		this.__path 		= o.path || "./";
		if (this.__path[this.__path.length-1] !== '/') this.__path += '/';
		this.__destination	= o.destination || this.__path;
		if (this.__destination[this.__destination.length-1] !== '/') this.__destination += '/';
		this.__global		= o.global || "window.render";
		this.__rendermodule	= o.rendermodule || {};
		this.__settings 	= o.templateSettings ? copy(o.templateSettings, copy(doT.templateSettings)) : undefined;
		this.__includes		= {};
	}
	
	InstallDots.prototype.compileToFile = function(path, template, def) {
		def = def || {};
		var modulename = path.substring(path.lastIndexOf("/")+1, path.lastIndexOf("."))
			, defs = copy(this.__includes, copy(def))
			, settings = this.__settings || doT.templateSettings
			, compileoptions = copy(settings)
			, defaultcompiled = doT.template(template, settings, defs)
			, exports = []
			, compiled = ""
			, fn;
	
		for (var property in defs) {
			if (defs[property] !== def[property] && defs[property] !== this.__includes[property]) {
				fn = undefined;
				if (typeof defs[property] === 'string') {
					fn = doT.template(defs[property], settings, defs);
				} else if (typeof defs[property] === 'function') {
					fn = defs[property];
				} else if (defs[property].arg) {
					compileoptions.varname = defs[property].arg;
					fn = doT.template(defs[property].text, compileoptions, defs);
				}
				if (fn) {
					compiled += fn.toString().replace('anonymous', property);
					exports.push(property);
				}
			}
		}
		compiled += defaultcompiled.toString().replace('anonymous', modulename);
		fs.writeFileSync(path, "(function(){" + compiled
			+ "var itself=" + modulename + ", _encodeHTML=(" + doT.encodeHTMLSource.toString() + "(" + (settings.doNotSkipEncoded || '') + "));"
			+ addexports(exports)
			+ "if(typeof module!=='undefined' && module.exports) module.exports=itself;else if(typeof define==='function')define(function(){return itself;});else {"
			+ this.__global + "=" + this.__global + "||{};" + this.__global + "['" + modulename + "']=itself;}}());");
	};
	
	function addexports(exports) {
		for (var ret ='', i=0; i< exports.length; i++) {
			ret += "itself." + exports[i]+ "=" + exports[i]+";";
		}
		return ret;
	}
	
	function copy(o, to) {
		to = to || {};
		for (var property in o) {
			to[property] = o[property];
		}
		return to;
	}
	
	function readdata(path) {
		var data = fs.readFileSync(path);
		if (data) return data.toString();
		console.log("problems with " + path);
	}
	
	InstallDots.prototype.compilePath = function(path) {
		var data = readdata(path);
		if (data) {
			return doT.template(data,
						this.__settings || doT.templateSettings,
						copy(this.__includes));
		}
	};
	
	InstallDots.prototype.compileAll = function() {
		console.log("Compiling all doT templates...");
	
		var defFolder = this.__path,
			sources = fs.readdirSync(defFolder),
			k, l, name;
	
		for( k = 0, l = sources.length; k < l; k++) {
			name = sources[k];
			if (/\.def(\.dot|\.jst)?$/.test(name)) {
				console.log("Loaded def " + name);
				this.__includes[name.substring(0, name.indexOf('.'))] = readdata(defFolder + name);
			}
		}
	
		for( k = 0, l = sources.length; k < l; k++) {
			name = sources[k];
			if (/\.dot(\.def|\.jst)?$/.test(name)) {
				console.log("Compiling " + name + " to function");
				this.__rendermodule[name.substring(0, name.indexOf('.'))] = this.compilePath(defFolder + name);
			}
			if (/\.jst(\.dot|\.def)?$/.test(name)) {
				console.log("Compiling " + name + " to file");
				this.compileToFile(this.__destination + name.substring(0, name.indexOf('.')) + '.js',
						readdata(defFolder + name));
			}
		}
		return this.__rendermodule;
	};


/***/ },
/* 449 */
/***/ function(module, exports) {



/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// doT.js
	// 2011-2014, Laura Doktorova, https://github.com/olado/doT
	// Licensed under the MIT license.
	
	(function() {
		"use strict";
	
		var doT = {
			version: "1.0.3",
			templateSettings: {
				evaluate:    /\{\{([\s\S]+?(\}?)+)\}\}/g,
				interpolate: /\{\{=([\s\S]+?)\}\}/g,
				encode:      /\{\{!([\s\S]+?)\}\}/g,
				use:         /\{\{#([\s\S]+?)\}\}/g,
				useParams:   /(^|[^\w$])def(?:\.|\[[\'\"])([\w$\.]+)(?:[\'\"]\])?\s*\:\s*([\w$\.]+|\"[^\"]+\"|\'[^\']+\'|\{[^\}]+\})/g,
				define:      /\{\{##\s*([\w\.$]+)\s*(\:|=)([\s\S]+?)#\}\}/g,
				defineParams:/^\s*([\w$]+):([\s\S]+)/,
				conditional: /\{\{\?(\?)?\s*([\s\S]*?)\s*\}\}/g,
				iterate:     /\{\{~\s*(?:\}\}|([\s\S]+?)\s*\:\s*([\w$]+)\s*(?:\:\s*([\w$]+))?\s*\}\})/g,
				varname:	"it",
				strip:		true,
				append:		true,
				selfcontained: false,
				doNotSkipEncoded: false
			},
			template: undefined, //fn, compile template
			compile:  undefined  //fn, for express
		}, _globals;
	
		doT.encodeHTMLSource = function(doNotSkipEncoded) {
			var encodeHTMLRules = { "&": "&#38;", "<": "&#60;", ">": "&#62;", '"': "&#34;", "'": "&#39;", "/": "&#47;" },
				matchHTML = doNotSkipEncoded ? /[&<>"'\/]/g : /&(?!#?\w+;)|<|>|"|'|\//g;
			return function(code) {
				return code ? code.toString().replace(matchHTML, function(m) {return encodeHTMLRules[m] || m;}) : "";
			};
		};
	
		_globals = (function(){ return this || (0,eval)("this"); }());
	
		if (typeof module !== "undefined" && module.exports) {
			module.exports = doT;
		} else if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return doT;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			_globals.doT = doT;
		}
	
		var startend = {
			append: { start: "'+(",      end: ")+'",      startencode: "'+encodeHTML(" },
			split:  { start: "';out+=(", end: ");out+='", startencode: "';out+=encodeHTML(" }
		}, skip = /$^/;
	
		function resolveDefs(c, block, def) {
			return ((typeof block === "string") ? block : block.toString())
			.replace(c.define || skip, function(m, code, assign, value) {
				if (code.indexOf("def.") === 0) {
					code = code.substring(4);
				}
				if (!(code in def)) {
					if (assign === ":") {
						if (c.defineParams) value.replace(c.defineParams, function(m, param, v) {
							def[code] = {arg: param, text: v};
						});
						if (!(code in def)) def[code]= value;
					} else {
						new Function("def", "def['"+code+"']=" + value)(def);
					}
				}
				return "";
			})
			.replace(c.use || skip, function(m, code) {
				if (c.useParams) code = code.replace(c.useParams, function(m, s, d, param) {
					if (def[d] && def[d].arg && param) {
						var rw = (d+":"+param).replace(/'|\\/g, "_");
						def.__exp = def.__exp || {};
						def.__exp[rw] = def[d].text.replace(new RegExp("(^|[^\\w$])" + def[d].arg + "([^\\w$])", "g"), "$1" + param + "$2");
						return s + "def.__exp['"+rw+"']";
					}
				});
				var v = new Function("def", "return " + code)(def);
				return v ? resolveDefs(c, v, def) : v;
			});
		}
	
		function unescape(code) {
			return code.replace(/\\('|\\)/g, "$1").replace(/[\r\t\n]/g, " ");
		}
	
		doT.template = function(tmpl, c, def) {
			c = c || doT.templateSettings;
			var cse = c.append ? startend.append : startend.split, needhtmlencode, sid = 0, indv,
				str  = (c.use || c.define) ? resolveDefs(c, tmpl, def || {}) : tmpl;
	
			str = ("var out='" + (c.strip ? str.replace(/(^|\r|\n)\t* +| +\t*(\r|\n|$)/g," ")
						.replace(/\r|\n|\t|\/\*[\s\S]*?\*\//g,""): str)
				.replace(/'|\\/g, "\\$&")
				.replace(c.interpolate || skip, function(m, code) {
					return cse.start + unescape(code) + cse.end;
				})
				.replace(c.encode || skip, function(m, code) {
					needhtmlencode = true;
					return cse.startencode + unescape(code) + cse.end;
				})
				.replace(c.conditional || skip, function(m, elsecase, code) {
					return elsecase ?
						(code ? "';}else if(" + unescape(code) + "){out+='" : "';}else{out+='") :
						(code ? "';if(" + unescape(code) + "){out+='" : "';}out+='");
				})
				.replace(c.iterate || skip, function(m, iterate, vname, iname) {
					if (!iterate) return "';} } out+='";
					sid+=1; indv=iname || "i"+sid; iterate=unescape(iterate);
					return "';var arr"+sid+"="+iterate+";if(arr"+sid+"){var "+vname+","+indv+"=-1,l"+sid+"=arr"+sid+".length-1;while("+indv+"<l"+sid+"){"
						+vname+"=arr"+sid+"["+indv+"+=1];out+='";
				})
				.replace(c.evaluate || skip, function(m, code) {
					return "';" + unescape(code) + "out+='";
				})
				+ "';return out;")
				.replace(/\n/g, "\\n").replace(/\t/g, '\\t').replace(/\r/g, "\\r")
				.replace(/(\s|;|\}|^|\{)out\+='';/g, '$1').replace(/\+''/g, "");
				//.replace(/(\s|;|\}|^|\{)out\+=''\+/g,'$1out+=');
	
			if (needhtmlencode) {
				if (!c.selfcontained && _globals && !_globals._encodeHTML) _globals._encodeHTML = doT.encodeHTMLSource(c.doNotSkipEncoded);
				str = "var encodeHTML = typeof _encodeHTML !== 'undefined' ? _encodeHTML : ("
					+ doT.encodeHTMLSource.toString() + "(" + (c.doNotSkipEncoded || '') + "));"
					+ str;
			}
			try {
				return new Function(c.varname, str);
			} catch (e) {
				if (typeof console !== "undefined") console.log("Could not create a template function: " + str);
				throw e;
			}
		};
	
		doT.compile = function(tmpl, def) {
			return doT.template(tmpl, null, def);
		};
	}());


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(304);
	
	/*! jQuery UI - v1.10.3 - 2013-08-11
	* http://jqueryui.com
	* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.slider.js
	* Copyright 2013 jQuery Foundation and other contributors Licensed MIT */
	
	(function(e,t){function i(t,i){var a,n,r,o=t.nodeName.toLowerCase();return"area"===o?(a=t.parentNode,n=a.name,t.href&&n&&"map"===a.nodeName.toLowerCase()?(r=e("img[usemap=#"+n+"]")[0],!!r&&s(r)):!1):(/input|select|textarea|button|object/.test(o)?!t.disabled:"a"===o?t.href||i:i)&&s(t)}function s(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return"hidden"===e.css(this,"visibility")}).length}var a=0,n=/^ui-id-\d+$/;e.ui=e.ui||{},e.extend(e.ui,{version:"1.10.3",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({focus:function(t){return function(i,s){return"number"==typeof i?this.each(function(){var t=this;setTimeout(function(){e(t).focus(),s&&s.call(t)},i)}):t.apply(this,arguments)}}(e.fn.focus),scrollParent:function(){var t;return t=e.ui.ie&&/(static|relative)/.test(this.css("position"))||/absolute/.test(this.css("position"))?this.parents().filter(function(){return/(relative|absolute|fixed)/.test(e.css(this,"position"))&&/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0):this.parents().filter(function(){return/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0),/fixed/.test(this.css("position"))||!t.length?e(document):t},zIndex:function(i){if(i!==t)return this.css("zIndex",i);if(this.length)for(var s,a,n=e(this[0]);n.length&&n[0]!==document;){if(s=n.css("position"),("absolute"===s||"relative"===s||"fixed"===s)&&(a=parseInt(n.css("zIndex"),10),!isNaN(a)&&0!==a))return a;n=n.parent()}return 0},uniqueId:function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++a)})},removeUniqueId:function(){return this.each(function(){n.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(i){return!!e.data(i,t)}}):function(t,i,s){return!!e.data(t,s[3])},focusable:function(t){return i(t,!isNaN(e.attr(t,"tabindex")))},tabbable:function(t){var s=e.attr(t,"tabindex"),a=isNaN(s);return(a||s>=0)&&i(t,!a)}}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(i,s){function a(t,i,s,a){return e.each(n,function(){i-=parseFloat(e.css(t,"padding"+this))||0,s&&(i-=parseFloat(e.css(t,"border"+this+"Width"))||0),a&&(i-=parseFloat(e.css(t,"margin"+this))||0)}),i}var n="Width"===s?["Left","Right"]:["Top","Bottom"],r=s.toLowerCase(),o={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+s]=function(i){return i===t?o["inner"+s].call(this):this.each(function(){e(this).css(r,a(this,i)+"px")})},e.fn["outer"+s]=function(t,i){return"number"!=typeof t?o["outer"+s].call(this,t):this.each(function(){e(this).css(r,a(this,t,!0,i)+"px")})}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(i){return arguments.length?t.call(this,e.camelCase(i)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),e.support.selectstart="onselectstart"in document.createElement("div"),e.fn.extend({disableSelection:function(){return this.bind((e.support.selectstart?"selectstart":"mousedown")+".ui-disableSelection",function(e){e.preventDefault()})},enableSelection:function(){return this.unbind(".ui-disableSelection")}}),e.extend(e.ui,{plugin:{add:function(t,i,s){var a,n=e.ui[t].prototype;for(a in s)n.plugins[a]=n.plugins[a]||[],n.plugins[a].push([i,s[a]])},call:function(e,t,i){var s,a=e.plugins[t];if(a&&e.element[0].parentNode&&11!==e.element[0].parentNode.nodeType)for(s=0;a.length>s;s++)e.options[a[s][0]]&&a[s][1].apply(e.element,i)}},hasScroll:function(t,i){if("hidden"===e(t).css("overflow"))return!1;var s=i&&"left"===i?"scrollLeft":"scrollTop",a=!1;return t[s]>0?!0:(t[s]=1,a=t[s]>0,t[s]=0,a)}})})(jQuery);(function(e,t){var i=0,s=Array.prototype.slice,n=e.cleanData;e.cleanData=function(t){for(var i,s=0;null!=(i=t[s]);s++)try{e(i).triggerHandler("remove")}catch(a){}n(t)},e.widget=function(i,s,n){var a,r,o,h,l={},u=i.split(".")[0];i=i.split(".")[1],a=u+"-"+i,n||(n=s,s=e.Widget),e.expr[":"][a.toLowerCase()]=function(t){return!!e.data(t,a)},e[u]=e[u]||{},r=e[u][i],o=e[u][i]=function(e,i){return this._createWidget?(arguments.length&&this._createWidget(e,i),t):new o(e,i)},e.extend(o,r,{version:n.version,_proto:e.extend({},n),_childConstructors:[]}),h=new s,h.options=e.widget.extend({},h.options),e.each(n,function(i,n){return e.isFunction(n)?(l[i]=function(){var e=function(){return s.prototype[i].apply(this,arguments)},t=function(e){return s.prototype[i].apply(this,e)};return function(){var i,s=this._super,a=this._superApply;return this._super=e,this._superApply=t,i=n.apply(this,arguments),this._super=s,this._superApply=a,i}}(),t):(l[i]=n,t)}),o.prototype=e.widget.extend(h,{widgetEventPrefix:r?h.widgetEventPrefix:i},l,{constructor:o,namespace:u,widgetName:i,widgetFullName:a}),r?(e.each(r._childConstructors,function(t,i){var s=i.prototype;e.widget(s.namespace+"."+s.widgetName,o,i._proto)}),delete r._childConstructors):s._childConstructors.push(o),e.widget.bridge(i,o)},e.widget.extend=function(i){for(var n,a,r=s.call(arguments,1),o=0,h=r.length;h>o;o++)for(n in r[o])a=r[o][n],r[o].hasOwnProperty(n)&&a!==t&&(i[n]=e.isPlainObject(a)?e.isPlainObject(i[n])?e.widget.extend({},i[n],a):e.widget.extend({},a):a);return i},e.widget.bridge=function(i,n){var a=n.prototype.widgetFullName||i;e.fn[i]=function(r){var o="string"==typeof r,h=s.call(arguments,1),l=this;return r=!o&&h.length?e.widget.extend.apply(null,[r].concat(h)):r,o?this.each(function(){var s,n=e.data(this,a);return n?e.isFunction(n[r])&&"_"!==r.charAt(0)?(s=n[r].apply(n,h),s!==n&&s!==t?(l=s&&s.jquery?l.pushStack(s.get()):s,!1):t):e.error("no such method '"+r+"' for "+i+" widget instance"):e.error("cannot call methods on "+i+" prior to initialization; "+"attempted to call method '"+r+"'")}):this.each(function(){var t=e.data(this,a);t?t.option(r||{})._init():e.data(this,a,new n(r,this))}),l}},e.Widget=function(){},e.Widget._childConstructors=[],e.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(t,s){s=e(s||this.defaultElement||this)[0],this.element=e(s),this.uuid=i++,this.eventNamespace="."+this.widgetName+this.uuid,this.options=e.widget.extend({},this.options,this._getCreateOptions(),t),this.bindings=e(),this.hoverable=e(),this.focusable=e(),s!==this&&(e.data(s,this.widgetFullName,this),this._on(!0,this.element,{remove:function(e){e.target===s&&this.destroy()}}),this.document=e(s.style?s.ownerDocument:s.document||s),this.window=e(this.document[0].defaultView||this.document[0].parentWindow)),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:e.noop,_getCreateEventData:e.noop,_create:e.noop,_init:e.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:e.noop,widget:function(){return this.element},option:function(i,s){var n,a,r,o=i;if(0===arguments.length)return e.widget.extend({},this.options);if("string"==typeof i)if(o={},n=i.split("."),i=n.shift(),n.length){for(a=o[i]=e.widget.extend({},this.options[i]),r=0;n.length-1>r;r++)a[n[r]]=a[n[r]]||{},a=a[n[r]];if(i=n.pop(),s===t)return a[i]===t?null:a[i];a[i]=s}else{if(s===t)return this.options[i]===t?null:this.options[i];o[i]=s}return this._setOptions(o),this},_setOptions:function(e){var t;for(t in e)this._setOption(t,e[t]);return this},_setOption:function(e,t){return this.options[e]=t,"disabled"===e&&(this.widget().toggleClass(this.widgetFullName+"-disabled ui-state-disabled",!!t).attr("aria-disabled",t),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")),this},enable:function(){return this._setOption("disabled",!1)},disable:function(){return this._setOption("disabled",!0)},_on:function(i,s,n){var a,r=this;"boolean"!=typeof i&&(n=s,s=i,i=!1),n?(s=a=e(s),this.bindings=this.bindings.add(s)):(n=s,s=this.element,a=this.widget()),e.each(n,function(n,o){function h(){return i||r.options.disabled!==!0&&!e(this).hasClass("ui-state-disabled")?("string"==typeof o?r[o]:o).apply(r,arguments):t}"string"!=typeof o&&(h.guid=o.guid=o.guid||h.guid||e.guid++);var l=n.match(/^(\w+)\s*(.*)$/),u=l[1]+r.eventNamespace,c=l[2];c?a.delegate(c,u,h):s.bind(u,h)})},_off:function(e,t){t=(t||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.unbind(t).undelegate(t)},_delay:function(e,t){function i(){return("string"==typeof e?s[e]:e).apply(s,arguments)}var s=this;return setTimeout(i,t||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){e(t.currentTarget).addClass("ui-state-hover")},mouseleave:function(t){e(t.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){e(t.currentTarget).addClass("ui-state-focus")},focusout:function(t){e(t.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(t,i,s){var n,a,r=this.options[t];if(s=s||{},i=e.Event(i),i.type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),i.target=this.element[0],a=i.originalEvent)for(n in a)n in i||(i[n]=a[n]);return this.element.trigger(i,s),!(e.isFunction(r)&&r.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},e.each({show:"fadeIn",hide:"fadeOut"},function(t,i){e.Widget.prototype["_"+t]=function(s,n,a){"string"==typeof n&&(n={effect:n});var r,o=n?n===!0||"number"==typeof n?i:n.effect||i:t;n=n||{},"number"==typeof n&&(n={duration:n}),r=!e.isEmptyObject(n),n.complete=a,n.delay&&s.delay(n.delay),r&&e.effects&&e.effects.effect[o]?s[t](n):o!==t&&s[o]?s[o](n.duration,n.easing,a):s.queue(function(i){e(this)[t](),a&&a.call(s[0]),i()})}})})(jQuery);(function(e){var t=!1;e(document).mouseup(function(){t=!1}),e.widget("ui.mouse",{version:"1.10.3",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var t=this;this.element.bind("mousedown."+this.widgetName,function(e){return t._mouseDown(e)}).bind("click."+this.widgetName,function(i){return!0===e.data(i.target,t.widgetName+".preventClickEvent")?(e.removeData(i.target,t.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):undefined}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(i){if(!t){this._mouseStarted&&this._mouseUp(i),this._mouseDownEvent=i;var s=this,n=1===i.which,a="string"==typeof this.options.cancel&&i.target.nodeName?e(i.target).closest(this.options.cancel).length:!1;return n&&!a&&this._mouseCapture(i)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){s.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(i)&&this._mouseDelayMet(i)&&(this._mouseStarted=this._mouseStart(i)!==!1,!this._mouseStarted)?(i.preventDefault(),!0):(!0===e.data(i.target,this.widgetName+".preventClickEvent")&&e.removeData(i.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(e){return s._mouseMove(e)},this._mouseUpDelegate=function(e){return s._mouseUp(e)},e(document).bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),i.preventDefault(),t=!0,!0)):!0}},_mouseMove:function(t){return e.ui.ie&&(!document.documentMode||9>document.documentMode)&&!t.button?this._mouseUp(t):this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,t)!==!1,this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){return e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&e.data(t.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(t)),!1},_mouseDistanceMet:function(e){return Math.max(Math.abs(this._mouseDownEvent.pageX-e.pageX),Math.abs(this._mouseDownEvent.pageY-e.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}})})(jQuery);(function(t){var e=5;t.widget("ui.slider",t.ui.mouse,{version:"1.10.3",widgetEventPrefix:"slide",options:{animate:!1,distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this.element.addClass("ui-slider ui-slider-"+this.orientation+" ui-widget"+" ui-widget-content"+" ui-corner-all"),this._refresh(),this._setOption("disabled",this.options.disabled),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var e,i,s=this.options,n=this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),a="<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",o=[];for(i=s.values&&s.values.length||1,n.length>i&&(n.slice(i).remove(),n=n.slice(0,i)),e=n.length;i>e;e++)o.push(a);this.handles=n.add(t(o.join("")).appendTo(this.element)),this.handle=this.handles.eq(0),this.handles.each(function(e){t(this).data("ui-slider-handle-index",e)})},_createRange:function(){var e=this.options,i="";e.range?(e.range===!0&&(e.values?e.values.length&&2!==e.values.length?e.values=[e.values[0],e.values[0]]:t.isArray(e.values)&&(e.values=e.values.slice(0)):e.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?this.range.removeClass("ui-slider-range-min ui-slider-range-max").css({left:"",bottom:""}):(this.range=t("<div></div>").appendTo(this.element),i="ui-slider-range ui-widget-header ui-corner-all"),this.range.addClass(i+("min"===e.range||"max"===e.range?" ui-slider-range-"+e.range:""))):this.range=t([])},_setupEvents:function(){var t=this.handles.add(this.range).filter("a");this._off(t),this._on(t,this._handleEvents),this._hoverable(t),this._focusable(t)},_destroy:function(){this.handles.remove(),this.range.remove(),this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all"),this._mouseDestroy()},_mouseCapture:function(e){var i,s,n,a,o,r,h,l,u=this,c=this.options;return c.disabled?!1:(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:e.pageX,y:e.pageY},s=this._normValueFromMouse(i),n=this._valueMax()-this._valueMin()+1,this.handles.each(function(e){var i=Math.abs(s-u.values(e));(n>i||n===i&&(e===u._lastChangedValue||u.values(e)===c.min))&&(n=i,a=t(this),o=e)}),r=this._start(e,o),r===!1?!1:(this._mouseSliding=!0,this._handleIndex=o,a.addClass("ui-state-active").focus(),h=a.offset(),l=!t(e.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=l?{left:0,top:0}:{left:e.pageX-h.left-a.width()/2,top:e.pageY-h.top-a.height()/2-(parseInt(a.css("borderTopWidth"),10)||0)-(parseInt(a.css("borderBottomWidth"),10)||0)+(parseInt(a.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(e,o,s),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,i),!1},_mouseStop:function(t){return this.handles.removeClass("ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,i,s,n,a;return"horizontal"===this.orientation?(e=this.elementSize.width,i=t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,i=t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),s=i/e,s>1&&(s=1),0>s&&(s=0),"vertical"===this.orientation&&(s=1-s),n=this._valueMax()-this._valueMin(),a=this._valueMin()+s*n,this._trimAlignValue(a)},_start:function(t,e){var i={handle:this.handles[e],value:this.value()};return this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("start",t,i)},_slide:function(t,e,i){var s,n,a;this.options.values&&this.options.values.length?(s=this.values(e?0:1),2===this.options.values.length&&this.options.range===!0&&(0===e&&i>s||1===e&&s>i)&&(i=s),i!==this.values(e)&&(n=this.values(),n[e]=i,a=this._trigger("slide",t,{handle:this.handles[e],value:i,values:n}),s=this.values(e?0:1),a!==!1&&this.values(e,i,!0))):i!==this.value()&&(a=this._trigger("slide",t,{handle:this.handles[e],value:i}),a!==!1&&this.value(i))},_stop:function(t,e){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("stop",t,i)},_change:function(t,e){if(!this._keySliding&&!this._mouseSliding){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._lastChangedValue=e,this._trigger("change",t,i)}},value:function(t){return arguments.length?(this.options.value=this._trimAlignValue(t),this._refreshValue(),this._change(null,0),undefined):this._value()},values:function(e,i){var s,n,a;if(arguments.length>1)return this.options.values[e]=this._trimAlignValue(i),this._refreshValue(),this._change(null,e),undefined;if(!arguments.length)return this._values();if(!t.isArray(arguments[0]))return this.options.values&&this.options.values.length?this._values(e):this.value();for(s=this.options.values,n=arguments[0],a=0;s.length>a;a+=1)s[a]=this._trimAlignValue(n[a]),this._change(null,a);this._refreshValue()},_setOption:function(e,i){var s,n=0;switch("range"===e&&this.options.range===!0&&("min"===i?(this.options.value=this._values(0),this.options.values=null):"max"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),t.isArray(this.options.values)&&(n=this.options.values.length),t.Widget.prototype._setOption.apply(this,arguments),e){case"orientation":this._detectOrientation(),this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-"+this.orientation),this._refreshValue();break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),s=0;n>s;s+=1)this._change(null,s);this._animateOff=!1;break;case"min":case"max":this._animateOff=!0,this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_value:function(){var t=this.options.value;return t=this._trimAlignValue(t)},_values:function(t){var e,i,s;if(arguments.length)return e=this.options.values[t],e=this._trimAlignValue(e);if(this.options.values&&this.options.values.length){for(i=this.options.values.slice(),s=0;i.length>s;s+=1)i[s]=this._trimAlignValue(i[s]);return i}return[]},_trimAlignValue:function(t){if(this._valueMin()>=t)return this._valueMin();if(t>=this._valueMax())return this._valueMax();var e=this.options.step>0?this.options.step:1,i=(t-this._valueMin())%e,s=t-i;return 2*Math.abs(i)>=e&&(s+=i>0?e:-e),parseFloat(s.toFixed(5))},_valueMin:function(){return this.options.min},_valueMax:function(){return this.options.max},_refreshValue:function(){var e,i,s,n,a,o=this.options.range,r=this.options,h=this,l=this._animateOff?!1:r.animate,u={};this.options.values&&this.options.values.length?this.handles.each(function(s){i=100*((h.values(s)-h._valueMin())/(h._valueMax()-h._valueMin())),u["horizontal"===h.orientation?"left":"bottom"]=i+"%",t(this).stop(1,1)[l?"animate":"css"](u,r.animate),h.options.range===!0&&("horizontal"===h.orientation?(0===s&&h.range.stop(1,1)[l?"animate":"css"]({left:i+"%"},r.animate),1===s&&h.range[l?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:r.animate})):(0===s&&h.range.stop(1,1)[l?"animate":"css"]({bottom:i+"%"},r.animate),1===s&&h.range[l?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:r.animate}))),e=i}):(s=this.value(),n=this._valueMin(),a=this._valueMax(),i=a!==n?100*((s-n)/(a-n)):0,u["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[l?"animate":"css"](u,r.animate),"min"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:i+"%"},r.animate),"max"===o&&"horizontal"===this.orientation&&this.range[l?"animate":"css"]({width:100-i+"%"},{queue:!1,duration:r.animate}),"min"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:i+"%"},r.animate),"max"===o&&"vertical"===this.orientation&&this.range[l?"animate":"css"]({height:100-i+"%"},{queue:!1,duration:r.animate}))},_handleEvents:{keydown:function(i){var s,n,a,o,r=t(i.target).data("ui-slider-handle-index");switch(i.keyCode){case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(i.preventDefault(),!this._keySliding&&(this._keySliding=!0,t(i.target).addClass("ui-state-active"),s=this._start(i,r),s===!1))return}switch(o=this.options.step,n=a=this.options.values&&this.options.values.length?this.values(r):this.value(),i.keyCode){case t.ui.keyCode.HOME:a=this._valueMin();break;case t.ui.keyCode.END:a=this._valueMax();break;case t.ui.keyCode.PAGE_UP:a=this._trimAlignValue(n+(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.PAGE_DOWN:a=this._trimAlignValue(n-(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:if(n===this._valueMax())return;a=this._trimAlignValue(n+o);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(n===this._valueMin())return;a=this._trimAlignValue(n-o)}this._slide(i,r,a)},click:function(t){t.preventDefault()},keyup:function(e){var i=t(e.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(e,i),this._change(e,i),t(e.target).removeClass("ui-state-active"))}}})})(jQuery);


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(304);
	
	/* ===========================================================
	 * bootstrap-tooltip.js v2.3.0
	 * http://twitter.github.com/bootstrap/javascript.html#tooltips
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ===========================================================
	 * Copyright 2012 Twitter, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 * ========================================================== */
	
	
	!function ($) {
	
	  "use strict"; // jshint ;_;
	
	
	 /* TOOLTIP PUBLIC CLASS DEFINITION
	  * =============================== */
	
	  var Tooltip = function (element, options) {
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.prototype = {
	
	    constructor: Tooltip
	
	  , init: function (type, element, options) {
	      var eventIn
	        , eventOut
	        , triggers
	        , trigger
	        , i
	
	      this.type = type
	      this.$element = $(element)
	      this.options = this.getOptions(options)
	      this.enabled = true
	
	      triggers = this.options.trigger.split(' ')
	
	      for (i = triggers.length; i--;) {
	        trigger = triggers[i]
	        if (trigger == 'click') {
	          this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	        } else if (trigger != 'manual') {
	          eventIn = trigger == 'hover' ? 'mouseenter' : 'focus'
	          eventOut = trigger == 'hover' ? 'mouseleave' : 'blur'
	          this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	          this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	        }
	      }
	
	      this.options.selector ?
	        (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	        this.fixTitle()
	    }
	
	  , getOptions: function (options) {
	      options = $.extend({}, $.fn[this.type].defaults, this.$element.data(), options)
	
	      if (options.delay && typeof options.delay == 'number') {
	        options.delay = {
	          show: options.delay
	        , hide: options.delay
	        }
	      }
	
	      return options
	    }
	
	  , enter: function (e) {
	      var self = $(e.currentTarget)[this.type](this._options).data(this.type)
	
	      if (!self.options.delay || !self.options.delay.show) return self.show()
	
	      clearTimeout(this.timeout)
	      self.hoverState = 'in'
	      this.timeout = setTimeout(function() {
	        if (self.hoverState == 'in') self.show()
	      }, self.options.delay.show)
	    }
	
	  , leave: function (e) {
	      var self = $(e.currentTarget)[this.type](this._options).data(this.type)
	
	      if (this.timeout) clearTimeout(this.timeout)
	      if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	      self.hoverState = 'out'
	      this.timeout = setTimeout(function() {
	        if (self.hoverState == 'out') self.hide()
	      }, self.options.delay.hide)
	    }
	
	  , show: function () {
	      var $tip
	        , pos
	        , actualWidth
	        , actualHeight
	        , placement
	        , tp
	        , e = $.Event('show')
	
	      if (this.hasContent() && this.enabled) {
	        this.$element.trigger(e)
	        if (e.isDefaultPrevented()) return
	        $tip = this.tip()
	        this.setContent()
	
	        if (this.options.animation) {
	          $tip.addClass('fade')
	        }
	
	        placement = typeof this.options.placement == 'function' ?
	          this.options.placement.call(this, $tip[0], this.$element[0]) :
	          this.options.placement
	
	        $tip
	          .detach()
	          .css({ top: 0, left: 0, display: 'block' })
	
	        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	
	        pos = this.getPosition()
	
	        actualWidth = $tip[0].offsetWidth
	        actualHeight = $tip[0].offsetHeight
	
	        switch (placement) {
	          case 'bottom':
	            tp = {top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2}
	            break
	          case 'top':
	            tp = {top: pos.top - actualHeight, left:pos.left-5}
	            break
	          // case 'top':
	          //   tp = {top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2}
	          //   break
	          case 'left':
	            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth}
	            break
	          case 'right':
	            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width}
	            break
	        }
	
	        this.applyPlacement(tp, placement)
	        this.$element.trigger('shown')
	      }
	    }
	
	  , applyPlacement: function(offset, placement){
	      var $tip = this.tip()
	        , width = $tip[0].offsetWidth
	        , height = $tip[0].offsetHeight
	        , actualWidth
	        , actualHeight
	        , delta
	        , replace
	
	      $tip
	        .offset(offset)
	        .addClass(placement)
	        .addClass('in')
	
	      actualWidth = $tip[0].offsetWidth
	      actualHeight = $tip[0].offsetHeight
	
	      if (placement == 'top' && actualHeight != height) {
	        offset.top = offset.top + height - actualHeight
	        replace = true
	      }
	
	      if (placement == 'bottom' || placement == 'top') {
	        delta = 0
	
	        if (offset.left < 0){
	          delta = offset.left * -2
	          offset.left = 0
	          $tip.offset(offset)
	          actualWidth = $tip[0].offsetWidth
	          actualHeight = $tip[0].offsetHeight
	        }
	
	        this.replaceArrow(delta - width + actualWidth, actualWidth, 'left')
	      } else {
	        this.replaceArrow(actualHeight - height, actualHeight, 'top')
	      }
	
	      if (replace) $tip.offset(offset)
	    }
	
	  , replaceArrow: function(delta, dimension, position){
	      this
	        .arrow()
	        .css(position, delta ? (50 * (1 - delta / dimension) + "%") : '')
	    }
	
	  , setContent: function () {
	      var $tip = this.tip()
	        , title = this.getTitle()
	
	      $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	      $tip.removeClass('fade in top bottom left right')
	    }
	
	  , hide: function () {
	      var that = this
	        , $tip = this.tip()
	        , e = $.Event('hide')
	
	      this.$element.trigger(e)
	      if (e.isDefaultPrevented()) return
	
	      $tip.removeClass('in')
	
	      function removeWithAnimation() {
	        var timeout = setTimeout(function () {
	          $tip.off($.support.transition.end).detach()
	        }, 500)
	
	        $tip.one($.support.transition.end, function () {
	          clearTimeout(timeout)
	          $tip.detach()
	        })
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        removeWithAnimation() :
	        $tip.detach()
	
	      this.$element.trigger('hidden')
	
	      return this
	    }
	
	  , fixTitle: function () {
	      var $e = this.$element
	      if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
	        $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	      }
	    }
	
	  , hasContent: function () {
	      return this.getTitle()
	    }
	
	  , getPosition: function () {
	      var el = this.$element[0]
	      return $.extend({}, (typeof el.getBoundingClientRect == 'function') ? el.getBoundingClientRect() : {
	        width: el.offsetWidth
	      , height: el.offsetHeight
	      }, this.$element.offset())
	    }
	
	  , getTitle: function () {
	      var title
	        , $e = this.$element
	        , o = this.options
	
	      title = $e.attr('data-original-title')
	        || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	      return title
	    }
	
	  , tip: function () {
	      return this.$tip = this.$tip || $(this.options.template)
	    }
	
	  , arrow: function(){
	      return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
	    }
	
	  , validate: function () {
	      if (!this.$element[0].parentNode) {
	        this.hide()
	        this.$element = null
	        this.options = null
	      }
	    }
	
	  , enable: function () {
	      this.enabled = true
	    }
	
	  , disable: function () {
	      this.enabled = false
	    }
	
	  , toggleEnabled: function () {
	      this.enabled = !this.enabled
	    }
	
	  , toggle: function (e) {
	      var self = e ? $(e.currentTarget)[this.type](this._options).data(this.type) : this
	      self.tip().hasClass('in') ? self.hide() : self.show()
	    }
	
	  , destroy: function () {
	      this.hide().$element.off('.' + this.type).removeData(this.type)
	    }
	
	  }
	
	
	 /* TOOLTIP PLUGIN DEFINITION
	  * ========================= */
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip = function ( option ) {
	    return this.each(function () {
	      var $this = $(this)
	        , data = $this.data('tooltip')
	        , options = typeof option == 'object' && option
	      if (!data) $this.data('tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  $.fn.tooltip.Constructor = Tooltip
	
	  $.fn.tooltip.defaults = {
	    animation: true
	  , placement: 'top'
	  , selector: false
	  , template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
	  , trigger: 'hover focus'
	  , title: ''
	  , delay: 0
	  , html: false
	  , container: false
	  }
	
	
	 /* TOOLTIP NO CONFLICT
	  * =================== */
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(window.jQuery);
	


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(304);
	
	/**
	 * DropKick
	 *
	 * Highly customizable <select> lists
	 * https://github.com/JamieLottering/DropKick
	 *
	 * &copy; 2011 Jamie Lottering <http://github.com/JamieLottering>
	 *                        <http://twitter.com/JamieLottering>
	 * 
	 */
	(function ($, window, document) {
	
	  document.documentElement.className = document.documentElement.className + ' dk_fouc';
	  
	  var
	    // Public methods exposed to $.fn.dropkick()
	    methods = {},
	
	    // Cache every <select> element that gets dropkicked
	    lists   = [],
	
	    // Convenience keys for keyboard navigation
	    keyMap = {
	      'left'  : 37,
	      'up'    : 38,
	      'right' : 39,
	      'down'  : 40,
	      'enter' : 13
	    },
	
	    // HTML template for the dropdowns
	    dropdownTemplate = [
	      '<div class="dk_container {{ classname }}" id="dk_container_{{ id }}" tabindex="{{ tabindex }}">',
	        '<a class="dk_toggle">',
	          '<span class="dk_label">{{ label }}</span>',
	          '<span class="select-icon"></span>',
	        '</a>',
	        '<div class="dk_options">',
	          '<ul class="dk_options_inner">',
	          '</ul>',
	        '</div>',
	      '</div>'
	    ].join(''),
	
	    // HTML template for dropdown options
	    optionTemplate = '<li class="{{ current }}"><a data-dk-dropdown-value="{{ value }}">{{ text }}</a></li>',
	
	    // Some nice default values
	    defaults = {
	      startSpeed : 100,  // I recommend a high value here, I feel it makes the changes less noticeable to the user
	      theme  : false,
	      change : false
	    },
	
	    // Make sure we only bind keydown on the document once
	    keysBound = false
	  ;
	
	  // Called by using $('foo').dropkick();
	  methods.init = function (settings) {
	    settings = $.extend({}, defaults, settings);
	
	    return this.each(function () {
	      var
	        // The current <select> element
	        $select = $(this),
	
	        // Store a reference to the originally selected <option> element
	        $original = $select.find(':selected').first(),
	
	        // Save all of the <option> elements
	        $options = $select.find('option'),
	
	        // We store lots of great stuff using jQuery data
	        data = $select.data('dropkick') || {},
	
	        // This gets applied to the 'dk_container' element
	        id = $select.attr('id') || $select.attr('name'),
	
	        // This gets updated to be equal to the longest <option> element
	        width  = settings.width || $select.outerWidth(),
	
	        // Check if we have a tabindex set or not
	        tabindex  = $select.attr('tabindex') ? $select.attr('tabindex') : '',
	
	        // Check if we have a class name set or not
	        classname  = $select.attr('class') ? $select.attr('class') : '',
	
	        // The completed dk_container element
	        $dk = false,
	
	        theme
	      ;
	
	      // Dont do anything if we've already setup dropkick on this element
	      if (data.id) {
	        return $select;
	      } else {
	        data.settings  = settings;
	        data.tabindex  = tabindex;
	        data.classname = classname;
	        data.id        = id;
	        data.$original = $original;
	        data.$select   = $select;
	        data.value     = _notBlank($select.val()) || _notBlank($original.attr('value'));
	        data.label     = $original.text();
	        data.options   = $options;
	      }
	
	      // Build the dropdown HTML
	      $dk = _build(dropdownTemplate, data);
	
	      // Make the dropdown fixed width if desired
	      $dk.find('.dk_toggle').css({
	        // Disable inline width since it should fill all available parrent space
	        // 'width' : width + 'px'
	      });
	
	      // Hide the <select> list and place our new one in front of it
	      $select.before($dk);
	
	      // Update the reference to $dk
	      $dk = $('#dk_container_' + id).addClass('dk_shown');
	
	      // Save the current theme
	      theme = settings.theme ? settings.theme : 'default';
	      $dk.addClass('dk_theme_' + theme);
	      data.theme = theme;
	
	      // Save the updated $dk reference into our data object
	      data.$dk = $dk;
	
	      // Save the dropkick data onto the <select> element
	      $select.data('dropkick', data);
	
	      // Do the same for the dropdown, but add a few helpers
	      $dk.data('dropkick', data);
	
	      lists[lists.length] = $select;
	
	      // Focus events
	      $dk.bind('focus.dropkick', function (e) {
	        $dk.addClass('dk_focus');
	      }).bind('blur.dropkick', function (e) {
	        $dk.removeClass('dk_open dk_focus');
	      });
	
	      setTimeout(function () {
	        $select.hide();
	      }, 0);
	    });
	  };
	
	  // Allows dynamic theme changes
	  methods.theme = function (newTheme) {
	    var
	      $select   = $(this),
	      list      = $select.data('dropkick'),
	      $dk       = list.$dk,
	      oldtheme  = 'dk_theme_' + list.theme
	    ;
	
	    $dk.removeClass(oldtheme).addClass('dk_theme_' + newTheme);
	
	    list.theme = newTheme;
	  };
	
	  // Reset all <selects and dropdowns in our lists array
	  methods.reset = function () {
	    for (var i = 0, l = lists.length; i < l; i++) {
	      var
	        listData  = lists[i].data('dropkick'),
	        $dk       = listData.$dk,
	        $current  = $dk.find('li').first()
	      ;
	
	      $dk.find('.dk_label').text(listData.label);
	      $dk.find('.dk_options_inner').animate({ scrollTop: 0 }, 0);
	
	      _setCurrent($current, $dk);
	      _updateFields($current, $dk, true);
	    }
	  };
	
	  // Expose the plugin
	  $.fn.dropkick = function (method) {
	    if (methods[method]) {
	      return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
	    } else if (typeof method === 'object' || ! method) {
	      return methods.init.apply(this, arguments);
	    }
	  };
	
	  // private
	  function _handleKeyBoardNav(e, $dk) {
	    var
	      code     = e.keyCode,
	      data     = $dk.data('dropkick'),
	      options  = $dk.find('.dk_options'),
	      open     = $dk.hasClass('dk_open'),
	      current  = $dk.find('.dk_option_current'),
	      first    = options.find('li').first(),
	      last     = options.find('li').last(),
	      next,
	      prev
	    ;
	
	    switch (code) {
	      case keyMap.enter:
	        if (open) {
	          _updateFields(current.find('a'), $dk);
	          _closeDropdown($dk);
	        } else {
	          _openDropdown($dk);
	        }
	        e.preventDefault();
	      break;
	
	      case keyMap.up:
	        prev = current.prev('li');
	        if (open) {
	          if (prev.length) {
	            _setCurrent(prev, $dk);
	          } else {
	            _setCurrent(last, $dk);
	          }
	        } else {
	          _openDropdown($dk);
	        }
	        e.preventDefault();
	      break;
	
	      case keyMap.down:
	        if (open) {
	          next = current.next('li').first();
	          if (next.length) {
	            _setCurrent(next, $dk);
	          } else {
	            _setCurrent(first, $dk);
	          }
	        } else {
	          _openDropdown($dk);
	        }
	        e.preventDefault();
	      break;
	
	      default:
	      break;
	    }
	  }
	
	  // Update the <select> value, and the dropdown label
	  function _updateFields(option, $dk, reset) {
	    var value, label, data;
	
	    value = option.attr('data-dk-dropdown-value');
	    label = option.text();
	    data  = $dk.data('dropkick');
	
	    $select = data.$select;
	    $select.val(value);
	
	    $dk.find('.dk_label').text(label);
	
	    reset = reset || false;
	
	    if (data.settings.change && !reset) {
	      data.settings.change.call($select, value, label);
	    }
	  }
	
	  // Set the currently selected option
	  function _setCurrent($current, $dk) {
	    $dk.find('.dk_option_current').removeClass('dk_option_current');
	    $current.addClass('dk_option_current');
	
	    _setScrollPos($dk, $current);
	  }
	
	  function _setScrollPos($dk, anchor) {
	    var height = anchor.prevAll('li').outerHeight() * anchor.prevAll('li').length;
	    $dk.find('.dk_options_inner').animate({ scrollTop: height + 'px' }, 0);
	  }
	
	  // Close a dropdown
	  function _closeDropdown($dk) {
	    $dk.removeClass('dk_open');
	  }
	
	  // Open a dropdown
	  function _openDropdown($dk) {
	    var data = $dk.data('dropkick');
	    $dk.find('.dk_options').css({ top : $dk.find('.dk_toggle').outerHeight() - 1 });
	    $dk.toggleClass('dk_open');
	
	  }
	
	  /**
	   * Turn the dropdownTemplate into a jQuery object and fill in the variables.
	   */
	  function _build (tpl, view) {
	    var
	      // Template for the dropdown
	      template  = tpl,
	      // Holder of the dropdowns options
	      options   = [],
	      $dk
	    ;
	
	    template = template.replace('{{ id }}', view.id);
	    template = template.replace('{{ label }}', view.label);
	    template = template.replace('{{ tabindex }}', view.tabindex);
	    template = template.replace('{{ classname }}', view.classname);
	
	    if (view.options && view.options.length) {
	      for (var i = 0, l = view.options.length; i < l; i++) {
	        var
	          $option   = $(view.options[i]),
	          current   = 'dk_option_current',
	          oTemplate = optionTemplate
	        ;
	
	        oTemplate = oTemplate.replace('{{ value }}', $option.val());
	        oTemplate = oTemplate.replace('{{ current }}', (_notBlank($option.val()) === view.value) ? current : '');
	        oTemplate = oTemplate.replace('{{ text }}', $option.text());
	
	        options[options.length] = oTemplate;
	      }
	    }
	
	    $dk = $(template);
	    $dk.find('.dk_options_inner').html(options.join(''));
	
	    return $dk;
	  }
	
	  function _notBlank(text) {
	    return ($.trim(text).length > 0) ? text : false;
	  }
	
	  $(function () {
	
	    // Handle click events on the dropdown toggler
	    $(document).on('click', '.dk_toggle', function (e) {
	      var $dk  = $(this).parents('.dk_container').first();
	
	      _openDropdown($dk);
	
	      if ("ontouchstart" in window) {
	        $dk.addClass('dk_touch');
	        $dk.find('.dk_options_inner').addClass('scrollable vertical');
	      }
	
	      e.preventDefault();
	      return false;
	    });
	
	    // Handle click events on individual dropdown options
	    $(document).on('click', '.dk_options a', function (e) {
	      var
	        $option = $(this),
	        $dk     = $option.parents('.dk_container').first(),
	        data    = $dk.data('dropkick')
	      ;
	    
	      _closeDropdown($dk);
	      _updateFields($option, $dk);
	      _setCurrent($option.parent(), $dk);
	    
	      e.preventDefault();
	      return false;
	    });
	
	    // Setup keyboard nav
	    $(document).bind('keydown.dk_nav', function (e) {
	      var
	        // Look for an open dropdown...
	        $open    = $('.dk_container.dk_open'),
	
	        // Look for a focused dropdown
	        $focused = $('.dk_container.dk_focus'),
	
	        // Will be either $open, $focused, or null
	        $dk = null
	      ;
	
	      // If we have an open dropdown, key events should get sent to that one
	      if ($open.length) {
	        $dk = $open;
	      } else if ($focused.length && !$open.length) {
	        // But if we have no open dropdowns, use the focused dropdown instead
	        $dk = $focused;
	      }
	
	      if ($dk) {
	        _handleKeyBoardNav(e, $dk);
	      }
	    });
	  });
	})(jQuery, window, document);
	


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var jQuery = __webpack_require__(304);
	
	/*
	
		jQuery Tags Input Plugin 1.3.3
		
		Copyright (c) 2011 XOXCO, Inc
		
		Documentation for this plugin lives here:
		http://xoxco.com/clickable/jquery-tags-input
		
		Licensed under the MIT license:
		http://www.opensource.org/licenses/mit-license.php
	
		ben@xoxco.com
	
	*/
	
	(function($) {
	
		var delimiter = new Array();
		var tags_callbacks = new Array();
		$.fn.doAutosize = function(o){
		    var minWidth = $(this).data('minwidth'),
		        maxWidth = $(this).data('maxwidth'),
		        val = '',
		        input = $(this),
		        testSubject = $('#'+$(this).data('tester_id'));
		
		    if (val === (val = input.val())) {return;}
		
		    // Enter new content into testSubject
		    var escaped = val.replace(/&/g, '&amp;').replace(/\s/g,' ').replace(/</g, '&lt;').replace(/>/g, '&gt;');
		    testSubject.html(escaped);
		    // Calculate new width + whether to change
		    var testerWidth = testSubject.width(),
		        newWidth = (testerWidth + o.comfortZone) >= minWidth ? testerWidth + o.comfortZone : minWidth,
		        currentWidth = input.width(),
		        isValidWidthChange = (newWidth < currentWidth && newWidth >= minWidth)
		                             || (newWidth > minWidth && newWidth < maxWidth);
		
		    // Animate width
		    if (isValidWidthChange) {
		        input.width(newWidth);
		    }
	
	
	  };
	  $.fn.resetAutosize = function(options){
	    // alert(JSON.stringify(options));
	    var minWidth =  $(this).data('minwidth') || options.minInputWidth || $(this).width(),
	        maxWidth = $(this).data('maxwidth') || options.maxInputWidth || ($(this).closest('.tagsinput').width() - options.inputPadding),
	        val = '',
	        input = $(this),
	        testSubject = $('<tester/>').css({
	            position: 'absolute',
	            top: -9999,
	            left: -9999,
	            width: 'auto',
	            fontSize: input.css('fontSize'),
	            fontFamily: input.css('fontFamily'),
	            fontWeight: input.css('fontWeight'),
	            letterSpacing: input.css('letterSpacing'),
	            whiteSpace: 'nowrap'
	        }),
	        testerId = $(this).attr('id')+'_autosize_tester';
	    if(! $('#'+testerId).length > 0){
	      testSubject.attr('id', testerId);
	      testSubject.appendTo('body');
	    }
	
	    input.data('minwidth', minWidth);
	    input.data('maxwidth', maxWidth);
	    input.data('tester_id', testerId);
	    input.css('width', minWidth);
	  };
	  
		$.fn.addTag = function(value,options) {
				options = jQuery.extend({focus:false,callback:true},options);
				this.each(function() { 
					var id = $(this).attr('id');
	
					var tagslist = $(this).val().split(delimiter[id]);
					if (tagslist[0] == '') { 
						tagslist = new Array();
					}
	
					value = jQuery.trim(value);
			
					if (options.unique) {
						var skipTag = $(this).tagExist(value);
						if(skipTag == true) {
						    //Marks fake input as not_valid to let styling it
	    				    $('#'+id+'_tag').addClass('not_valid');
	    				}
					} else {
						var skipTag = false; 
					}
					
					if (value !='' && skipTag != true) { 
	                    $('<span>').addClass('tag').append(
	                        $('<span>').text(value).append('&nbsp;&nbsp;'),
	                        $('<a class="tagsinput-remove-link fui-cross-16">', {
	                            href  : '#',
	                            title : 'Remove tag',
	                            text  : ''
	                        }).click(function () {
	                            return $('#' + id).removeTag(escape(value));
	                        })
	                    ).insertBefore('#' + id + '_addTag');
	
						tagslist.push(value);
					
						$('#'+id+'_tag').val('');
						if (options.focus) {
							$('#'+id+'_tag').focus();
						} else {		
							$('#'+id+'_tag').blur();
						}
						
						$.fn.tagsInput.updateTagsField(this,tagslist);
						
						if (options.callback && tags_callbacks[id] && tags_callbacks[id]['onAddTag']) {
							var f = tags_callbacks[id]['onAddTag'];
							f.call(this, value);
						}
						if(tags_callbacks[id] && tags_callbacks[id]['onChange'])
						{
							var i = tagslist.length;
							var f = tags_callbacks[id]['onChange'];
							f.call(this, $(this), tagslist[i-1]);
						}					
					}
			
				});		
				
				return false;
			};
			
		$.fn.removeTag = function(value) { 
				value = unescape(value);
				this.each(function() { 
					var id = $(this).attr('id');
		
					var old = $(this).val().split(delimiter[id]);
						
					$('#'+id+'_tagsinput .tag').remove();
					str = '';
					for (i=0; i< old.length; i++) { 
						if (old[i]!=value) { 
							str = str + delimiter[id] +old[i];
						}
					}
					
					$.fn.tagsInput.importTags(this,str);
	
					if (tags_callbacks[id] && tags_callbacks[id]['onRemoveTag']) {
						var f = tags_callbacks[id]['onRemoveTag'];
						f.call(this, value);
					}
				});
						
				return false;
			};
		
		$.fn.tagExist = function(val) {
			var id = $(this).attr('id');
			var tagslist = $(this).val().split(delimiter[id]);
			return (jQuery.inArray(val, tagslist) >= 0); //true when tag exists, false when not
		};
		
		// clear all existing tags and import new ones from a string
		$.fn.importTags = function(str) {
	                id = $(this).attr('id');
			$('#'+id+'_tagsinput .tag').remove();
			$.fn.tagsInput.importTags(this,str);
		}
			
		$.fn.tagsInput = function(options) { 
	    var settings = jQuery.extend({
	      interactive:true,
	      defaultText:'',
	      minChars:0,
	      width:'',
	      height:'',
	      autocomplete: {selectFirst: false },
	      'hide':true,
	      'delimiter':',',
	      'unique':true,
	      removeWithBackspace:true,
	      placeholderColor:'#666666',
	      autosize: true,
	      comfortZone: 20,
	      inputPadding: 6*2
	    },options);
	
			this.each(function() { 
				if (settings.hide) { 
					$(this).hide();				
				}
				var id = $(this).attr('id');
				if (!id || delimiter[$(this).attr('id')]) {
					id = $(this).attr('id', 'tags' + new Date().getTime()).attr('id');
				}
				
				var data = jQuery.extend({
					pid:id,
					real_input: '#'+id,
					holder: '#'+id+'_tagsinput',
					input_wrapper: '#'+id+'_addTag',
					fake_input: '#'+id+'_tag'
				},settings);
		
				delimiter[id] = data.delimiter;
				
				if (settings.onAddTag || settings.onRemoveTag || settings.onChange) {
					tags_callbacks[id] = new Array();
					tags_callbacks[id]['onAddTag'] = settings.onAddTag;
					tags_callbacks[id]['onRemoveTag'] = settings.onRemoveTag;
					tags_callbacks[id]['onChange'] = settings.onChange;
				}
		
				var markup = '<div id="'+id+'_tagsinput" class="tagsinput"><div class="tagsinput-add-container" id="'+id+'_addTag"><div class="tagsinput-add fui-plus-16"></div>';
				
				if (settings.interactive) {
					markup = markup + '<input id="'+id+'_tag" value="" data-default="'+settings.defaultText+'" />';
				}
				
				markup = markup + '</div></div>';
				
				$(markup).insertAfter(this);
	
				$(data.holder).css('width',settings.width);
				$(data.holder).css('min-height',settings.height);
				$(data.holder).css('height','100%');
		
				if ($(data.real_input).val()!='') { 
					$.fn.tagsInput.importTags($(data.real_input),$(data.real_input).val());
				}		
				if (settings.interactive) { 
					$(data.fake_input).val($(data.fake_input).attr('data-default'));
					$(data.fake_input).css('color',settings.placeholderColor);
			        $(data.fake_input).resetAutosize(settings);
			
					$(data.holder).bind('click',data,function(event) {
						$(event.data.fake_input).focus();
					});
				
					$(data.fake_input).bind('focus',data,function(event) {
						if ($(event.data.fake_input).val()==$(event.data.fake_input).attr('data-default')) { 
							$(event.data.fake_input).val('');
						}
						$(event.data.fake_input).css('color','#000000');		
					});
							
					if (settings.autocomplete_url != undefined) {
						autocomplete_options = {source: settings.autocomplete_url};
						for (attrname in settings.autocomplete) { 
							autocomplete_options[attrname] = settings.autocomplete[attrname]; 
						}
					
						if (jQuery.Autocompleter !== undefined) {
							$(data.fake_input).autocomplete(settings.autocomplete_url, settings.autocomplete);
							$(data.fake_input).bind('result',data,function(event,data,formatted) {
								if (data) {
									$('#'+id).addTag(data[0] + "",{focus:true,unique:(settings.unique)});
								}
						  	});
						} else if (jQuery.ui.autocomplete !== undefined) {
							$(data.fake_input).autocomplete(autocomplete_options);
							$(data.fake_input).bind('autocompleteselect',data,function(event,ui) {
								$(event.data.real_input).addTag(ui.item.value,{focus:true,unique:(settings.unique)});
								return false;
							});
						}
					
						
					} else {
							// if a user tabs out of the field, create a new tag
							// this is only available if autocomplete is not used.
							$(data.fake_input).bind('blur',data,function(event) { 
								var d = $(this).attr('data-default');
								if ($(event.data.fake_input).val()!='' && $(event.data.fake_input).val()!=d) { 
									if( (event.data.minChars <= $(event.data.fake_input).val().length) && (!event.data.maxChars || (event.data.maxChars >= $(event.data.fake_input).val().length)) )
										$(event.data.real_input).addTag($(event.data.fake_input).val(),{focus:true,unique:(settings.unique)});
								} else {
									$(event.data.fake_input).val($(event.data.fake_input).attr('data-default'));
									$(event.data.fake_input).css('color',settings.placeholderColor);
								}
								return false;
							});
					
					}
					// if user types a comma, create a new tag
					$(data.fake_input).bind('keypress',data,function(event) {
						if (event.which==event.data.delimiter.charCodeAt(0) || event.which==13 ) {
						    event.preventDefault();
							if( (event.data.minChars <= $(event.data.fake_input).val().length) && (!event.data.maxChars || (event.data.maxChars >= $(event.data.fake_input).val().length)) )
								$(event.data.real_input).addTag($(event.data.fake_input).val(),{focus:true,unique:(settings.unique)});
						  	$(event.data.fake_input).resetAutosize(settings);
							return false;
						} else if (event.data.autosize) {
				            $(event.data.fake_input).doAutosize(settings);
	            
	          			}
					});
					//Delete last tag on backspace
					data.removeWithBackspace && $(data.fake_input).bind('keydown', function(event)
					{
						if(event.keyCode == 8 && $(this).val() == '')
						{
							 event.preventDefault();
							 var last_tag = $(this).closest('.tagsinput').find('.tag:last').text();
							 var id = $(this).attr('id').replace(/_tag$/, '');
							 last_tag = last_tag.replace(/[\s\u00a0]+x$/, '');
							 $('#' + id).removeTag(escape(last_tag));
							 $(this).trigger('focus');
						}
					});
					$(data.fake_input).blur();
					
					//Removes the not_valid class when user changes the value of the fake input
					if(data.unique) {
					    $(data.fake_input).keydown(function(event){
					        if(event.keyCode == 8 || String.fromCharCode(event.which).match(/\w+|[áéíóúÁÉÍÓÚñÑ,/]+/)) {
					            $(this).removeClass('not_valid');
					        }
					    });
					}
				} // if settings.interactive
			});
				
			return this;
		
		};
		
		$.fn.tagsInput.updateTagsField = function(obj,tagslist) { 
			var id = $(obj).attr('id');
			$(obj).val(tagslist.join(delimiter[id]));
		};
		
		$.fn.tagsInput.importTags = function(obj,val) {			
			$(obj).val('');
			var id = $(obj).attr('id');
			var tags = val.split(delimiter[id]);
			for (i=0; i<tags.length; i++) { 
				$(obj).addTag(tags[i],{focus:false,callback:false});
			}
			if(tags_callbacks[id] && tags_callbacks[id]['onChange'])
			{
				var f = tags_callbacks[id]['onChange'];
				f.call(obj, obj, tags[i]);
			}
		};
	
	})(jQuery);
	


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(304)
	    ], __WEBPACK_AMD_DEFINE_RESULT__ = function(
	        $
	    ){
	
	        var toggleHandler = function(toggle) {
	            var toggle = toggle;
	            var radio = $(toggle).find("input");
	
	            var checkToggleState = function() {
	                if (radio.eq(0).is(":checked")) {
	                    $(toggle).removeClass("toggle-off");
	                } else {
	                    $(toggle).addClass("toggle-off");
	                }
	            };
	
	            checkToggleState();
	
	            radio.eq(0).click(function() {
	                $(toggle).toggleClass("toggle-off");
	            });
	
	            radio.eq(1).click(function() {
	                $(toggle).toggleClass("toggle-off");
	            });
	        };
	
	        function init( scope ){
	            scope = scope || $('body');
	
	            $("html").addClass("has-js");
	
	            // First let's prepend icons (needed for effects)
	            var els = $(".checkbox:not([data-init]), .radio:not([data-init])", scope);
	
	            els.attr('data-init', 'true');
	            els.prepend("<span class='icon'></span><span class='icon-to-fade'></span>");
	
	            els.find('input[type="checkbox"], input[type="radio"]').on('click', function(){
	                
	                var $this = $(this);
	                $this.parent().toggleClass('checked', $this.is(':checked'));
	                $this.parent().toggleClass('disabled', $this.is(':disabled'));
	            });
	
	            els.find('input[type="checkbox"]:checked').parent().addClass('checked');
	
	            $(".toggle:not([data-init])", scope).each(function(index, toggle) {
	                toggle.attr('data-init', 'true');
	                toggleHandler(toggle);
	            });
	        }
	
	        return init;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	
	    var units = {
	        micro: 1e-6,
	        nano: 1e-9,
	        pico: 1e-12,
	        femto: 1e-15,
	        deg: Math.PI / 180
	    };
	
	    function convertFrom(unit, val) {
	
	        if (!val) {
	            return 0;
	        }
	
	        if (!(unit in units)) {
	            throw 'Unit "' + unit + '" not defined in units.';
	        }
	
	        return val * units[unit];
	    }
	
	    function convertTo(unit, val, precision) {
	
	        if (!val) {
	            return 0;
	        }
	
	        precision = precision === undefined ? 2 : precision;
	
	        if (!(unit in units)) {
	            throw 'Unit "' + unit + '" not defined in units.';
	        }
	
	        return (val / units[unit]).toFixed(precision);
	    }
	
	    return {
	
	        from: convertFrom,
	        to: convertTo
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(456)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, converter) {
	
	    'use strict';
	
	    var defaults = {
	
	        data: {}
	    };
	
	    /**
	     * @module Panel
	     * @implements {Stapes}
	     */
	    var Panel = Stapes.subclass({
	
	        /**
	         * Mediator Constructor
	         * @return {void}
	         */
	        constructor: function constructor(config) {
	
	            var self = this;
	
	            self.options = $.extend({}, defaults, config);
	
	            self.set(self.options.data);
	
	            self.initEvents();
	        },
	
	        initEvents: function initEvents() {
	
	            var self = this;
	
	            self.els = $();
	
	            self.on('change', function (key) {
	
	                var val = this.get(key);
	
	                // refresh parameter values in the html
	                self.els.find('[name="' + key + '"]').each(function () {
	
	                    var el = $(this),
	                        unit = el.data('unit');
	
	                    if (unit) {
	                        val = converter.to(unit, val);
	                    }
	
	                    el.val(val);
	                });
	            });
	        },
	
	        attachView: function attachView(domEl) {
	
	            var self = this;
	
	            domEl.on('change.panel', 'input[type="text"], select', function () {
	
	                var $this = $(this),
	                    key = $this.attr('name'),
	                    val = $this.val(),
	                    parse = $this.data('parse'),
	                    unit = $this.data('unit');
	
	                if (parse === 'float') {
	                    val = parseFloat(val);
	                }
	
	                if (unit) {
	                    val = converter.from(unit, val);
	                }
	
	                // update the corresponding property in the plotOpts object
	                self.set(key, val);
	            });
	
	            domEl.on('change.panel', 'input[type="checkbox"]', function () {
	                var $this = $(this),
	                    key = $this.attr('name'),
	                    val = $this.is(':checked');
	
	                // update the corresponding boolean property in the parameters object
	                self.set(key, val);
	            });
	
	            self.els = self.els.add(domEl);
	        },
	
	        detachView: function detachView(domEl) {
	
	            var self = this;
	
	            domEl.off('.panel');
	
	            self.els = self.els.not(domEl);
	        }
	    });
	
	    return function (config) {
	
	        return new Panel(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(487), __webpack_require__(488)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, tplJSALayout, tplDocsJSA) {
	
	    'use strict';
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsaUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 2,
	        tplPlots: tplJSALayout,
	        tplDoc: tplDocsJSA,
	        showPlotOpts: ['grid_size', 'signal-wavelength', 'idler-wavelength'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-jsa', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            var margins = {
	                top: 60,
	                right: 40,
	                left: 80,
	                bottom: 60
	            };
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Joint spectral amplitude',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Wavelength of Signal (nm)',
	                    y: 'Wavelength of Idler (nm)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            self.addPlot(self.plot);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	
	            self.plotOpts.set({
	                'grid_size': 100,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max
	                // 'ls_start': 0.81E-6,
	                // 'ls_stop': 0.81E-6,
	                // 'li_start': 0.81E-6,
	                // 'li_stop': 0.81E-6
	            });
	        },
	
	        updateTitle: function updateTitle(PM) {
	            var self = this;
	            return self.workers[this.nWorkers - 1].exec('jsaHelper.doCalcSchmidt', [PM]).then(function (S) {
	                self.plot.setTitle("Schmidt Number = " + Math.round(1000 * S) / 1000);
	            });
	        },
	
	        calc: function calc(props) {
	            // var testlinspace = PhaseMatch.linspace(0,25.3, 10);
	            // console.log("linspace test: ", testlinspace);
	            var self = this;
	
	            var propsJSON = props.get(),
	                grid_size = self.plotOpts.get('grid_size');
	
	            var lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size);
	
	            var Nthreads = self.nWorkers - 1;
	
	            var divisions = Math.floor(grid_size / Nthreads);
	
	            var lambda_i_range = [];
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	            // Get the normalization
	            var P = props.clone();
	            P.phi_i = P.phi_s + Math.PI;
	            P.update_all_angles();
	
	            props.optimum_idler(props);
	            // console.log("Theta_s - Theta_i: ",(props.theta_s)*180/Math.PI, (props.theta_i)*180/Math.PI,  (props.theta_s - props.theta_i)*180/Math.PI);
	
	            // P.theta_i_e = PhaseMatch.find_external_angle(P,"idler");
	            // console.log("External angle of the idler is:", P.theta_i_e*180/Math.PI );
	            // console.log("angles: ", P.theta_s * 180/Math.PI,  P.theta_i * 180/Math.PI,  P.theta_s_e * 180/Math.PI,  P.theta_i_e * 180/Math.PI);
	            // var PMN =  PhaseMatch.phasematch(props);
	            // var norm = Math.sqrt(PMN[0]*PMN[0] + PMN[1]*PMN[1]);
	            // var norm = 1;
	            var norm = Math.sqrt(PhaseMatch.normalize_joint_spectrum(props));
	            // console.log("Normalization: ",norm);
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var promises = [];
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSACalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, norm]);
	            }
	
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    // console.log(j, j*lambda_s.length*lambda_i_range[j].length, values[j].length +  j*lambda_s.length*lambda_i_range[j].length);
	
	                    arr.set(values[j], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                // PhaseMatch.normalize(arr);
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	
	                var p = self.updateTitle(PM);
	                self.data = PM;
	                // console.log("data", PM);
	                self.plot.setZRange([0, Math.max.apply(null, PM)]);
	                self.plot.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plot.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	                console.log("Grid Size:", grid_size, " Elapsed time: ", endtime - starttime);
	                // return p;
	                return true;
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data,
	                dfd = when.defer();
	
	            if (!data) {
	                return this;
	            }
	
	            // async... but not inside webworker
	            setTimeout(function () {
	                self.plot.plotData(data);
	                dfd.resolve();
	            }, 10);
	
	            return dfd.promise;
	        }
	
	    });
	
	    return function (config) {
	
	        return new jsaUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(460)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, d3) {
	    'use strict';
	
	    var defaults = {
	
	        title: "Awesome Graph",
	        width: 480,
	        height: 480,
	        labels: {
	            x: 'X axis label',
	            y: 'Y axis label'
	        },
	        // default autocalc
	        xrange: null,
	        yrange: null,
	
	        margins: {
	            top: 60,
	            right: 40,
	            left: 80,
	            bottom: 60
	        },
	
	        legend: false,
	
	        // string value. See https://github.com/mbostock/d3/wiki/Formatting#wiki-d3_format
	        format: {
	            x: '.02f',
	            y: '.02f'
	        }
	
	    };
	
	    function LinePlot(options) {
	
	        options = $.extend({}, defaults, options);
	
	        this.labels = options.labels;
	        this.xrange = options.xrange;
	        this.yrange = options.yrange;
	        this.format = options.format;
	
	        this.el = $('<div>').css('position', 'relative').addClass('plot line-plot').appendTo(options.el);
	
	        this.elTitle = $('<label>').addClass('title').appendTo(this.el).css({
	            'position': 'absolute',
	            'top': '0',
	            'left': '0'
	        });
	
	        this.setTitle(options.title);
	
	        // init scales
	        this.scales = {
	            x: d3.scale.linear(),
	            y: d3.scale.linear()
	        };
	
	        this.clear();
	
	        // init svg
	        this.svg = d3.select(this.el.get(0)).append("svg");
	        this.svgPlot = this.svg.append("g");
	
	        this.margin = defaults.margins;
	        this.setFormat(options.format);
	        this.resize(options.width, options.height);
	        this.setMargins(options.margins);
	
	        this.showlegend = !!options.legend;
	    }
	
	    LinePlot.prototype = {
	
	        setFormat: function setFormat(fmt) {
	
	            this.format = {};
	
	            if ((typeof fmt === 'undefined' ? 'undefined' : _typeof(fmt)) === 'object') {
	
	                this.format = $.extend(this.format, fmt);
	            } else {
	
	                this.format.x = fmt;
	                this.format.y = fmt;
	                this.format.z = fmt;
	            }
	
	            this.refreshAxes();
	        },
	
	        setTitle: function setTitle(title) {
	
	            this.elTitle.text(title);
	        },
	
	        setYLabel: function setYLabel(title) {
	
	            this.labels.y(title);
	        },
	
	        setXLabel: function setXLabel(title) {
	
	            this.labels.x.text(title);
	        },
	
	        setMargins: function setMargins(cfg) {
	
	            var w = this.width + this.margin.left + this.margin.right,
	                h = this.height + this.margin.top + this.margin.bottom,
	                margin = this.margin = $.extend({}, this.margin, cfg);
	
	            this.svgPlot.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
	            this.elTitle.css({
	                'top': margin.top,
	                'margin-top': '-1.6em',
	                'left': margin.left
	            });
	
	            this.resize(w, h);
	        },
	
	        setXRange: function setXRange(xrange) {
	
	            this.xrange = xrange;
	            this.refreshAxes();
	        },
	
	        setYRange: function setYRange(yrange) {
	
	            this.yrange = yrange;
	            this.refreshAxes();
	        },
	
	        resize: function resize(w, h) {
	
	            var margin = this.margin;
	
	            if (!h) {
	                h = this.height / this.width * w;
	            }
	
	            this.width = w;
	            this.height = h;
	
	            w += margin.left + margin.right;
	            h += margin.top + margin.bottom;
	
	            this.el.css('width', w + 'px').css('height', h + 'px');
	
	            this.svg.attr("width", w).attr("height", h);
	        },
	
	        refreshAxes: function refreshAxes() {
	            // Check for edge initialization cases
	            if (this.width === undefined) {
	                this.width = 400;
	            }
	
	            if (this.height === undefined) {
	                this.height = 400;
	            }
	            var svg = this.svgPlot,
	                x = this.scales.x,
	                y = this.scales.y,
	                labels = this.labels,
	                width = this.width,
	                height = this.height;
	
	            // init axes
	            var xAxis = d3.svg.axis().scale(x).tickFormat(d3.format(this.format.x)).orient("bottom").ticks(width / 50 | 0);
	
	            var yAxis = d3.svg.axis().scale(y).tickFormat(d3.format(this.format.y)).orient("left").ticks(height / 40 | 0);
	
	            svg.selectAll('.axis').remove();
	
	            svg.append("g").attr("class", "x axis").attr("transform", "translate(0, " + height + ")").call(xAxis).append("text").attr("y", 0).attr("dy", this.margin.bottom - 16).attr("x", width / 2).style("text-anchor", "middle").text(labels.x);
	
	            svg.append("g").attr("class", "y axis").call(yAxis).append("text").attr("x", -height / 2).attr("y", 0).attr("transform", "rotate(-90)").attr("dy", -this.margin.left + 16).style("text-anchor", "middle").text(labels.y);
	
	            if (this.showlegend) {
	                this.drawLegend();
	            }
	        },
	
	        displayLegend: function displayLegend(bool) {
	            this.showlegend = bool;
	        },
	
	        drawLegend: function drawLegend() {
	            var svg = this.svgPlot,
	                x = this.scales.x,
	                y = this.scales.y,
	                labels = this.labels,
	                width = this.width,
	                height = this.height;
	
	            svg.selectAll('.legend').remove();
	
	            var legend = svg.append('g').attr('class', 'legend');
	
	            for (var i = 0, l = this.series.length; i < l; ++i) {
	
	                var title = this.series[i]['title'];
	                var color = this.series[i]['color'];
	                var ycoord = i * 20;
	
	                legend.append('rect').attr('x', width - 60).attr('y', ycoord).attr('width', 10).attr('height', 4).style('fill', color);
	
	                legend.append("text").attr("x", width - 45).attr("y", ycoord + 2).attr("dy", ".35em").text(title); //function(d) { return  });
	            }
	        },
	
	        getLogPlot: function getLogPlot() {},
	
	        exportData: function exportData() {
	
	            // clone
	            // var data = $.map(this.series[0].data, $.proxy($.extend, $, true));
	
	            return {
	                title: this.elTitle.text(),
	                type: 'line',
	                x: {
	                    label: this.labels.x
	                },
	                y: {
	                    label: this.labels.y
	                },
	                data: [].concat(this.series)
	            };
	        },
	
	        calcRanges: function calcRanges() {
	
	            if (this.xrange && this.yrange) {
	                return;
	            }
	
	            var all = [];
	
	            for (var i = 0, l = this.series.length; i < l; ++i) {
	
	                all.push.apply(all, this.series[i].data);
	            }
	
	            this.xrangeauto = d3.extent(all, function (d) {
	                return d.x;
	            });
	            this.yrangeauto = d3.extent(all, function (d) {
	                return d.y;
	            });
	        },
	
	        // call as one of:
	        // addSeries( data );
	        // addSeries( data, 'title' );
	        // addSeries( data, { title: 'title', color: 'color' });
	        // addSeries({ title: 'title', color: 'color', data: data });
	        addSeries: function addSeries(data, cfg) {
	
	            if (!data) {
	                return;
	            }
	
	            if ((typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
	
	                if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' && data.data) {
	
	                    cfg = data;
	                    data = cfg.data;
	                } else {
	
	                    cfg = {
	                        title: cfg || 'Series ' + this.series.length,
	                        color: this.colors(this.series.length)
	                    };
	                }
	            }
	
	            cfg.data = data;
	
	            this.series.push(cfg);
	        },
	
	        clear: function clear() {
	
	            this.colors = d3.scale.category10();
	            this.series = [];
	        },
	
	        plotData: function plotData(data) {
	
	            var svg = this.svgPlot,
	                x = this.scales.x,
	                y = this.scales.y,
	                width = this.width,
	                height = this.height,
	                line,
	                series;
	
	            if (data) {
	                this.clear();
	                this.addSeries(data);
	            }
	
	            this.calcRanges();
	
	            x.domain(this.xrange || this.xrangeauto).range([0, width]);
	
	            y.domain(this.yrange || this.yrangeauto).range([height, 0]);
	
	            svg.selectAll('.line').remove();
	
	            var scaleX = function scaleX(d) {
	                return x(d.x);
	            };
	            var scaleY = function scaleY(d) {
	                return y(d.y);
	            };
	
	            for (var i = 0, l = this.series.length; i < l; ++i) {
	
	                series = this.series[i];
	
	                line = d3.svg.line(series.data).x(scaleX).y(scaleY);
	
	                svg.append('path').datum(series.data).attr("class", "line").attr("d", line).attr("stroke", series.color);
	            }
	
	            this.refreshAxes();
	        }
	    };
	
	    return LinePlot;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	
	/**
	 * Promises/A+ and when() implementation
	 * when is part of the cujoJS family of libraries (http://cujojs.com/)
	 * @author Brian Cavalier
	 * @author John Hann
	 */
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	
		var timed = __webpack_require__(462);
		var array = __webpack_require__(467);
		var flow = __webpack_require__(470);
		var fold = __webpack_require__(471);
		var inspect = __webpack_require__(472);
		var generate = __webpack_require__(473);
		var progress = __webpack_require__(474);
		var withThis = __webpack_require__(475);
		var unhandledRejection = __webpack_require__(476);
		var TimeoutError = __webpack_require__(466);
	
		var Promise = [array, flow, fold, generate, progress,
			inspect, withThis, timed, unhandledRejection]
			.reduce(function(Promise, feature) {
				return feature(Promise);
			}, __webpack_require__(478));
	
		var apply = __webpack_require__(469)(Promise);
	
		// Public API
	
		when.promise     = promise;              // Create a pending promise
		when.resolve     = Promise.resolve;      // Create a resolved promise
		when.reject      = Promise.reject;       // Create a rejected promise
	
		when.lift        = lift;                 // lift a function to return promises
		when['try']      = attempt;              // call a function and return a promise
		when.attempt     = attempt;              // alias for when.try
	
		when.iterate     = Promise.iterate;      // DEPRECATED (use cujojs/most streams) Generate a stream of promises
		when.unfold      = Promise.unfold;       // DEPRECATED (use cujojs/most streams) Generate a stream of promises
	
		when.join        = join;                 // Join 2 or more promises
	
		when.all         = all;                  // Resolve a list of promises
		when.settle      = settle;               // Settle a list of promises
	
		when.any         = lift(Promise.any);    // One-winner race
		when.some        = lift(Promise.some);   // Multi-winner race
		when.race        = lift(Promise.race);   // First-to-settle race
	
		when.map         = map;                  // Array.map() for promises
		when.filter      = filter;               // Array.filter() for promises
		when.reduce      = lift(Promise.reduce);       // Array.reduce() for promises
		when.reduceRight = lift(Promise.reduceRight);  // Array.reduceRight() for promises
	
		when.isPromiseLike = isPromiseLike;      // Is something promise-like, aka thenable
	
		when.Promise     = Promise;              // Promise constructor
		when.defer       = defer;                // Create a {promise, resolve, reject} tuple
	
		// Error types
	
		when.TimeoutError = TimeoutError;
	
		/**
		 * Get a trusted promise for x, or by transforming x with onFulfilled
		 *
		 * @param {*} x
		 * @param {function?} onFulfilled callback to be called when x is
		 *   successfully fulfilled.  If promiseOrValue is an immediate value, callback
		 *   will be invoked immediately.
		 * @param {function?} onRejected callback to be called when x is
		 *   rejected.
		 * @param {function?} onProgress callback to be called when progress updates
		 *   are issued for x. @deprecated
		 * @returns {Promise} a new promise that will fulfill with the return
		 *   value of callback or errback or the completion value of promiseOrValue if
		 *   callback and/or errback is not supplied.
		 */
		function when(x, onFulfilled, onRejected, onProgress) {
			var p = Promise.resolve(x);
			if (arguments.length < 2) {
				return p;
			}
	
			return p.then(onFulfilled, onRejected, onProgress);
		}
	
		/**
		 * Creates a new promise whose fate is determined by resolver.
		 * @param {function} resolver function(resolve, reject, notify)
		 * @returns {Promise} promise whose fate is determine by resolver
		 */
		function promise(resolver) {
			return new Promise(resolver);
		}
	
		/**
		 * Lift the supplied function, creating a version of f that returns
		 * promises, and accepts promises as arguments.
		 * @param {function} f
		 * @returns {Function} version of f that returns promises
		 */
		function lift(f) {
			return function() {
				for(var i=0, l=arguments.length, a=new Array(l); i<l; ++i) {
					a[i] = arguments[i];
				}
				return apply(f, this, a);
			};
		}
	
		/**
		 * Call f in a future turn, with the supplied args, and return a promise
		 * for the result.
		 * @param {function} f
		 * @returns {Promise}
		 */
		function attempt(f /*, args... */) {
			/*jshint validthis:true */
			for(var i=0, l=arguments.length-1, a=new Array(l); i<l; ++i) {
				a[i] = arguments[i+1];
			}
			return apply(f, this, a);
		}
	
		/**
		 * Creates a {promise, resolver} pair, either or both of which
		 * may be given out safely to consumers.
		 * @return {{promise: Promise, resolve: function, reject: function, notify: function}}
		 */
		function defer() {
			return new Deferred();
		}
	
		function Deferred() {
			var p = Promise._defer();
	
			function resolve(x) { p._handler.resolve(x); }
			function reject(x) { p._handler.reject(x); }
			function notify(x) { p._handler.notify(x); }
	
			this.promise = p;
			this.resolve = resolve;
			this.reject = reject;
			this.notify = notify;
			this.resolver = { resolve: resolve, reject: reject, notify: notify };
		}
	
		/**
		 * Determines if x is promise-like, i.e. a thenable object
		 * NOTE: Will return true for *any thenable object*, and isn't truly
		 * safe, since it may attempt to access the `then` property of x (i.e.
		 *  clever/malicious getters may do weird things)
		 * @param {*} x anything
		 * @returns {boolean} true if x is promise-like
		 */
		function isPromiseLike(x) {
			return x && typeof x.then === 'function';
		}
	
		/**
		 * Return a promise that will resolve only once all the supplied arguments
		 * have resolved. The resolution value of the returned promise will be an array
		 * containing the resolution values of each of the arguments.
		 * @param {...*} arguments may be a mix of promises and values
		 * @returns {Promise}
		 */
		function join(/* ...promises */) {
			return Promise.all(arguments);
		}
	
		/**
		 * Return a promise that will fulfill once all input promises have
		 * fulfilled, or reject when any one input promise rejects.
		 * @param {array|Promise} promises array (or promise for an array) of promises
		 * @returns {Promise}
		 */
		function all(promises) {
			return when(promises, Promise.all);
		}
	
		/**
		 * Return a promise that will always fulfill with an array containing
		 * the outcome states of all input promises.  The returned promise
		 * will only reject if `promises` itself is a rejected promise.
		 * @param {array|Promise} promises array (or promise for an array) of promises
		 * @returns {Promise} promise for array of settled state descriptors
		 */
		function settle(promises) {
			return when(promises, Promise.settle);
		}
	
		/**
		 * Promise-aware array map function, similar to `Array.prototype.map()`,
		 * but input array may contain promises or values.
		 * @param {Array|Promise} promises array of anything, may contain promises and values
		 * @param {function(x:*, index:Number):*} mapFunc map function which may
		 *  return a promise or value
		 * @returns {Promise} promise that will fulfill with an array of mapped values
		 *  or reject if any input promise rejects.
		 */
		function map(promises, mapFunc) {
			return when(promises, function(promises) {
				return Promise.map(promises, mapFunc);
			});
		}
	
		/**
		 * Filter the provided array of promises using the provided predicate.  Input may
		 * contain promises and values
		 * @param {Array|Promise} promises array of promises and values
		 * @param {function(x:*, index:Number):boolean} predicate filtering predicate.
		 *  Must return truthy (or promise for truthy) for items to retain.
		 * @returns {Promise} promise that will fulfill with an array containing all items
		 *  for which predicate returned truthy.
		 */
		function filter(promises, predicate) {
			return when(promises, function(promises) {
				return Promise.filter(promises, predicate);
			});
		}
	
		return when;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(__webpack_require__(465));


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	
		var env = __webpack_require__(463);
		var TimeoutError = __webpack_require__(466);
	
		function setTimeout(f, ms, x, y) {
			return env.setTimer(function() {
				f(x, y, ms);
			}, ms);
		}
	
		return function timed(Promise) {
			/**
			 * Return a new promise whose fulfillment value is revealed only
			 * after ms milliseconds
			 * @param {number} ms milliseconds
			 * @returns {Promise}
			 */
			Promise.prototype.delay = function(ms) {
				var p = this._beget();
				this._handler.fold(handleDelay, ms, void 0, p._handler);
				return p;
			};
	
			function handleDelay(ms, x, h) {
				setTimeout(resolveDelay, ms, x, h);
			}
	
			function resolveDelay(x, h) {
				h.resolve(x);
			}
	
			/**
			 * Return a new promise that rejects after ms milliseconds unless
			 * this promise fulfills earlier, in which case the returned promise
			 * fulfills with the same value.
			 * @param {number} ms milliseconds
			 * @param {Error|*=} reason optional rejection reason to use, defaults
			 *   to a TimeoutError if not provided
			 * @returns {Promise}
			 */
			Promise.prototype.timeout = function(ms, reason) {
				var p = this._beget();
				var h = p._handler;
	
				var t = setTimeout(onTimeout, ms, reason, p._handler);
	
				this._handler.visit(h,
					function onFulfill(x) {
						env.clearTimer(t);
						this.resolve(x); // this = h
					},
					function onReject(x) {
						env.clearTimer(t);
						this.reject(x); // this = h
					},
					h.notify);
	
				return p;
			};
	
			function onTimeout(reason, h, ms) {
				var e = typeof reason === 'undefined'
					? new TimeoutError('timed out after ' + ms + 'ms')
					: reason;
				h.reject(e);
			}
	
			return Promise;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;var require;/* WEBPACK VAR INJECTION */(function(process) {/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	/*global process,document,setTimeout,clearTimeout,MutationObserver,WebKitMutationObserver*/
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
		/*jshint maxcomplexity:6*/
	
		// Sniff "best" async scheduling option
		// Prefer process.nextTick or MutationObserver, then check for
		// setTimeout, and finally vertx, since its the only env that doesn't
		// have setTimeout
	
		var MutationObs;
		var capturedSetTimeout = typeof setTimeout !== 'undefined' && setTimeout;
	
		// Default env
		var setTimer = function(f, ms) { return setTimeout(f, ms); };
		var clearTimer = function(t) { return clearTimeout(t); };
		var asap = function (f) { return capturedSetTimeout(f, 0); };
	
		// Detect specific env
		if (isNode()) { // Node
			asap = function (f) { return process.nextTick(f); };
	
		} else if (MutationObs = hasMutationObserver()) { // Modern browser
			asap = initMutationObserver(MutationObs);
	
		} else if (!capturedSetTimeout) { // vert.x
			var vertxRequire = require;
			var vertx = __webpack_require__(464);
			setTimer = function (f, ms) { return vertx.setTimer(ms, f); };
			clearTimer = vertx.cancelTimer;
			asap = vertx.runOnLoop || vertx.runOnContext;
		}
	
		return {
			setTimer: setTimer,
			clearTimer: clearTimer,
			asap: asap
		};
	
		function isNode () {
			return typeof process !== 'undefined' &&
				Object.prototype.toString.call(process) === '[object process]';
		}
	
		function hasMutationObserver () {
			return (typeof MutationObserver === 'function' && MutationObserver) ||
				(typeof WebKitMutationObserver === 'function' && WebKitMutationObserver);
		}
	
		function initMutationObserver(MutationObserver) {
			var scheduled;
			var node = document.createTextNode('');
			var o = new MutationObserver(run);
			o.observe(node, { characterData: true });
	
			function run() {
				var f = scheduled;
				scheduled = void 0;
				f();
			}
	
			var i = 0;
			return function (f) {
				scheduled = f;
				node.data = (i ^= 1);
			};
		}
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 464 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 465 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		/**
		 * Custom error type for promises rejected by promise.timeout
		 * @param {string} message
		 * @constructor
		 */
		function TimeoutError (message) {
			Error.call(this);
			this.message = message;
			this.name = TimeoutError.name;
			if (typeof Error.captureStackTrace === 'function') {
				Error.captureStackTrace(this, TimeoutError);
			}
		}
	
		TimeoutError.prototype = Object.create(Error.prototype);
		TimeoutError.prototype.constructor = TimeoutError;
	
		return TimeoutError;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	
		var state = __webpack_require__(468);
		var applier = __webpack_require__(469);
	
		return function array(Promise) {
	
			var applyFold = applier(Promise);
			var toPromise = Promise.resolve;
			var all = Promise.all;
	
			var ar = Array.prototype.reduce;
			var arr = Array.prototype.reduceRight;
			var slice = Array.prototype.slice;
	
			// Additional array combinators
	
			Promise.any = any;
			Promise.some = some;
			Promise.settle = settle;
	
			Promise.map = map;
			Promise.filter = filter;
			Promise.reduce = reduce;
			Promise.reduceRight = reduceRight;
	
			/**
			 * When this promise fulfills with an array, do
			 * onFulfilled.apply(void 0, array)
			 * @param {function} onFulfilled function to apply
			 * @returns {Promise} promise for the result of applying onFulfilled
			 */
			Promise.prototype.spread = function(onFulfilled) {
				return this.then(all).then(function(array) {
					return onFulfilled.apply(this, array);
				});
			};
	
			return Promise;
	
			/**
			 * One-winner competitive race.
			 * Return a promise that will fulfill when one of the promises
			 * in the input array fulfills, or will reject when all promises
			 * have rejected.
			 * @param {array} promises
			 * @returns {Promise} promise for the first fulfilled value
			 */
			function any(promises) {
				var p = Promise._defer();
				var resolver = p._handler;
				var l = promises.length>>>0;
	
				var pending = l;
				var errors = [];
	
				for (var h, x, i = 0; i < l; ++i) {
					x = promises[i];
					if(x === void 0 && !(i in promises)) {
						--pending;
						continue;
					}
	
					h = Promise._handler(x);
					if(h.state() > 0) {
						resolver.become(h);
						Promise._visitRemaining(promises, i, h);
						break;
					} else {
						h.visit(resolver, handleFulfill, handleReject);
					}
				}
	
				if(pending === 0) {
					resolver.reject(new RangeError('any(): array must not be empty'));
				}
	
				return p;
	
				function handleFulfill(x) {
					/*jshint validthis:true*/
					errors = null;
					this.resolve(x); // this === resolver
				}
	
				function handleReject(e) {
					/*jshint validthis:true*/
					if(this.resolved) { // this === resolver
						return;
					}
	
					errors.push(e);
					if(--pending === 0) {
						this.reject(errors);
					}
				}
			}
	
			/**
			 * N-winner competitive race
			 * Return a promise that will fulfill when n input promises have
			 * fulfilled, or will reject when it becomes impossible for n
			 * input promises to fulfill (ie when promises.length - n + 1
			 * have rejected)
			 * @param {array} promises
			 * @param {number} n
			 * @returns {Promise} promise for the earliest n fulfillment values
			 *
			 * @deprecated
			 */
			function some(promises, n) {
				/*jshint maxcomplexity:7*/
				var p = Promise._defer();
				var resolver = p._handler;
	
				var results = [];
				var errors = [];
	
				var l = promises.length>>>0;
				var nFulfill = 0;
				var nReject;
				var x, i; // reused in both for() loops
	
				// First pass: count actual array items
				for(i=0; i<l; ++i) {
					x = promises[i];
					if(x === void 0 && !(i in promises)) {
						continue;
					}
					++nFulfill;
				}
	
				// Compute actual goals
				n = Math.max(n, 0);
				nReject = (nFulfill - n + 1);
				nFulfill = Math.min(n, nFulfill);
	
				if(n > nFulfill) {
					resolver.reject(new RangeError('some(): array must contain at least '
					+ n + ' item(s), but had ' + nFulfill));
				} else if(nFulfill === 0) {
					resolver.resolve(results);
				}
	
				// Second pass: observe each array item, make progress toward goals
				for(i=0; i<l; ++i) {
					x = promises[i];
					if(x === void 0 && !(i in promises)) {
						continue;
					}
	
					Promise._handler(x).visit(resolver, fulfill, reject, resolver.notify);
				}
	
				return p;
	
				function fulfill(x) {
					/*jshint validthis:true*/
					if(this.resolved) { // this === resolver
						return;
					}
	
					results.push(x);
					if(--nFulfill === 0) {
						errors = null;
						this.resolve(results);
					}
				}
	
				function reject(e) {
					/*jshint validthis:true*/
					if(this.resolved) { // this === resolver
						return;
					}
	
					errors.push(e);
					if(--nReject === 0) {
						results = null;
						this.reject(errors);
					}
				}
			}
	
			/**
			 * Apply f to the value of each promise in a list of promises
			 * and return a new list containing the results.
			 * @param {array} promises
			 * @param {function(x:*, index:Number):*} f mapping function
			 * @returns {Promise}
			 */
			function map(promises, f) {
				return Promise._traverse(f, promises);
			}
	
			/**
			 * Filter the provided array of promises using the provided predicate.  Input may
			 * contain promises and values
			 * @param {Array} promises array of promises and values
			 * @param {function(x:*, index:Number):boolean} predicate filtering predicate.
			 *  Must return truthy (or promise for truthy) for items to retain.
			 * @returns {Promise} promise that will fulfill with an array containing all items
			 *  for which predicate returned truthy.
			 */
			function filter(promises, predicate) {
				var a = slice.call(promises);
				return Promise._traverse(predicate, a).then(function(keep) {
					return filterSync(a, keep);
				});
			}
	
			function filterSync(promises, keep) {
				// Safe because we know all promises have fulfilled if we've made it this far
				var l = keep.length;
				var filtered = new Array(l);
				for(var i=0, j=0; i<l; ++i) {
					if(keep[i]) {
						filtered[j++] = Promise._handler(promises[i]).value;
					}
				}
				filtered.length = j;
				return filtered;
	
			}
	
			/**
			 * Return a promise that will always fulfill with an array containing
			 * the outcome states of all input promises.  The returned promise
			 * will never reject.
			 * @param {Array} promises
			 * @returns {Promise} promise for array of settled state descriptors
			 */
			function settle(promises) {
				return all(promises.map(settleOne));
			}
	
			function settleOne(p) {
				var h = Promise._handler(p);
				if(h.state() === 0) {
					return toPromise(p).then(state.fulfilled, state.rejected);
				}
	
				h._unreport();
				return state.inspect(h);
			}
	
			/**
			 * Traditional reduce function, similar to `Array.prototype.reduce()`, but
			 * input may contain promises and/or values, and reduceFunc
			 * may return either a value or a promise, *and* initialValue may
			 * be a promise for the starting value.
			 * @param {Array|Promise} promises array or promise for an array of anything,
			 *      may contain a mix of promises and values.
			 * @param {function(accumulated:*, x:*, index:Number):*} f reduce function
			 * @returns {Promise} that will resolve to the final reduced value
			 */
			function reduce(promises, f /*, initialValue */) {
				return arguments.length > 2 ? ar.call(promises, liftCombine(f), arguments[2])
						: ar.call(promises, liftCombine(f));
			}
	
			/**
			 * Traditional reduce function, similar to `Array.prototype.reduceRight()`, but
			 * input may contain promises and/or values, and reduceFunc
			 * may return either a value or a promise, *and* initialValue may
			 * be a promise for the starting value.
			 * @param {Array|Promise} promises array or promise for an array of anything,
			 *      may contain a mix of promises and values.
			 * @param {function(accumulated:*, x:*, index:Number):*} f reduce function
			 * @returns {Promise} that will resolve to the final reduced value
			 */
			function reduceRight(promises, f /*, initialValue */) {
				return arguments.length > 2 ? arr.call(promises, liftCombine(f), arguments[2])
						: arr.call(promises, liftCombine(f));
			}
	
			function liftCombine(f) {
				return function(z, x, i) {
					return applyFold(f, void 0, [z,x,i]);
				};
			}
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return {
			pending: toPendingState,
			fulfilled: toFulfilledState,
			rejected: toRejectedState,
			inspect: inspect
		};
	
		function toPendingState() {
			return { state: 'pending' };
		}
	
		function toRejectedState(e) {
			return { state: 'rejected', reason: e };
		}
	
		function toFulfilledState(x) {
			return { state: 'fulfilled', value: x };
		}
	
		function inspect(handler) {
			var state = handler.state();
			return state === 0 ? toPendingState()
				 : state > 0   ? toFulfilledState(handler.value)
				               : toRejectedState(handler.value);
		}
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		makeApply.tryCatchResolve = tryCatchResolve;
	
		return makeApply;
	
		function makeApply(Promise, call) {
			if(arguments.length < 2) {
				call = tryCatchResolve;
			}
	
			return apply;
	
			function apply(f, thisArg, args) {
				var p = Promise._defer();
				var l = args.length;
				var params = new Array(l);
				callAndResolve({ f:f, thisArg:thisArg, args:args, params:params, i:l-1, call:call }, p._handler);
	
				return p;
			}
	
			function callAndResolve(c, h) {
				if(c.i < 0) {
					return call(c.f, c.thisArg, c.params, h);
				}
	
				var handler = Promise._handler(c.args[c.i]);
				handler.fold(callAndResolveNext, c, void 0, h);
			}
	
			function callAndResolveNext(c, x, h) {
				c.params[c.i] = x;
				c.i -= 1;
				callAndResolve(c, h);
			}
		}
	
		function tryCatchResolve(f, thisArg, args, resolver) {
			try {
				resolver.resolve(f.apply(thisArg, args));
			} catch(e) {
				resolver.reject(e);
			}
		}
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));
	
	


/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return function flow(Promise) {
	
			var resolve = Promise.resolve;
			var reject = Promise.reject;
			var origCatch = Promise.prototype['catch'];
	
			/**
			 * Handle the ultimate fulfillment value or rejection reason, and assume
			 * responsibility for all errors.  If an error propagates out of result
			 * or handleFatalError, it will be rethrown to the host, resulting in a
			 * loud stack track on most platforms and a crash on some.
			 * @param {function?} onResult
			 * @param {function?} onError
			 * @returns {undefined}
			 */
			Promise.prototype.done = function(onResult, onError) {
				this._handler.visit(this._handler.receiver, onResult, onError);
			};
	
			/**
			 * Add Error-type and predicate matching to catch.  Examples:
			 * promise.catch(TypeError, handleTypeError)
			 *   .catch(predicate, handleMatchedErrors)
			 *   .catch(handleRemainingErrors)
			 * @param onRejected
			 * @returns {*}
			 */
			Promise.prototype['catch'] = Promise.prototype.otherwise = function(onRejected) {
				if (arguments.length < 2) {
					return origCatch.call(this, onRejected);
				}
	
				if(typeof onRejected !== 'function') {
					return this.ensure(rejectInvalidPredicate);
				}
	
				return origCatch.call(this, createCatchFilter(arguments[1], onRejected));
			};
	
			/**
			 * Wraps the provided catch handler, so that it will only be called
			 * if the predicate evaluates truthy
			 * @param {?function} handler
			 * @param {function} predicate
			 * @returns {function} conditional catch handler
			 */
			function createCatchFilter(handler, predicate) {
				return function(e) {
					return evaluatePredicate(e, predicate)
						? handler.call(this, e)
						: reject(e);
				};
			}
	
			/**
			 * Ensures that onFulfilledOrRejected will be called regardless of whether
			 * this promise is fulfilled or rejected.  onFulfilledOrRejected WILL NOT
			 * receive the promises' value or reason.  Any returned value will be disregarded.
			 * onFulfilledOrRejected may throw or return a rejected promise to signal
			 * an additional error.
			 * @param {function} handler handler to be called regardless of
			 *  fulfillment or rejection
			 * @returns {Promise}
			 */
			Promise.prototype['finally'] = Promise.prototype.ensure = function(handler) {
				if(typeof handler !== 'function') {
					return this;
				}
	
				return this.then(function(x) {
					return runSideEffect(handler, this, identity, x);
				}, function(e) {
					return runSideEffect(handler, this, reject, e);
				});
			};
	
			function runSideEffect (handler, thisArg, propagate, value) {
				var result = handler.call(thisArg);
				return maybeThenable(result)
					? propagateValue(result, propagate, value)
					: propagate(value);
			}
	
			function propagateValue (result, propagate, x) {
				return resolve(result).then(function () {
					return propagate(x);
				});
			}
	
			/**
			 * Recover from a failure by returning a defaultValue.  If defaultValue
			 * is a promise, it's fulfillment value will be used.  If defaultValue is
			 * a promise that rejects, the returned promise will reject with the
			 * same reason.
			 * @param {*} defaultValue
			 * @returns {Promise} new promise
			 */
			Promise.prototype['else'] = Promise.prototype.orElse = function(defaultValue) {
				return this.then(void 0, function() {
					return defaultValue;
				});
			};
	
			/**
			 * Shortcut for .then(function() { return value; })
			 * @param  {*} value
			 * @return {Promise} a promise that:
			 *  - is fulfilled if value is not a promise, or
			 *  - if value is a promise, will fulfill with its value, or reject
			 *    with its reason.
			 */
			Promise.prototype['yield'] = function(value) {
				return this.then(function() {
					return value;
				});
			};
	
			/**
			 * Runs a side effect when this promise fulfills, without changing the
			 * fulfillment value.
			 * @param {function} onFulfilledSideEffect
			 * @returns {Promise}
			 */
			Promise.prototype.tap = function(onFulfilledSideEffect) {
				return this.then(onFulfilledSideEffect)['yield'](this);
			};
	
			return Promise;
		};
	
		function rejectInvalidPredicate() {
			throw new TypeError('catch predicate must be a function');
		}
	
		function evaluatePredicate(e, predicate) {
			return isError(predicate) ? e instanceof predicate : predicate(e);
		}
	
		function isError(predicate) {
			return predicate === Error
				|| (predicate != null && predicate.prototype instanceof Error);
		}
	
		function maybeThenable(x) {
			return (typeof x === 'object' || typeof x === 'function') && x !== null;
		}
	
		function identity(x) {
			return x;
		}
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	/** @author Jeff Escalante */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return function fold(Promise) {
	
			Promise.prototype.fold = function(f, z) {
				var promise = this._beget();
	
				this._handler.fold(function(z, x, to) {
					Promise._handler(z).fold(function(x, z, to) {
						to.resolve(f.call(this, z, x));
					}, x, this, to);
				}, z, promise._handler.receiver, promise._handler);
	
				return promise;
			};
	
			return Promise;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	
		var inspect = __webpack_require__(468).inspect;
	
		return function inspection(Promise) {
	
			Promise.prototype.inspect = function() {
				return inspect(Promise._handler(this));
			};
	
			return Promise;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return function generate(Promise) {
	
			var resolve = Promise.resolve;
	
			Promise.iterate = iterate;
			Promise.unfold = unfold;
	
			return Promise;
	
			/**
			 * @deprecated Use github.com/cujojs/most streams and most.iterate
			 * Generate a (potentially infinite) stream of promised values:
			 * x, f(x), f(f(x)), etc. until condition(x) returns true
			 * @param {function} f function to generate a new x from the previous x
			 * @param {function} condition function that, given the current x, returns
			 *  truthy when the iterate should stop
			 * @param {function} handler function to handle the value produced by f
			 * @param {*|Promise} x starting value, may be a promise
			 * @return {Promise} the result of the last call to f before
			 *  condition returns true
			 */
			function iterate(f, condition, handler, x) {
				return unfold(function(x) {
					return [x, f(x)];
				}, condition, handler, x);
			}
	
			/**
			 * @deprecated Use github.com/cujojs/most streams and most.unfold
			 * Generate a (potentially infinite) stream of promised values
			 * by applying handler(generator(seed)) iteratively until
			 * condition(seed) returns true.
			 * @param {function} unspool function that generates a [value, newSeed]
			 *  given a seed.
			 * @param {function} condition function that, given the current seed, returns
			 *  truthy when the unfold should stop
			 * @param {function} handler function to handle the value produced by unspool
			 * @param x {*|Promise} starting value, may be a promise
			 * @return {Promise} the result of the last value produced by unspool before
			 *  condition returns true
			 */
			function unfold(unspool, condition, handler, x) {
				return resolve(x).then(function(seed) {
					return resolve(condition(seed)).then(function(done) {
						return done ? seed : resolve(unspool(seed)).spread(next);
					});
				});
	
				function next(item, newSeed) {
					return resolve(handler(item)).then(function() {
						return unfold(unspool, condition, handler, newSeed);
					});
				}
			}
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return function progress(Promise) {
	
			/**
			 * @deprecated
			 * Register a progress handler for this promise
			 * @param {function} onProgress
			 * @returns {Promise}
			 */
			Promise.prototype.progress = function(onProgress) {
				return this.then(void 0, void 0, onProgress);
			};
	
			return Promise;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return function addWith(Promise) {
			/**
			 * Returns a promise whose handlers will be called with `this` set to
			 * the supplied receiver.  Subsequent promises derived from the
			 * returned promise will also have their handlers called with receiver
			 * as `this`. Calling `with` with undefined or no arguments will return
			 * a promise whose handlers will again be called in the usual Promises/A+
			 * way (no `this`) thus safely undoing any previous `with` in the
			 * promise chain.
			 *
			 * WARNING: Promises returned from `with`/`withThis` are NOT Promises/A+
			 * compliant, specifically violating 2.2.5 (http://promisesaplus.com/#point-41)
			 *
			 * @param {object} receiver `this` value for all handlers attached to
			 *  the returned promise.
			 * @returns {Promise}
			 */
			Promise.prototype['with'] = Promise.prototype.withThis = function(receiver) {
				var p = this._beget();
				var child = p._handler;
				child.receiver = receiver;
				this._handler.chain(child, receiver);
				return p;
			};
	
			return Promise;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));
	


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function(require) {
	
		var setTimer = __webpack_require__(463).setTimer;
		var format = __webpack_require__(477);
	
		return function unhandledRejection(Promise) {
	
			var logError = noop;
			var logInfo = noop;
			var localConsole;
	
			if(typeof console !== 'undefined') {
				// Alias console to prevent things like uglify's drop_console option from
				// removing console.log/error. Unhandled rejections fall into the same
				// category as uncaught exceptions, and build tools shouldn't silence them.
				localConsole = console;
				logError = typeof localConsole.error !== 'undefined'
					? function (e) { localConsole.error(e); }
					: function (e) { localConsole.log(e); };
	
				logInfo = typeof localConsole.info !== 'undefined'
					? function (e) { localConsole.info(e); }
					: function (e) { localConsole.log(e); };
			}
	
			Promise.onPotentiallyUnhandledRejection = function(rejection) {
				enqueue(report, rejection);
			};
	
			Promise.onPotentiallyUnhandledRejectionHandled = function(rejection) {
				enqueue(unreport, rejection);
			};
	
			Promise.onFatalRejection = function(rejection) {
				enqueue(throwit, rejection.value);
			};
	
			var tasks = [];
			var reported = [];
			var running = null;
	
			function report(r) {
				if(!r.handled) {
					reported.push(r);
					logError('Potentially unhandled rejection [' + r.id + '] ' + format.formatError(r.value));
				}
			}
	
			function unreport(r) {
				var i = reported.indexOf(r);
				if(i >= 0) {
					reported.splice(i, 1);
					logInfo('Handled previous rejection [' + r.id + '] ' + format.formatObject(r.value));
				}
			}
	
			function enqueue(f, x) {
				tasks.push(f, x);
				if(running === null) {
					running = setTimer(flush, 0);
				}
			}
	
			function flush() {
				running = null;
				while(tasks.length > 0) {
					tasks.shift()(tasks.shift());
				}
			}
	
			return Promise;
		};
	
		function throwit(e) {
			throw e;
		}
	
		function noop() {}
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return {
			formatError: formatError,
			formatObject: formatObject,
			tryStringify: tryStringify
		};
	
		/**
		 * Format an error into a string.  If e is an Error and has a stack property,
		 * it's returned.  Otherwise, e is formatted using formatObject, with a
		 * warning added about e not being a proper Error.
		 * @param {*} e
		 * @returns {String} formatted string, suitable for output to developers
		 */
		function formatError(e) {
			var s = typeof e === 'object' && e !== null && (e.stack || e.message) ? e.stack || e.message : formatObject(e);
			return e instanceof Error ? s : s + ' (WARNING: non-Error used)';
		}
	
		/**
		 * Format an object, detecting "plain" objects and running them through
		 * JSON.stringify if possible.
		 * @param {Object} o
		 * @returns {string}
		 */
		function formatObject(o) {
			var s = String(o);
			if(s === '[object Object]' && typeof JSON !== 'undefined') {
				s = tryStringify(o, s);
			}
			return s;
		}
	
		/**
		 * Try to return the result of JSON.stringify(x).  If that fails, return
		 * defaultValue
		 * @param {*} x
		 * @param {*} defaultValue
		 * @returns {String|*} JSON.stringify(x) or defaultValue
		 */
		function tryStringify(x, defaultValue) {
			try {
				return JSON.stringify(x);
			} catch(e) {
				return defaultValue;
			}
		}
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	
		var makePromise = __webpack_require__(479);
		var Scheduler = __webpack_require__(480);
		var async = __webpack_require__(463).asap;
	
		return makePromise({
			scheduler: new Scheduler(async)
		});
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(__webpack_require__(465));


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process) {/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		return function makePromise(environment) {
	
			var tasks = environment.scheduler;
			var emitRejection = initEmitRejection();
	
			var objectCreate = Object.create ||
				function(proto) {
					function Child() {}
					Child.prototype = proto;
					return new Child();
				};
	
			/**
			 * Create a promise whose fate is determined by resolver
			 * @constructor
			 * @returns {Promise} promise
			 * @name Promise
			 */
			function Promise(resolver, handler) {
				this._handler = resolver === Handler ? handler : init(resolver);
			}
	
			/**
			 * Run the supplied resolver
			 * @param resolver
			 * @returns {Pending}
			 */
			function init(resolver) {
				var handler = new Pending();
	
				try {
					resolver(promiseResolve, promiseReject, promiseNotify);
				} catch (e) {
					promiseReject(e);
				}
	
				return handler;
	
				/**
				 * Transition from pre-resolution state to post-resolution state, notifying
				 * all listeners of the ultimate fulfillment or rejection
				 * @param {*} x resolution value
				 */
				function promiseResolve (x) {
					handler.resolve(x);
				}
				/**
				 * Reject this promise with reason, which will be used verbatim
				 * @param {Error|*} reason rejection reason, strongly suggested
				 *   to be an Error type
				 */
				function promiseReject (reason) {
					handler.reject(reason);
				}
	
				/**
				 * @deprecated
				 * Issue a progress event, notifying all progress listeners
				 * @param {*} x progress event payload to pass to all listeners
				 */
				function promiseNotify (x) {
					handler.notify(x);
				}
			}
	
			// Creation
	
			Promise.resolve = resolve;
			Promise.reject = reject;
			Promise.never = never;
	
			Promise._defer = defer;
			Promise._handler = getHandler;
	
			/**
			 * Returns a trusted promise. If x is already a trusted promise, it is
			 * returned, otherwise returns a new trusted Promise which follows x.
			 * @param  {*} x
			 * @return {Promise} promise
			 */
			function resolve(x) {
				return isPromise(x) ? x
					: new Promise(Handler, new Async(getHandler(x)));
			}
	
			/**
			 * Return a reject promise with x as its reason (x is used verbatim)
			 * @param {*} x
			 * @returns {Promise} rejected promise
			 */
			function reject(x) {
				return new Promise(Handler, new Async(new Rejected(x)));
			}
	
			/**
			 * Return a promise that remains pending forever
			 * @returns {Promise} forever-pending promise.
			 */
			function never() {
				return foreverPendingPromise; // Should be frozen
			}
	
			/**
			 * Creates an internal {promise, resolver} pair
			 * @private
			 * @returns {Promise}
			 */
			function defer() {
				return new Promise(Handler, new Pending());
			}
	
			// Transformation and flow control
	
			/**
			 * Transform this promise's fulfillment value, returning a new Promise
			 * for the transformed result.  If the promise cannot be fulfilled, onRejected
			 * is called with the reason.  onProgress *may* be called with updates toward
			 * this promise's fulfillment.
			 * @param {function=} onFulfilled fulfillment handler
			 * @param {function=} onRejected rejection handler
			 * @param {function=} onProgress @deprecated progress handler
			 * @return {Promise} new promise
			 */
			Promise.prototype.then = function(onFulfilled, onRejected, onProgress) {
				var parent = this._handler;
				var state = parent.join().state();
	
				if ((typeof onFulfilled !== 'function' && state > 0) ||
					(typeof onRejected !== 'function' && state < 0)) {
					// Short circuit: value will not change, simply share handler
					return new this.constructor(Handler, parent);
				}
	
				var p = this._beget();
				var child = p._handler;
	
				parent.chain(child, parent.receiver, onFulfilled, onRejected, onProgress);
	
				return p;
			};
	
			/**
			 * If this promise cannot be fulfilled due to an error, call onRejected to
			 * handle the error. Shortcut for .then(undefined, onRejected)
			 * @param {function?} onRejected
			 * @return {Promise}
			 */
			Promise.prototype['catch'] = function(onRejected) {
				return this.then(void 0, onRejected);
			};
	
			/**
			 * Creates a new, pending promise of the same type as this promise
			 * @private
			 * @returns {Promise}
			 */
			Promise.prototype._beget = function() {
				return begetFrom(this._handler, this.constructor);
			};
	
			function begetFrom(parent, Promise) {
				var child = new Pending(parent.receiver, parent.join().context);
				return new Promise(Handler, child);
			}
	
			// Array combinators
	
			Promise.all = all;
			Promise.race = race;
			Promise._traverse = traverse;
	
			/**
			 * Return a promise that will fulfill when all promises in the
			 * input array have fulfilled, or will reject when one of the
			 * promises rejects.
			 * @param {array} promises array of promises
			 * @returns {Promise} promise for array of fulfillment values
			 */
			function all(promises) {
				return traverseWith(snd, null, promises);
			}
	
			/**
			 * Array<Promise<X>> -> Promise<Array<f(X)>>
			 * @private
			 * @param {function} f function to apply to each promise's value
			 * @param {Array} promises array of promises
			 * @returns {Promise} promise for transformed values
			 */
			function traverse(f, promises) {
				return traverseWith(tryCatch2, f, promises);
			}
	
			function traverseWith(tryMap, f, promises) {
				var handler = typeof f === 'function' ? mapAt : settleAt;
	
				var resolver = new Pending();
				var pending = promises.length >>> 0;
				var results = new Array(pending);
	
				for (var i = 0, x; i < promises.length && !resolver.resolved; ++i) {
					x = promises[i];
	
					if (x === void 0 && !(i in promises)) {
						--pending;
						continue;
					}
	
					traverseAt(promises, handler, i, x, resolver);
				}
	
				if(pending === 0) {
					resolver.become(new Fulfilled(results));
				}
	
				return new Promise(Handler, resolver);
	
				function mapAt(i, x, resolver) {
					if(!resolver.resolved) {
						traverseAt(promises, settleAt, i, tryMap(f, x, i), resolver);
					}
				}
	
				function settleAt(i, x, resolver) {
					results[i] = x;
					if(--pending === 0) {
						resolver.become(new Fulfilled(results));
					}
				}
			}
	
			function traverseAt(promises, handler, i, x, resolver) {
				if (maybeThenable(x)) {
					var h = getHandlerMaybeThenable(x);
					var s = h.state();
	
					if (s === 0) {
						h.fold(handler, i, void 0, resolver);
					} else if (s > 0) {
						handler(i, h.value, resolver);
					} else {
						resolver.become(h);
						visitRemaining(promises, i+1, h);
					}
				} else {
					handler(i, x, resolver);
				}
			}
	
			Promise._visitRemaining = visitRemaining;
			function visitRemaining(promises, start, handler) {
				for(var i=start; i<promises.length; ++i) {
					markAsHandled(getHandler(promises[i]), handler);
				}
			}
	
			function markAsHandled(h, handler) {
				if(h === handler) {
					return;
				}
	
				var s = h.state();
				if(s === 0) {
					h.visit(h, void 0, h._unreport);
				} else if(s < 0) {
					h._unreport();
				}
			}
	
			/**
			 * Fulfill-reject competitive race. Return a promise that will settle
			 * to the same state as the earliest input promise to settle.
			 *
			 * WARNING: The ES6 Promise spec requires that race()ing an empty array
			 * must return a promise that is pending forever.  This implementation
			 * returns a singleton forever-pending promise, the same singleton that is
			 * returned by Promise.never(), thus can be checked with ===
			 *
			 * @param {array} promises array of promises to race
			 * @returns {Promise} if input is non-empty, a promise that will settle
			 * to the same outcome as the earliest input promise to settle. if empty
			 * is empty, returns a promise that will never settle.
			 */
			function race(promises) {
				if(typeof promises !== 'object' || promises === null) {
					return reject(new TypeError('non-iterable passed to race()'));
				}
	
				// Sigh, race([]) is untestable unless we return *something*
				// that is recognizable without calling .then() on it.
				return promises.length === 0 ? never()
					 : promises.length === 1 ? resolve(promises[0])
					 : runRace(promises);
			}
	
			function runRace(promises) {
				var resolver = new Pending();
				var i, x, h;
				for(i=0; i<promises.length; ++i) {
					x = promises[i];
					if (x === void 0 && !(i in promises)) {
						continue;
					}
	
					h = getHandler(x);
					if(h.state() !== 0) {
						resolver.become(h);
						visitRemaining(promises, i+1, h);
						break;
					} else {
						h.visit(resolver, resolver.resolve, resolver.reject);
					}
				}
				return new Promise(Handler, resolver);
			}
	
			// Promise internals
			// Below this, everything is @private
	
			/**
			 * Get an appropriate handler for x, without checking for cycles
			 * @param {*} x
			 * @returns {object} handler
			 */
			function getHandler(x) {
				if(isPromise(x)) {
					return x._handler.join();
				}
				return maybeThenable(x) ? getHandlerUntrusted(x) : new Fulfilled(x);
			}
	
			/**
			 * Get a handler for thenable x.
			 * NOTE: You must only call this if maybeThenable(x) == true
			 * @param {object|function|Promise} x
			 * @returns {object} handler
			 */
			function getHandlerMaybeThenable(x) {
				return isPromise(x) ? x._handler.join() : getHandlerUntrusted(x);
			}
	
			/**
			 * Get a handler for potentially untrusted thenable x
			 * @param {*} x
			 * @returns {object} handler
			 */
			function getHandlerUntrusted(x) {
				try {
					var untrustedThen = x.then;
					return typeof untrustedThen === 'function'
						? new Thenable(untrustedThen, x)
						: new Fulfilled(x);
				} catch(e) {
					return new Rejected(e);
				}
			}
	
			/**
			 * Handler for a promise that is pending forever
			 * @constructor
			 */
			function Handler() {}
	
			Handler.prototype.when
				= Handler.prototype.become
				= Handler.prototype.notify // deprecated
				= Handler.prototype.fail
				= Handler.prototype._unreport
				= Handler.prototype._report
				= noop;
	
			Handler.prototype._state = 0;
	
			Handler.prototype.state = function() {
				return this._state;
			};
	
			/**
			 * Recursively collapse handler chain to find the handler
			 * nearest to the fully resolved value.
			 * @returns {object} handler nearest the fully resolved value
			 */
			Handler.prototype.join = function() {
				var h = this;
				while(h.handler !== void 0) {
					h = h.handler;
				}
				return h;
			};
	
			Handler.prototype.chain = function(to, receiver, fulfilled, rejected, progress) {
				this.when({
					resolver: to,
					receiver: receiver,
					fulfilled: fulfilled,
					rejected: rejected,
					progress: progress
				});
			};
	
			Handler.prototype.visit = function(receiver, fulfilled, rejected, progress) {
				this.chain(failIfRejected, receiver, fulfilled, rejected, progress);
			};
	
			Handler.prototype.fold = function(f, z, c, to) {
				this.when(new Fold(f, z, c, to));
			};
	
			/**
			 * Handler that invokes fail() on any handler it becomes
			 * @constructor
			 */
			function FailIfRejected() {}
	
			inherit(Handler, FailIfRejected);
	
			FailIfRejected.prototype.become = function(h) {
				h.fail();
			};
	
			var failIfRejected = new FailIfRejected();
	
			/**
			 * Handler that manages a queue of consumers waiting on a pending promise
			 * @constructor
			 */
			function Pending(receiver, inheritedContext) {
				Promise.createContext(this, inheritedContext);
	
				this.consumers = void 0;
				this.receiver = receiver;
				this.handler = void 0;
				this.resolved = false;
			}
	
			inherit(Handler, Pending);
	
			Pending.prototype._state = 0;
	
			Pending.prototype.resolve = function(x) {
				this.become(getHandler(x));
			};
	
			Pending.prototype.reject = function(x) {
				if(this.resolved) {
					return;
				}
	
				this.become(new Rejected(x));
			};
	
			Pending.prototype.join = function() {
				if (!this.resolved) {
					return this;
				}
	
				var h = this;
	
				while (h.handler !== void 0) {
					h = h.handler;
					if (h === this) {
						return this.handler = cycle();
					}
				}
	
				return h;
			};
	
			Pending.prototype.run = function() {
				var q = this.consumers;
				var handler = this.handler;
				this.handler = this.handler.join();
				this.consumers = void 0;
	
				for (var i = 0; i < q.length; ++i) {
					handler.when(q[i]);
				}
			};
	
			Pending.prototype.become = function(handler) {
				if(this.resolved) {
					return;
				}
	
				this.resolved = true;
				this.handler = handler;
				if(this.consumers !== void 0) {
					tasks.enqueue(this);
				}
	
				if(this.context !== void 0) {
					handler._report(this.context);
				}
			};
	
			Pending.prototype.when = function(continuation) {
				if(this.resolved) {
					tasks.enqueue(new ContinuationTask(continuation, this.handler));
				} else {
					if(this.consumers === void 0) {
						this.consumers = [continuation];
					} else {
						this.consumers.push(continuation);
					}
				}
			};
	
			/**
			 * @deprecated
			 */
			Pending.prototype.notify = function(x) {
				if(!this.resolved) {
					tasks.enqueue(new ProgressTask(x, this));
				}
			};
	
			Pending.prototype.fail = function(context) {
				var c = typeof context === 'undefined' ? this.context : context;
				this.resolved && this.handler.join().fail(c);
			};
	
			Pending.prototype._report = function(context) {
				this.resolved && this.handler.join()._report(context);
			};
	
			Pending.prototype._unreport = function() {
				this.resolved && this.handler.join()._unreport();
			};
	
			/**
			 * Wrap another handler and force it into a future stack
			 * @param {object} handler
			 * @constructor
			 */
			function Async(handler) {
				this.handler = handler;
			}
	
			inherit(Handler, Async);
	
			Async.prototype.when = function(continuation) {
				tasks.enqueue(new ContinuationTask(continuation, this));
			};
	
			Async.prototype._report = function(context) {
				this.join()._report(context);
			};
	
			Async.prototype._unreport = function() {
				this.join()._unreport();
			};
	
			/**
			 * Handler that wraps an untrusted thenable and assimilates it in a future stack
			 * @param {function} then
			 * @param {{then: function}} thenable
			 * @constructor
			 */
			function Thenable(then, thenable) {
				Pending.call(this);
				tasks.enqueue(new AssimilateTask(then, thenable, this));
			}
	
			inherit(Pending, Thenable);
	
			/**
			 * Handler for a fulfilled promise
			 * @param {*} x fulfillment value
			 * @constructor
			 */
			function Fulfilled(x) {
				Promise.createContext(this);
				this.value = x;
			}
	
			inherit(Handler, Fulfilled);
	
			Fulfilled.prototype._state = 1;
	
			Fulfilled.prototype.fold = function(f, z, c, to) {
				runContinuation3(f, z, this, c, to);
			};
	
			Fulfilled.prototype.when = function(cont) {
				runContinuation1(cont.fulfilled, this, cont.receiver, cont.resolver);
			};
	
			var errorId = 0;
	
			/**
			 * Handler for a rejected promise
			 * @param {*} x rejection reason
			 * @constructor
			 */
			function Rejected(x) {
				Promise.createContext(this);
	
				this.id = ++errorId;
				this.value = x;
				this.handled = false;
				this.reported = false;
	
				this._report();
			}
	
			inherit(Handler, Rejected);
	
			Rejected.prototype._state = -1;
	
			Rejected.prototype.fold = function(f, z, c, to) {
				to.become(this);
			};
	
			Rejected.prototype.when = function(cont) {
				if(typeof cont.rejected === 'function') {
					this._unreport();
				}
				runContinuation1(cont.rejected, this, cont.receiver, cont.resolver);
			};
	
			Rejected.prototype._report = function(context) {
				tasks.afterQueue(new ReportTask(this, context));
			};
	
			Rejected.prototype._unreport = function() {
				if(this.handled) {
					return;
				}
				this.handled = true;
				tasks.afterQueue(new UnreportTask(this));
			};
	
			Rejected.prototype.fail = function(context) {
				this.reported = true;
				emitRejection('unhandledRejection', this);
				Promise.onFatalRejection(this, context === void 0 ? this.context : context);
			};
	
			function ReportTask(rejection, context) {
				this.rejection = rejection;
				this.context = context;
			}
	
			ReportTask.prototype.run = function() {
				if(!this.rejection.handled && !this.rejection.reported) {
					this.rejection.reported = true;
					emitRejection('unhandledRejection', this.rejection) ||
						Promise.onPotentiallyUnhandledRejection(this.rejection, this.context);
				}
			};
	
			function UnreportTask(rejection) {
				this.rejection = rejection;
			}
	
			UnreportTask.prototype.run = function() {
				if(this.rejection.reported) {
					emitRejection('rejectionHandled', this.rejection) ||
						Promise.onPotentiallyUnhandledRejectionHandled(this.rejection);
				}
			};
	
			// Unhandled rejection hooks
			// By default, everything is a noop
	
			Promise.createContext
				= Promise.enterContext
				= Promise.exitContext
				= Promise.onPotentiallyUnhandledRejection
				= Promise.onPotentiallyUnhandledRejectionHandled
				= Promise.onFatalRejection
				= noop;
	
			// Errors and singletons
	
			var foreverPendingHandler = new Handler();
			var foreverPendingPromise = new Promise(Handler, foreverPendingHandler);
	
			function cycle() {
				return new Rejected(new TypeError('Promise cycle'));
			}
	
			// Task runners
	
			/**
			 * Run a single consumer
			 * @constructor
			 */
			function ContinuationTask(continuation, handler) {
				this.continuation = continuation;
				this.handler = handler;
			}
	
			ContinuationTask.prototype.run = function() {
				this.handler.join().when(this.continuation);
			};
	
			/**
			 * Run a queue of progress handlers
			 * @constructor
			 */
			function ProgressTask(value, handler) {
				this.handler = handler;
				this.value = value;
			}
	
			ProgressTask.prototype.run = function() {
				var q = this.handler.consumers;
				if(q === void 0) {
					return;
				}
	
				for (var c, i = 0; i < q.length; ++i) {
					c = q[i];
					runNotify(c.progress, this.value, this.handler, c.receiver, c.resolver);
				}
			};
	
			/**
			 * Assimilate a thenable, sending it's value to resolver
			 * @param {function} then
			 * @param {object|function} thenable
			 * @param {object} resolver
			 * @constructor
			 */
			function AssimilateTask(then, thenable, resolver) {
				this._then = then;
				this.thenable = thenable;
				this.resolver = resolver;
			}
	
			AssimilateTask.prototype.run = function() {
				var h = this.resolver;
				tryAssimilate(this._then, this.thenable, _resolve, _reject, _notify);
	
				function _resolve(x) { h.resolve(x); }
				function _reject(x)  { h.reject(x); }
				function _notify(x)  { h.notify(x); }
			};
	
			function tryAssimilate(then, thenable, resolve, reject, notify) {
				try {
					then.call(thenable, resolve, reject, notify);
				} catch (e) {
					reject(e);
				}
			}
	
			/**
			 * Fold a handler value with z
			 * @constructor
			 */
			function Fold(f, z, c, to) {
				this.f = f; this.z = z; this.c = c; this.to = to;
				this.resolver = failIfRejected;
				this.receiver = this;
			}
	
			Fold.prototype.fulfilled = function(x) {
				this.f.call(this.c, this.z, x, this.to);
			};
	
			Fold.prototype.rejected = function(x) {
				this.to.reject(x);
			};
	
			Fold.prototype.progress = function(x) {
				this.to.notify(x);
			};
	
			// Other helpers
	
			/**
			 * @param {*} x
			 * @returns {boolean} true iff x is a trusted Promise
			 */
			function isPromise(x) {
				return x instanceof Promise;
			}
	
			/**
			 * Test just enough to rule out primitives, in order to take faster
			 * paths in some code
			 * @param {*} x
			 * @returns {boolean} false iff x is guaranteed *not* to be a thenable
			 */
			function maybeThenable(x) {
				return (typeof x === 'object' || typeof x === 'function') && x !== null;
			}
	
			function runContinuation1(f, h, receiver, next) {
				if(typeof f !== 'function') {
					return next.become(h);
				}
	
				Promise.enterContext(h);
				tryCatchReject(f, h.value, receiver, next);
				Promise.exitContext();
			}
	
			function runContinuation3(f, x, h, receiver, next) {
				if(typeof f !== 'function') {
					return next.become(h);
				}
	
				Promise.enterContext(h);
				tryCatchReject3(f, x, h.value, receiver, next);
				Promise.exitContext();
			}
	
			/**
			 * @deprecated
			 */
			function runNotify(f, x, h, receiver, next) {
				if(typeof f !== 'function') {
					return next.notify(x);
				}
	
				Promise.enterContext(h);
				tryCatchReturn(f, x, receiver, next);
				Promise.exitContext();
			}
	
			function tryCatch2(f, a, b) {
				try {
					return f(a, b);
				} catch(e) {
					return reject(e);
				}
			}
	
			/**
			 * Return f.call(thisArg, x), or if it throws return a rejected promise for
			 * the thrown exception
			 */
			function tryCatchReject(f, x, thisArg, next) {
				try {
					next.become(getHandler(f.call(thisArg, x)));
				} catch(e) {
					next.become(new Rejected(e));
				}
			}
	
			/**
			 * Same as above, but includes the extra argument parameter.
			 */
			function tryCatchReject3(f, x, y, thisArg, next) {
				try {
					f.call(thisArg, x, y, next);
				} catch(e) {
					next.become(new Rejected(e));
				}
			}
	
			/**
			 * @deprecated
			 * Return f.call(thisArg, x), or if it throws, *return* the exception
			 */
			function tryCatchReturn(f, x, thisArg, next) {
				try {
					next.notify(f.call(thisArg, x));
				} catch(e) {
					next.notify(e);
				}
			}
	
			function inherit(Parent, Child) {
				Child.prototype = objectCreate(Parent.prototype);
				Child.prototype.constructor = Child;
			}
	
			function snd(x, y) {
				return y;
			}
	
			function noop() {}
	
			function initEmitRejection() {
				/*global process, self, CustomEvent*/
				if(typeof process !== 'undefined' && process !== null
					&& typeof process.emit === 'function') {
					// Returning falsy here means to call the default
					// onPotentiallyUnhandledRejection API.  This is safe even in
					// browserify since process.emit always returns falsy in browserify:
					// https://github.com/defunctzombie/node-process/blob/master/browser.js#L40-L46
					return function(type, rejection) {
						return type === 'unhandledRejection'
							? process.emit(type, rejection.value, rejection)
							: process.emit(type, rejection);
					};
				} else if(typeof self !== 'undefined' && typeof CustomEvent === 'function') {
					return (function(noop, self, CustomEvent) {
						var hasCustomEvent = false;
						try {
							var ev = new CustomEvent('unhandledRejection');
							hasCustomEvent = ev instanceof CustomEvent;
						} catch (e) {}
	
						return !hasCustomEvent ? noop : function(type, rejection) {
							var ev = new CustomEvent(type, {
								detail: {
									reason: rejection.value,
									key: rejection
								},
								bubbles: false,
								cancelable: true
							});
	
							return !self.dispatchEvent(ev);
						};
					}(noop, self, CustomEvent));
				}
	
				return noop;
			}
	
			return Promise;
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(295)))

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/** @license MIT License (c) copyright 2010-2014 original author or authors */
	/** @author Brian Cavalier */
	/** @author John Hann */
	
	(function(define) { 'use strict';
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
		// Credit to Twisol (https://github.com/Twisol) for suggesting
		// this type of extensible queue + trampoline approach for next-tick conflation.
	
		/**
		 * Async task scheduler
		 * @param {function} async function to schedule a single async function
		 * @constructor
		 */
		function Scheduler(async) {
			this._async = async;
			this._running = false;
	
			this._queue = this;
			this._queueLen = 0;
			this._afterQueue = {};
			this._afterQueueLen = 0;
	
			var self = this;
			this.drain = function() {
				self._drain();
			};
		}
	
		/**
		 * Enqueue a task
		 * @param {{ run:function }} task
		 */
		Scheduler.prototype.enqueue = function(task) {
			this._queue[this._queueLen++] = task;
			this.run();
		};
	
		/**
		 * Enqueue a task to run after the main task queue
		 * @param {{ run:function }} task
		 */
		Scheduler.prototype.afterQueue = function(task) {
			this._afterQueue[this._afterQueueLen++] = task;
			this.run();
		};
	
		Scheduler.prototype.run = function() {
			if (!this._running) {
				this._running = true;
				this._async(this.drain);
			}
		};
	
		/**
		 * Drain the handler queue entirely, and then the after queue
		 */
		Scheduler.prototype._drain = function() {
			var i = 0;
			for (; i < this._queueLen; ++i) {
				this._queue[i].run();
				this._queue[i] = void 0;
			}
	
			this._queueLen = 0;
			this._running = false;
	
			for (i = 0; i < this._afterQueueLen; ++i) {
				this._afterQueue[i].run();
				this._afterQueue[i] = void 0;
			}
	
			this._afterQueueLen = 0;
		};
	
		return Scheduler;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}(__webpack_require__(465)));


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(460)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, d3) {
	    'use strict';
	
	    var defaults = {
	
	        title: "Awesome Graph",
	        width: 400,
	        height: 400,
	        labels: {
	            x: 'X axis label',
	            y: 'Y axis label'
	        },
	        margins: {
	            top: 60,
	            right: 40,
	            left: 80,
	            bottom: 60
	        },
	        xrange: [0, 1],
	        yrange: [0, 1],
	        // See https://github.com/mbostock/d3/wiki/Formatting#wiki-d3_format
	        format: {
	            x: '.02f',
	            y: '.02f',
	            z: '.1f'
	        },
	
	        // use antialiasing when scaling the data
	        antialias: true,
	
	        //show log plot
	        logplot: false,
	
	        // use a d3 scale to control the color mapping
	        // colorScale: d3.scale.linear()
	        colorScale: function colorScale(logplot, zrangeArr) {
	            var colorsc;
	            if (logplot) {
	                //make sure we don't set any of the domain values to 0.
	                if (zrangeArr[0] === 0) {
	                    zrangeArr[0] = 0.01;
	                }
	                if (zrangeArr[1] === 0) {
	                    zrangeArr[1] = 0.01;
	                }
	
	                colorsc = d3.scale.log().domain(zrangeArr).interpolate(d3.interpolateLab).range(["hsl(210, 100%, 100%)", "hsl(210, 29%, 29%)"]);
	                // .interpolate(d3.interpolateLab);
	            } else {
	                colorsc = d3.scale.linear().domain(zrangeArr).range(["hsl(210, 100%, 100%)", "hsl(210, 29%, 29%)"]).interpolate(d3.interpolateLab);
	            }
	
	            return colorsc;
	        }
	
	    };
	
	    function create2DArray(data, dimx, dimy) {
	        var data2D = [];
	        var index = 0;
	
	        for (var i = 0; i < dimy; i++) {
	
	            var row = new Float64Array(dimx);
	
	            for (var j = 0; j < dimx; j++) {
	                row[j] = data[index];
	                index += 1;
	            }
	
	            data2D[i] = row;
	        }
	
	        return data2D;
	    }
	
	    function HeatMap(options) {
	
	        var self = this;
	        options = $.extend({}, defaults, options);
	        this.labels = options.labels;
	        this.antialias = options.antialias;
	
	        this.el = $('<div>').addClass('plot heat-map').appendTo(options.el).css('position', 'relative');
	
	        this.elTitle = $('<label>').addClass('title').appendTo(this.el).css({
	            'position': 'absolute',
	            'top': '0',
	            'left': '0'
	        });
	
	        this.setTitle(options.title);
	
	        this.svg = d3.select(this.el.get(0)).append("svg");
	        $(this.svg.node()).css({
	            'position': 'absolute',
	            'top': 0,
	            'left': 0,
	            'width': '100%',
	            'height': '100%',
	            zIndex: 2
	        });
	        this.svgAxis = this.svg.append("g").classed('axis-box', true);
	
	        this.canvas = document.createElement('canvas');
	        this.el.append($(this.canvas).css('zIndex', 1).css('position', 'relative'));
	        this.hiddenCanvas = document.createElement('canvas');
	
	        this.logplot = options.logplot;
	
	        // init scales
	
	        if (this.logplot) {
	            this.scales = {
	                x: d3.scale.linear().domain(options.xrange),
	                y: d3.scale.linear().domain(options.yrange),
	                z: options.colorScale(this.logplot, [0.0001, 1]).copy()
	            };
	        } else {
	            this.scales = {
	                x: d3.scale.linear().domain(options.xrange),
	                y: d3.scale.linear().domain(options.yrange),
	                z: options.colorScale(this.logplot, [0, 1]).copy()
	            };
	        }
	
	        this.margin = defaults.margins;
	
	        this.setFormat(options.format); // problem line
	
	        this.resize(options.width, options.height);
	        this.setMargins(options.margins);
	
	        this.hiddenCtx = this.hiddenCanvas.getContext('2d');
	        this.ctx = this.canvas.getContext('2d');
	
	        var calcXindex = function calcXindex(val) {
	            var range = self.scales.x.domain();
	            var index = Math.floor((val - range[0]) / (range[1] - range[0]) * self.cols);
	
	            return index;
	        };
	
	        var calcYindex = function calcYindex(val) {
	            var range = self.scales.y.domain();
	            var index = Math.floor((val - range[0]) / (range[1] - range[0]) * self.rows);
	
	            return index;
	        };
	
	        $(this.el).on('mousemove', function (e) {
	            var offset = $(self.canvas).offset();
	
	            var x = e.pageX - offset.left;
	            var y = e.pageY - offset.top;
	            self.el.css("cursor", "auto");
	
	            if (x >= 0 && y >= 0 && x < self.width && y < self.height) {
	                self.el.css("cursor", "crosshair");
	                var xcoord = self.scales.x.invert(e.pageX - offset.left);
	                var ycoord = self.scales.y.invert(e.pageY - offset.top);
	                var indexX = calcXindex(xcoord);
	                var indexY = calcYindex(ycoord);
	                var zcoord = self.data[self.cols * (self.cols - indexY - 1) + indexX];
	
	                self.setTitle('Coordinates: (' + xcoord.toFixed(3) + ', ' + ycoord.toFixed(3) + ', ' + zcoord.toFixed(3) + ')');
	            }
	        });
	
	        $(this.el).on('mouseenter', function (e) {
	            self.backuptitle = self.elTitle.text();
	        });
	
	        $(this.el).on('mouseleave', function (e) {
	            self.setTitle(self.backuptitle);
	        });
	    }
	    // mouseenter
	    // mouseleave
	    // CSS:
	    // .heatmap canvas {
	    // cursor: crosshair;
	
	    HeatMap.prototype = {
	
	        setFormat: function setFormat(fmt) {
	
	            this.format = {};
	
	            if ((typeof fmt === 'undefined' ? 'undefined' : _typeof(fmt)) === 'object') {
	
	                this.format = $.extend(this.format, fmt);
	            } else {
	
	                this.format.x = fmt;
	                this.format.y = fmt;
	                this.format.z = fmt;
	            }
	
	            this.refreshAxes();
	        },
	
	        setTitle: function setTitle(title) {
	
	            this.elTitle.text(title);
	        },
	
	        setMargins: function setMargins(cfg) {
	
	            var margin = this.margin = $.extend({}, this.margin, cfg),
	                w = this.width,
	                h = this.height;
	
	            this.el.css({
	                'padding': [margin.top, margin.right, margin.bottom, margin.left].join('px ') + 'px'
	            });
	
	            this.elTitle.css({
	                'top': margin.top,
	                'margin-top': '-2.4em',
	                'left': margin.left
	            });
	
	            this.svgAxis.attr("transform", "translate(" + margin.left + "," + margin.top + ")");
	
	            this.resize(w, h);
	        },
	
	        resize: function resize(w, h) {
	
	            if (!h) {
	                h = this.height / this.width * w;
	            }
	
	            this.el.css({
	                'width': w + 'px',
	                'height': h + 'px'
	            });
	
	            this.width = w;
	            this.height = h;
	
	            this.canvas.width = w;
	            this.canvas.height = h;
	            this.hiddenCanvas.width = w;
	            this.hiddenCanvas.height = h;
	
	            this.scales.x.range([0, w]);
	            this.scales.y.range([h, 0]);
	
	            this.refreshAxes();
	        },
	
	        // these only make cosmetic changes...
	        setXRange: function setXRange(xrangeArr) {
	
	            this.scales.x.domain(xrangeArr);
	            this.refreshAxes();
	        },
	
	        setYRange: function setYRange(yrangeArr) {
	
	            // yes, it should be domain here. not range
	            this.scales.y.domain(yrangeArr);
	            this.refreshAxes();
	        },
	
	        setZRange: function setZRange(zrangeArr) {
	            // this.scales.z.domain( zrangeArr );
	            this.scales.z = defaults.colorScale(this.logplot, zrangeArr).copy();
	            this.refreshAxes();
	        },
	
	        setLogPlot: function setLogPlot(bool) {
	            this.logplot = bool;
	
	            this.scales.z = defaults.colorScale(this.logplot, this.scales.z.domain()).copy();
	            // this.refreshAxes();
	            this.plotData(this.data);
	            this.refreshAxes();
	        },
	
	        getLogPlot: function getLogPlot() {
	            return this.logplot;
	        },
	
	        refreshAxes: function refreshAxes() {
	            // Check for edge initialization cases
	            if (this.width === undefined) {
	                this.width = 400;
	            }
	
	            if (this.height === undefined) {
	                this.height = 400;
	            }
	
	            var self = this,
	                svg = this.svgAxis,
	                x = this.scales.x,
	                y = this.scales.y
	            // ,z = this.scales.z
	            ,
	                z = defaults.colorScale(this.logplot, this.scales.z.domain()).copy(),
	                labels = this.labels,
	                width = this.width,
	                height = this.height;
	
	            // init axes
	            var xAxis = d3.svg.axis().scale(x).tickFormat(d3.format(this.format.x)).orient("bottom").ticks(width / 80 | 0).tickSubdivide(5).tickSize(6, 3, 0);
	
	            var yAxis = d3.svg.axis().scale(y).tickFormat(d3.format(this.format.y)).orient("left").ticks(height / 80 | 0).tickSubdivide(5).tickSize(6, 3, 0);
	
	            svg.selectAll('.axis').remove();
	
	            svg.append("g").attr("class", "x axis").attr("transform", "translate(0, " + height + ")").call(xAxis).append("text").attr("y", 0).attr("dy", this.margin.bottom - 16).attr("x", width / 2).style("text-anchor", "middle").text(labels.x);
	
	            svg.append("g").attr("class", "y axis").call(yAxis).append("text").attr("x", -height / 2).attr("y", 0).attr("transform", "rotate(-90)").attr("dy", -this.margin.left + 16).style("text-anchor", "middle").text(labels.y);
	
	            var colorBarWidth = 100;
	            var colorBarHeight = 12;
	            var dom = z.domain();
	            var colorBarVals = d3.range(dom[0], dom[1], Math.abs(dom[1] - dom[0]) / colorBarWidth);
	            var xColorBar = d3.scale.ordinal().domain(colorBarVals).rangeRoundBands([0, colorBarWidth], 0);
	
	            var colorbar = svg.append("g").attr("class", "z axis").attr('transform', 'translate(' + [width - colorBarWidth, -2 * colorBarHeight].join(',') + ')');
	
	            // This is a hacky way to replace the xColorBar from d3.js which occasionally fails.
	            var xpos = 0;
	            var xColorBarPos = function xColorBarPos() {
	                xpos = xpos + colorBarWidth / colorBarVals.length;
	                return xpos;
	            };
	
	            var barwidth = colorBarWidth / colorBarVals.length;
	
	            colorbar.selectAll('rect').data(colorBarVals).enter().append("rect")
	            // .attr("x", xColorBar)
	            .attr("x", function (x) {
	                return xColorBarPos();
	            }).attr("width", barwidth)
	            // .attr("width", xColorBar.rangeBand())
	            .attr("height", colorBarHeight).style("fill", function (v) {
	                return z(v);
	            });
	
	            // border around
	            colorbar.append('rect').attr('width', colorBarWidth).attr('height', colorBarHeight).style('fill', 'none').style('stroke', '#000').style('shape-rendering', 'crispEdges');
	
	            var vals = [].concat(dom);
	            var zAxis;
	            if (this.logplot) {
	                vals.splice(1, 0, dom[0] + dom[1] / 10);
	                zAxis = d3.svg.axis()
	                // .scale( d3.scale.linear().domain( dom ).range([0, colorBarWidth]) )
	                .scale(d3.scale.log().domain(dom).range([0, colorBarWidth])).tickValues(vals).tickFormat(d3.format('.2f')).orient("top");
	            } else {
	                vals.splice(1, 0, (dom[1] - dom[0]) / 2 + dom[0]);
	                zAxis = d3.svg.axis().scale(d3.scale.linear().domain(dom).range([0, colorBarWidth])).tickValues(vals).tickFormat(d3.format('.2f')).orient("top");
	            }
	
	            // var zAxis = d3.svg.axis()
	            //     // .scale( d3.scale.linear().domain( dom ).range([0, colorBarWidth]) )
	            //     .scale( d3.scale.log().domain( dom ).range([0, colorBarWidth]) )
	            //     .tickValues( vals )
	            //     .tickFormat( d3.format( '.1f' ) )
	            //     .orient("top")
	            //     ;
	
	            colorbar.call(zAxis);
	        },
	
	        getCanvas: function getCanvas() {
	
	            return this.canvas;
	        },
	
	        setColorScale: function setColorScale(fn) {
	
	            this.scales.z = fn || defaults.colorScale.copy();
	            this.refreshAxes();
	        },
	
	        makeImageData: function makeImageData(width, height, data) {
	
	            var img = this.hiddenCtx.getImageData(0, 0, width, height)
	            // ,colorScale = this.scales.z
	            ,
	                colorScale = defaults.colorScale(this.logplot, this.scales.z.domain()).copy(),
	                val,
	                idx,
	                color;
	
	            // for every data point, get its color
	            // and write the pixel data
	            for (var i = 0, l = data.length; i < l; ++i) {
	
	                val = data[i];
	                if (isNaN(val)) {
	                    val = Math.min.apply(null, this.scales.z.domain());
	                }
	                color = d3.rgb(colorScale(val));
	                idx = 4 * i;
	                img.data[idx] = color.r; //red
	                img.data[idx + 1] = color.g; //green
	                img.data[idx + 2] = color.b; //blue
	                img.data[idx + 3] = 255; //alpha
	            }
	
	            return img;
	        },
	
	        exportData: function exportData() {
	
	            if (!this.data) {
	                return [];
	            }
	
	            var data = this.data,
	                l = data.length,
	                cols = this.width,
	                rows = this.height,
	                scale = Math.sqrt(l) / Math.sqrt(cols * rows),
	                i,
	                xvals = [],
	                yvals = [],
	                x = this.scales.x,
	                y = this.scales.y;
	
	            cols *= scale;
	            rows *= scale;
	
	            cols = Math.floor(cols);
	            rows = Math.floor(rows);
	
	            scale = Math.sqrt((cols - 1) * (rows - 1)) / Math.sqrt(this.width * this.height);
	
	            for (var _i = 0; _i < cols; ++_i) {
	
	                xvals.push(x.invert(_i / scale));
	            }
	
	            for (var _i2 = 0; _i2 < rows; ++_i2) {
	
	                yvals.push(y.invert(_i2 / scale));
	            }
	            // console.log("Exporting DATA", create2DArray( data, cols, rows ));
	
	            return {
	                title: this.elTitle.text(),
	                type: 'heat-map',
	                x: {
	                    label: this.labels.x,
	                    values: xvals,
	                    length: cols
	                },
	                y: {
	                    label: this.labels.y,
	                    values: yvals,
	                    length: rows
	                },
	                data: create2DArray(data, cols, rows)
	            };
	        },
	
	        scaleImageData: function scaleImageData(srcImg, width, height, scale) {
	
	            var src_p = 0;
	            var dst_p = 0;
	            var imgdata = this.ctx.createImageData(scale * width, scale * height);
	            var d = imgdata.data;
	            var src = srcImg.data;
	
	            for (var y = 0; y < height; ++y) {
	                for (var i = 0; i < scale; ++i) {
	                    for (var x = 0; x < width; ++x) {
	                        src_p = 4 * (y * width + x);
	                        for (var j = 0; j < scale; ++j) {
	                            var tmp = src_p;
	                            d[dst_p++] = src[tmp++];
	                            d[dst_p++] = src[tmp++];
	                            d[dst_p++] = src[tmp++];
	                            d[dst_p++] = src[tmp++];
	                        }
	                    }
	                }
	            }
	
	            return imgdata;
	        },
	
	        plotData: function plotData(data) {
	
	            var l = data.length,
	                cols = this.width,
	                rows = this.height,
	                scale = Math.sqrt(l / (cols * rows)),
	                img;
	
	            this.data = data;
	
	            cols *= scale;
	            rows *= scale;
	
	            cols = Math.floor(cols);
	            rows = Math.floor(rows);
	
	            this.cols = cols;
	            this.rows = rows;
	
	            // write the image data to the hidden canvas
	            img = this.makeImageData(cols, rows, data);
	
	            if (this.antialias) {
	
	                this.hiddenCtx.putImageData(img, 0, 0);
	
	                // draw to the visible canvas
	                this.ctx.save();
	
	                if (scale < 1) {
	                    // scale it if necessary
	                    this.ctx.scale(1 / scale, 1 / scale);
	                }
	
	                this.ctx.drawImage(this.hiddenCanvas, 0, 0);
	                this.ctx.restore();
	            } else {
	
	                var invScale = Math.floor(1 / scale);
	                this.ctx.putImageData(this.scaleImageData(img, cols, rows, invScale), 0, 0);
	            }
	        }
	    };
	
	    return HeatMap;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(456), __webpack_require__(457), __webpack_require__(483), __webpack_require__(455), __webpack_require__(484), __webpack_require__(485)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, converter, Panel, ddmenu, customCheckbox, W, tplPlotMenu) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var to;
	    var defaults = {};
	
	    /**
	     * @module SkeletonUI
	     * @implements {Stapes}
	     */
	    var SkeletonUI = Stapes.subclass({
	
	        /**
	         * Mediator Constructor
	         * @return {void}
	         */
	        constructor: function constructor(config) {
	
	            var self = this;
	
	            self.options = $.extend({}, defaults, config);
	
	            if (!self.tplPlots) {
	                throw 'Specify the property tplPlots: template in the submodule class definition';
	            }
	
	            self.tplPlots.converter = converter;
	
	            self.el = $(self.tplPlots());
	
	            self.elPlotOpts = $('<div>');
	            self.plots = [];
	            self.initPlots();
	        },
	
	        initPlots: function initPlots() {
	
	            throw 'You must override the initPlots() method.';
	        },
	
	        addPlot: function addPlot(plot) {
	
	            var self = this,
	                plots = self.plots;
	
	            plots.push(plot);
	
	            self.addPlotMenu(plot);
	        },
	
	        addPlotMenu: function addPlotMenu(plot) {
	
	            var self = this;
	
	            plot.el.prepend(tplPlotMenu({}));
	
	            var dd = plot.el.find('.dropdown');
	
	            ddmenu(dd);
	
	            dd.on('click', '.export-csv-ctrl', function (e) {
	
	                self.emit('export-csv', plot.exportData());
	            });
	
	            dd.on('click', '.log-plot-ctrl', function (e) {
	
	                // self.emit('log-plot', function(){
	                // console.log('inside emit', plot.getLogPlot());
	                if (plot.getLogPlot() === true) {
	                    plot.setLogPlot(false);
	                } else if (plot.getLogPlot() === false) {
	                    plot.setLogPlot(true);
	                }
	            });
	        },
	
	        /**
	         * Connect to main app
	         * @return {void}
	         */
	        connect: function connect(app) {
	
	            var self = this;
	
	            self.parameters = app.parameters;
	            self.plotOpts = app.plotOpts;
	            self.initWorkers(self.nWorkers);
	
	            // connect to the app events
	            app.on({
	
	                calculate: self.refresh
	
	            }, self);
	
	            app.plotOpts.els.find('[id^="plot-opt-"]').hide();
	            // show plot opts if needed
	            if (self.showPlotOpts) {
	                app.plotOpts.els.find('#plot-opt-' + self.showPlotOpts.join(',#plot-opt-')).show();
	            }
	
	            // auto draw
	
	            self.autocalcPlotOpts();
	
	            self.refresh();
	        },
	
	        disconnect: function disconnect(app) {
	
	            var self = this;
	
	            // close all workers
	            self.initWorkers(0);
	            // disconnect from app events
	            app.off('calculate', self.refresh);
	        },
	
	        initWorkers: function initWorkers(n) {
	
	            var self = this,
	                leftovers;
	
	            self.workers = self.workers || [];
	
	            if (self.workers.length > n) {
	                leftovers = self.workers.splice(0, self.workers.length - n);
	                for (var i = 0, l = leftovers.length; i < l; ++i) {
	
	                    leftovers[i].destroy();
	                }
	            } else {
	                while (self.workers.length < n) {
	                    self.workers.push(pmWorker.spawn());
	                }
	            }
	
	            return self;
	        },
	
	        resize: function resize() {
	
	            // var self = this
	            //     ,par = self.el.parent()
	            //     ,width = par.width()
	            //     ,height = $(window).height()
	            //     ,dim = Math.min( width, height ) - 100 // - margin
	            //     ;
	
	            // if (dim > 400){
	            //     dim = 400;
	            // }
	
	            // for ( var i = 0, l = self.plots.length; i < l; ++i ){
	
	            //     self.plots[ i ].resize( dim );
	            // }
	
	            // self.draw();
	        },
	
	        getMainPanel: function getMainPanel() {
	            return this.el;
	        },
	
	        refresh: function refresh() {
	
	            var self = this;
	            self.calculating = true;
	
	            if (self.plotOpts.get('autocalc_plotopts')) {
	                self.autocalcPlotOpts();
	            }
	
	            self.spinner(true);
	
	            when(self.calc(self.parameters.getProps())).then(function () {
	
	                self.calculating = false;
	
	                return when(self.draw()).then(function () {
	
	                    self.spinner(false);
	                    self.emit('refresh');
	                });
	            }, function (msg) {
	
	                // error callback
	                console.error(msg);
	                self.spinner(false);
	            });
	        },
	
	        spinner: function spinner(tog) {
	
	            this.getMainPanel().toggleClass('spinner', tog);
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            throw 'You must override the autocalcPlotOpts() method.';
	        },
	
	        calc: function calc(props) {
	
	            throw 'You must override the calc() method.';
	        },
	
	        draw: function draw() {
	
	            throw 'You must override the draw() method.';
	        }
	    });
	
	    return SkeletonUI;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
	    var menus = $();
	
	    function init(el) {
	
	        return el.each(function () {
	
	            var $this = $(this);
	
	            if ($this.data('ddmenu')) {
	                return;
	            }
	
	            $this.data('ddmenu', true);
	
	            $this.on('click', '> a, > button', function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                $this.find('.dropdown-menu').toggle('fast');
	            });
	
	            menus = menus.add($this.find('.dropdown-menu'));
	        });
	    }
	
	    $(window).on('click', function () {
	
	        menus.hide('fast');
	    });
	
	    return init;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(461)], __WEBPACK_AMD_DEFINE_RESULT__ = function (when) {
	    'use strict';
	
	    // log errors
	
	    function onError(e) {
	
	        if (typeof e === 'string') {
	            console.error(e);
	        } else {
	            var msg = ['Webworker ERROR: Line ', e.lineno, ' in ', e.filename, ': ', e.message].join('');
	
	            console.error(msg);
	        }
	    }
	
	    // setup messaging
	    var _nJobs = 0;
	    var relay = function relay(_worker) {
	
	        _worker.addEventListener('error', onError, false);
	
	        return {
	
	            exec: function exec(cmd, args) {
	
	                var dfd = when.defer();
	                var jobId = _nJobs++;
	                var send;
	                var listeners = {};
	
	                var unlisten = function unlisten() {
	                    _worker.removeEventListener('message', listeners.callback);
	                    _worker.removeEventListener('error', listeners.errback);
	                };
	
	                listeners.callback = function callback(e) {
	                    e.data.jobId = e.data.jobId | 0; // int
	                    if (e.data.jobId === jobId) {
	
	                        if (e.data.result && e.data.result.error) {
	                            dfd.reject(e.data.result.error);
	                        } else {
	                            dfd.resolve(e.data.result);
	                        }
	                        unlisten();
	                    }
	                };
	
	                listeners.errback = function errback(e) {
	                    var msg = ['Webworker ERROR: Line ', e.lineno, ' in ', e.filename, ': ', e.message].join('');
	                    unlisten();
	                    dfd.reject(msg);
	                };
	
	                _worker.addEventListener('error', listeners.errback, false);
	                _worker.addEventListener('message', listeners.callback, false);
	
	                send = {
	                    jobId: jobId,
	                    cmd: cmd,
	                    args: args
	                };
	
	                _worker.postMessage(send);
	
	                return dfd.promise;
	            },
	
	            destroy: function destroy() {
	
	                _worker.terminate();
	            }
	        };
	    };
	
	    // Wrapper
	    function Wrapper(_worker) {
	
	        var self = this;
	        self.worker = relay(_worker);
	    }
	
	    Wrapper.prototype = {
	        exec: function exec(what, args) {
	
	            var self = this;
	            var send = {
	                args: args
	            };
	
	            if (typeof what === 'string') {
	
	                what = what.split('.');
	                send.name = what[0];
	                send.method = what[1];
	            } else {
	
	                send.fn = what.toString();
	            }
	
	            return self.worker.exec('exec', send);
	        },
	
	        map: function map(what, args, transfer) {
	
	            var self = this;
	            var send = {
	                args: args,
	                map: true,
	                transfer: transfer
	            };
	
	            if (typeof what === 'string') {
	
	                what = what.split('.');
	                send.name = what[0];
	                send.method = what[1];
	            } else {
	
	                send.fn = what.toString();
	            }
	
	            return self.worker.exec('exec', send);
	        },
	
	        destroy: function destroy() {
	
	            var self = this;
	            self.worker.destroy();
	        }
	    };
	
	    // api
	    var W = function W(worker) {
	
	        return {
	            spawn: function spawn() {
	                return new Wrapper(new worker());
	            }
	        };
	    };
	
	    // Allows us to use this as a requireJS plugin
	    W.load = function (name, req, onLoad, config) {
	        if (config.isBuild) {
	            //don't do anything if this is a build, can't inline a web worker
	            onLoad();
	            return;
	        }
	
	        var url = req.toUrl(name);
	
	        if (window.Worker) {
	            onLoad(W(url));
	        } else {
	            req(["plugins/worker-fake"], function () {
	                onLoad({
	                    spawn: function spawn(name) {
	                        return W(W(url));
	                    }
	                });
	            });
	        }
	    };
	
	    return W;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 485 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="dropdown menu-ctrl"> <!-- <button class="btn"><i class="fui-settings-16"></i></button> --> <button class="btn">&#9660;</button> <ul class="dropdown-menu" role="menu"> <li><a tabindex="-1" href="#" class="export-csv-ctrl">Export as CSV</a></li> <li><a tabindex="-1" href="#" class="log-plot-ctrl">Toggle Log Plot</a></li> <!-- <li><a tabindex="-1" href="#">Another action</a></li> <li><a tabindex="-1" href="#">Something else here</a></li> <li class="divider"></li> <li><a tabindex="-1" href="#">Separated link</a></li> --> </ul></div>';return out;
	}

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function() {
		return new Worker(__webpack_require__.p + "98e323a3a9ee673c9e25.worker.js");
	};

/***/ },
/* 487 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Joint spectral intensity</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-jsa">&#x2296;</button> </div> </div><div class="heat-map-wrapper"> <!-- heat map goes here --></div></div>';return out;
	}

/***/ },
/* 488 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<br/><br/><h2>SPDCalc: a fast design tool for spontaneous parametric downconversion sources</h2><!-- <p style="font-style: italic">, L. K. Shalm, J. Palfree, Z. H. Levine, A. Migdall, T. Gerrits, S. W. Nam, and R. P. Mirin </p> --><p>The process of spontaneous parametric downconversion is an important source of single-photons and quantum states of light. Much recent theoretical and experimental work focuses on engineering the properties of the photons emitted from downconversion. For multi-photon experiments generating photon pairs that are spectrally pure, meaning the signal and idler photons are uncorrelated, has been an active area of investigation. For fundamental tests of quantum mechanics, such as loop-hole-free Bell tests, optimizing the coupling of photons to single-mode fiber is an important consideration.<p><p>While the principles behind the nonlinear process of downconversion are well understood, calculating the properties of the photons can be difficult and time-consuming when considering photons emitted at an angle with respect to the pump (non collinear) when the signal, idler, and pump can experience birefringent walk off. Here we present a program designed to simplify these calculations that builds on previous work. The application is web-based, open-sourced, and is designed to run in a user\'s browser. The program allows a user to easily determine the phasematching properties as well as the emission characteristics and joint spectrum of the signal and idler photons. The program also allows a user to quickly find phasematching parameters that generate spectrally pure states. The Hong-Ou-Mandel dip between the signal and idler is also calculated, and the joint spectrum in the dip can also be easily examined. Finally, the spatial mode structure and single-mode fiber coupling efficiency can be computed. The program is designed to be flexible, and can handle periodically-poled crystals that have been apodized with a Gaussian function.</p><p>SPDCalc is currently in beta testing. If you find any errors, or have suggestions, send them to Krister Shalm (krister [AT] dancingphysicist.com).<!-- <h2>References</h2><p>[1] N. Boeuf, Opt. Eng. 39(4) 1016–1024 (2000)</p><p>[2] W. P. Grice and I. A. Walmsley, Phys. Rev. A 56 (2), 1627 (1997); R Ram ́ırez-Alarco ́n, Laser Phys. 23 055204 (2013)</p><p>[3] R. S. Bennink, PRA 81, 053805 (2010)</p> --><!-- $$ \\int_0^\\infty x dx $$ -->';return out;
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484), __webpack_require__(490), __webpack_require__(491)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplJSALayout, tplTimeDelayCtrl) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var delTConversion = 1e-15;
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsahomUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 5,
	        tplPlots: tplJSALayout,
	        showPlotOpts: ['T_2HOM', 'grid_size', 'signal-wavelength', 'idler-wavelength', 'time-delay'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            self.el.on('click', '#collapse-homjsa', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // init plot
	            self.plot1d = new LinePlot({
	                title: 'Hong-Ou-Mandel Dip',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Time delay (fs)',
	                    y: 'Coincidence probability'
	                },
	                format: { x: '.0f' },
	                width: 400,
	                height: 200,
	                yrange: [0, 0.65]
	            });
	
	            self.plot1d.resize(400, 150);
	            // self.plot1d.setTitle("boo");
	
	            self.elPlot1d = $(self.plot1d.el);
	
	            self.eldelT = $(tplTimeDelayCtrl()).appendTo(self.el.find('.heat-map-wrapper'));
	
	            self.eldelT.slider({
	                min: -800,
	                max: 800,
	                value: 0,
	                orientation: "horizontal",
	                range: "min",
	                change: function change() {
	
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                },
	                slide: function slide() {
	
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                }
	            });
	
	            self.set('delT', 0);
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Joint spectral amplitude',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            // internal events
	            var to;
	            self.on('change:delT', function (delT) {
	
	                self.refreshLine(delT);
	                self.plot1d.setTitle("Time delay = " + delT / 1e-15);
	
	                clearTimeout(to);
	                to = setTimeout(function () {
	
	                    // only refresh plots after a time delay
	                    self.refreshJSA();
	                }, 50);
	            });
	
	            self.on('refresh', function () {
	                self.refreshLine(self.get('delT'));
	            });
	
	            self.addPlot(self.plot);
	            self.addPlot(self.plot1d);
	
	            self.initEvents();
	        },
	
	        refreshJSA: function refreshJSA() {
	
	            var self = this;
	            self.calc_HOM_JSA(self.parameters.getProps());
	            self.draw();
	        },
	
	        // refresh the vertical line on the line-plot
	        refreshLine: function refreshLine(delT) {
	
	            var self = this,
	                line = self.plot1d.svgPlot.selectAll('.vline').data([delT]),
	                y = self.plot1d.scales.y,
	                dom = y.domain();
	
	            //
	
	            // create
	            line.enter().append('rect').attr("class", 'vline').attr("width", 2)
	            // .attr("height", 20)
	            // this measurement is awkward...
	            .attr("height", Math.abs(y(dom[0]) - y(dom[1]))).style("fill", '#16A085');
	
	            line.attr('x', function (d) {
	                return self.plot1d.scales.x(d / delTConversion);
	            });
	
	            line.exit().remove();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                tsi;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max);
	
	            self.set_slider_values(tsi[0], tsi[1], tsi[2]);
	
	            self.plotOpts.set({
	                'grid_size': 50,
	                'T_2HOM': 200,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	
	                'delT_start': tsi[1],
	                'delT_stop': tsi[2]
	            });
	        },
	
	        calc: function calc(props) {
	
	            props = this.parameters.getProps();
	
	            var self = this,
	                threshold = 0.5,
	                lim = PhaseMatch.autorange_lambda(props, threshold),
	                tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max),
	                data1d = [],
	                po = self.plotOpts,
	                dim = po.get('T_2HOM'),
	                trange = [],
	                delT = PhaseMatch.linspace(po.get('delT_start'), po.get('delT_stop'), dim),
	                Nthreads = self.nWorkers - 1,
	                divisions = Math.floor(dim / Nthreads),
	                promises = [];
	
	            // First calc the joint spectrum.
	            self.calc_HOM_JSA(props);
	
	            // Next we begin the calculation of the HOM dip
	            var starttime = new Date();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                trange.push(delT.subarray(i * divisions, i * divisions + divisions));
	            }
	            trange.push(delT.subarray((Nthreads - 1) * divisions, delT.length));
	
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.doHOM', [props.get(), trange[j], po.get('ls_start'), po.get('ls_stop'), po.get('li_start'), po.get('li_stop'), po.get('grid_size'), true]);
	            }
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(dim);
	
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    arr.set(values[j], startindex);
	
	                    startindex += trange[j].length;
	                }
	
	                var endtime = new Date();
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (HOM) {
	
	                for (var i = 0, l = HOM.length; i < l; i++) {
	                    data1d.push({
	                        x: delT[i] / 1e-15,
	                        y: HOM[i]
	                    });
	                }
	                self.data1d = data1d;
	                self.draw();
	
	                // Calculate visibility
	                var vis = (0.5 - Math.min.apply(null, HOM)) / 0.5;
	                self.plot1d.setTitle("Hong-Ou-Mandel visibility = " + Math.round(1000 * vis) / 1000); //("Hong-Ou-Mandel Dip, Visbibility = ");
	                self.plot1d.setYRange([0, Math.max.apply(null, HOM) * 1.2]);
	
	                self.set_slider_values(tsi[0], po.get('delT_start'), po.get('delT_stop'));
	
	                var endtime = new Date();
	
	                return true;
	            });
	        },
	
	        set_slider_values: function set_slider_values(zero_delay, t_start, t_stop) {
	            var self = this;
	            //
	            // @TODO Krister: Noticed a weird bug where using self.set to change "delT" causes the red line to
	            // disappear for any value other than 0.
	            self.eldelT.slider({
	                min: Math.round(t_start / 1e-15),
	                max: Math.round(t_stop / 1e-15)
	            });
	        },
	
	        calc_HOM_JSA: function calc_HOM_JSA(props) {
	
	            var self = this,
	                delT = self.get('delT'),
	                po = self.plotOpts;
	
	            var st = new Date();
	
	            // Can only run in one thread. This graph is not easily parallizable. Need
	            // the entire grid to do the computation.
	            return self.workers[self.nWorkers - 1].exec('jsaHelper.doCalcHOMJSA', [props.get(), po.get('ls_start'), po.get('ls_stop'), po.get('li_start'), po.get('li_stop'), delT, po.get('grid_size'), true]).then(function (PM) {
	                self.data = PM;
	                self.draw();
	                // var S= PhaseMatch.calc_Schmidt(PM);
	                // self.plot.setTitle("Schmidt Number = " + Math.round(1000*S)/1000);
	                self.plot.setXRange([converter.to('nano', po.get('ls_start')), converter.to('nano', po.get('ls_stop'))]);
	                self.plot.setYRange([converter.to('nano', po.get('li_start')), converter.to('nano', po.get('li_stop'))]);
	                var sp = new Date();
	                //
	            });
	
	            // var PM = PhaseMatch.calc_HOM_JSA(
	            //     props,
	            //     po.get('ls_start'),
	            //     po.get('ls_stop'),
	            //     po.get('li_start'),
	            //     po.get('li_stop'),
	            //     self.get('delT'),
	            //     po.get('grid_size'),
	            //     true
	            // )
	            // ;
	
	
	            // self.data = PM;
	
	            // // var S= PhaseMatch.calc_Schmidt(PM);
	            // // self.plot.setTitle("Schmidt Number = " + Math.round(1000*S)/1000);
	
	            // self.plot.setXRange([ converter.to('nano', po.get('ls_start')), converter.to('nano', po.get('ls_stop')) ]);
	            // self.plot.setYRange([ converter.to('nano', po.get('li_start')), converter.to('nano', po.get('li_stop')) ]);
	            // self.plot1d.setTitle("Time delay = " + self.get('delT')/1e-15);
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data,
	                dfd = when.defer();
	
	            if (!data) {
	                return this;
	            }
	
	            self.plot.plotData(data);
	
	            // other plot
	            var data1d = self.data1d;
	
	            if (!data1d) {
	                return this;
	            }
	
	            setTimeout(function () {
	                self.plot1d.plotData(data1d);
	                dfd.resolve();
	            }, 50);
	
	            return dfd.promise;
	
	            // self.plot1d.plotData( data1d );
	        }
	    });
	
	    return function (config) {
	
	        return new jsahomUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 490 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Hong-Ou-Mandel interference between signal and idler photons</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-homjsa">&#x2296;</button> </div> </div> <!-- <div class="control-group"> <label class="checkbox control-label hom-bunch" for="hom-bunch"> Bunching <input type="checkbox" name="hom-bunch" id="hom-bunch" > </label> </div> --> <!-- <div class="control-group"> --> <!-- <label class="checkbox" for="autocalc_plotopts"> Bunching <input type="checkbox" name="autocalc_plotopts" id="autocalc_plotopts" checked="checked"> </label> --><!--     </div> --><div class="heat-map-wrapper"> <!-- heat map goes here --></div></div>';return out;
	}

/***/ },
/* 491 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div id="time-delay" class="ui-slider"> <div class="ui-slider-segment"></div> <div class="ui-slider-segment"></div> <div class="ui-slider-segment"></div></div>';return out;
	}

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(493)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, PhaseMatch, HeatMap, LinePlot, SkeletonUI, tplKSLayout) {
	
	    'use strict';
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var kitchen_sink_UI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        tplPlots: tplKSLayout,
	        showPlotOpts: false,
	
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // JSA plot
	            self.plotJSA = new HeatMap({
	                el: self.el.find('.jsa-wrapper').get(0)
	            });
	
	            self.elPlotJSA = $(self.plotJSA.el);
	
	            // PMXY plot
	            self.plotPMXY = new HeatMap({
	                el: self.el.find('.PMXY-wrapper').get(0)
	            });
	            self.elplotPMXY = $(self.plotPMXY.el);
	
	            // Lambda_s vs theta_s plot
	            self.plotLambdasThetas = new HeatMap({
	                el: self.el.find('.lambda_s-theta_s-wrapper').get(0)
	            });
	            self.elplotLambdasThetas = $(self.plotLambdasThetas.el);
	
	            // Theta/Phi in the crystal
	            self.plotThetaPhi = new HeatMap({
	                el: self.el.find('.pm-theta-phi-wrapper').get(0)
	            });
	            self.elplotThetaPhi = $(self.plotThetaPhi.el);
	
	            // HOM plot
	            self.plot1d = new LinePlot({
	                el: self.el.find('.HOM-wrapper').get(0),
	                labels: {
	                    x: 'x-axis',
	                    y: 'y-axis'
	                }
	            });
	
	            self.elPlot1d = $(self.plot1d.el);
	
	            self.addPlot(self.plotJSA);
	            self.addPlot(self.plotPMXY);
	            self.addPlot(self.plotLambdasThetas);
	            self.addPlot(self.plotThetaPhi);
	            self.addPlot(self.plot1d);
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {},
	
	        calc: function calc(props) {
	
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            var dim = 200;
	            var threshold = 0.5;
	            var lim = PhaseMatch.autorange_lambda(props, threshold);
	            var l_start = lim.lambda_s.min;
	            var l_stop = lim.lambda_s.max;
	
	            var data1d = [];
	            var dataPMXY = [];
	            var dataJSA = [];
	            var dataLambdasThetas = [];
	            var dataThetaPhi = [];
	
	            var self = this,
	                PMJSA = PhaseMatch.calc_JSA(props, l_start, l_stop, l_start, l_stop, dim);
	            self.dataJSA = PMJSA;
	
	            var x_start = -10 * Math.PI / 180;
	            var x_stop = 10 * Math.PI / 180;
	            var PMXY = PhaseMatch.calc_XY(props, x_start, x_stop, x_start, x_stop, dim);
	            self.dataPMXY = PMXY;
	
	            // Lambda signal vs theta signal
	            var t_start = 0 * Math.PI / 180;
	            var t_stop = 5 * Math.PI / 180;
	            var PMLambdasThetas = PhaseMatch.calc_lambda_s_vs_theta_s(props, l_start, l_stop, t_start, t_stop, dim);
	            self.dataLambdasThetas = PMLambdasThetas;
	
	            // Theta vs Phi in crystal
	            var PMThetaPhi = PhaseMatch.calc_theta_phi(props, 0, 90 * Math.PI / 180, 0, 180 * Math.PI / 180, dim);
	            self.dataThetaPhi = PMThetaPhi;
	
	            // Hong-Ou-Mandel dip
	            t_start = -800e-15;
	            t_stop = 800e-15;
	            var delT = PhaseMatch.linspace(t_start, t_stop, dim);
	            var HOM = PhaseMatch.calc_HOM_scan(props, t_start, t_stop, l_start, l_stop, l_start, l_stop, dim);
	            for (var i = 0, l = HOM.length; i < l; i++) {
	                data1d.push({
	                    x: delT[i] / 1e-15,
	                    y: HOM[i]
	                });
	            }
	
	            self.data1d = data1d;
	        },
	
	        draw: function draw() {
	
	            var self = this;
	
	            if (!self.dataJSA || !self.dataPMXY || !self.dataLambdasThetas || !self.dataThetaPhi || !self.data1d) {
	                return this;
	            }
	
	            self.plotJSA.plotData(self.dataJSA);
	
	            self.plotPMXY.plotData(self.dataPMXY);
	
	            self.plotLambdasThetas.plotData(self.dataLambdasThetas);
	
	            self.plotThetaPhi.plotData(self.dataThetaPhi);
	
	            self.plot1d.clear();
	            self.plot1d.addSeries(self.data1d);
	            self.plot1d.addSeries($.map(new Array(100), function (val, i) {
	                return { x: i * 5 - 400, y: Math.sin(i / 10) };
	            }));
	            self.plot1d.plotData();
	        }
	    });
	
	    return function (config) {
	
	        return new kitchen_sink_UI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 493 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div> <div class="jsa-wrapper"> <!-- heat map goes here --> </div> <div class="PMXY-wrapper"> <!-- angular emissio XY --> </div>  <div class="lambda_s-theta_s-wrapper"> <!-- lambda_signal vs theta signal --> </div>  <div class="pm-theta-phi-wrapper"> <!-- phasematching curve for crystal theta/phi --> </div> <div class="HOM-wrapper"> </div></div>';return out;
	}

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(456), __webpack_require__(484), __webpack_require__(482), __webpack_require__(495)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, converter, W, SkeletonUI, tplXYLayout) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var xy_UI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 5,
	        tplPlots: tplXYLayout,
	        showPlotOpts: ['grid_size', 'signal-wavelength', 'idler-wavelength', 'theta'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-xy-emission', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-theta-phi', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-thetas-thetai', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-lambda-theta', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // PMXY plot
	            self.plotPMXY = new HeatMap({
	                title: 'External Emission angle',
	                el: self.el.find('.PMXY-wrapper').get(0),
	                labels: {
	                    x: 'X Emission Angle (deg)',
	                    y: 'Y Emission Angle (deg)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            self.elplotPMXY = $(self.plotPMXY.el);
	
	            // PMXY_both plot
	            self.plotPMXYBoth = new HeatMap({
	                title: 'Signal and Idler',
	                el: self.el.find('.PMXYBoth-wrapper').get(0),
	                labels: {
	                    x: 'X Emission Angle (deg)',
	                    y: 'Y Emission Angle (deg)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            self.elplotPMXYBoth = $(self.plotPMXYBoth.el);
	
	            // Lambda_s vs theta_s plot
	            self.plotLambdasThetas = new HeatMap({
	                title: 'Wavelength vs emission angle',
	                el: self.el.find('.lambda_s-theta_s-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength (nm)',
	                    y: 'Theta Signal (deg)'
	                },
	                format: { z: '.0f' }
	            });
	
	            self.elplotLambdasThetas = $(self.plotLambdasThetas.el);
	
	            // Theta/Phi in the crystal
	            self.plotThetaPhi = new HeatMap({
	                title: 'Signal Theta vs Phi',
	                el: self.el.find('.pm-theta-phi-wrapper').get(0),
	                labels: {
	                    x: 'Theta Signal (deg)',
	                    y: 'Phi Signal (deg)'
	                }
	            });
	
	            self.elplotThetaPhi = $(self.plotThetaPhi.el);
	
	            // Theta/Phi in the crystal
	            self.plotThetaTheta = new HeatMap({
	                title: 'Signal vs Idler',
	                el: self.el.find('.pm-theta-theta-wrapper').get(0),
	                labels: {
	                    x: 'Theta Signal (deg)',
	                    y: 'Theta Idler (deg)'
	                }
	            });
	
	            self.elplotThetaTheta = $(self.plotThetaTheta.el);
	
	            self.addPlot(self.plotPMXY);
	            self.addPlot(self.plotPMXYBoth);
	            self.addPlot(self.plotLambdasThetas);
	            self.addPlot(self.plotThetaPhi);
	            self.addPlot(self.plotThetaTheta);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                lim_theta;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            lim_theta = PhaseMatch.autorange_theta(props);
	
	            self.plotOpts.set({
	                'grid_size': 100,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	
	                'theta_start': lim_theta[0],
	                'theta_stop': lim_theta[1]
	            });
	        },
	
	        calc: function calc(props) {
	            var self = this,
	                po = this.plotOpts,
	                data1d = [],
	                dataPMXY = [],
	                dataJSA = [],
	                dataLambdasThetas = [],
	                dataThetaPhi = [],
	                dataThetaTheta = [],
	                l_start = converter.to('nano', po.get('ls_start')),
	                l_stop = converter.to('nano', po.get('ls_stop')),
	                t_start = converter.to('deg', po.get('theta_start')),
	                t_stop = converter.to('deg', po.get('theta_stop')),
	                x_start = -1 * t_stop,
	                x_stop = t_stop,
	                Nthreads = self.nWorkers,
	                promises = [];
	            // console.log("start, stop angles are:", x_start, x_stop, po.get('theta_stop'));
	            var isfibercoupled = props.calcfibercoupling;
	            props.calcfibercoupling = false;
	            var propsJSON = props.get();
	            props.calcfibercoupling = isfibercoupled;
	
	            promises[0] = self.workers[0].exec('jsaHelper.docalc_XY', [propsJSON, -1 * po.get('theta_stop'), po.get('theta_stop'), -1 * po.get('theta_stop'), po.get('theta_stop'), po.get('grid_size')
	            // propsJSON,
	            // x_start*Math.PI/80,
	            // x_stop*Math.PI/80,
	            // x_start*Math.PI/80,
	            // x_stop*Math.PI/80,
	            // po.get('grid_size')
	
	            ]);
	
	            promises[1] = self.workers[0].exec('jsaHelper.doXYBoth', [propsJSON, -2 * po.get('theta_stop'), 2 * po.get('theta_stop'), -2 * po.get('theta_stop'), 2 * po.get('theta_stop'), po.get('grid_size')]);
	
	            // Lambda signal vs theta signal
	            promises[2] = self.workers[0].exec('jsaHelper.doXYLambdasThetas', [propsJSON, po.get('ls_start'), po.get('ls_stop'), po.get('theta_start'), po.get('theta_stop'), po.get('grid_size')]);
	
	            // Theta vs Phi in crystal
	            promises[3] = self.workers[0].exec('jsaHelper.doXYThetavsPhi', [propsJSON, po.get('theta_start'), po.get('theta_stop'), 0, 0.5 * Math.PI, po.get('grid_size')]);
	
	            // var XYThetaPhi = PhaseMatch.calc_signal_theta_phi(
	            //     props,
	            //     po.get('theta_start'),
	            //     po.get('theta_stop'),
	            //     0,
	            //     0.5 * Math.PI,
	            //     po.get('grid_size')
	            // );
	            // self.dataThetaPhi = XYThetaPhi;
	            // self.plotThetaPhi.setXRange([ t_start, t_stop ]);
	            // self.plotThetaPhi.setYRange([0 ,90]);
	
	            // Signal Theta vs Idler Theta in crystal
	            promises[4] = self.workers[0].exec('jsaHelper.doXYThetaTheta', [propsJSON, po.get('theta_start'), po.get('theta_stop'), po.get('theta_start'), po.get('theta_stop'), po.get('grid_size')]);
	
	            return when.all(promises).then(function (values) {
	                self.dataPMXY = values[0];
	                self.plotPMXY.setXRange([x_start, x_stop]);
	                self.plotPMXY.setYRange([x_start, x_stop]);
	                self.plotPMXY.setZRange([0, Math.max.apply(null, values[0])]);
	
	                // console.log("start, stop angles are:", x_start, x_stop, po.get('theta_stop'));
	
	                self.dataPMXYBoth = values[1];
	                self.plotPMXYBoth.setXRange([2 * x_start, 2 * x_stop]);
	                self.plotPMXYBoth.setYRange([2 * x_start, 2 * x_stop]);
	                self.plotPMXYBoth.setZRange([0, 2]);
	
	                self.dataLambdasThetas = values[2].data;
	                self.plotLambdasThetas.setXRange([l_start, l_stop]);
	                self.plotLambdasThetas.setYRange([t_start, t_stop]);
	
	                self.dataThetaPhi = values[3];
	                self.plotThetaPhi.setXRange([t_start, t_stop]);
	                self.plotThetaPhi.setYRange([0, 90]);
	
	                self.dataThetaTheta = values[4];
	                self.plotThetaTheta.setXRange([t_start, t_stop]);
	                self.plotThetaTheta.setYRange([t_start, t_stop]);
	
	                return true; // this value is passed on to the next "then()"
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                dfd = when.defer();
	
	            // PMXY plot
	            // if (!self.dataPMXY ||
	            //     !self.dataLambdasThetas ||
	            //     !self.dataThetaPhi ||
	            //     !self.dataThetaTheta
	            // ){
	            //     return this;
	            // }
	
	            // async... but not inside webworker
	
	            setTimeout(function () {
	                self.plotPMXY.plotData(self.dataPMXY);
	                self.plotPMXYBoth.plotData(self.dataPMXYBoth);
	
	                // lambda signal vs theta signal plot
	                self.plotLambdasThetas.plotData(self.dataLambdasThetas);
	
	                // Theta vs Phi in the crystal
	                self.plotThetaPhi.plotData(self.dataThetaPhi);
	
	                // Theta vs Phi in the crystal
	                self.plotThetaTheta.plotData(self.dataThetaTheta);
	                dfd.resolve();
	            }, 10);
	            return dfd.promise;
	        }
	    });
	
	    return function (config) {
	
	        return new xy_UI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 495 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Emission angles of both the signal and idler photons in the XY lab frame</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-xy-emission">&#x2296;</button> </div> </div> <div class="PMXYBoth-wrapper"> <!-- angular emissio XY --> </div> </div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Emission angles of the signal photon in the XY lab frame</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-xy-emission">&#x2296;</button> </div> </div> <div class="PMXY-wrapper"> <!-- angular emissio XY --> </div> </div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Opening angle (theta) versus azimuthal angle (phi) for the signal photon</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-theta-phi">&#x2296;</button> </div> </div> <div class="pm-theta-phi-wrapper"> <!-- phasematching curve for crystal theta/phi --> </div> </div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Emission angle of the signal versus the emission angle of the idler</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-thetas-thetai">&#x2296;</button> </div> </div> <div class="pm-theta-theta-wrapper"> <!-- lambda_signal vs theta signal --> </div> </div> <div class="plot-wrapper span7 offset1 last-parameters"> <div class="row-fluid"> <h2 class="title">Wavelength versus emission angle for the signal photon</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-lambda-theta">&#x2296;</button> </div> </div> <div class="lambda_s-theta_s-wrapper"> <!-- lambda_signal vs theta signal --> </div> </div></div>';return out;
	}

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484), __webpack_require__(497)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplSchmidtLayout) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module schmidtUI
	     * @implements {Stapes}
	     */
	    var schmidtUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 4,
	        tplPlots: tplSchmidtLayout,
	        showPlotOpts: ['grid_size_schmidt', 'signal-wavelength', 'idler-wavelength', 'xtal_length_range', 'pump_bw_range'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-schmidt', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            var margins = {
	                top: 60,
	                right: 40,
	                left: 80,
	                bottom: 60
	            };
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Schmidt number',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Crystal Length (um)',
	                    y: 'Pump Bandwidth (nm)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                antialias: false,
	                format: {
	                    x: '.01f',
	                    y: '.02f'
	                }
	            });
	
	            self.addPlot(self.plot);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	
	            self.plotOpts.set({
	                'grid_size_schmidt': 10,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	                'xtal_l_start': props.L / 3,
	                'xtal_l_stop': props.L * 3,
	                'bw_start': props.p_bw / 3,
	                'bw_stop': props.p_bw * 3
	            });
	        },
	
	        calc: function calc(props) {
	
	            var self = this,
	                Nthreads = self.nWorkers,
	                grid_size = self.plotOpts.get('grid_size_schmidt'),
	                divisions = Math.floor(grid_size / Nthreads),
	                xrange = [],
	                yrange = [],
	                promises = [];
	
	            var params = {
	                x: "L",
	                y: "BW"
	            };
	
	            var xtalL = PhaseMatch.linspace(self.plotOpts.get('xtal_l_start'), self.plotOpts.get('xtal_l_stop'), grid_size);
	
	            // be sure to reverse the order of this array so the graph makes sense.
	            // Effectively, this moves the origin to the bottom right corner.
	            var bw = PhaseMatch.linspace(self.plotOpts.get('bw_stop'), self.plotOpts.get('bw_start'), grid_size);
	
	            xrange = xtalL;
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                yrange.push(bw.subarray(i * divisions, i * divisions + divisions));
	            }
	            yrange.push(bw.subarray((Nthreads - 1) * divisions, bw.length));
	
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.doCalcSchmidtPlot', [props.get(), xrange, yrange[j], self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), self.plotOpts.get('li_start'), self.plotOpts.get('li_stop'), self.plotOpts.get('grid_size_schmidt'), params]);
	            }
	
	            var startindex = 0;
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    arr.set(values[j], startindex);
	                    // console.log("arr val set");
	                    startindex += xrange.length * yrange[j].length;
	                }
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	                self.data = PM;
	                self.plot.setZRange([1, Math.max.apply(null, PM) * 1]);
	                self.plot.setXRange([converter.to('micro', self.plotOpts.get('xtal_l_start')), converter.to('micro', self.plotOpts.get('xtal_l_stop'))]);
	                self.plot.setYRange([converter.to('nano', self.plotOpts.get('bw_start')), converter.to('nano', self.plotOpts.get('bw_stop'))]);
	                return true;
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data,
	                dfd = when.defer();
	
	            if (!data) {
	                return this;
	            }
	
	            // self.plot.plotData( data );
	            // async... but not inside webworker
	            setTimeout(function () {
	                self.plot.plotData(data);
	                dfd.resolve();
	            }, 10);
	
	            return dfd.promise;
	        }
	    });
	
	    return function (config) {
	
	        return new schmidtUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 497 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Schmidt number as a function of crystal length and pump bandwidth</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-schmidt">&#x2296;</button> </div> </div><div class="heat-map-wrapper"> <!-- heat map goes here --></div></div>';return out;
	}

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(499)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, tplMSLayout) {
	
	    'use strict';
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsaUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        tplPlots: tplMSLayout,
	        showPlotOpts: ['grid_size_ms', 'signal-wavelength', 'idler-wavelength'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-modesolver', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            var margins = {
	                top: 60,
	                right: 40,
	                left: 80,
	                bottom: 60
	            };
	
	            this.heatmapmargins = margins;
	
	            // init plot
	            self.plot2dSignal = new HeatMap({
	                title: 'Idler spatial mode',
	                el: self.el.find('.signalmode').get(0),
	                margins: margins,
	                labels: {
	                    x: 'X emission angle (deg)',
	                    y: 'Y emission angle (deg)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                format: {
	                    x: '.02f',
	                    y: '.02f'
	                }
	            });
	
	            self.addPlot(self.plot2dSignal);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	
	            self.plotOpts.set({
	                'grid_size_ms': 16,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max
	            });
	        },
	
	        calc: function calc(props) {
	
	            var self = this;
	            var po = this.plotOpts;
	
	            // Make sure fiber coupling is enabled.
	            var isfibercoupled = props.calcfibercoupling;
	            props.calcfibercoupling = true;
	
	            var scale = 3;
	
	            //make sure the angles are correct so we can calculate the right ranges
	            props.phi_i = props.phi_s + Math.PI;
	            props.update_all_angles();
	            //find the external idler angle
	            props.theta_i_e = PhaseMatch.find_external_angle(props, 'idler');
	
	            var X_0 = Math.asin(Math.sin(props.theta_i_e) * Math.cos(props.phi_i));
	            var Y_0 = Math.asin(Math.sin(props.theta_i_e) * Math.sin(props.phi_i));
	
	            // console.log("central idler angles:", props.theta_i_e *180/Math.PI);
	            // console.log(po.get('collection_bw')/1e-9);
	
	            // var W = Math.max(props.W_sx, props.W_sy);
	            var convertfromFWHM = 1 / (2 * Math.sqrt(Math.log(2)));
	            var Ws = props.W_sx * convertfromFWHM;
	            //calculate Rayleigh range
	            var zrs = Math.PI * (Ws * Ws) / props.lambda_s;
	            Ws = props.lambda_s / (Math.PI * Ws); // angular spread
	
	            var Wp = props.W * convertfromFWHM;
	            //calculate Rayleigh range
	            var zrp = Math.PI * (Wp * Wp) / props.lambda_p;
	            Wp = props.lambda_p / (Math.PI * Wp); // angular spread
	
	            // var W = 1/(1/Ws + 1/Wp);
	            var W = Ws + Wp / 4;
	            // console.log(Ws, Wp, W);
	
	
	            console.log("rayleigh Range", zrs / props.L, zrp / props.L);
	
	            var x_start = X_0 - scale * W;
	            var x_stop = X_0 + scale * W;
	            var y_start = Y_0 - scale * W;
	            var y_stop = Y_0 + scale * W;
	
	            var wavelengths = {
	                "ls_start": po.get("ls_start"),
	                "ls_stop": po.get("ls_stop"),
	                "li_start": po.get("li_start"),
	                "li_stop": po.get("li_stop")
	            };
	
	            // If the filters are mismatched, we need to integrate over more points.
	            var lambdadiff = Math.abs(po.get("ls_stop") - po.get("ls_start")) - Math.abs(po.get("li_stop") - po.get("li_start"));
	            var dimlambda;
	            lambdadiff = lambdadiff / Math.abs(po.get("ls_stop") - po.get("ls_start")) + Math.abs(po.get("li_stop") - po.get("li_start")) / 2;
	            console.log("lambda diff", lambdadiff);
	            if (Math.abs(lambdadiff) > 0.3) {
	                dimlambda = 32;
	            } else if (Math.abs(lambdadiff) > 0.1) {
	                dimlambda = 24;
	            } else {
	                dimlambda = 16;
	            }
	            // dimlambda = 60;
	
	            var startTime = new Date();
	
	            var PM_s = PhaseMatch.calc_XY_mode_solver2(props, x_start, x_stop, y_start, y_stop, wavelengths, po.get('grid_size_ms'), dimlambda);
	
	            var endTime = new Date();
	            var timeDiff = endTime - startTime;
	            console.log(timeDiff);
	            // console.log(scale, props.W_sx*180/Math.PI, props.W_sx*scale *180/Math.PI);
	
	            // var PM_s = PhaseMatch.calc_XY_mode_solver(
	            //     props,
	            //     -1 * po.get('theta_stop'),
	            //     po.get('theta_stop'),
	            //     -1 * po.get('theta_stop'),
	            //     po.get('theta_stop'),
	            //     po.get('grid_size')
	            // );
	            // console.log(PM_s[0]);
	            self.data = PhaseMatch.normalize(PM_s['pmsingles']);
	            self.plot2dSignal.setZRange([0, Math.max.apply(null, PM_s['pmsingles'])]);
	            self.plot2dSignal.setXRange([converter.to('deg', x_start), converter.to('deg', x_stop)]);
	            self.plot2dSignal.setYRange([converter.to('deg', y_start), converter.to('deg', y_stop)]);
	
	            self.refreshSignalFWHMCircle(Ws, X_0, Y_0, props);
	
	            self.plot2dSignal.setTitle("Idler coupling efficiency  = " + Math.round(1000 * PM_s['eff']) / 10 + "%");
	
	            // if (PM_s['warning'] || zrp/props.L <5 || zrs/props.L <5){
	            //     alert("Warning: this calculation should be treated with suspiscion. The parameters chosen are outside the approximations used in the program. Most likely the crystal is too long, or focusing is too tight.");
	            // }
	
	            if (zrs / props.L < 2) {
	                alert("Warning: this calculation should be treated with suspiscion.  The Rayleigh range of the idler collection mode is too small compared to the length of the crystal.");
	            } else if (zrp / props.L < 2) {
	                alert("Warning: this calculation should be treated with suspiscion. The Rayleigh range of the pump mode is too small compared to the length of the crystal.");
	            } else if (PM_s['warning']) {
	                alert("Warning: this calculation should be treated with suspiscion. The parameters chosen are outside the approximations used in the program. Most likely the crystal is too long, or focusing is too tight.");
	            }
	
	            props.calcfibercoupling = isfibercoupled;
	        },
	
	        // draw circle outlining FWHM of the signal photon
	        refreshSignalFWHMCircle: function refreshSignalFWHMCircle(W, X0, Y0, props) {
	
	            var self = this;
	            var deg = 180 / Math.PI;
	
	            var data = [];
	
	            data = [{ X0: X0 * deg, Y0: Y0 * deg, r: W * deg, opacity: 0.9, title: 'Idler collection FWHM', labelX: X0 * deg, labelY: (Y0 + 6 * W / 2) * deg }, { X0: X0 * deg, Y0: Y0 * deg, r: 1.699 * W * deg, opacity: 0.3, title: 'Idler collection 1/e^2', labelX: X0 * deg, labelY: -1 * (Y0 + 6 * W / 2) * deg }];
	            var xx = self.plot2dSignal.scales.x;
	            var yy = self.plot2dSignal.scales.y;
	
	            // console.log("refreshing: ", xx(1*data[0].X0*deg), xx(1*X0*deg), Math.abs( xx(data[0].X0 + data[0].r) - xx(data[0].X0) ));
	
	            var extension = 0.15; // percentage of yrange to extend label line through
	
	            //Need to remove the elements first in order to redraw them
	            self.plot2dSignal.svg.selectAll('.overlay').remove();
	
	            var overlays = self.plot2dSignal.svg.selectAll('.overlay').data(data);
	
	            var overlaysEnter = overlays.enter().append('g')
	            // translate the whole group to correct for margins
	            .attr('transform', 'translate(' + this.heatmapmargins.left + ',' + this.heatmapmargins.top + ')').attr('class', 'overlay');
	
	            // create the circle on new data
	            overlaysEnter.append('circle').style('fill', 'transparent').style('stroke', '#1ABC9C').style('stroke-width', 2).style('stroke-opacity', function (d) {
	                return d.opacity;
	            });
	
	            // create lines
	            overlaysEnter.append('line').style('stroke', '#1ABC9C').style('stroke-width', 2).style('stroke-opacity', 0.3);
	
	            // create text
	            overlaysEnter.append('text').attr('text-anchor', 'middle');
	
	            // set line dimensions based on data
	            overlays.selectAll('line').attr('x1', function (d) {
	                return xx(d.X0);
	            }).attr('y1', function (d, a, idx) {
	                // naive alternating of direction...
	                var sign = idx % 2 ? -1 : 1;
	                return yy(d.Y0 + sign * d.r);
	            }).attr('x2', function (d) {
	                return xx(d.labelX);
	            }).attr('y2', function (d, a, idx) {
	                var sign = idx % 2 ? -1 : 1;
	                // return yy( d.Y0 - sign * d.r) - sign * (yy.range()[1] - yy.range()[0]) * extension;
	                return yy(d.labelY) + sign * 25;
	            });
	
	            // update text properties based on data
	            overlays.selectAll('text').attr('x', function (d) {
	                return xx(d.labelX);
	            }).attr('y', function (d, a, idx) {
	                var sign = idx % 2 ? -1 : 1;
	                // return yy( d.Y0 - sign * d.r) - sign * (yy.range()[1] - yy.range()[0]) * extension;
	                // console.log("text y label", yy(d.labelY));
	                return yy(d.labelY);
	            }).attr('dx', 0).attr('dy', function (d, a, idx) {
	                var sign = idx % 2 ? -1 : 1;
	                return 10 * sign;
	            }).text(function (d) {
	                return d.title;
	            });
	
	            // update the circle based on data
	            overlays.selectAll('circle').attr('r', function (d) {
	                // console.log("circle Radius", Math.abs( xx(d.X0 + d.r) - xx(d.X0) ));
	
	                return Math.abs(xx(d.X0 + d.r) - xx(d.X0));
	            }).attr('cx', function (d) {
	                // console.log("circle x: ", d.X0, ( X0 * deg ));
	                return xx(d.X0);
	            }).attr('cy', function (d) {
	
	                return yy(d.Y0);
	            });
	
	            // remove the overlays when data removed
	            overlays.exit().remove();
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data;
	
	            if (!data) {
	                return this;
	            }
	
	            self.plot2dSignal.plotData(data);
	        }
	    });
	
	    return function (config) {
	
	        return new jsaUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 499 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Idler spatial distribution after projecting the signal into a Gaussian mode</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-modesolver">&#x2296;</button> </div> <p> WARNING: This module is under heavy development. Do not trus ANY of the results you obtain from it. </p> </div><div class="signalmode"> <!-- heat map goes here --></div></div>';return out;
	}

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(456), __webpack_require__(484), __webpack_require__(482), __webpack_require__(501)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, converter, W, SkeletonUI, tplCurvesLayout) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var xy_UI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 3,
	        tplPlots: tplCurvesLayout,
	        showPlotOpts: ['grid_size', 'signal-wavelength',
	        // 'pm-signal-wavelength',
	        // 'idler-wavelength',
	        'pump-wavelength', 'pump-theta', 'pump-phi', 'poling-period', 'theta'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-curve-signal', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-curve-crystal', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-curve-theta-phi', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            /////////////////////////////
	            self.el.on('click', '#collapse-theta-phi', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-thetas-thetai', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-lambda-theta', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // Pump vs signal phasematching
	            self.plotSignal = new HeatMap({
	                title: 'Phasematching',
	                el: self.el.find('.curve-signal-wrapper').get(0),
	                labels: {
	                    x: 'Pump Wavelength (nm)',
	                    y: 'Signal Wavelength (nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            self.elplotSignal = $(self.plotSignal.el);
	
	            // Phasematching poling period vs theta
	            self.plotPolingTheta = new HeatMap({
	                title: 'Phasematching',
	                el: self.el.find('.curve-poling-wrapper').get(0),
	                labels: {
	                    x: 'Poling Period (um)',
	                    y: 'Angle of optic axis with respect to pump direction (deg)'
	                },
	                format: {
	                    y: '.0f'
	                }
	            });
	
	            self.elplotPolingTheta = $(self.plotPolingTheta.el);
	
	            // Phasematching curve for theta and phi.
	            self.plotThetaPhi = new HeatMap({
	                title: 'Phasematching',
	                el: self.el.find('.curve-theta-phi-wrapper').get(0),
	                labels: {
	                    x: 'Theta of pump with respect to optic axis (deg)',
	                    y: 'Phi of pump with respect to optic axis (deg)'
	                }
	            });
	
	            self.elplotThetaPhi = $(self.plotThetaPhi.el);
	
	            //////////////////////////////
	            // Lambda_s vs theta_s plot
	            self.plotLambdasThetas = new HeatMap({
	                title: 'Wavelength vs emission angle',
	                el: self.el.find('.lambda_s-theta_s-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength (nm)',
	                    y: 'Theta Signal (deg)'
	                },
	                format: { z: '.0f' }
	            });
	
	            self.elplotLambdasThetas = $(self.plotLambdasThetas.el);
	
	            // Theta/Phi in the crystal
	            self.plotThetaPhiSignal = new HeatMap({
	                title: 'Signal Theta vs Phi',
	                el: self.el.find('.pm-theta-phi-wrapper').get(0),
	                labels: {
	                    x: 'Theta Signal (deg)',
	                    y: 'Phi Signal (deg)'
	                }
	            });
	
	            self.elplotThetaPhiSignal = $(self.plotThetaPhiSignal.el);
	
	            // Theta/Phi in the crystal
	            self.plotThetaTheta = new HeatMap({
	                title: 'Signal vs Idler',
	                el: self.el.find('.pm-theta-theta-wrapper').get(0),
	                labels: {
	                    x: 'Theta Signal (deg)',
	                    y: 'Theta Idler (deg)'
	                }
	            });
	
	            self.elplotThetaTheta = $(self.plotThetaTheta.el);
	
	            self.addPlot(self.plotSignal);
	            // self.addPlot( self.plotTheta );
	            self.addPlot(self.plotPolingTheta);
	            self.addPlot(self.plotThetaPhi);
	            self.addPlot(self.plotLambdasThetas);
	            self.addPlot(self.plotThetaPhiSignal);
	            self.addPlot(self.plotThetaTheta);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                lim_theta;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            lim_theta = PhaseMatch.autorange_theta(props);
	            var poling_limits = PhaseMatch.autorange_poling_period(props);
	
	            self.plotOpts.set({
	                'grid_size': 100,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	                'pm_signal_wavelength_start': lim.lambda_s.min - 100e-9,
	                'pm_signal_wavelength_stop': lim.lambda_s.min + 100e-9,
	                'lp_start': props.lambda_p - 4e-9,
	                'lp_stop': props.lambda_p + 4e-9,
	                'pump_theta_start': props.theta - 10 * Math.PI / 180,
	                'pump_theta_stop': props.theta + 10 * Math.PI / 180,
	                'pump_phi_start': 0,
	                'pump_phi_stop': Math.PI / 2,
	                'poling_period_start': poling_limits[0],
	                'poling_period_stop': poling_limits[1],
	                'theta_start': lim_theta[0],
	                'theta_stop': lim_theta[1]
	
	            });
	        },
	
	        calc: function calc(props) {
	
	            var self = this,
	                dim = 200,
	                po = this.plotOpts
	            // ,dataSignal = []
	            // ,theta = []
	            // ,dataBoth = []
	            ,
	                l_start = converter.to('nano', po.get('ls_start')),
	                l_stop = converter.to('nano', po.get('ls_stop')),
	                t_start = converter.to('deg', po.get('theta_start')),
	                t_stop = converter.to('deg', po.get('theta_stop')),
	                Nthreads = 6,
	                promises = [];
	
	            // Turn off fiber coupling to get accurate results
	            var isfibercoupled = props.calcfibercoupling;
	            props.calcfibercoupling = false;
	            var propsJSON = props.get();
	            props.calcfibercoupling = isfibercoupled;
	
	            promises[0] = self.workers[0].exec('jsaHelper.doPMSignal', [propsJSON,
	            // po.get('pm_signal_wavelength_start'),
	            // po.get('pm_signal_wavelength_stop'),
	            po.get('ls_start'), po.get('ls_stop'), po.get('lp_start'), po.get('lp_stop'), "signal", po.get('grid_size')]);
	
	            promises[1] = self.workers[1].exec('jsaHelper.doPMThetaPhi', [propsJSON, po.get('pump_theta_start'), po.get('pump_theta_stop'), po.get('pump_phi_start'), po.get('pump_phi_stop'), po.get('grid_size')]);
	
	            promises[2] = self.workers[2].exec('jsaHelper.doPMPolingTheta', [propsJSON, po.get('poling_period_start'), po.get('poling_period_stop'), po.get('pump_theta_start'), po.get('pump_theta_stop'), po.get('grid_size')]);
	
	            ////////////////////////////////////
	            // Lambda signal vs theta signal
	            promises[3] = self.workers[0].exec('jsaHelper.doXYLambdasThetas', [propsJSON, po.get('ls_start'), po.get('ls_stop'), po.get('theta_start'), po.get('theta_stop'), po.get('grid_size')]);
	
	            // Theta vs Phi in crystal
	            promises[4] = self.workers[0].exec('jsaHelper.doXYThetavsPhi', [propsJSON, po.get('theta_start'), po.get('theta_stop'), 0, 0.5 * Math.PI, po.get('grid_size')]);
	
	            promises[5] = self.workers[0].exec('jsaHelper.doXYThetaTheta', [propsJSON, po.get('theta_start'), po.get('theta_stop'), po.get('theta_start'), po.get('theta_stop'), po.get('grid_size')]);
	
	            return when.all(promises).then(function (values) {
	                self.dataSignal = values[0];
	                self.plotSignal.setXRange([converter.to('nano', po.get('lp_start')), converter.to('nano', po.get('lp_stop'))]);
	                self.plotSignal.setYRange([converter.to('nano', po.get('ls_start')), converter.to('nano', po.get('ls_stop'))]);
	
	                self.dataThetaPhi = values[1];
	                self.plotThetaPhi.setXRange([converter.to('deg', po.get('pump_theta_start')), converter.to('deg', po.get('pump_theta_stop'))]);
	                self.plotThetaPhi.setYRange([converter.to('deg', po.get('pump_phi_start')), converter.to('deg', po.get('pump_phi_stop'))]);
	
	                self.dataPolingTheta = values[2];
	                self.plotPolingTheta.setXRange([converter.to('micro', po.get('poling_period_start')), converter.to('micro', po.get('poling_period_stop'))]);
	                self.plotPolingTheta.setYRange([converter.to('deg', po.get('pump_theta_start')), converter.to('deg', po.get('pump_theta_stop'))]);
	
	                ///////////////////////////
	                self.dataLambdasThetas = values[3].data;
	                self.plotLambdasThetas.setXRange([l_start, l_stop]);
	                self.plotLambdasThetas.setYRange([t_start, t_stop]);
	
	                self.dataThetaPhiSignal = values[4];
	                self.plotThetaPhiSignal.setXRange([t_start, t_stop]);
	                self.plotThetaPhiSignal.setYRange([0, 90]);
	
	                self.dataThetaTheta = values[5];
	                self.plotThetaTheta.setXRange([t_start, t_stop]);
	                self.plotThetaTheta.setYRange([t_start, t_stop]);
	
	                return true; // this value is passed on to the next "then()"
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                dfd = when.defer();
	            // async... but not inside webworker
	
	            setTimeout(function () {
	                self.plotSignal.plotData(self.dataSignal);
	                self.plotPolingTheta.plotData(self.dataPolingTheta);
	                self.plotThetaPhi.plotData(self.dataThetaPhi);
	
	                ////////////////
	
	                // lambda signal vs theta signal plot
	                self.plotLambdasThetas.plotData(self.dataLambdasThetas);
	
	                // Theta vs Phi in the crystal
	                self.plotThetaPhiSignal.plotData(self.dataThetaPhiSignal);
	
	                // Theta vs Phi in the crystal
	                self.plotThetaTheta.plotData(self.dataThetaTheta);
	                dfd.resolve();
	            }, 10);
	            return dfd.promise;
	        }
	    });
	
	    return function (config) {
	
	        return new xy_UI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 501 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Phasematching as a function of the crystal angles</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-curve-theta-phi">&#x2296;</button> </div> </div> <div class="curve-theta-phi-wrapper"> </div> </div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Poling period as a function of crystal theta</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-curve-crystal">&#x2296;</button> </div> </div> <div class="curve-poling-wrapper"> <!-- phasematching curve for crystal theta/phi --> </div> </div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Signal wavelength as a function of pump wavelength</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-curve-signal">&#x2296;</button> </div> </div> <div class="curve-signal-wrapper"> <!-- angular emissio XY --> </div> </div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Opening angle (theta) versus azimuthal angle (phi) for the signal photon</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-theta-phi">&#x2296;</button> </div> </div> <div class="pm-theta-phi-wrapper"> <!-- phasematching curve for crystal theta/phi --> </div> </div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Emission angle of the signal versus the emission angle of the idler</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-thetas-thetai">&#x2296;</button> </div> </div> <div class="pm-theta-theta-wrapper"> <!-- lambda_signal vs theta signal --> </div> </div> <div class="plot-wrapper span7 offset1 last-parameters"> <div class="row-fluid"> <h2 class="title">Wavelength versus emission angle for the signal photon</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-lambda-theta">&#x2296;</button> </div> </div> <div class="lambda_s-theta_s-wrapper"> <!-- lambda_signal vs theta signal --> </div> </div></div>';return out;
	}

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484), __webpack_require__(503)
	// 'tpl!templates/time-delay-ctrl.tpl'
	], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplJSALayout
	// tplTimeDelayCtrl
	) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var delTConversion = 1e-15;
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsa2homUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 4,
	        tplPlots: tplJSALayout,
	        showPlotOpts: ['T_2HOM', 'signal-wavelength', 'idler-wavelength', 'time-delay'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            self.el.on('click', '#collapse-homjsa', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // init plot
	            self.plot1d = new LinePlot({
	                title: 'Hong-Ou-Mandel Dip',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Time delay (fs)',
	                    y: 'Coincidence probability'
	                },
	                format: { x: '.0f' },
	                width: 400,
	                height: 400,
	                yrange: [0, 0.65]
	            });
	
	            self.plot1d.resize(400, 250);
	            self.plot1d.displayLegend(true);
	            // self.plot1d.setTitle("boo");
	
	            self.elPlot1d = $(self.plot1d.el);
	
	            self.addPlot(self.plot1d);
	
	            self.initEvents();
	        },
	
	        refreshJSA: function refreshJSA() {
	
	            var self = this;
	            // self.calc_HOM_JSA( self.parameters.getProps() );
	            self.draw();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                tsi;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            tsi = PhaseMatch.autorange_delT_2crystal(props, lim.lambda_s.min, lim.lambda_s.max);
	
	            // self.set_slider_values(tsi[0], tsi[1], tsi[2]);
	
	            self.plotOpts.set({
	                'T_2HOM': 50,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	
	                'delT_start': tsi[1],
	                'delT_stop': tsi[2]
	            });
	        },
	
	        calc: function calc(props) {
	
	            var self = this,
	                threshold = 0.5;
	            // ,props = self.parameters.getProps();
	
	            var lim = PhaseMatch.autorange_lambda(props, threshold);
	            var tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max);
	
	            // self.calc_HOM_JSA( props );
	
	            // Hong-Ou-Mandel dip
	            // var t_start = 0e-15;
	            // var t_stop = 10000e-15;
	
	            var starttime = new Date();
	            var data_ss = [],
	                data_ii = [],
	                data_si = [],
	                po = self.plotOpts,
	                dim = po.get('T_2HOM'),
	                trange = [],
	                delT = PhaseMatch.linspace(po.get('delT_start'), po.get('delT_stop'), dim),
	                Nthreads = self.nWorkers,
	                divisions = Math.floor(dim / Nthreads),
	                promises = [];
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                trange.push(delT.subarray(i * divisions, i * divisions + divisions));
	            }
	            trange.push(delT.subarray((Nthreads - 1) * divisions, delT.length));
	
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.do2HOM', [props.get(), trange[j], po.get('ls_start'), po.get('ls_stop'), po.get('li_start'), po.get('li_stop'), dim]);
	            }
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr_ss = new Float64Array(dim);
	                var arr_ii = new Float64Array(dim);
	                var arr_si = new Float64Array(dim);
	
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    arr_ss.set(values[j][0], startindex);
	                    arr_ii.set(values[j][1], startindex);
	                    arr_si.set(values[j][2], startindex);
	                    // console.log("arr val set");
	                    startindex += trange[j].length;
	                }
	
	                var endtime = new Date();
	                console.log("2HOM Elapsed time: ", endtime - starttime);
	
	                return [arr_ss, arr_ii, arr_si]; // this value is passed on to the next "then()"
	            }).then(function (HOM) {
	
	                var data_ss = [],
	                    data_ii = [],
	                    data_si = [];
	
	                for (var i = 0, l = HOM[0].length; i < l; i++) {
	                    data_ss.push({
	                        x: delT[i] / 1e-15,
	                        y: HOM[0][i]
	                    });
	                }
	
	                for (i = 0, l = HOM[1].length; i < l; i++) {
	                    data_ii.push({
	                        x: delT[i] / 1e-15,
	                        y: HOM[1][i]
	                    });
	                }
	
	                for (i = 0, l = HOM[2].length; i < l; i++) {
	                    data_si.push({
	                        x: delT[i] / 1e-15,
	                        y: HOM[2][i]
	                    });
	                }
	
	                self.data1d = data_ss;
	                self.data_ii = data_ii;
	                self.data_si = data_si;
	
	                // Calculate visibility
	                // title: 'Hong-Ou-Mandel Dip'
	                var vis = (0.5 - Math.min.apply(null, HOM[0])) / 0.5;
	                // console.log("visibility", vis);
	                self.plot1d.setTitle("Hong-Ou-Mandel visibility = " + Math.round(1000 * vis) / 1000); //("Hong-Ou-Mandel Dip, Visbibility = ");
	                self.plot1d.setYRange([0, Math.max.apply(null, HOM[0]) * 1.3]);
	
	                return true;
	            });
	
	            // var HOM = PhaseMatch.calc_2HOM_scan_p(
	            //         props,
	            //         trange[0],
	            //         po.get('ls_start'),
	            //         po.get('ls_stop'),
	            //         po.get('li_start'),
	            //         po.get('li_stop'),
	            //         dim
	            //     )
	            //     ;
	
	
	            // var endtime = new Date();
	            // console.log("Time to run HOM scan code: ", endtime-starttime);
	
	            // for ( var i = 0, l = HOM['ss'].length; i < l; i ++){
	            //     data_ss.push({
	            //         x: delT[i]/1e-15,
	            //         y: HOM['ss'][i]
	            //     })
	            // }
	
	            // for (i = 0, l = HOM['ii'].length; i < l; i ++){
	            //     data_ii.push({
	            //         x: delT[i]/1e-15,
	            //         y: HOM['ii'][i]
	            //     })
	            // }
	
	            // for (i = 0, l = HOM['si'].length; i < l; i ++){
	            //     data_si.push({
	            //         x: delT[i]/1e-15,
	            //         y: HOM['si'][i]
	            //     })
	            // }
	
	            // self.data1d = data_ss;
	            // self.data_ii = data_ii;
	            // self.data_si = data_si;
	
	            // // Calculate visibility
	            // // title: 'Hong-Ou-Mandel Dip'
	            // var vis = (0.5 -  Math.min.apply(null, HOM['ss']))/0.5;
	            // // console.log("visibility", vis);
	            // self.plot1d.setTitle("Hong-Ou-Mandel visibility = " + Math.round(1000*vis)/1000);//("Hong-Ou-Mandel Dip, Visbibility = ");
	            // self.plot1d.setYRange([0, Math.max.apply(null,HOM['ss'])*1.3]);
	
	            // // self.plot1d.addSeries( data_ii, 'idler-idler' );
	
	
	            // // self.set_slider_values(tsi[0], po.get('delT_start'), po.get('delT_stop'));
	        },
	
	        set_slider_values: function set_slider_values(zero_delay, t_start, t_stop) {
	            var self = this;
	            // console.log("set slider values", self.eldelT.slider);
	            // @TODO Krister: Noticed a weird bug where using self.set to change "delT" causes the red line to
	            // disappear for any value other than 0.
	            self.eldelT.slider({
	                min: Math.round(t_start / 1e-15),
	                max: Math.round(t_stop / 1e-15)
	            });
	        },
	
	        calc_HOM_JSA: function calc_HOM_JSA(props) {
	
	            var self = this,
	                delT = self.get('delT'),
	                po = self.plotOpts,
	                PM = PhaseMatch.calc_HOM_JSA(props, po.get('ls_start'), po.get('ls_stop'), po.get('li_start'), po.get('li_stop'), self.get('delT'), po.get('grid_size'));
	
	            self.data = PM;
	
	            self.plot.setXRange([converter.to('nano', po.get('ls_start')), converter.to('nano', po.get('ls_stop'))]);
	            self.plot.setYRange([converter.to('nano', po.get('li_start')), converter.to('nano', po.get('li_stop'))]);
	            self.plot1d.setTitle("Time delay = " + self.get('delT') / 1e-15);
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data;
	
	            // other plot
	            // var data1d = self.data1d;
	            self.plot1d.clear();
	            self.plot1d.addSeries(self.data1d, 'signal-signal');
	            self.plot1d.addSeries(self.data_ii, 'idler-idler');
	            // self.plot1d.addSeries( self.data_si, 'signal-idler' );
	            self.plot1d.plotData();
	
	            // if (!data1d){
	            //     return this;
	            // }
	
	            // self.plot1d.plotData( data1d );
	
	
	            // if (!data){
	            //     return this;
	            // }
	        }
	    });
	
	    return function (config) {
	
	        return new jsa2homUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 503 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Hong-Ou-Mandel interference between signal and idler photons</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-homjsa">&#x2296;</button> </div> </div><div class="heat-map-wrapper"> <!-- heat map goes here --></div></div>';return out;
	}

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484), __webpack_require__(490), __webpack_require__(491)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplJSALayout, tplTimeDelayCtrl) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var delTConversion = 1e-15;
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsahomBunchUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 3,
	        tplPlots: tplJSALayout,
	        showPlotOpts: ['T_2HOM', 'grid_size', 'signal-wavelength', 'idler-wavelength', 'time-delay'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            self.el.on('click', '#collapse-homjsa', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // init plot
	            self.plot1d = new LinePlot({
	                title: 'Hong-Ou-Mandel Bunching',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Time delay (fs)',
	                    y: 'Coincidence probability'
	                },
	                format: { x: '.0f' },
	                width: 400,
	                height: 200,
	                yrange: [0.4, 1.2]
	            });
	
	            self.plot1d.resize(400, 150);
	            // self.plot1d.setTitle("boo");
	
	            self.elPlot1d = $(self.plot1d.el);
	
	            self.eldelT = $(tplTimeDelayCtrl()).appendTo(self.el.find('.heat-map-wrapper'));
	
	            self.eldelT.slider({
	                min: -800,
	                max: 800,
	                value: 0,
	                orientation: "horizontal",
	                range: "min",
	                change: function change() {
	
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                },
	                slide: function slide() {
	
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                }
	            });
	
	            self.set('delT', 0);
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Joint spectral amplitude',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            // internal events
	            var to;
	            self.on('change:delT', function (delT) {
	
	                self.refreshLine(delT);
	                self.plot1d.setTitle("Time delay = " + delT / 1e-15);
	
	                clearTimeout(to);
	                to = setTimeout(function () {
	
	                    // only refresh plots after a time delay
	                    self.refreshJSA();
	                }, 50);
	            });
	
	            self.on('refresh', function () {
	                self.refreshLine(self.get('delT'));
	            });
	
	            self.addPlot(self.plot);
	            self.addPlot(self.plot1d);
	            self.initEvents();
	        },
	
	        refreshJSA: function refreshJSA() {
	
	            var self = this;
	            self.calc_HOM_JSA(self.parameters.getProps());
	            self.draw();
	        },
	
	        // refresh the vertical line on the line-plot
	        refreshLine: function refreshLine(delT) {
	
	            var self = this,
	                line = self.plot1d.svgPlot.selectAll('.vline').data([delT]),
	                y = self.plot1d.scales.y,
	                dom = y.domain();
	
	            // console.log("dom", dom)
	
	            // create
	            line.enter().append('rect').attr("class", 'vline').attr("width", 2)
	            // .attr("height", 20)
	            // this measurement is awkward...
	            .attr("height", Math.abs(y(dom[0]) - y(dom[1]))).style("fill", '#16A085');
	
	            line.attr('x', function (d) {
	                return self.plot1d.scales.x(d / delTConversion);
	            });
	
	            line.exit().remove();
	
	            // var circle = self.plot1d.svgPlot.selectAll("circle").data([ delT ]);
	
	            // circle.enter()
	            //     .append('circle')
	            //     .attr("r", 4)
	            //     .style("fill", '#16A085');
	
	            // circle.attr('cx', function(d) {
	            //         return self.plot1d.scales.x( d / delTConversion );
	            //     })
	            //     ;
	
	            // // circle.attr('cy', function(d) {
	            // //         console.log("y pos", self.plot1d.scales.y( .1 ));
	            // //         return self.plot1d.scales.y( d/delTConversion );
	            // //     })
	            // //     ;
	
	            // circle.exit().remove();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                tsi;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max);
	
	            self.set_slider_values(tsi[0], tsi[1], tsi[2]);
	
	            self.plotOpts.set({
	                'grid_size': 50,
	                'T_2HOM': 200,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	
	                'delT_start': tsi[1],
	                'delT_stop': tsi[2]
	            });
	        },
	
	        calc: function calc(props) {
	
	            props = this.parameters.getProps();
	
	            var self = this,
	                threshold = 0.5,
	                lim = PhaseMatch.autorange_lambda(props, threshold),
	                tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max),
	                data1d = [],
	                po = self.plotOpts,
	                dim = po.get('T_2HOM'),
	                trange = [],
	                delT = PhaseMatch.linspace(po.get('delT_start'), po.get('delT_stop'), dim),
	                Nthreads = self.nWorkers - 2,
	                divisions = Math.floor(dim / Nthreads),
	                promises = [];
	
	            // First calc the joint spectrum.
	            self.calc_HOM_JSA(props);
	
	            // Next we begin the calculation of the HOM dip
	            var starttime = new Date();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                trange.push(delT.subarray(i * divisions, i * divisions + divisions));
	            }
	            trange.push(delT.subarray((Nthreads - 1) * divisions, delT.length));
	
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.doHOM', [props.get(), trange[j], po.get('ls_start'), po.get('ls_stop'), po.get('li_start'), po.get('li_stop'), po.get('grid_size'), false]);
	            }
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(dim);
	
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    arr.set(values[j], startindex);
	
	                    startindex += trange[j].length;
	                }
	
	                var endtime = new Date();
	                console.log("HOM bunching Elapsed time: ", endtime - starttime);
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (HOM) {
	
	                for (var i = 0, l = HOM.length; i < l; i++) {
	                    data1d.push({
	                        x: delT[i] / 1e-15,
	                        y: HOM[i]
	                    });
	                }
	                self.data1d = data1d;
	                self.draw();
	
	                // Calculate visibility
	                // var vis = (0.5 -  Math.min.apply(null, HOM))/0.5;
	                // self.plot1d.setTitle("Hong-Ou-Mandel visibility = " + Math.round(1000*vis)/1000);//("Hong-Ou-Mandel Dip, Visbibility = ");
	                // self.plot1d.setYRange([0, Math.max.apply(null,HOM)*1.2]);
	                self.plot1d.setYRange([0.4, Math.max.apply(null, HOM) * 1.2]);
	                self.set_slider_values(tsi[0], po.get('delT_start'), po.get('delT_stop'));
	
	                var endtime = new Date();
	
	                return true;
	            });
	        },
	
	        set_slider_values: function set_slider_values(zero_delay, t_start, t_stop) {
	            var self = this;
	            // console.log("set slider values", self.eldelT.slider);
	            // @TODO Krister: Noticed a weird bug where using self.set to change "delT" causes the red line to
	            // disappear for any value other than 0.
	            self.eldelT.slider({
	                min: Math.round(t_start / 1e-15),
	                max: Math.round(t_stop / 1e-15)
	            });
	        },
	
	        updateJSATitle: function updateJSATitle(PM) {
	            var self = this;
	            return self.workers[self.nWorkers - 1].exec('jsaHelper.doCalcSchmidt', [PM], true).then(function (S) {
	                self.plot.setTitle("Schmidt Number = " + Math.round(1000 * S) / 1000);
	            });
	        },
	
	        calc_HOM_JSA: function calc_HOM_JSA(props) {
	
	            var self = this,
	                delT = self.get('delT'),
	                po = self.plotOpts;
	
	            var st = new Date();
	
	            // Can only run in one thread. This graph is not easily parallizable. Need
	            // the entire grid to do the computation.
	            return self.workers[self.nWorkers - 2].exec('jsaHelper.doCalcHOMJSA', [props.get(), po.get('ls_start'), po.get('ls_stop'), po.get('li_start'), po.get('li_stop'), delT, po.get('grid_size'), false]).then(function (PM) {
	                var p = self.updateJSATitle(PM);
	                self.data = PM;
	                self.draw();
	                // var S= PhaseMatch.calc_Schmidt(PM);
	                // self.plot.setTitle("Schmidt Number = " + Math.round(1000*S)/1000);
	                self.plot.setXRange([converter.to('nano', po.get('ls_start')), converter.to('nano', po.get('ls_stop'))]);
	                self.plot.setYRange([converter.to('nano', po.get('li_start')), converter.to('nano', po.get('li_stop'))]);
	                var sp = new Date();
	
	                return p;
	                // console.log("time jsa", sp -st);
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data;
	
	            if (!data) {
	                return this;
	            }
	
	            self.plot.plotData(data);
	
	            // other plot
	            var data1d = self.data1d;
	
	            if (!data1d) {
	                return this;
	            }
	
	            self.plot1d.plotData(data1d);
	        }
	    });
	
	    return function (config) {
	
	        return new jsahomBunchUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(506)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, tplMSLayout) {
	
	    'use strict';
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsaUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        tplPlots: tplMSLayout,
	        showPlotOpts: ['grid_size', 'signal-wavelength', 'idler-wavelength'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-modesolver', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            var margins = {
	                top: 60,
	                right: 40,
	                left: 80,
	                bottom: 60
	            };
	
	            this.heatmapmargins = margins;
	
	            // init plot
	            self.plot2dSignal = new HeatMap({
	                title: 'Idler spatial mode',
	                el: self.el.find('.signalmode').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Pump Waist (um)',
	                    y: 'Signal/Idler Waist (um)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                format: {
	                    x: '.02f',
	                    y: '.02f'
	                }
	            });
	
	            self.addPlot(self.plot2dSignal);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	
	            self.plotOpts.set({
	                'grid_size': 8,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max
	            });
	        },
	
	        calc: function calc(props) {
	
	            var self = this;
	            var po = this.plotOpts;
	
	            var scale = 6;
	            var dimlambda = 10;
	
	            //make sure the angles are correct so we can calculate the right ranges
	            props.phi_i = props.phi_s + Math.PI;
	            props.update_all_angles();
	            //find the external idler angle
	            props.theta_i_e = PhaseMatch.find_external_angle(props, 'idler');
	
	            var X_0 = Math.asin(Math.sin(props.theta_i_e) * Math.cos(props.phi_i));
	            var Y_0 = Math.asin(Math.sin(props.theta_i_e) * Math.sin(props.phi_i));
	
	            // console.log("central idler angles:", props.theta_i_e *180/Math.PI);
	            // console.log(po.get('collection_bw')/1e-9);
	
	            // var W = Math.max(props.W_sx, props.W_sy);
	            var convertfromFWHM = 1 / (2 * Math.sqrt(Math.log(2)));
	            var W = props.W * convertfromFWHM;
	            W = props.lambda_p / (Math.PI * W); // angular spread
	
	            var x_start = X_0 - scale * W / 2;
	            var x_stop = X_0 + scale * W / 2;
	            var y_start = Y_0 - scale * W / 2;
	            var y_stop = Y_0 + scale * W / 2;
	
	            var wavelengths = {
	                "ls_start": po.get("ls_start"),
	                "ls_stop": po.get("ls_stop"),
	                "li_start": po.get("li_start"),
	                "li_stop": po.get("li_stop")
	            };
	
	            var startTime = new Date();
	
	            var PM_s = PhaseMatch.calc_XY_mode_solver2(props, x_start, x_stop, y_start, y_stop, wavelengths, po.get('grid_size'), dimlambda);
	
	            var endTime = new Date();
	            var timeDiff = endTime - startTime;
	            console.log(timeDiff);
	            // console.log(scale, props.W_sx*180/Math.PI, props.W_sx*scale *180/Math.PI);
	
	            // var PM_s = PhaseMatch.calc_XY_mode_solver(
	            //     props,
	            //     -1 * po.get('theta_stop'),
	            //     po.get('theta_stop'),
	            //     -1 * po.get('theta_stop'),
	            //     po.get('theta_stop'),
	            //     po.get('grid_size')
	            // );
	            // console.log(PM_s[0]);
	            self.data = PM_s['pmsingles'];
	            self.plot2dSignal.setZRange([0, Math.max.apply(null, PM_s['pmsingles'])]);
	            self.plot2dSignal.setXRange([converter.to('deg', x_start), converter.to('deg', x_stop)]);
	            self.plot2dSignal.setYRange([converter.to('deg', y_start), converter.to('deg', y_stop)]);
	
	            self.plot2dSignal.setTitle("Idler coupling efficiency  = " + Math.round(1000 * PM_s['eff']) / 10 + "%");
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data;
	
	            if (!data) {
	                return this;
	            }
	
	            self.plot2dSignal.plotData(data);
	        }
	    });
	
	    return function (config) {
	
	        return new jsaUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Idler coupling efficiency assuming symmetric coupling </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-modesolver">&#x2296;</button> </div> </div><div class="signalmode"> <!-- heat map goes here --></div></div>';return out;
	}

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(487), __webpack_require__(488)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, tplJSALayout, tplDocsJSA) {
	
	    'use strict';
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module HeraldingUI
	     * @implements {Stapes}
	     */
	    var heraldingUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 6,
	        tplPlots: tplJSALayout,
	        tplDoc: tplDocsJSA,
	        showPlotOpts: ['grid_size', 'signal-wavelength', 'idler-wavelength'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-jsa', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            var margins = {
	                top: 60,
	                right: 40,
	                left: 80,
	                bottom: 60
	            };
	
	            // init plot
	            self.plotSingles = new HeatMap({
	                title: 'Joint spectral amplitude',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Wavelength of Signal (nm)',
	                    y: 'Wavelength of Idler (nm)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            self.plotCoinc = new HeatMap({
	                title: 'Joint spectral Intensity Coincidences',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Wavelength of Signal (nm)',
	                    y: 'Wavelength of Idler (nm)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                }
	            });
	
	            self.addPlot(self.plotSingles);
	            self.addPlot(self.plotCoinc);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	
	            self.plotOpts.set({
	                'grid_size': 40,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max
	                // 'ls_start': 0.81E-6,
	                // 'ls_stop': 0.81E-6,
	                // 'li_start': 0.81E-6,
	                // 'li_stop': 0.81E-6
	            });
	        },
	
	        updateTitle: function updateTitle(PM) {
	            var self = this;
	            return self.workers[this.nWorkers - 1].exec('jsaHelper.doCalcSchmidt', [PM]).then(function (S) {
	                self.plotSingles.setTitle("Schmidt Number = " + Math.round(1000 * S) / 1000);
	            });
	        },
	
	        calc: function calc(props) {
	            // var testlinspace = PhaseMatch.linspace(0,25.3, 10);
	            // console.log("linspace test: ", testlinspace);
	            var self = this;
	            // var props = PhaseMatch.convertToMicrons(P);
	            // console.log("FINISHED CONVERSION");
	            var propsJSON = props.get(),
	                grid_size = self.plotOpts.get('grid_size');
	
	            var lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size);
	
	            var Nthreads = self.nWorkers - 1;
	
	            var divisions = Math.floor(grid_size / Nthreads);
	
	            var lambda_i_range = [];
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	            // Get the normalization
	            var Pn = props.clone();
	            Pn.phi_i = Pn.phi_s + Math.PI;
	            Pn.update_all_angles();
	            props.optimum_idler();
	            // console.log("Theta_s - Theta_i: ",(props.theta_s)*180/Math.PI, (props.theta_i)*180/Math.PI,  (props.theta_s - props.theta_i)*180/Math.PI);
	            // Pn.optimum_idler(P);
	            // P.theta_i_e = PhaseMatch.find_external_angle(P,"idler");
	            // console.log("External angle of the idler is:", P.theta_i_e*180/Math.PI );
	            // console.log("angles: ", P.theta_s * 180/Math.PI,  P.theta_i * 180/Math.PI,  P.theta_s_e * 180/Math.PI,  P.theta_i_e * 180/Math.PI);
	            // var PMN =  PhaseMatch.phasematch(props);
	            // var norm = Math.sqrt(PMN[0]*PMN[0] + PMN[1]*PMN[1]);
	            var norm = 1;
	            // var norm = Math.sqrt(PhaseMatch.normalize_joint_spectrum(props));
	            // console.log("Normalization: ",norm);
	            self.calcRSingles(props, propsJSON, lambda_s, lambda_i_range, grid_size, norm, Nthreads);
	
	            // self.calcRCoinc(props, propsJSON,lambda_s,lambda_i_range,grid_size, norm, Nthreads);
	
	            // var norm = 1;
	
	            // // The calculation is split up and reutrned as a series of promises
	            // var starttime = new Date();
	            // var self = this;
	            // var promises = [];
	
	
	            // for (var j = 0; j < Nthreads; j++){
	
	            //     promises[j] = self.workers[j].exec('jsaHelper.doJSASinglesCalc', [
	            //         propsJSON,
	            //         lambda_s,
	            //         lambda_i_range[j],
	            //         grid_size,
	            //         norm
	            //     ]);
	            // }
	            // // console.log(PhaseMatch.linspace(0,10,10));
	
	            // return when.all( promises ).then(function( values ){
	            //         // put the results back together
	            //         var arr = new Float64Array( grid_size *  grid_size );
	            //         var startindex = 0;
	
	            //         for (j = 0; j<Nthreads; j++){
	            //             // console.log(j, j*lambda_s.length*lambda_i_range[j].length, values[j].length +  j*lambda_s.length*lambda_i_range[j].length);
	
	            //              arr.set(values[j], startindex);
	            //              startindex += lambda_s.length*lambda_i_range[j].length;
	
	            //         }
	            //         // PhaseMatch.normalize(arr);
	
	            //         return arr; // this value is passed on to the next "then()"
	
	            //      }).then(function( PM ){
	            //         // var p = self.updateTitle( PM );
	            //         self.data = PM;
	            //         // console.log("data", PM);
	            //         self.plotSingles.setZRange([0,Math.max.apply(null,PM)]);
	            //         self.plotSingles.setXRange([ converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop')) ]);
	            //         self.plotSingles.setYRange([ converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop')) ]);
	
	            //         var endtime = new Date();
	            //         // console.log("Grid Size:", grid_size, " Elapsed time: ", endtime - starttime);
	            //         // return p;
	            //         // self.draw();
	            //         self.calcRCoinc(props, propsJSON,lambda_s,lambda_i_range,grid_size, Nthreads);
	            //         return true;
	
	            //     // }).then(self.calcRCoinc(props, propsJSON,lambda_s,lambda_i_range,grid_size, Nthreads))
	            //     // // }).then(function() {
	            //     // //     self.calcRCoinc(props, propsJSON,lambda_s,lambda_i_range,grid_size, Nthreads);
	            //     // //     return true;
	            //     // // });
	            //     // .then(function(val) {
	            //     //     return true;
	            //     });
	        },
	
	        calcRSingles: function calcRSingles(props, propsJSON, lambda_s, lambda_i_range, grid_size, norm, Nthreads) {
	            // @TODO: Not sure I need the sqrt here.
	            // var norm = Math.sqrt(PhaseMatch.normalize_joint_spectrum_singles(props));
	            norm = 1;
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var self = this;
	            var promises = [];
	
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSASinglesCalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, norm]);
	            }
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    // console.log(j, j*lambda_s.length*lambda_i_range[j].length, values[j].length +  j*lambda_s.length*lambda_i_range[j].length);
	
	                    arr.set(values[j], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                // PhaseMatch.normalize(arr);
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	                // var p = self.updateTitle( PM );
	                self.data = PM;
	                // console.log("Max singles", PhaseMatch.max(PM));
	                self.plotSingles.setZRange([0, Math.max.apply(null, PM)]);
	                self.plotSingles.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotSingles.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	                self.calcRCoinc(props, propsJSON, lambda_s, lambda_i_range, grid_size, Nthreads);
	                return true;
	            });
	        },
	
	        calcRCoinc: function calcRCoinc(props, propsJSON, lambda_s, lambda_i_range, grid_size, Nthreads) {
	
	            // var norm = Math.sqrt(PhaseMatch.normalize_joint_spectrum(props));
	            // console.log("norm differences:", norm,  Math.sqrt(PhaseMatch.normalize_joint_spectrum(props)));
	            var norm = 1;
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var self = this;
	            var promises = [];
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSACalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, norm]);
	            }
	
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    // console.log(j, j*lambda_s.length*lambda_i_range[j].length, values[j].length +  j*lambda_s.length*lambda_i_range[j].length);
	
	                    arr.set(values[j], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                // PhaseMatch.normalize(arr);
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	
	                // var p = self.updateTitle( PM );
	                self.dataCoinc = PM;
	                // console.log("data", PM);
	                self.plotCoinc.setZRange([0, Math.max.apply(null, PM)]);
	                self.plotCoinc.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotCoinc.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	                // console.log("Grid Size:", grid_size, " Elapsed time: ", endtime - starttime);
	
	
	                var eff = self.calcEfficiency(props);
	                console.log("efficiency: ", eff);
	                self.draw();
	                // console.log("FINISHED PLOTTING");
	                return true;
	            });
	        },
	
	        calcEfficiency: function calcEfficiency(P) {
	            var self = this;
	            if (!self.data || !self.dataCoinc) {
	                return 0;
	            }
	
	            var convfromFWHM = 1,
	                Wi_SQ = Math.pow(P.W_sx * convfromFWHM, 2) // convert from FWHM to sigma @TODO: Change to P.W_i
	            ,
	                PHI_s = 1 / Math.cos(P.theta_s_e),
	                Rc = PhaseMatch.Sum(self.dataCoinc),
	                Rs = PhaseMatch.Sum(self.data),
	                eff = Rc / Rs * (Wi_SQ * PHI_s),
	                Rmax = PhaseMatch.max(self.dataCoinc) / PhaseMatch.max(self.data) * (Wi_SQ * PHI_s);
	
	            console.log("From calc:", Rc, Rs, eff);
	
	            return eff;
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data = self.data,
	                dfd = when.defer();
	
	            if (!data || !self.dataCoinc) {
	                return this;
	            }
	
	            // async... but not inside webworker
	            setTimeout(function () {
	                self.plotSingles.plotData(data);
	                self.plotCoinc.plotData(self.dataCoinc);
	                dfd.resolve();
	            }, 10);
	
	            return dfd.promise;
	        }
	
	    });
	
	    return function (config) {
	
	        return new heraldingUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484), __webpack_require__(509)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplHeraldingLayout) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module schmidtUI
	     * @implements {Stapes}
	     */
	    var heralding2dUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 6,
	        tplPlots: tplHeraldingLayout,
	        showPlotOpts: ['grid_size_heralding', 'signal-wavelength', 'idler-wavelength', 'pump-waist', 'signal-waist'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-efficiency-s', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-efficiency-i', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-s', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-i', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-coinc', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            var margins = {
	                top: 60,
	                right: 40,
	                left: 80,
	                bottom: 60
	            };
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Idler heralding efficiency',
	                el: self.el.find('.efficiency_i-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Pump Waist (1/e^2) (um)',
	                    y: 'Signal & Idler Waist (1/e^2) (um)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                antialias: false,
	                format: {
	                    x: '.01f',
	                    y: '.01f'
	                }
	            });
	
	            // Signal Heralding Efficiency plot
	            self.plotSignalEff = new HeatMap({
	                title: 'Signal heralding efficiency',
	                el: self.el.find('.efficiency_s-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Pump Waist (1/e^2) (um)',
	                    y: 'Signal & Idler Waist (1/e^2) (um)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                antialias: false,
	                format: {
	                    x: '.01f',
	                    y: '.01f'
	                }
	            });
	
	            // Signal singles plot
	            self.plotSingles = new HeatMap({
	                title: 'Signal singles rate',
	                el: self.el.find('.singles_s-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Pump Waist (1/e^2) (um) ',
	                    y: 'Signal/Idler Waist (1/e^2) (um)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                antialias: false,
	                format: {
	                    x: '.01f',
	                    y: '.01f'
	                }
	            });
	
	            // Idler singles plot
	            self.plotIdlerSingles = new HeatMap({
	                title: 'Idler Singles rate',
	                el: self.el.find('.singles_i-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Pump Waist (1/e^2) (um) ',
	                    y: 'Signal/Idler Waist (1/e^2) (um)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                antialias: false,
	                format: {
	                    x: '.01f',
	                    y: '.01f'
	                }
	            });
	
	            // Coinc plot
	            self.plotCoinc = new HeatMap({
	                title: 'Coinc rate (normalized to max singles value)',
	                el: self.el.find('.coinc-wrapper').get(0),
	                margins: margins,
	                labels: {
	                    x: 'Pump Waist (1/e^2) (um)',
	                    y: 'Signal/Idler Waist (1/e^2) (um)'
	                },
	                xrange: [0, 200],
	                yrange: [0, 100],
	                antialias: false,
	                format: {
	                    x: '.01f',
	                    y: '.01f'
	                }
	            });
	
	            self.addPlot(self.plot);
	            self.addPlot(self.plotSignalEff);
	            self.addPlot(self.plotSingles);
	            self.addPlot(self.plotIdlerSingles);
	            self.addPlot(self.plotCoinc);
	            self.initEvents();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	
	            self.plotOpts.set({
	                'grid_size_heralding': 5,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	                'Ws_start': 50e-6,
	                'Ws_stop': 150e-6,
	                'Wp_start': 50e-6,
	                'Wp_stop': 300e-6
	
	            });
	        },
	
	        calc: function calc(props) {
	
	            var self = this,
	                Nthreads = self.nWorkers,
	                grid_size = self.plotOpts.get('grid_size_heralding'),
	                divisions = Math.floor(grid_size / Nthreads),
	                xrange = [],
	                yrange = [],
	                promises = [];
	
	            // var params = {
	            //     x: "L",
	            //     y: "BW"
	            // };
	
	            var Ws = PhaseMatch.linspace(self.plotOpts.get('Ws_stop'), self.plotOpts.get('Ws_start'), grid_size);
	
	            // be sure to reverse the order of this array so the graph makes sense.
	            // Effectively, this moves the origin to the bottom right corner.
	            var Wp = PhaseMatch.linspace(self.plotOpts.get('Wp_start'), self.plotOpts.get('Wp_stop'), grid_size);
	
	            xrange = Wp;
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                yrange.push(Ws.subarray(i * divisions, i * divisions + divisions));
	            }
	            yrange.push(Ws.subarray((Nthreads - 1) * divisions, Ws.length));
	
	            var starttime = new Date();
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.doCalcHeraldingEff', [props.get(), xrange, yrange[j], self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), self.plotOpts.get('li_start'), self.plotOpts.get('li_stop'), self.plotOpts.get('grid_size_heralding')]);
	            }
	
	            var startindex = 0;
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var eff_i = new Float64Array(grid_size * grid_size);
	                var eff_s = new Float64Array(grid_size * grid_size);
	                var singles_s = new Float64Array(grid_size * grid_size);
	                var singles_i = new Float64Array(grid_size * grid_size);
	                var coinc = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	                for (j = 0; j < Nthreads; j++) {
	                    eff_i.set(values[j][0], startindex);
	                    eff_s.set(values[j][1], startindex);
	                    singles_s.set(values[j][2], startindex);
	                    singles_i.set(values[j][3], startindex);
	                    coinc.set(values[j][4], startindex);
	                    // console.log("eff_i val set");
	                    startindex += xrange.length * yrange[j].length;
	                }
	                return [eff_i, eff_s, singles_s, singles_i, coinc]; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	                self.eff_i = PM[0];
	                self.eff_s = PM[1];
	                self.singles_s = PM[2];
	                self.singles_i = PM[3];
	                self.coinc = PM[4];
	
	                var maxEff_s = Math.max.apply(null, self.eff_s);
	                var maxEff_i = Math.max.apply(null, self.eff_i);
	                var maxEff = Math.max(maxEff_s, maxEff_i);
	
	                // self.plot.setZRange([Math.min.apply(null,PM[0]),Math.max.apply(null,self.eff_i)]);
	                self.plot.setZRange([0, maxEff]);
	                self.plot.setXRange([converter.to('micro', self.plotOpts.get('Wp_start')), converter.to('micro', self.plotOpts.get('Wp_stop'))]);
	                self.plot.setYRange([converter.to('micro', self.plotOpts.get('Ws_start')), converter.to('micro', self.plotOpts.get('Ws_stop'))]);
	
	                // self.plotSignalEff.setZRange([Math.min.apply(null,PM[0]),Math.max.apply(null,self.eff_s)]);
	                self.plotSignalEff.setZRange([0, maxEff]);
	                self.plotSignalEff.setXRange([converter.to('micro', self.plotOpts.get('Wp_start')), converter.to('micro', self.plotOpts.get('Wp_stop'))]);
	                self.plotSignalEff.setYRange([converter.to('micro', self.plotOpts.get('Ws_start')), converter.to('micro', self.plotOpts.get('Ws_stop'))]);
	
	                var norm_s = Math.max.apply(null, self.singles_s);
	                var norm_i = Math.max.apply(null, self.singles_i);
	                var norm = Math.max(norm_s, norm_i);
	                // var norm = 1;
	
	                self.singles_s = PhaseMatch.normalizeToVal(self.singles_s, norm);
	                self.singles_i = PhaseMatch.normalizeToVal(self.singles_i, norm);
	
	                self.plotSingles.setZRange([0, 1]);
	                self.plotSingles.setXRange([converter.to('micro', self.plotOpts.get('Wp_start')), converter.to('micro', self.plotOpts.get('Wp_stop'))]);
	                self.plotSingles.setYRange([converter.to('micro', self.plotOpts.get('Ws_start')), converter.to('micro', self.plotOpts.get('Ws_stop'))]);
	
	                self.plotIdlerSingles.setZRange([0, 1]);
	                self.plotIdlerSingles.setXRange([converter.to('micro', self.plotOpts.get('Wp_start')), converter.to('micro', self.plotOpts.get('Wp_stop'))]);
	                self.plotIdlerSingles.setYRange([converter.to('micro', self.plotOpts.get('Ws_start')), converter.to('micro', self.plotOpts.get('Ws_stop'))]);
	
	                // self.plotCoinc.setZRange([0,Math.max.apply(null,PM[1])]);
	                self.coinc = PhaseMatch.normalizeToVal(self.coinc, norm);
	                // self.plotCoinc.setZRange([0,1]);
	                self.plotCoinc.setXRange([converter.to('micro', self.plotOpts.get('Wp_start')), converter.to('micro', self.plotOpts.get('Wp_stop'))]);
	                self.plotCoinc.setYRange([converter.to('micro', self.plotOpts.get('Ws_start')), converter.to('micro', self.plotOpts.get('Ws_stop'))]);
	                var endtime = new Date();
	                console.log(" Elapsed time: ", endtime - starttime);
	
	                return true;
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                eff_i = self.eff_i,
	                eff_s = self.eff_s,
	                singles_s = self.singles_s,
	                singles_i = self.singles_i,
	                coinc = self.coinc,
	                dfd = when.defer();
	
	            if (!eff_i && !singles_s && !coinc && !eff_s && !singles_i) {
	                return this;
	            }
	
	            // self.plot.plotData( eff_i );
	            // async... but not inside webworker
	            setTimeout(function () {
	                self.plot.plotData(eff_i);
	                self.plotSignalEff.plotData(eff_s);
	                self.plotSingles.plotData(singles_s);
	                self.plotIdlerSingles.plotData(singles_i);
	                self.plotCoinc.plotData(coinc);
	                dfd.resolve();
	            }, 10);
	
	            return dfd.promise;
	        }
	    });
	
	    return function (config) {
	
	        return new heralding2dUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 509 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Signal heralding efficiency ( \\( \\eta_s = \\frac{R_i}{R_c} \\)) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-efficiency-s">&#x2296;</button> </div> </div> <div class="efficiency_s-wrapper "> <!-- heat map goes here --> </div> </div> <div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Idler heralding efficiency ( \\( \\eta_i = \\frac{R_s}{R_c} \\)) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-efficiency-i">&#x2296;</button> </div> </div><div class="efficiency_i-wrapper "> <!-- heat map goes here --></div></div><div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Normalized singles rates for the Signal (\\(R_s\\)) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-singles-s">&#x2296;</button> </div> </div><div class="singles_s-wrapper "> <!-- heat map goes here --></div></div> <div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Normalized singles rates for the Idler (\\(R_i\\)) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-singles-i">&#x2296;</button> </div> </div> <div class="singles_i-wrapper "> <!-- heat map goes here --> </div> </div><div class="plot-wrapper last-parameters span7 offset1"> <div class="row-fluid"> <h2 class="title">Fiber-coupled coincidences rates (\\(R_c\\)) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-coinc">&#x2296;</button> </div> </div><div class="coinc-wrapper "> <!-- heat map goes here --></div></div>';return out;
	}

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484), __webpack_require__(511), __webpack_require__(491)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplJSALayout, tplWaistCtrl) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var delTConversion = 1e-6;
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsahomUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 6,
	        tplPlots: tplJSALayout,
	        showPlotOpts: ['npts-heralding-waist', 'grid_size_heralding_JSI', 'signal-wavelength', 'idler-wavelength', 'signal-waist'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            self.el.on('click', '#collapse-homjsa', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-s', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-i', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-coinc', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // init plot
	            self.plot1dEff = new LinePlot({
	                title: 'Heralding Efficiency',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Signal and Idler Collection Waist (um)',
	                    y: 'Efficiency'
	                },
	                format: { x: '1f',
	                    y: '.2f' },
	                width: 400,
	                height: 200,
	                yrange: [0, 1]
	            });
	
	            self.plot1dEff.resize(400, 150);
	            self.plot1dEff.displayLegend(true);
	            // self.plot1dEff.setTitle("boo");
	
	            self.elPlot1d = $(self.plot1dEff.el);
	
	            self.eldelT = $(tplWaistCtrl()).appendTo(self.el.find('.heat-map-wrapper'));
	
	            self.eldelT.slider({
	                min: 50,
	                max: 200,
	                value: 100,
	                orientation: "horizontal",
	                range: "min",
	                change: function change() {
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                },
	                slide: function slide() {
	
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                }
	            });
	
	            self.set('delT', 100e-6);
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.singles-s-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	
	            self.plotIdler = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.singles-i-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	            // init plot Coinc
	            self.plotCoinc = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.coinc-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: ''
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	
	            self.dataCoinc = PhaseMatch.zeros(40, 40);
	
	            // internal events
	            var to;
	            self.on('change:delT', function (delT) {
	
	                self.refreshLine(delT);
	                // self.plot1dEff.setTitle("Collection Waist = " + delT/1e-6);
	
	                clearTimeout(to);
	                to = setTimeout(function () {
	
	                    // only refresh plots after a time delay
	                    self.refreshJSA();
	                }, 50);
	            });
	
	            self.on('refresh', function () {
	                self.refreshLine(self.get('delT'));
	            });
	
	            self.addPlot(self.plot);
	            self.addPlot(self.plotIdler);
	            self.addPlot(self.plotCoinc);
	            self.addPlot(self.plot1dEff);
	            self.initEvents();
	
	            // var props = self.parameters.getProps();
	            // self.set('delT', 200e-6);
	        },
	
	        refreshJSA: function refreshJSA() {
	
	            var self = this;
	            // self.calc_HOM_JSA( self.parameters.getProps() );
	            self.calcRSingles(self.parameters.getProps());
	            // self.calcRCoinc( self.parameters.getProps() );
	            self.draw();
	        },
	
	        // refresh the vertical line on the line-plot
	        refreshLine: function refreshLine(delT) {
	
	            var self = this,
	                line = self.plot1dEff.svgPlot.selectAll('.vline').data([delT]),
	                y = self.plot1dEff.scales.y,
	                dom = y.domain();
	
	            // console.log("dom", dom)
	
	            // create
	            line.enter().append('rect').attr("class", 'vline').attr("width", 2)
	            // .attr("height", 20)
	            // this measurement is awkward...
	            .attr("height", Math.abs(y(dom[0]) - y(dom[1]))).style("fill", '#16A085');
	
	            // console.log("ydim: ", Math.abs(y(dom[0]) - y(dom[1])));
	            line.attr('x', function (d) {
	                return self.plot1dEff.scales.x(d / delTConversion);
	            });
	
	            line.exit().remove();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                tsi;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max);
	
	            self.plotOpts.set({
	                'grid_size_heralding_JSI': 30,
	                'n_pts_eff_1d': 10,
	                'n_int': 14,
	                // 'grid_size_heralding_JSI': 2,
	                // 'n_pts_eff_1d': 2,
	                // 'n_int': 2,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	
	                // 'delT_start': tsi[1],
	                // 'delT_stop': tsi[2],
	
	                'Ws_start': 30e-6,
	                'Ws_stop': 130e-6
	            });
	
	            self.set_slider_values(100e-6, self.plotOpts.get['Ws_start'], self.plotOpts.get['Ws_stop']);
	        },
	
	        calc: function calc(P) {
	
	            var self = this,
	                threshold = 0.5
	            // ,props = self.parameters.getProps()
	            ,
	                props = P.clone(),
	                lim = PhaseMatch.autorange_lambda(props, threshold),
	                tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max),
	                data1d = [],
	                po = self.plotOpts,
	                dim = po.get('n_pts_eff_1d'),
	                npts = po.get('n_pts_eff_1d'),
	                trange = [],
	                Nthreads = self.nWorkers - 1,
	                divisions = Math.floor(npts / Nthreads),
	                promises = [],
	                yrange = [],
	                Ws = PhaseMatch.linspace(self.plotOpts.get('Ws_start'), self.plotOpts.get('Ws_stop'), npts);
	            // ,Ws = PhaseMatch.linspace(
	            //         P.W_sx,
	            //         1.001*P.W_sx,
	            //         npts
	            //     );
	            // ;
	
	            // // First calc the joint spectrum.
	            // // self.calc_HOM_JSA( props );
	            self.calcRSingles(P);
	            // self.calcRCoinc( props );
	
	            // Next we begin the calculation of the HOM dip
	            var starttime = new Date();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                yrange.push(Ws.subarray(i * divisions, i * divisions + divisions));
	            }
	            yrange.push(Ws.subarray((Nthreads - 1) * divisions, Ws.length));
	
	            starttime = new Date();
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.doCalcHeraldingEff', [props.get(), [props.W], yrange[j], self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), self.plotOpts.get('li_start'), self.plotOpts.get('li_stop'), self.plotOpts.get('n_int')]);
	            }
	
	            var startindex = 0;
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var eff_i = new Float64Array(npts);
	                var eff_s = new Float64Array(npts);
	                var singles_s = new Float64Array(npts);
	                var singles_i = new Float64Array(npts);
	                var coinc = new Float64Array(npts);
	                var startindex = 0;
	                for (j = 0; j < Nthreads; j++) {
	                    eff_i.set(values[j][0], startindex);
	                    eff_s.set(values[j][1], startindex);
	                    singles_s.set(values[j][2], startindex);
	                    singles_i.set(values[j][3], startindex);
	                    coinc.set(values[j][4], startindex);
	                    // console.log("eff_i val set");
	                    startindex += yrange[j].length;
	                }
	                // return eff_i;
	                return [eff_i, eff_s, singles_s, singles_i, coinc]; // this value is passed on to the next "then()"
	
	            }).then(function (data) {
	
	                var eff_i = data[0],
	                    eff_s = data[1],
	                    dataEff_i = [],
	                    dataEff_s = [];
	
	                for (var _i = 0, l = eff_i.length; _i < l; _i++) {
	                    // console.log(eff[i]);
	                    dataEff_i.push({
	                        x: Ws[_i] / 1e-6,
	                        y: eff_i[_i]
	                    });
	                }
	                self.dataEff_i = dataEff_i;
	
	                for (var _i2 = 0, _l = eff_s.length; _i2 < _l; _i2++) {
	                    // console.log(eff[i]);
	                    dataEff_s.push({
	                        x: Ws[_i2] / 1e-6,
	                        y: eff_s[_i2]
	                    });
	                }
	                self.dataEff_s = dataEff_s;
	
	                self.draw();
	
	                // Calculate visibility
	                self.plot1dEff.setTitle("Efficiency"); //("Hong-Ou-Mandel Dip, Visbibility = ");
	                var effMax = Math.max(Math.max.apply(null, eff_s), Math.max.apply(null, eff_i)),
	                    effMin = Math.min(Math.min.apply(null, eff_s), Math.min.apply(null, eff_i));
	                if (effMax * 1.1 > 1) {
	                    effMax = 1;
	                }
	                effMin = Math.floor(effMin * 10 / 1.1) / 10;
	
	                self.plot1dEff.setYRange([effMin, effMax]);
	
	                self.set_slider_values(props.W_sx, po.get('Ws_start'), po.get('Ws_stop'));
	
	                var endtime = new Date();
	                return true;
	            });
	        },
	
	        set_slider_values: function set_slider_values(zero_delay, t_start, t_stop) {
	            var self = this;
	            // self.set('delT', 100e-6);
	            // console.log("set slider values", self.eldelT.slider);
	            // @TODO Krister: Noticed a weird bug where using self.set to change "delT" causes the red line to
	            // disappear for any value other than 0.
	            self.eldelT.slider({
	                min: Math.round(t_start / 1e-6),
	                max: Math.round(t_stop / 1e-6)
	            });
	        },
	
	        calcRSingles: function calcRSingles(P) {
	            var self = this,
	                props = P.clone(),
	                grid_size = self.plotOpts.get('grid_size_heralding_JSI'),
	                Nthreads = self.nWorkers - 1,
	                lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size),
	                norm = 1,
	                divisions = Math.floor(grid_size / Nthreads),
	                lambda_i_range = [],
	                Ws = self.get('delT');
	
	            // console.log("Ws: ", Ws*1e6);
	
	            props.W_sx = Ws;
	            props.W_ix = Ws;
	            props.W_sy = Ws;
	            props.W_iy = Ws;
	            // props.update_all_angles();
	            // props.optimum_idler();
	
	            var propsJSON = props.get();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var promises = [];
	
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSASinglesCalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, norm]);
	            }
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var singles_s = new Float64Array(grid_size * grid_size);
	                var singles_i = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    singles_s.set(values[j][0], startindex);
	                    singles_i.set(values[j][1], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                return [singles_s, singles_i]; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	                // var p = self.updateTitle( PM );
	                var singles_s = PM[0],
	                    singles_i = PM[1];
	
	                var norm_s = Math.max.apply(null, singles_s),
	                    norm_i = Math.max.apply(null, singles_i);
	
	                // console.log(singles_i);
	                // console.log(norm_s, norm_i);
	                self.norm = Math.max(norm_s, norm_i);
	                singles_s = PhaseMatch.normalizeToVal(singles_s, self.norm);
	                singles_i = PhaseMatch.normalizeToVal(singles_i, self.norm);
	
	                self.data_s = singles_s;
	                self.data_i = singles_i;
	                // self.draw();
	                // console.log("Max singles", PhaseMatch.max(singles_s));
	                // self.plot.setZRange([0,Math.max.apply(null,PM[0])]);
	                self.plot.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plot.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                // self.plotIdler.setZRange([0,Math.max.apply(null,PM[1])]);
	                self.plotIdler.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotIdler.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	                self.calcRCoinc(props);
	                return true;
	            });
	        },
	
	        calcRCoinc: function calcRCoinc(P) {
	
	            var self = this,
	                props = P.clone(),
	                grid_size = self.plotOpts.get('grid_size_heralding_JSI'),
	                Nthreads = self.nWorkers - 1,
	                lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size)
	            // ,norm = 1
	            ,
	                divisions = Math.floor(grid_size / Nthreads),
	                lambda_i_range = [],
	                Ws = self.get('delT')
	            // ,Wi_SQ = Math.pow(Ws,2) // convert from FWHM to sigma @TODO: Change to props.W_i
	            // ,PHI_s = 1/Math.cos(props.theta_s_e)
	            // ,PHI_i = 1/Math.cos(props.theta_i_e)
	            // ,prefactor = ((Wi_SQ * PHI_s))
	            // ,scale_s = ((Wi_SQ * PHI_s))
	            // ,scale_i = ((Wi_SQ * PHI_i))
	            // ,prefactor = 1
	            ;
	
	            props.W_sx = Ws;
	            props.W_ix = Ws;
	            // props.update_all_angles();
	            // props.optimum_idler();
	
	            var propsJSON = props.get();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var promises = [];
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSACalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, 1]);
	            }
	
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    // console.log(j, j*lambda_s.length*lambda_i_range[j].length, values[j].length +  j*lambda_s.length*lambda_i_range[j].length);
	
	                    arr.set(values[j], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                // PhaseMatch.normalize(arr);
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	
	                var coinc_max = Math.max.apply(null, PM);
	                PM = PhaseMatch.normalizeToVal(PM, self.norm);
	                self.dataCoinc = PM;
	                var Rs = PhaseMatch.Sum(self.data_s),
	                    Ri = PhaseMatch.Sum(self.data_i),
	                    Rc = PhaseMatch.Sum(self.dataCoinc),
	                    eff_i = Rc / Rs,
	                    eff_s = Rc / Ri;
	                // console.log("Efficiency from sum: ", Rc, Rs, eff); /// PhaseMatch.sum(self.data));
	                // console.log("Efficiency from sum: ", Ws, eff); /// PhaseMatch.sum(self.data));
	                self.plot1dEff.setTitle("Waist: " + (Ws * 1e6).toFixed(0) + "um  |  Signal: " + eff_s.toFixed(3) + "  |  Idler: " + eff_i.toFixed(3));
	
	                self.plotCoinc.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotCoinc.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	
	                self.draw();
	                // console.log("FINISHED PLOTTING");
	                return true;
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data_s = self.data_s,
	                data_i = self.data_i,
	                dataCoinc = self.dataCoinc,
	                dfd = when.defer();
	
	            if (!data_s) {
	                return this;
	            }
	
	            // other plot
	            var dataEff_i = self.dataEff_i;
	            var dataEff_s = self.dataEff_s;
	
	            if (!dataEff_i && !dataEff_s) {
	                return this;
	            }
	
	            setTimeout(function () {
	                self.plot1dEff.clear();
	                self.plot1dEff.addSeries(dataEff_i, 'Idler');
	                self.plot1dEff.addSeries(dataEff_s, 'Signal');
	                self.plot1dEff.plotData();
	
	                // self.plot1dEff.plotData( dataEff_i );
	                self.plot.plotData(data_s);
	                self.plotIdler.plotData(data_i);
	                self.plotCoinc.plotData(dataCoinc);
	                dfd.resolve();
	            }, 10);
	
	            return dfd.promise;
	
	            // self.plot1dEff.plotData( data1d );
	        }
	    });
	
	    return function (config) {
	
	        return new jsahomUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Heralding efficiency for a fixed pump waist.</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-homjsa">&#x2296;</button> </div> </div><div class="heat-map-wrapper"> <!-- heat map goes here --></div></div><div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Joint spectral intensity with Signal fiber coupled (singles) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-singles-s">&#x2296;</button> </div> </div> <div class="singles-s-wrapper "> <!-- heat map goes here --> </div></div><div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Joint spectral intensity with Idler fiber coupled (singles) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-singles-i">&#x2296;</button> </div> </div> <div class="singles-i-wrapper "> <!-- heat map goes here --> </div></div><div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Joint spectral intensity with Signal & Idler fiber coupled (coincidences) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-coinc">&#x2296;</button> </div> </div> <div class="coinc-wrapper "> <!-- heat map goes here --> </div></div>';return out;
	}

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484), __webpack_require__(511), __webpack_require__(491)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplJSALayout, tplWaistCtrl) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var delTConversion = 1e-6;
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsahomUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 4,
	        tplPlots: tplJSALayout,
	        showPlotOpts: ['npts-heralding-waist', 'grid_size_heralding_JSI', 'signal-wavelength', 'idler-wavelength', 'signal-waist'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            self.el.on('click', '#collapse-homjsa', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-s', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-i', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-coinc', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // init plot
	            self.plot1dEff = new LinePlot({
	                title: 'Heralding Efficiency',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Signal and Idler Collection Waist (um)',
	                    y: 'Efficiency'
	                },
	                format: { x: '1f',
	                    y: '.2f' },
	                width: 400,
	                height: 200,
	                yrange: [0, 1]
	            });
	
	            self.plot1dEff.resize(400, 150);
	            self.plot1dEff.displayLegend(true);
	            // self.plot1dEff.setTitle("boo");
	
	            self.elPlot1d = $(self.plot1dEff.el);
	
	            self.eldelT = $(tplWaistCtrl()).appendTo(self.el.find('.heat-map-wrapper'));
	
	            self.eldelT.slider({
	                min: 50,
	                max: 200,
	                value: 100,
	                orientation: "horizontal",
	                range: "min",
	                change: function change() {
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                },
	                slide: function slide() {
	
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                }
	            });
	
	            self.set('delT', 100e-6);
	
	            // init plot
	            self.plot1dRates = new LinePlot({
	                title: 'Brightness',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Signal and Idler Collection Waist (um)',
	                    y: 'Counts/s'
	                },
	                format: { x: '1f',
	                    y: '1f' },
	                width: 400,
	                height: 200
	            });
	
	            self.plot1dRates.resize(400, 150);
	            self.plot1dRates.displayLegend(true);
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.singles-s-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	
	            self.plotIdler = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.singles-i-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	            // init plot Coinc
	            self.plotCoinc = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.coinc-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: ''
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	
	            self.dataCoinc = PhaseMatch.zeros(40, 40);
	
	            // internal events
	            var to;
	            self.on('change:delT', function (delT) {
	
	                self.refreshLine(delT);
	                // self.plot1dEff.setTitle("Collection Waist = " + delT/1e-6);
	
	                clearTimeout(to);
	                to = setTimeout(function () {
	
	                    // only refresh plots after a time delay
	                    self.refreshJSA();
	                }, 50);
	            });
	
	            self.on('refresh', function () {
	                self.refreshLine(self.get('delT'));
	            });
	
	            self.addPlot(self.plot);
	            self.addPlot(self.plotIdler);
	            self.addPlot(self.plotCoinc);
	            self.addPlot(self.plot1dEff);
	            self.initEvents();
	
	            // var props = self.parameters.getProps();
	            // self.set('delT', 200e-6);
	        },
	
	        refreshJSA: function refreshJSA() {
	
	            var self = this;
	            // self.calc_HOM_JSA( self.parameters.getProps() );
	            self.calcRSingles(self.parameters.getProps());
	            // self.calcRCoinc( self.parameters.getProps() );
	            self.draw();
	        },
	
	        // refresh the vertical line on the line-plot
	        refreshLine: function refreshLine(delT) {
	
	            this.refresh1dEffLine(delT);
	            this.refresh1dRatesLine(delT);
	        },
	
	        refresh1dEffLine: function refresh1dEffLine(delT) {
	
	            var self = this,
	                line = self.plot1dEff.svgPlot.selectAll('.vline').data([delT]),
	                y = self.plot1dEff.scales.y,
	                dom = y.domain();
	
	            // console.log("dom", dom)
	
	            // create
	            line.enter().append('rect').attr("class", 'vline').attr("width", 2)
	            // .attr("height", 20)
	            // this measurement is awkward...
	            .attr("height", Math.abs(y(dom[0]) - y(dom[1]))).style("fill", '#16A085');
	
	            // console.log("ydim: ", Math.abs(y(dom[0]) - y(dom[1])));
	            line.attr('x', function (d) {
	                return self.plot1dEff.scales.x(d / delTConversion);
	            });
	
	            line.exit().remove();
	        },
	
	        refresh1dRatesLine: function refresh1dRatesLine(delT) {
	
	            var self = this,
	                line = self.plot1dRates.svgPlot.selectAll('.vline').data([delT]),
	                y = self.plot1dRates.scales.y,
	                dom = y.domain();
	
	            // console.log("dom", dom)
	
	            // create
	            line.enter().append('rect').attr("class", 'vline').attr("width", 2)
	            // .attr("height", 20)
	            // this measurement is awkward...
	            .attr("height", Math.abs(y(dom[0]) - y(dom[1]))).style("fill", '#16A085');
	
	            // console.log("ydim: ", Math.abs(y(dom[0]) - y(dom[1])));
	            line.attr('x', function (d) {
	                return self.plot1dRates.scales.x(d / delTConversion);
	            });
	
	            line.exit().remove();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                tsi;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max);
	
	            self.plotOpts.set({
	                'grid_size_heralding_JSI': 30,
	                'n_pts_eff_1d': 10,
	                'n_int': 14,
	                // 'grid_size_heralding_JSI': 2,
	                // 'n_pts_eff_1d': 2,
	                // 'n_int': 2,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max,
	
	                // 'delT_start': tsi[1],
	                // 'delT_stop': tsi[2],
	
	                'Ws_start': 30e-6,
	                'Ws_stop': 130e-6
	            });
	
	            self.set_slider_values(100e-6, self.plotOpts.get['Ws_start'], self.plotOpts.get['Ws_stop']);
	        },
	
	        calc: function calc(P) {
	
	            var self = this,
	                threshold = 0.5
	            // ,props = self.parameters.getProps()
	            ,
	                props = P.clone(),
	                lim = PhaseMatch.autorange_lambda(props, threshold),
	                tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max),
	                data1d = [],
	                po = self.plotOpts,
	                dim = po.get('n_pts_eff_1d'),
	                npts = po.get('n_pts_eff_1d'),
	                trange = [],
	                Nthreads = self.nWorkers - 1,
	                divisions = Math.floor(npts / Nthreads),
	                promises = [],
	                yrange = [],
	                Ws = PhaseMatch.linspace(self.plotOpts.get('Ws_start'), self.plotOpts.get('Ws_stop'), npts);
	            // ,Ws = PhaseMatch.linspace(
	            //         P.W_sx,
	            //         1.001*P.W_sx,
	            //         npts
	            //     );
	            // ;
	
	            self.Nrates = P.get_rates_constant();
	            self.calcRSingles(P);
	            // self.calcRCoinc( props );
	
	            // var starttime = new Date();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                yrange.push(Ws.subarray(i * divisions, i * divisions + divisions));
	            }
	            yrange.push(Ws.subarray((Nthreads - 1) * divisions, Ws.length));
	
	            var starttime = new Date();
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.doCalcHeraldingEff', [props.get(), [props.W], yrange[j], self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), self.plotOpts.get('li_start'), self.plotOpts.get('li_stop'), self.plotOpts.get('n_int')]);
	            }
	
	            var startindex = 0;
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var eff_i = new Float64Array(npts);
	                var eff_s = new Float64Array(npts);
	                var singles_s = new Float64Array(npts);
	                var singles_i = new Float64Array(npts);
	                var coinc = new Float64Array(npts);
	                var startindex = 0;
	                for (j = 0; j < Nthreads; j++) {
	                    eff_i.set(values[j][0], startindex);
	                    eff_s.set(values[j][1], startindex);
	                    singles_s.set(values[j][2], startindex);
	                    singles_i.set(values[j][3], startindex);
	                    coinc.set(values[j][4], startindex);
	                    // console.log("eff_i val set");
	                    startindex += yrange[j].length;
	                }
	                // return eff_i;
	                return [eff_i, eff_s, singles_s, singles_i, coinc]; // this value is passed on to the next "then()"
	
	            }).then(function (data) {
	
	                var eff_i = data[0],
	                    eff_s = data[1],
	                    R_s = data[2],
	                    R_i = data[3],
	                    R_coin = data[4],
	                    dataEff_i = [],
	                    dataEff_s = [],
	                    dataR_s = [],
	                    dataR_i = [],
	                    dataR_coin = [];
	
	                for (var _i = 0, l = eff_i.length; _i < l; _i++) {
	                    // console.log(eff[i]);
	                    dataEff_i.push({
	                        x: Ws[_i] / 1e-6,
	                        y: eff_i[_i]
	                    });
	                }
	                self.dataEff_i = dataEff_i;
	
	                for (var _i2 = 0, _l = eff_s.length; _i2 < _l; _i2++) {
	                    // console.log(eff[i]);
	                    dataEff_s.push({
	                        x: Ws[_i2] / 1e-6,
	                        y: eff_s[_i2]
	                    });
	                }
	                self.dataEff_s = dataEff_s;
	
	                var RMax = Math.max(Math.max.apply(null, R_s), Math.max.apply(null, R_i));
	                // var  RCoincMax = Math.max.apply(null,R_coin)
	                // console.log("RMAX: ", RMax, "Singles: ", RMax*self.Nrates, "Coinc: ", RCoincMax*self.Nrates, RCoincMax);
	                // self.RMax = RMax;
	                // var RMax = 1/self.Nrates;
	                // self.RMax = 1/self.Nrates;
	                RMax = 1;
	
	                for (var _i3 = 0, _l2 = R_s.length; _i3 < _l2; _i3++) {
	                    // console.log(eff[i]);
	                    dataR_s.push({
	                        x: Ws[_i3] / 1e-6,
	                        y: R_s[_i3] / RMax
	                    });
	                }
	                self.dataR_s = dataR_s;
	
	                for (var _i4 = 0, _l3 = R_i.length; _i4 < _l3; _i4++) {
	                    // console.log(eff[i]);
	                    dataR_i.push({
	                        x: Ws[_i4] / 1e-6,
	                        y: R_i[_i4] / RMax
	                    });
	                }
	                self.dataR_i = dataR_i;
	
	                for (var _i5 = 0, _l4 = R_coin.length; _i5 < _l4; _i5++) {
	                    // console.log(eff[i]);
	                    dataR_coin.push({
	                        x: Ws[_i5] / 1e-6,
	                        y: R_coin[_i5] / RMax
	                    });
	                }
	                self.dataR_coin = dataR_coin;
	
	                var endtime = new Date();
	                console.log("Efficiency time: " + (endtime - starttime));
	                self.draw();
	
	                // Calculate max and min efficiencies
	                self.plot1dEff.setTitle("Efficiency");
	                self.plot1dRates.setTitle("Counts/s per mW of pump power");
	                // console.log("RMax: ",RMax.toPrecision(4));
	
	                var effMax = Math.max(Math.max.apply(null, eff_s), Math.max.apply(null, eff_i)),
	                    effMin = Math.min(Math.min.apply(null, eff_s), Math.min.apply(null, eff_i));
	                if (effMax * 1.1 > 1) {
	                    effMax = 1;
	                }
	                effMin = Math.floor(effMin * 10 / 1.1) / 10;
	
	                self.plot1dEff.setYRange([effMin, effMax]);
	
	                self.set_slider_values(props.W_sx, po.get('Ws_start'), po.get('Ws_stop'));
	
	                return true;
	            });
	        },
	
	        set_slider_values: function set_slider_values(zero_delay, t_start, t_stop) {
	            var self = this;
	            // self.set('delT', 100e-6);
	            // console.log("set slider values", self.eldelT.slider);
	            // @TODO Krister: Noticed a weird bug where using self.set to change "delT" causes the red line to
	            // disappear for any value other than 0.
	            self.eldelT.slider({
	                min: Math.round(t_start / 1e-6),
	                max: Math.round(t_stop / 1e-6)
	            });
	        },
	
	        calcRSingles: function calcRSingles(P) {
	            var self = this,
	                props = P.clone(),
	                grid_size = self.plotOpts.get('grid_size_heralding_JSI'),
	                Nthreads = self.nWorkers - 1,
	                lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size),
	                norm = 1,
	                divisions = Math.floor(grid_size / Nthreads),
	                lambda_i_range = [],
	                Ws = self.get('delT');
	
	            // console.log("Ws: ", Ws*1e6);
	
	            props.W_sx = Ws;
	            props.W_ix = Ws;
	            props.W_sy = Ws;
	            props.W_iy = Ws;
	            // props.update_all_angles();
	            // props.optimum_idler();
	
	            var propsJSON = props.get();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var promises = [];
	
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSASinglesCalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, norm]);
	            }
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var singles_s = new Float64Array(grid_size * grid_size);
	                var singles_i = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    singles_s.set(values[j][0], startindex);
	                    singles_i.set(values[j][1], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                return [singles_s, singles_i]; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	                // var p = self.updateTitle( PM );
	                var singles_s = PM[0],
	                    singles_i = PM[1];
	
	                var norm_s = Math.max.apply(null, singles_s),
	                    norm_i = Math.max.apply(null, singles_i);
	
	                self.data_s = singles_s;
	                self.data_i = singles_i;
	                // console.log(singles_i);
	                // console.log(norm_s, norm_i);
	                self.norm = Math.max(norm_s, norm_i);
	                console.log("NORM: ", self.norm);
	                // self.norm = 1
	                // singles_s = PhaseMatch.normalizeToVal(singles_s, self.norm);
	                // singles_i = PhaseMatch.normalizeToVal(singles_i, self.norm);
	
	                // self.draw();
	                // console.log("Max singles", PhaseMatch.max(singles_s));
	                // self.plot.setZRange([0,Math.max.apply(null,PM[0])]);
	                self.plot.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plot.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                // self.plotIdler.setZRange([0,Math.max.apply(null,PM[1])]);
	                self.plotIdler.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotIdler.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	                self.calcRCoinc(props);
	                return true;
	            });
	        },
	
	        calcRCoinc: function calcRCoinc(P) {
	
	            var self = this,
	                props = P.clone(),
	                grid_size = self.plotOpts.get('grid_size_heralding_JSI'),
	                Nthreads = self.nWorkers - 1,
	                lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size)
	            // ,norm = 1
	            ,
	                divisions = Math.floor(grid_size / Nthreads),
	                lambda_i_range = [],
	                Ws = self.get('delT')
	            // ,Wi_SQ = Math.pow(Ws,2) // convert from FWHM to sigma @TODO: Change to props.W_i
	            // ,PHI_s = 1/Math.cos(props.theta_s_e)
	            // ,PHI_i = 1/Math.cos(props.theta_i_e)
	            // ,prefactor = ((Wi_SQ * PHI_s))
	            // ,scale_s = ((Wi_SQ * PHI_s))
	            // ,scale_i = ((Wi_SQ * PHI_i))
	            // ,prefactor = 1
	            ;
	
	            props.W_sx = Ws;
	            props.W_ix = Ws;
	            // props.update_all_angles();
	            // props.optimum_idler();
	
	            var propsJSON = props.get();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var promises = [];
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSACoincCalcRates', [propsJSON, lambda_s, lambda_i_range[j], grid_size, 1]);
	            }
	
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    // console.log(j, j*lambda_s.length*lambda_i_range[j].length, values[j].length +  j*lambda_s.length*lambda_i_range[j].length);
	
	                    arr.set(values[j], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                // PhaseMatch.normalize(arr);
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	
	                self.dataCoinc = PM;
	                var coinc_max = Math.max.apply(null, PM);
	                // PM = PhaseMatch.normalizeToVal(PM, self.norm);
	
	
	                var Rs = PhaseMatch.Sum(self.data_s) //* self.Nrates
	                ,
	                    Ri = PhaseMatch.Sum(self.data_i) //* self.Nrates
	                ,
	                    Rc = PhaseMatch.Sum(self.dataCoinc) //* self.Nrates
	                ,
	                    eff_i = Rc / Rs,
	                    eff_s = Rc / Ri;
	                // console.log("Efficiency from sum: ", Rc, Rs, eff); /// PhaseMatch.sum(self.data));
	                // console.log("Efficiency from sum: ", Ws, eff); /// PhaseMatch.sum(self.data));
	                self.plot1dEff.setTitle("Waist: " + (Ws * 1e6).toFixed(0) + "um  |  Signal: " + eff_s.toFixed(3) + "  |  Idler: " + eff_i.toFixed(3));
	                self.plot1dRates.setTitle("Singles_signal: " + Rs.toFixed(0) + "  |  Singles_idler: " + Ri.toFixed(0) + "  |  Coinc: " + Rc.toFixed(0));
	
	                self.plotCoinc.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotCoinc.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	
	                self.data_s = PhaseMatch.normalizeToVal(self.data_s, self.norm);
	                self.data_i = PhaseMatch.normalizeToVal(self.data_i, self.norm);
	                self.dataCoinc = PhaseMatch.normalizeToVal(self.dataCoinc, self.norm);
	
	                self.draw();
	                // console.log("FINISHED PLOTTING");
	                return true;
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data_s = self.data_s,
	                data_i = self.data_i,
	                dataCoinc = self.dataCoinc,
	                dfd = when.defer();
	
	            // // Normalize the joint spectrum graphs
	            // var  norm_s = Math.max.apply(null, data_s)
	            //     ,norm_i = Math.max.apply(null, data_i)
	            //     ;
	            // var norm = Math.max(norm_s,norm_i);
	            // self.norm = 1
	
	
	            if (!data_s) {
	                return this;
	            }
	
	            // other plot
	            var dataEff_i = self.dataEff_i;
	            var dataEff_s = self.dataEff_s;
	
	            // data_s = PhaseMatch.normalizeToVal(data_s, self.norm);
	            // data_i = PhaseMatch.normalizeToVal(data_i, self.norm);
	            // dataCoinc = PhaseMatch.normalizeToVal(dataCoinc, self.norm);
	
	            var dataR_s = self.dataR_s;
	            var dataR_i = self.dataR_i;
	            var dataR_coin = self.dataR_coin;
	
	            if (!dataEff_i && !dataEff_s && !dataR_s && !dataR_i && !dataR_coin) {
	                return this;
	            }
	
	            setTimeout(function () {
	                self.plot1dEff.clear();
	                self.plot1dEff.addSeries(dataEff_i, 'Idler');
	                self.plot1dEff.addSeries(dataEff_s, 'Signal');
	                self.plot1dEff.plotData();
	
	                self.plot1dRates.clear();
	                self.plot1dRates.addSeries(dataR_i, 'Idler');
	                self.plot1dRates.addSeries(dataR_s, 'Signal');
	                self.plot1dRates.addSeries(dataR_coin, 'Coincidences');
	                self.plot1dRates.plotData();
	                console.log("Rates_i", dataR_i, dataR_coin);
	
	                // data_s = PhaseMatch.normalizeToVal(data_s, self.norm);
	                // data_i = PhaseMatch.normalizeToVal(data_i, self.norm);
	                // dataCoinc = PhaseMatch.normalizeToVal(dataCoinc, self.norm);
	
	
	                // self.plot1dEff.plotData( dataEff_i );
	                self.plot.plotData(data_s);
	                self.plotIdler.plotData(data_i);
	                self.plotCoinc.plotData(dataCoinc);
	                dfd.resolve();
	            }, 10);
	
	            return dfd.promise;
	
	            // self.plot1dEff.plotData( data1d );
	        }
	    });
	
	    return function (config) {
	
	        return new jsahomUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(484),
	
	// 'tpl!templates/jsa-heralding-1d-layout.tpl',
	__webpack_require__(514), __webpack_require__(491)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, W, tplJSALayout, tplWaistCtrl) {
	
	    'use strict';
	
	    var pmWorker = W(__webpack_require__(486));
	
	    var delTConversion = 1e-6;
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module JSAUI
	     * @implements {Stapes}
	     */
	    var jsahomUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 6,
	        tplPlots: tplJSALayout,
	        showPlotOpts: ['npts-heralding-waist', 'grid_size_heralding_JSI', 'signal-wavelength', 'idler-wavelength'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            self.el.on('click', '#collapse-homjsa', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-s', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-singles-i', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	
	            self.el.on('click', '#collapse-coinc', function (e) {
	                e.preventDefault();
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            var self = this;
	
	            // init plot
	            self.plot1dEff = new LinePlot({
	                title: 'Heralding Efficiency',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Signal and Idler Collection Waist (um)',
	                    y: 'Efficiency'
	                },
	                format: { x: '1f',
	                    y: '.2f' },
	                width: 400,
	                height: 200,
	                yrange: [0, 1]
	            });
	
	            self.plot1dEff.resize(400, 150);
	            self.plot1dEff.displayLegend(true);
	            // self.plot1dEff.setTitle("boo");
	
	            self.elPlot1d = $(self.plot1dEff.el);
	
	            self.eldelT = $(tplWaistCtrl()).appendTo(self.el.find('.heat-map-wrapper'));
	
	            self.eldelT.slider({
	                min: 50,
	                max: 200,
	                value: 100,
	                orientation: "horizontal",
	                range: "min",
	                change: function change() {
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                },
	                slide: function slide() {
	
	                    // set local prop and convert
	                    self.set('delT', parseFloat(self.eldelT.slider('value')) * delTConversion);
	                }
	            });
	            // var props = this.parameters.getProps();
	
	            self.set('delT', 0);
	
	            // init plot
	            self.plot1dRates = new LinePlot({
	                title: 'Rates',
	                el: self.el.find('.heat-map-wrapper').get(0),
	                labels: {
	                    x: 'Signal and Idler Collection Waist (um)',
	                    y: 'Rates'
	                },
	                format: { x: '1f',
	                    y: '.2f' },
	                width: 400,
	                height: 200,
	                yrange: [0, 1]
	            });
	
	            self.plot1dRates.resize(400, 150);
	            self.plot1dRates.displayLegend(true);
	
	            // init plot
	            self.plot = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.singles-s-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	
	            self.plotIdler = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.singles-i-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: 'Idler Wavelength(nm)'
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	            // init plot Coinc
	            self.plotCoinc = new HeatMap({
	                title: 'Normailized to the max singles rate',
	                el: self.el.find('.coinc-wrapper').get(0),
	                labels: {
	                    x: 'Signal Wavelength(nm)',
	                    y: ''
	                },
	                format: {
	                    x: '.0f',
	                    y: '.0f'
	                },
	                width: 400,
	                height: 400
	            });
	
	            self.dataCoinc = PhaseMatch.zeros(40, 40);
	
	            // internal events
	            var to;
	            self.on('change:delT', function (delT) {
	
	                self.refreshLine(delT);
	                // self.plot1dEff.setTitle("Collection Waist = " + delT/1e-6);
	
	                clearTimeout(to);
	                to = setTimeout(function () {
	
	                    // only refresh plots after a time delay
	                    self.refreshJSA();
	                }, 50);
	            });
	
	            self.on('refresh', function () {
	                self.refreshLine(self.get('delT'));
	            });
	
	            self.addPlot(self.plot);
	            self.addPlot(self.plotIdler);
	            self.addPlot(self.plotCoinc);
	            self.addPlot(self.plot1dEff);
	            self.initEvents();
	
	            // var props = self.parameters.getProps();
	            // self.set('delT', 200e-6);
	        },
	
	        refreshJSA: function refreshJSA() {
	
	            var self = this;
	            // self.calc_HOM_JSA( self.parameters.getProps() );
	            self.calcRSingles(self.parameters.getProps());
	            // self.calcRCoinc( self.parameters.getProps() );
	            self.draw();
	        },
	
	        // refresh the vertical line on the line-plot
	        refreshLine: function refreshLine(delT) {
	            this.refresh1dEffLine(delT);
	            this.refresh1dRatesLine(delT);
	        },
	
	        refresh1dEffLine: function refresh1dEffLine(delT) {
	
	            var self = this,
	                line = self.plot1dEff.svgPlot.selectAll('.vline').data([delT]),
	                y = self.plot1dEff.scales.y,
	                dom = y.domain();
	
	            // console.log("dom", dom)
	
	            // create
	            line.enter().append('rect').attr("class", 'vline').attr("width", 2)
	            // .attr("height", 20)
	            // this measurement is awkward...
	            .attr("height", Math.abs(y(dom[0]) - y(dom[1]))).style("fill", '#16A085');
	
	            // console.log("ydim: ", Math.abs(y(dom[0]) - y(dom[1])));
	            line.attr('x', function (d) {
	                return self.plot1dEff.scales.x(d / delTConversion);
	            });
	
	            line.exit().remove();
	        },
	
	        refresh1dRatesLine: function refresh1dRatesLine(delT) {
	
	            var self = this,
	                line = self.plot1dRates.svgPlot.selectAll('.vline').data([delT]),
	                y = self.plot1dRates.scales.y,
	                dom = y.domain();
	
	            // console.log("dom", dom)
	
	            // create
	            line.enter().append('rect').attr("class", 'vline').attr("width", 2)
	            // .attr("height", 20)
	            // this measurement is awkward...
	            .attr("height", Math.abs(y(dom[0]) - y(dom[1]))).style("fill", '#16A085');
	
	            // console.log("ydim: ", Math.abs(y(dom[0]) - y(dom[1])));
	            line.attr('x', function (d) {
	                return self.plot1dRates.scales.x(d / delTConversion);
	            });
	
	            line.exit().remove();
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            var self = this,
	                threshold = 0.5,
	                props = self.parameters.getProps(),
	                lim,
	                tsi;
	
	            // this does nothing... need to use .set()
	            props.lambda_i = 1 / (1 / props.lambda_p - 1 / props.lambda_s);
	            lim = PhaseMatch.autorange_lambda(props, threshold);
	            tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max);
	
	            self.plotOpts.set({
	                'grid_size_heralding_JSI': 30,
	                'n_pts_eff_1d': 10,
	                'n_int': 14,
	                // 'grid_size_heralding_JSI': 2,
	                // 'n_pts_eff_1d': 2,
	                // 'n_int': 2,
	                'ls_start': lim.lambda_s.min,
	                'ls_stop': lim.lambda_s.max,
	                'li_start': lim.lambda_i.min,
	                'li_stop': lim.lambda_i.max
	
	                // 'delT_start': tsi[1],
	                // 'delT_stop': tsi[2],
	
	                // 'Ws_start': 30e-6,
	                // 'Ws_stop': 130e-6
	            });
	
	            self.set_slider_values(150e-6, self.plotOpts.get['Ws_start'], self.plotOpts.get['Ws_stop']);
	        },
	
	        calc: function calc(P) {
	
	            var self = this,
	                threshold = 0.5
	            // ,props = self.parameters.getProps()
	            ,
	                props = P.clone(),
	                lim = PhaseMatch.autorange_lambda(props, threshold),
	                tsi = PhaseMatch.autorange_delT(props, lim.lambda_s.min, lim.lambda_s.max),
	                data1d = [],
	                po = self.plotOpts,
	                dim = po.get('n_pts_eff_1d'),
	                npts = po.get('n_pts_eff_1d'),
	                trange = [],
	                Nthreads = self.nWorkers - 1,
	                divisions = Math.floor(npts / Nthreads),
	                promises = [],
	                yrange = []
	            // ,Ws = PhaseMatch.linspace(
	            //         self.plotOpts.get('Ws_start'),
	            //         self.plotOpts.get('Ws_stop'),
	            //         npts
	            //     )
	            ,
	                Ws = PhaseMatch.linspace(-props.L, 0, npts);
	
	            self.calcRSingles(P);
	            // self.calcRCoinc( props );
	
	            var starttime = new Date();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                yrange.push(Ws.subarray(i * divisions, i * divisions + divisions));
	            }
	            yrange.push(Ws.subarray((Nthreads - 1) * divisions, Ws.length));
	
	            starttime = new Date();
	            // The calculation is split up and reutrned as a series of promises
	            for (var j = 0; j < Nthreads; j++) {
	                promises[j] = self.workers[j].exec('jsaHelper.doCalcHeraldingEffFocus', [props.get(), yrange[j], self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), self.plotOpts.get('li_start'), self.plotOpts.get('li_stop'), self.plotOpts.get('n_int')]);
	            }
	
	            var startindex = 0;
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var eff_i = new Float64Array(npts);
	                var eff_s = new Float64Array(npts);
	                var singles_s = new Float64Array(npts);
	                var singles_i = new Float64Array(npts);
	                var coinc = new Float64Array(npts);
	                var startindex = 0;
	                for (j = 0; j < Nthreads; j++) {
	                    eff_i.set(values[j][0], startindex);
	                    eff_s.set(values[j][1], startindex);
	                    singles_s.set(values[j][2], startindex);
	                    singles_i.set(values[j][3], startindex);
	                    coinc.set(values[j][4], startindex);
	                    // console.log("eff_i val set");
	                    startindex += yrange[j].length;
	                }
	                // return eff_i;
	                return [eff_i, eff_s, singles_s, singles_i, coinc]; // this value is passed on to the next "then()"
	
	            }).then(function (data) {
	
	                var eff_i = data[0],
	                    eff_s = data[1],
	                    R_s = data[2],
	                    R_i = data[3],
	                    R_coin = data[4],
	                    dataEff_i = [],
	                    dataEff_s = [],
	                    dataR_s = [],
	                    dataR_i = [],
	                    dataR_coin = [];
	
	                for (var _i = 0, l = eff_i.length; _i < l; _i++) {
	                    // console.log(eff[i]);
	                    dataEff_i.push({
	                        x: Ws[_i] / 1e-6,
	                        y: eff_i[_i]
	                    });
	                }
	                self.dataEff_i = dataEff_i;
	
	                for (var _i2 = 0, _l = eff_s.length; _i2 < _l; _i2++) {
	                    // console.log(eff[i]);
	                    dataEff_s.push({
	                        x: Ws[_i2] / 1e-6,
	                        y: eff_s[_i2]
	                    });
	                }
	                self.dataEff_s = dataEff_s;
	
	                var RMax = Math.max(Math.max.apply(null, R_s), Math.max.apply(null, R_i));
	                self.RMax = RMax;
	
	                for (var _i3 = 0, _l2 = R_s.length; _i3 < _l2; _i3++) {
	                    // console.log(eff[i]);
	                    dataR_s.push({
	                        x: Ws[_i3] / 1e-6,
	                        y: R_s[_i3] / RMax
	                    });
	                }
	                self.dataR_s = dataR_s;
	
	                for (var _i4 = 0, _l3 = R_i.length; _i4 < _l3; _i4++) {
	                    // console.log(eff[i]);
	                    dataR_i.push({
	                        x: Ws[_i4] / 1e-6,
	                        y: R_i[_i4] / RMax
	                    });
	                }
	                self.dataR_i = dataR_i;
	
	                for (var _i5 = 0, _l4 = R_coin.length; _i5 < _l4; _i5++) {
	                    // console.log(eff[i]);
	                    dataR_coin.push({
	                        x: Ws[_i5] / 1e-6,
	                        y: R_coin[_i5] / RMax
	                    });
	                }
	                self.dataR_coin = dataR_coin;
	
	                self.draw();
	
	                // Calculate max and min efficiencies
	                self.plot1dEff.setTitle("Efficiency");
	                self.plot1dRates.setTitle("Relative Rates (scale: " + RMax.toPrecision(4) + " a.u.)");
	                // console.log("RMax: ",RMax.toPrecision(4));
	
	                var effMax = Math.max(Math.max.apply(null, eff_s), Math.max.apply(null, eff_i)),
	                    effMin = Math.min(Math.min.apply(null, eff_s), Math.min.apply(null, eff_i));
	                if (effMax * 1.1 > 1) {
	                    effMax = 1;
	                }
	                effMin = Math.floor(effMin * 10 / 1.1) / 10;
	
	                self.plot1dEff.setYRange([effMin, effMax]);
	
	                self.set_slider_values(props.W_sx, Ws[0], Ws[Ws.length - 1]);
	
	                var endtime = new Date();
	                return true;
	            });
	        },
	
	        set_slider_values: function set_slider_values(zero_delay, t_start, t_stop) {
	            var self = this;
	            // self.set('delT', 100e-6);
	            // console.log("set slider values", self.eldelT.slider);
	            // @TODO Krister: Noticed a weird bug where using self.set to change "delT" causes the red line to
	            // disappear for any value other than 0.
	            self.eldelT.slider({
	                min: Math.round(t_start / 1e-6),
	                max: Math.round(t_stop / 1e-6)
	            });
	        },
	
	        calcRSingles: function calcRSingles(P) {
	            var self = this,
	                props = P.clone(),
	                grid_size = self.plotOpts.get('grid_size_heralding_JSI'),
	                Nthreads = self.nWorkers - 1,
	                lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size),
	                norm = 1,
	                divisions = Math.floor(grid_size / Nthreads),
	                lambda_i_range = [],
	                z0 = self.get('delT');
	
	            props.z0s = z0;
	            props.z0i = z0;
	            console.log("Z0: ", z0 * 1e6);
	
	            // props.W_sx = Ws;
	            // props.W_ix = Ws;
	            // props.W_sy = Ws;
	            // props.W_iy = Ws;
	            // props.update_all_angles();
	            // props.optimum_idler();
	
	            var propsJSON = props.get();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var promises = [];
	
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSASinglesCalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, norm]);
	            }
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var singles_s = new Float64Array(grid_size * grid_size);
	                var singles_i = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    singles_s.set(values[j][0], startindex);
	                    singles_i.set(values[j][1], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                return [singles_s, singles_i]; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	                // var p = self.updateTitle( PM );
	                var singles_s = PM[0],
	                    singles_i = PM[1];
	
	                var norm_s = Math.max.apply(null, singles_s),
	                    norm_i = Math.max.apply(null, singles_i);
	
	                // console.log(singles_i);
	                // console.log(norm_s, norm_i);
	                self.norm = Math.max(norm_s, norm_i);
	                singles_s = PhaseMatch.normalizeToVal(singles_s, self.norm);
	                singles_i = PhaseMatch.normalizeToVal(singles_i, self.norm);
	
	                self.data_s = singles_s;
	                self.data_i = singles_i;
	                // self.draw();
	                // console.log("Max singles", PhaseMatch.max(singles_s));
	                // self.plot.setZRange([0,Math.max.apply(null,PM[0])]);
	                self.plot.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plot.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                // self.plotIdler.setZRange([0,Math.max.apply(null,PM[1])]);
	                self.plotIdler.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotIdler.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	                self.calcRCoinc(props);
	                return true;
	            });
	        },
	
	        calcRCoinc: function calcRCoinc(P) {
	
	            var self = this,
	                props = P.clone(),
	                grid_size = self.plotOpts.get('grid_size_heralding_JSI'),
	                Nthreads = self.nWorkers - 1,
	                lambda_s = PhaseMatch.linspace(self.plotOpts.get('ls_start'), self.plotOpts.get('ls_stop'), grid_size),
	                lambda_i = PhaseMatch.linspace(self.plotOpts.get('li_stop'), self.plotOpts.get('li_start'), grid_size)
	            // ,norm = 1
	            ,
	                divisions = Math.floor(grid_size / Nthreads),
	                lambda_i_range = [],
	                z0 = self.get('delT');
	
	            props.z0s = z0;
	            props.z0i = z0;
	            // ,Wi_SQ = Math.pow(Ws,2) // convert from FWHM to sigma @TODO: Change to props.W_i
	            // ,PHI_s = 1/Math.cos(props.theta_s_e)
	            // ,PHI_i = 1/Math.cos(props.theta_i_e)
	            // ,prefactor = ((Wi_SQ * PHI_s))
	            // ,scale_s = ((Wi_SQ * PHI_s))
	            // ,scale_i = ((Wi_SQ * PHI_i))
	            // ,prefactor = 1
	            // ;
	
	
	            // props.W_sx = Ws;
	            // props.W_ix = Ws;
	            // props.update_all_angles();
	            // props.optimum_idler();
	
	            var propsJSON = props.get();
	
	            for (var i = 0; i < Nthreads - 1; i++) {
	                lambda_i_range.push(lambda_i.subarray(i * divisions, i * divisions + divisions));
	            }
	            lambda_i_range.push(lambda_i.subarray((Nthreads - 1) * divisions, lambda_i.length)); //make up the slack with the last one
	
	
	            // The calculation is split up and reutrned as a series of promises
	            var starttime = new Date();
	            var promises = [];
	            for (var j = 0; j < Nthreads; j++) {
	
	                promises[j] = self.workers[j].exec('jsaHelper.doJSACalc', [propsJSON, lambda_s, lambda_i_range[j], grid_size, 1]);
	            }
	
	            // console.log(PhaseMatch.linspace(0,10,10));
	
	            return when.all(promises).then(function (values) {
	                // put the results back together
	                var arr = new Float64Array(grid_size * grid_size);
	                var startindex = 0;
	
	                for (j = 0; j < Nthreads; j++) {
	                    // console.log(j, j*lambda_s.length*lambda_i_range[j].length, values[j].length +  j*lambda_s.length*lambda_i_range[j].length);
	
	                    arr.set(values[j], startindex);
	                    startindex += lambda_s.length * lambda_i_range[j].length;
	                }
	                // PhaseMatch.normalize(arr);
	
	                return arr; // this value is passed on to the next "then()"
	            }).then(function (PM) {
	
	                var coinc_max = Math.max.apply(null, PM);
	                PM = PhaseMatch.normalizeToVal(PM, self.norm);
	                self.dataCoinc = PM;
	                var Rs = PhaseMatch.Sum(self.data_s),
	                    Ri = PhaseMatch.Sum(self.data_i),
	                    Rc = PhaseMatch.Sum(self.dataCoinc),
	                    eff_i = Rc / Rs,
	                    eff_s = Rc / Ri;
	                console.log("in coinc calc");
	                // console.log("Efficiency from sum: ", Rc, Rs, eff); /// PhaseMatch.sum(self.data));
	                // console.log("Efficiency from sum: ", Ws, eff); /// PhaseMatch.sum(self.data));
	                self.plot1dEff.setTitle("Waist position: " + (z0 * 1e6).toFixed(0) + "um  |  Signal: " + eff_s.toFixed(3) + "  |  Idler: " + eff_i.toFixed(3));
	
	                self.plotCoinc.setXRange([converter.to('nano', self.plotOpts.get('ls_start')), converter.to('nano', self.plotOpts.get('ls_stop'))]);
	                self.plotCoinc.setYRange([converter.to('nano', self.plotOpts.get('li_start')), converter.to('nano', self.plotOpts.get('li_stop'))]);
	
	                var endtime = new Date();
	
	                self.draw();
	                console.log("FINISHED PLOTTING");
	                return true;
	            });
	        },
	
	        draw: function draw() {
	
	            var self = this,
	                data_s = self.data_s,
	                data_i = self.data_i,
	                dataCoinc = self.dataCoinc,
	                dfd = when.defer();
	
	            if (!data_s) {
	                return this;
	            }
	
	            // other plot
	            var dataEff_i = self.dataEff_i;
	            var dataEff_s = self.dataEff_s;
	            var dataR_s = self.dataR_s;
	            var dataR_i = self.dataR_i;
	            var dataR_coin = self.dataR_coin;
	
	            if (!dataEff_i && !dataEff_s && !dataR_s && !dataR_i && !dataR_coin) {
	                return this;
	            }
	
	            setTimeout(function () {
	                self.plot1dEff.clear();
	                self.plot1dEff.addSeries(dataEff_i, 'Idler');
	                self.plot1dEff.addSeries(dataEff_s, 'Signal');
	                self.plot1dEff.plotData();
	
	                self.plot1dRates.clear();
	                self.plot1dRates.addSeries(dataR_i, 'Idler');
	                self.plot1dRates.addSeries(dataR_s, 'Signal');
	                self.plot1dRates.addSeries(dataR_coin, 'Coincidences');
	                self.plot1dRates.plotData();
	                // console.log("Rates_i", dataR_i, dataR_coin, eff_s);
	
	                // self.plot1dEff.plotData( dataEff_i );
	                self.plot.plotData(data_s);
	                self.plotIdler.plotData(data_i);
	                self.plotCoinc.plotData(dataCoinc);
	                dfd.resolve();
	            }, 10);
	
	            return dfd.promise;
	
	            // self.plot1dEff.plotData( data1d );
	        }
	    });
	
	    return function (config) {
	
	        return new jsahomUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ },
/* 514 */
/***/ function(module, exports) {

	module.exports = function anonymous(it
	/**/) {
	var out='<div class="plot-wrapper span7 offset1"> <div class="row-fluid"> <h2 class="title">Heralding efficiencies for different signal/idler waist positions in the crystal (pump waist is located at the center of the crystal).</h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-homjsa">&#x2296;</button> </div> </div><div class="heat-map-wrapper"> <!-- heat map goes here --></div></div><div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Joint spectral intensity with Signal fiber coupled (singles) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-singles-s">&#x2296;</button> </div> </div> <div class="singles-s-wrapper "> <!-- heat map goes here --> </div></div><div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Joint spectral intensity with Idler fiber coupled (singles) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-singles-i">&#x2296;</button> </div> </div> <div class="singles-i-wrapper "> <!-- heat map goes here --> </div></div><div class="plot-wrapper  span7 offset1"> <div class="row-fluid"> <h2 class="title">Joint spectral intensity with Signal & Idler fiber coupled (coincidences) </h2> <div class="btn-wrap "> <button class="btn collapse-ctrl-plot" id="collapse-coinc">&#x2296;</button> </div> </div> <div class="coinc-wrapper "> <!-- heat map goes here --> </div></div>';return out;
	}

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(304), __webpack_require__(307), __webpack_require__(461), __webpack_require__(308), __webpack_require__(481), __webpack_require__(459), __webpack_require__(482), __webpack_require__(456), __webpack_require__(487), __webpack_require__(488)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($, Stapes, when, PhaseMatch, HeatMap, LinePlot, SkeletonUI, converter, tplJSALayout, tplDocsJSA) {
	
	    'use strict';
	
	    var con = PhaseMatch.constants;
	
	    /**
	     * @module testingUI
	     * @implements {Stapes}
	     */
	    var testingUI = SkeletonUI.subclass({
	
	        constructor: SkeletonUI.prototype.constructor,
	        nWorkers: 2,
	        tplPlots: tplJSALayout,
	        tplDoc: tplDocsJSA,
	        showPlotOpts: ['grid_size', 'signal-wavelength', 'idler-wavelength'],
	
	        initEvents: function initEvents() {
	            var self = this;
	            // self.el = $(tplPlots());
	            // collapse button for JSA module plot
	            self.el.on('click', '#collapse-jsa', function (e) {
	                e.preventDefault();
	                // var target = self.elParameters.parent()
	                var target = $(this).parent().parent().parent(),
	                    text = target.is('.collapsed') ? String.fromCharCode(0x2296) : String.fromCharCode(0x2295);
	
	                $(this).text(text);
	                target.toggleClass('collapsed');
	            });
	        },
	        /**
	         * Initialize Plots
	         * @return {void}
	         */
	        initPlots: function initPlots() {
	
	            return;
	        },
	
	        autocalcPlotOpts: function autocalcPlotOpts() {
	
	            return;
	        },
	
	        calc: function calc(props) {
	            var self = this;
	
	            var P = props.clone();
	            P.lambda_s = P.lambda_p * 2;
	            P.lambda_i = P.lambda_s;
	            // P.W = 100E-6;
	            P.phi_i = P.phi_s + Math.PI;
	            P.update_all_angles();
	            P.optimum_idler(P);
	
	            var pm_singles = PhaseMatch.calc_PM_tz_k_singles(P);
	            // console.log("Singles");
	            // console.log("REAL: ", pm_singles[0], "IMAG: ", pm_singles[1]);
	            // var abs_singles = pm_singles[0] * pm_singles[0] + pm_singles[1] * pm_singles[1];
	            // // console.log("ABS: ", abs_singles);
	            // console.log("");
	            var pm_coinc = PhaseMatch.calc_PM_tz_k_coinc(P);
	            // console.log("Coinc");
	            // console.log("REAL: ", pm_coinc[0].toExponential(), "IMAG: ", pm_coinc[1].toExponential());
	            // var abs_coinc = pm_coinc[0] * pm_coinc[0] + pm_coinc[1] * pm_coinc[1];
	            // console.log("ABS: ", abs_coinc);
	            console.log("");
	            console.log("");
	
	            return;
	        },
	
	        draw: function draw() {
	
	            //     var self = this
	            //         ,data = self.data
	            //         ,dfd = when.defer()
	            //         ;
	
	            //     if (!data){
	            //         return this;
	            //     }
	
	
	            //     // async... but not inside webworker
	            //     setTimeout(function(){
	            //         self.plot.plotData( data );
	            //         dfd.resolve();
	            //     }, 10);
	
	            //     return dfd.promise;
	            return;
	        }
	
	    });
	
	    return function (config) {
	
	        return new testingUI(config);
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** spdcalc.js
 **/